// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../node_modules/leaflet/dist/leaflet.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23636f83%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%2844, 56, 74, 0.681%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.681%29%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.95%29%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255, 255, 255, 0.87%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 21, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23998fed%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.87%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%232eb85c%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e55353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e55353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2844, 56, 74, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--cui-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%232d1cc5%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.95%29%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.38%29%27 points=%2795.314 447.313 72.686 424.687 245.373 252 72.686 79.313 95.314 56.687 290.627 252 95.314 447.313%27%3e%3c/polygon%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.38%29%27 points=%27255.314 447.313 232.686 424.687 405.373 252 232.686 79.313 255.314 56.687 450.627 252 255.314 447.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.38%29%27 points=%27416.686 447.313 221.373 252 416.686 56.687 439.314 79.313 266.627 252 439.314 424.687 416.686 447.313%27%3e%3c/polygon%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.38%29%27 points=%27256.686 447.313 61.373 252 256.686 56.687 279.314 79.313 106.627 252 279.314 424.687 256.686 447.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%2795.314 447.313 72.686 424.687 245.373 252 72.686 79.313 95.314 56.687 290.627 252 95.314 447.313%27%3e%3c/polygon%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27255.314 447.313 232.686 424.687 405.373 252 232.686 79.313 255.314 56.687 450.627 252 255.314 447.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27416.686 447.313 221.373 252 416.686 56.687 439.314 79.313 266.627 252 439.314 424.687 416.686 447.313%27%3e%3c/polygon%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27256.686 447.313 61.373 252 256.686 56.687 279.314 79.313 106.627 252 279.314 424.687 256.686 447.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.38%29%27 points=%27179.313 451.313 156.687 428.687 329.372 256 156.687 83.313 179.313 60.687 374.627 256 179.313 451.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.38%29%27 points=%27324.687 451.313 129.373 256 324.687 60.687 347.313 83.313 174.628 256 347.313 428.687 324.687 451.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27179.313 451.313 156.687 428.687 329.372 256 156.687 83.313 179.313 60.687 374.627 256 179.313 451.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27324.687 451.313 129.373 256 324.687 60.687 347.313 83.313 174.628 256 347.313 428.687 324.687 451.313%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpath fill=%27%23e55353%27 d=%27M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z%27%3e%3c/path%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27224%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27224%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27224%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27224%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27296%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27296%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27296%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27296%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27368%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27368%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27368%27 fill=%27%23e55353%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27368%27 fill=%27%23e55353%27%3e%3c/rect%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpath fill=%27%232eb85c%27 d=%27M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z%27%3e%3c/path%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27224%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27224%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27224%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27224%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27296%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27296%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27296%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27296%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27368%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27368%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27368%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27368%27 fill=%27%232eb85c%27%3e%3c/rect%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%238a93a2%27 points=%27359.873 121.377 337.246 144.004 433.243 240.001 16 240.001 16 240.002 16 272.001 16 272.002 433.24 272.002 337.246 367.996 359.873 390.623 494.498 256 359.873 121.377%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%238a93a2%27 points=%27497.333 239.999 80.092 239.999 176.087 144.004 153.46 121.377 18.837 256 153.46 390.623 176.087 367.996 80.09 271.999 497.333 271.999 497.333 239.999%27%3e%3c/polygon%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%238a93a2%27 points=%27306.912 214.461 256 265.373 205.088 214.461 182.461 237.088 233.373 288 182.461 338.912 205.088 361.539 256 310.627 306.912 361.539 329.539 338.912 278.627 288 329.539 237.088 306.912 214.461%27%3e%3c/polygon%3e%3cpath fill=%27%238a93a2%27 d=%27M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27306.912 214.461 256 265.373 205.088 214.461 182.461 237.088 233.373 288 182.461 338.912 205.088 361.539 256 310.627 306.912 361.539 329.539 338.912 278.627 288 329.539 237.088 306.912 214.461%27%3e%3c/polygon%3e%3cpath fill=%27rgba%2844, 56, 74, 0.95%29%29%27 d=%27M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpath fill=%27%238a93a2%27 d=%27M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z%27%3e%3c/path%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27224%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27224%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27224%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27224%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27296%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27296%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27296%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27296%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27112%27 y=%27368%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27200%27 y=%27368%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27280%27 y=%27368%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3crect width=%2732%27 height=%2732%27 x=%27368%27 y=%27368%27 fill=%27%238a93a2%27%3e%3c/rect%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%23e55353%27 points=%27271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5%27 class=%27ci-primary%27%3e%3c/polygon%3e%3cpath fill=%27%23e55353%27 d=%27M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z%27 class=%27ci-primary%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%232eb85c%27 points=%27271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5%27 class=%27ci-primary%27%3e%3c/polygon%3e%3cpath fill=%27%232eb85c%27 d=%27M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z%27 class=%27ci-primary%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%238a93a2%27 points=%27271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5%27 class=%27ci-primary%27%3e%3c/polygon%3e%3cpath fill=%27%238a93a2%27 d=%27M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z%27 class=%27ci-primary%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27%238a93a2%27 points=%27348.071 141.302 260.308 229.065 172.545 141.302 149.917 163.929 237.681 251.692 149.917 339.456 172.545 362.083 260.308 274.32 348.071 362.083 370.699 339.456 282.935 251.692 370.699 163.929 348.071 141.302%27 class=%27ci-primary%27%3e%3c/polygon%3e%3cpath fill=%27%238a93a2%27 d=%27M425.706,86.294A240,240,0,0,0,86.294,425.706,240,240,0,0,0,425.706,86.294ZM256,464C141.309,464,48,370.691,48,256S141.309,48,256,48s208,93.309,208,208S370.691,464,256,464Z%27 class=%27ci-primary%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 512 512%27 role=%27img%27%3e%3cpolygon fill=%27rgba%2844, 56, 74, 0.95%29%27 points=%27348.071 141.302 260.308 229.065 172.545 141.302 149.917 163.929 237.681 251.692 149.917 339.456 172.545 362.083 260.308 274.32 348.071 362.083 370.699 339.456 282.935 251.692 370.699 163.929 348.071 141.302%27 class=%27ci-primary%27%3e%3c/polygon%3e%3cpath fill=%27rgba%2844, 56, 74, 0.95%29%27 d=%27M425.706,86.294A240,240,0,0,0,86.294,425.706,240,240,0,0,0,425.706,86.294ZM256,464C141.309,464,48,370.691,48,256S141.309,48,256,48s208,93.309,208,208S370.691,464,256,464Z%27 class=%27ci-primary%27%3e%3c/path%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27currentColor%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.38%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%28255, 255, 255, 0.87%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.6%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.681%29%27><path fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%2844, 56, 74, 0.95%29%27><path fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%2844, 56, 74, 0.681%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cpath fill=%27rgba%2844, 56, 74, 0.95%29%27 d=%27M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27><path fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.87%29%27><path d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.6%29%27><path d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.75%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 0.9%29%27 stroke-width=%272.25%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgba%28255, 255, 255, 0.6%29%27><path fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../assets/residential2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../assets/loginpic.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* stylelint-disable-line scss/dollar-variable-default */
/* stylelint-disable-line scss/dollar-variable-default */
/*!
 * CoreUI PRO  v4.6.4 (https://coreui.io)
 * Copyright (c) 2023 creativeLabs Łukasz Holeczek
 * License (https://coreui.io/pro/license/)
 */
:root {
  --cui-blue: #0d6efd;
  --cui-indigo: #6610f2;
  --cui-purple: #6f42c1;
  --cui-pink: #d63384;
  --cui-red: #dc3545;
  --cui-orange: #fd7e14;
  --cui-yellow: #ffc107;
  --cui-green: #198754;
  --cui-teal: #20c997;
  --cui-cyan: #0dcaf0;
  --cui-black: #000015;
  --cui-white: #fff;
  --cui-gray: #8a93a2;
  --cui-gray-dark: #636f83;
  --cui-gray-100: #ebedef;
  --cui-gray-200: #d8dbe0;
  --cui-gray-300: #c4c9d0;
  --cui-gray-400: #b1b7c1;
  --cui-gray-500: #9da5b1;
  --cui-gray-600: #8a93a2;
  --cui-gray-700: #768192;
  --cui-gray-800: #636f83;
  --cui-gray-900: #4f5d73;
  --cui-primary: #321fdb;
  --cui-secondary: #9da5b1;
  --cui-success: #2eb85c;
  --cui-info: #39f;
  --cui-warning: #f9b115;
  --cui-danger: #e55353;
  --cui-light: #ebedef;
  --cui-dark: #4f5d73;
  --cui-primary-rgb: 50, 31, 219;
  --cui-secondary-rgb: 157, 165, 177;
  --cui-success-rgb: 46, 184, 92;
  --cui-info-rgb: 51, 153, 255;
  --cui-warning-rgb: 249, 177, 21;
  --cui-danger-rgb: 229, 83, 83;
  --cui-light-rgb: 235, 237, 239;
  --cui-dark-rgb: 79, 93, 115;
  --cui-white-rgb: 255, 255, 255;
  --cui-black-rgb: 0, 0, 21;
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --cui-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --cui-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --cui-body-font-family: var(--cui-font-sans-serif);
  --cui-body-font-size: 1rem;
  --cui-body-font-weight: 400;
  --cui-body-line-height: 1.5;
  --cui-body-color: rgba(44, 56, 74, 0.95);
  --cui-body-color-rgb: 44, 56, 74;
  --cui-body-bg: #fff;
  --cui-body-bg-rgb: 255, 255, 255;
  --cui-emphasis-color: #000015;
  --cui-emphasis-color-rgb: 0, 0, 21;
  --cui-secondary-color: rgba(44, 56, 74, 0.681);
  --cui-secondary-color-rgb: 44, 56, 74;
  --cui-secondary-bg: #d8dbe0;
  --cui-secondary-bg-rgb: 216, 219, 224;
  --cui-tertiary-color: rgba(44, 56, 74, 0.38);
  --cui-tertiary-color-rgb: 44, 56, 74;
  --cui-tertiary-bg: #ebedef;
  --cui-tertiary-bg-rgb: 235, 237, 239;
  --cui-high-emphasis: rgba(44, 56, 74, 0.95);
  --cui-medium-emphasis: rgba(44, 56, 74, 0.681);
  --cui-disabled: rgba(44, 56, 74, 0.38);
  --cui-high-emphasis-inverse: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis-inverse: rgba(255, 255, 255, 0.6);
  --cui-disabled-inverse: rgba(255, 255, 255, 0.38);
  --cui-heading-color: inherit;
  --cui-link-color: #321fdb;
  --cui-link-color-rgb: 50, 31, 219;
  --cui-link-decoration: underline;
  --cui-link-hover-color: #2819af;
  --cui-link-hover-color-rgb: 40, 25, 175;
  --cui-code-color: #d63384;
  --cui-highlight-color: rgba(44, 56, 74, 0.95);
  --cui-highlight-bg: #fff3cd;
  --cui-border-width: 1px;
  --cui-border-style: solid;
  --cui-border-color: #d8dbe0;
  --cui-border-color-translucent: rgba(0, 0, 21, 0.175);
  --cui-border-radius: 0.375rem;
  --cui-border-radius-sm: 0.25rem;
  --cui-border-radius-lg: 0.5rem;
  --cui-border-radius-xl: 1rem;
  --cui-border-radius-xxl: 2rem;
  --cui-border-radius-2xl: var(--cui-border-radius-xxl);
  --cui-border-radius-pill: 50rem;
  --cui-box-shadow: 0 0.5rem 1rem rgba(0, 0, 21, 0.15);
  --cui-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.075);
  --cui-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 21, 0.175);
  --cui-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 21, 0.075);
  --cui-focus-ring-width: 0.25rem;
  --cui-focus-ring-opacity: 0.25;
  --cui-focus-ring-color: rgba(50, 31, 219, 0.25);
  --cui-form-valid-color: #2eb85c;
  --cui-form-valid-border-color: #2eb85c;
  --cui-form-invalid-color: #e55353;
  --cui-form-invalid-border-color: #e55353;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--cui-body-font-family);
  font-size: var(--cui-body-font-size);
  font-weight: var(--cui-body-font-weight);
  line-height: var(--cui-body-line-height);
  color: var(--cui-body-color);
  text-align: var(--cui-body-text-align);
  background-color: var(--cui-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 21, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--cui-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--cui-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
}
html:not([dir=rtl]) dd {
  margin-left: 0;
}
*[dir=rtl] dd {
  margin-right: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--cui-highlight-color);
  background-color: var(--cui-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --cui-link-color-rgb: var(--cui-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--cui-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
  color: var(--cui-pre-color, );
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--cui-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--cui-kbd-color, var(--cui-body-bg));
  background-color: var(--cui-kbd-bg, var(--cui-body-color));
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-table-caption-color, var(--cui-secondary-color));
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
html:not([dir=rtl]) legend {
  float: left;
}
*[dir=rtl] legend {
  float: right;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

*[dir=rtl] [type=tel],
*[dir=rtl] [type=url],
*[dir=rtl] [type=email],
*[dir=rtl] [type=number] {
  direction: ltr;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  list-style: none;
}
html:not([dir=rtl]) .list-unstyled {
  padding-left: 0;
}
*[dir=rtl] .list-unstyled {
  padding-right: 0;
}

.list-inline {
  list-style: none;
}
html:not([dir=rtl]) .list-inline {
  padding-left: 0;
}
*[dir=rtl] .list-inline {
  padding-right: 0;
}

.list-inline-item {
  display: inline-block;
}
html:not([dir=rtl]) .list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
*[dir=rtl] .list-inline-item:not(:last-child) {
  margin-left: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #8a93a2;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--cui-thumbnail-bg, var(--cui-body-bg));
  border: var(--cui-border-width) solid var(--cui-thumbnail-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--cui-figure-caption-color, var(--cui-secondary-color));
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --cui-breakpoint-xs: 0;
  --cui-breakpoint-sm: 576px;
  --cui-breakpoint-md: 768px;
  --cui-breakpoint-lg: 992px;
  --cui-breakpoint-xl: 1200px;
  --cui-breakpoint-xxl: 1400px;
  --cui-mobile-breakpoint: md;
}

.row {
  --cui-gutter-x: 1.5rem;
  --cui-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--cui-gutter-y));
  margin-right: calc(-0.5 * var(--cui-gutter-x));
  margin-left: calc(-0.5 * var(--cui-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--cui-gutter-x) * 0.5);
  padding-left: calc(var(--cui-gutter-x) * 0.5);
  margin-top: var(--cui-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

html:not([dir=rtl]) .offset-1 {
  margin-left: 8.33333333%;
}
*[dir=rtl] .offset-1 {
  margin-right: 8.33333333%;
}

html:not([dir=rtl]) .offset-2 {
  margin-left: 16.66666667%;
}
*[dir=rtl] .offset-2 {
  margin-right: 16.66666667%;
}

html:not([dir=rtl]) .offset-3 {
  margin-left: 25%;
}
*[dir=rtl] .offset-3 {
  margin-right: 25%;
}

html:not([dir=rtl]) .offset-4 {
  margin-left: 33.33333333%;
}
*[dir=rtl] .offset-4 {
  margin-right: 33.33333333%;
}

html:not([dir=rtl]) .offset-5 {
  margin-left: 41.66666667%;
}
*[dir=rtl] .offset-5 {
  margin-right: 41.66666667%;
}

html:not([dir=rtl]) .offset-6 {
  margin-left: 50%;
}
*[dir=rtl] .offset-6 {
  margin-right: 50%;
}

html:not([dir=rtl]) .offset-7 {
  margin-left: 58.33333333%;
}
*[dir=rtl] .offset-7 {
  margin-right: 58.33333333%;
}

html:not([dir=rtl]) .offset-8 {
  margin-left: 66.66666667%;
}
*[dir=rtl] .offset-8 {
  margin-right: 66.66666667%;
}

html:not([dir=rtl]) .offset-9 {
  margin-left: 75%;
}
*[dir=rtl] .offset-9 {
  margin-right: 75%;
}

html:not([dir=rtl]) .offset-10 {
  margin-left: 83.33333333%;
}
*[dir=rtl] .offset-10 {
  margin-right: 83.33333333%;
}

html:not([dir=rtl]) .offset-11 {
  margin-left: 91.66666667%;
}
*[dir=rtl] .offset-11 {
  margin-right: 91.66666667%;
}

.g-0,
.gx-0 {
  --cui-gutter-x: 0;
}

.g-0,
.gy-0 {
  --cui-gutter-y: 0;
}

.g-1,
.gx-1 {
  --cui-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --cui-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --cui-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --cui-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --cui-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --cui-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --cui-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --cui-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --cui-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --cui-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-sm-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-sm-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-sm-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-sm-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-sm-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-sm-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-sm-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-sm-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-sm-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-sm-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-sm-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-sm-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-sm-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-sm-11 {
    margin-right: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --cui-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --cui-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --cui-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --cui-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --cui-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-md-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-md-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-md-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-md-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-md-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-md-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-md-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-md-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-md-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-md-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-md-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-md-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-md-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-md-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-md-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-md-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-md-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-md-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-md-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-md-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-md-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-md-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-md-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-md-11 {
    margin-right: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --cui-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --cui-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --cui-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --cui-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --cui-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-lg-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-lg-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-lg-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-lg-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-lg-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-lg-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-lg-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-lg-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-lg-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-lg-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-lg-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-lg-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-lg-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-lg-11 {
    margin-right: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --cui-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --cui-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --cui-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --cui-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --cui-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-xl-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-xl-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-xl-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-xl-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-xl-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-xl-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-xl-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-xl-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-xl-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-xl-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-xl-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-xl-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-xl-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-xl-11 {
    margin-right: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --cui-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --cui-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --cui-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  html:not([dir=rtl]) .offset-xxl-0 {
    margin-left: 0;
  }
  *[dir=rtl] .offset-xxl-0 {
    margin-right: 0;
  }
  html:not([dir=rtl]) .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  *[dir=rtl] .offset-xxl-1 {
    margin-right: 8.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  *[dir=rtl] .offset-xxl-2 {
    margin-right: 16.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-3 {
    margin-left: 25%;
  }
  *[dir=rtl] .offset-xxl-3 {
    margin-right: 25%;
  }
  html:not([dir=rtl]) .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  *[dir=rtl] .offset-xxl-4 {
    margin-right: 33.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  *[dir=rtl] .offset-xxl-5 {
    margin-right: 41.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-6 {
    margin-left: 50%;
  }
  *[dir=rtl] .offset-xxl-6 {
    margin-right: 50%;
  }
  html:not([dir=rtl]) .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  *[dir=rtl] .offset-xxl-7 {
    margin-right: 58.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  *[dir=rtl] .offset-xxl-8 {
    margin-right: 66.66666667%;
  }
  html:not([dir=rtl]) .offset-xxl-9 {
    margin-left: 75%;
  }
  *[dir=rtl] .offset-xxl-9 {
    margin-right: 75%;
  }
  html:not([dir=rtl]) .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  *[dir=rtl] .offset-xxl-10 {
    margin-right: 83.33333333%;
  }
  html:not([dir=rtl]) .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  *[dir=rtl] .offset-xxl-11 {
    margin-right: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --cui-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --cui-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --cui-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --cui-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --cui-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --cui-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --cui-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --cui-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --cui-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --cui-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --cui-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --cui-gutter-y: 3rem;
  }
}
.table {
  --cui-table-color-type: initial;
  --cui-table-bg-type: initial;
  --cui-table-color-state: initial;
  --cui-table-bg-state: initial;
  --cui-table-color: var(--cui-emphasis-color);
  --cui-table-bg: var(--cui-body-bg);
  --cui-table-border-color: var(--cui-border-color);
  --cui-table-accent-bg: transparent;
  --cui-table-striped-color: var(--cui-emphasis-color);
  --cui-table-striped-bg: rgba(var(--cui-emphasis-color-rgb), 0.05);
  --cui-table-active-color: var(--cui-emphasis-color);
  --cui-table-active-bg: rgba(var(--cui-emphasis-color-rgb), 0.1);
  --cui-table-hover-color: var(--cui-emphasis-color);
  --cui-table-hover-bg: rgba(var(--cui-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--cui-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--cui-table-color-state, var(--cui-table-color-type, var(--cui-table-color)));
  background-color: var(--cui-table-bg);
  border-bottom-width: var(--cui-border-width);
  box-shadow: inset 0 0 0 9999px var(--cui-table-bg-state, var(--cui-table-bg-type, var(--cui-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--cui-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--cui-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--cui-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --cui-table-color-type: var(--cui-table-striped-color);
  --cui-table-bg-type: var(--cui-table-striped-bg);
}

.table-active {
  --cui-table-color-state: var(--cui-table-active-color);
  --cui-table-bg-state: var(--cui-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --cui-table-color-state: var(--cui-table-hover-color);
  --cui-table-bg-state: var(--cui-table-hover-bg);
}

.table-primary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6d2f8;
  --cui-table-border-color: rgba(183, 182, 216, 0.99);
  --cui-table-striped-bg: rgba(206, 203, 240, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 196, 232, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 199, 236, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-secondary {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(200, 204, 209, 0.99);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-success {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d5f1de;
  --cui-table-border-color: rgba(182, 207, 195, 0.99);
  --cui-table-striped-bg: rgba(205, 233, 215, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 224, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(201, 228, 212, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-info {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #d6ebff;
  --cui-table-border-color: rgba(183, 202, 222, 0.99);
  --cui-table-striped-bg: rgba(206, 227, 247, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(198, 219, 238, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(202, 223, 243, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-warning {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #feefd0;
  --cui-table-border-color: rgba(215, 205, 183, 0.99);
  --cui-table-striped-bg: rgba(244, 231, 202, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(235, 222, 196, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(240, 226, 199, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-danger {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #fadddd;
  --cui-table-border-color: rgba(212, 191, 194, 0.99);
  --cui-table-striped-bg: rgba(241, 214, 214, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(231, 206, 208, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(236, 210, 211, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-light {
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-bg: #ebedef;
  --cui-table-border-color: rgba(200, 204, 209, 0.99);
  --cui-table-striped-bg: rgba(226, 229, 232, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(218, 220, 224, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(222, 225, 228, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-dark {
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-bg: #4f5d73;
  --cui-table-border-color: rgba(107, 119, 138, 0.974);
  --cui-table-striped-bg: rgba(86, 99, 120, 0.9935);
  --cui-table-striped-color: rgba(255, 255, 255, 0.87);
  --cui-table-active-bg: rgba(93, 106, 126, 0.987);
  --cui-table-active-color: rgba(255, 255, 255, 0.87);
  --cui-table-hover-bg: rgba(89, 103, 123, 0.99025);
  --cui-table-hover-color: rgba(255, 255, 255, 0.87);
  color: var(--cui-table-color);
  border-color: var(--cui-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  color: var(--cui-form-label-color, );
}

.col-form-label {
  padding-top: calc(0.375rem + var(--cui-border-width));
  padding-bottom: calc(0.375rem + var(--cui-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  color: var(--cui-form-label-color, );
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--cui-border-width));
  padding-bottom: calc(0.5rem + var(--cui-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--cui-border-width));
  padding-bottom: calc(0.25rem + var(--cui-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-text-color, var(--cui-secondary-color));
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-input-bg, var(--cui-body-bg));
  background-clip: padding-box;
  border: var(--cui-border-width) solid var(--cui-input-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--cui-input-focus-color, var(--cui-body-color));
  background-color: var(--cui-input-focus-bg, var(--cui-body-bg));
  border-color: var(--cui-input-focus-border-color, #998fed);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--cui-input-placeholder-color, var(--cui-secondary-color));
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--cui-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--cui-form-file-button-color, var(--cui-body-color));
  background-color: var(--cui-form-file-button-bg, var(--cui-tertiary-bg));
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--cui-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--cui-form-file-button-hover-bg, var(--cui-secondary-bg));
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-input-plaintext-color, var(--cui-body-color));
  background-color: transparent;
  border: solid transparent;
  border-width: var(--cui-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--cui-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--cui-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--cui-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--cui-border-width) * 2));
}

.form-select {
  --cui-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-form-select-color, var(--cui-body-color));
  appearance: none;
  background-color: var(--cui-form-select-bg, var(--cui-body-bg));
  background-image: var(--cui-form-select-bg-img), var(--cui-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-size: 16px 12px;
  border: var(--cui-border-width) solid var(--cui-form-select-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
html:not([dir=rtl]) .form-select {
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
}
*[dir=rtl] .form-select {
  padding: 0.375rem 0.75rem 0.375rem 2.25rem;
}
html:not([dir=rtl]) .form-select {
  background-position: right 0.75rem center;
}
*[dir=rtl] .form-select {
  background-position: left 0.75rem center;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--cui-form-select-focus-border-color, #998fed);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  background-image: none;
}
html:not([dir=rtl]) .form-select[multiple], html:not([dir=rtl]) .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
}
*[dir=rtl] .form-select[multiple], *[dir=rtl] .form-select[size]:not([size="1"]) {
  padding-left: 0.75rem;
}
.form-select:disabled {
  color: var(--cui-form-select-disabled-color, );
  background-color: var(--cui-form-select-disabled-bg, var(--cui-secondary-bg));
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--cui-form-select-color, var(--cui-body-color));
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}
html:not([dir=rtl]) .form-select-sm {
  padding-left: 0.5rem;
}
*[dir=rtl] .form-select-sm {
  padding-right: 0.5rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}
html:not([dir=rtl]) .form-select-lg {
  padding-left: 1rem;
}
*[dir=rtl] .form-select-lg {
  padding-right: 1rem;
}

.dark-theme .form-select > option {
  background-color: #44454e;
}

.form-multi-select {
  --cui-form-multi-select-padding-y: 0.375rem;
  --cui-form-multi-select-padding-x: 0.75rem;
  --cui-form-multi-select-font-family: ;
  --cui-form-multi-select-font-size: 1rem;
  --cui-form-multi-select-font-weight: 400;
  --cui-form-multi-select-line-height: 1.5;
  --cui-form-multi-select-color: var(--cui-body-color);
  --cui-form-multi-select-bg: var(--cui-body-bg);
  --cui-form-multi-select-bg-position: right 0.75rem center;
  --cui-form-multi-select-bg-size: 16px 12px;
  --cui-form-multi-select-border-color: var(--cui-border-color);
  --cui-form-multi-select-border: var(--cui-border-width) solid var(--cui-form-multi-select-border-color);
  --cui-form-multi-select-border-radius: var(--cui-border-radius);
  --cui-form-multi-select-disabled-color: ;
  --cui-form-multi-select-disabled-bg: var(--cui-secondary-bg);
  --cui-form-multi-select-focus-color: var(--cui-body-color);
  --cui-form-multi-select-focus-bg: var(--cui-body-bg);
  --cui-form-multi-select-focus-border-color: #6557e4;
  --cui-form-multi-select-selection-tags-padding-y: 0.125rem;
  --cui-form-multi-select-selection-tags-padding-x: 0.125rem;
  --cui-form-multi-select-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --cui-form-multi-select-indicator-padding: 2.25rem;
  --cui-form-multi-select-cleaner-width: 0.75rem;
  --cui-form-multi-select-cleaner-height: 0.75rem;
  --cui-form-multi-select-cleaner-padding-y: 0.5rem;
  --cui-form-multi-select-cleaner-padding-x: 0.75rem;
  --cui-form-multi-select-cleaner-bg: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --cui-form-multi-select-cleaner-hover-bg: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --cui-form-multi-select-cleaner-focus-bg: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --cui-form-multi-select-search-color: var(--cui-body-color);
  --cui-form-multi-select-search-bg: var(--cui-body-bg);
  --cui-form-multi-select-search-border-radius: 0.375rem;
  --cui-form-multi-select-select-all-padding-y: 0.5rem;
  --cui-form-multi-select-select-all-padding-x: 0.75rem;
  --cui-form-multi-select-select-all-color: var(--cui-body-secondary-color);
  --cui-form-multi-select-select-all-bg: transparent;
  --cui-form-multi-select-select-all-border-color: var(--cui-border-color);
  --cui-form-multi-select-select-all-border: var(--cui-border-width) solid var(--cui-form-multi-select-select-all-border-color);
  --cui-form-multi-select-select-all-hover-color: var(--cui-body-color);
  --cui-form-multi-select-select-all-hover-bg: transparent;
  --cui-form-multi-select-options-margin-top: 0.625rem;
  --cui-form-multi-select-options-bg: #fff;
  --cui-form-multi-select-options-border-color: #d8dbe0;
  --cui-form-multi-select-options-border: 1px solid var(--cui-form-multi-select-options-border-color);
  --cui-form-multi-select-options-border-radius: 0.375rem;
  --cui-form-multi-select-options-padding-y: 0.5rem;
  --cui-form-multi-select-options-padding-x: 0.75rem;
  --cui-form-multi-select-options-color: var(--cui-body-color);
  --cui-form-multi-select-option-padding-y: 0.5rem;
  --cui-form-multi-select-option-padding-x: 1.25rem;
  --cui-form-multi-select-option-border-radius: 0.375rem;
  --cui-form-multi-select-option-hover-color: #4b586d;
  --cui-form-multi-select-option-hover-bg: rgba(235, 237, 239, 0.5);
  --cui-form-multi-select-option-disabled-color: #8a93a2;
  --cui-form-multi-select-option-indicator-width: 1em;
  --cui-form-multi-select-option-indicator-bg: var(--cui-body-bg);
  --cui-form-multi-select-option-indicator-border: var(--cui-border-width) solid var(--cui-border-color);
  --cui-form-multi-select-option-indicator-border-radius: 0.25em;
  --cui-form-multi-select-option-selected-bg: #ebedef;
  --cui-form-multi-select-option-selected-indicator-bg: #321fdb;
  --cui-form-multi-select-option-selected-indicator-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  --cui-form-multi-select-option-selected-indicator-border-color: #321fdb;
  --cui-form-multi-select-tag-padding-y: calc(0.125rem - var(--cui-border-width));
  --cui-form-multi-select-tag-padding-x: 0.5rem;
  --cui-form-multi-select-tag-margin-y: 0.125rem;
  --cui-form-multi-select-tag-margin-x: 0.125rem;
  --cui-form-multi-select-tag-bg: var(--cui-secondary-bg);
  --cui-form-multi-select-tag-border-color: var(--cui-border-color);
  --cui-form-multi-select-tag-border: var(--cui-border-width) solid var(--cui-form-multi-select-tag-border-color);
  --cui-form-multi-select-tag-border-radius: 0.25rem;
  position: relative;
  display: block;
  width: 100%;
  padding: var(--cui-form-multi-select-padding-y) var(--cui-form-multi-select-padding-x);
  font-family: var(--cui-form-multi-select-font-family);
  font-size: var(--cui-form-multi-select-font-size);
  font-weight: var(--cui-form-multi-select-font-weight);
  line-height: var(--cui-form-multi-select-line-height);
  color: var(--cui-form-multi-select-color);
  appearance: none;
  background-color: var(--cui-form-multi-select-bg);
  background-image: var(--cui-form-multi-select-indicator);
  background-repeat: no-repeat;
  background-size: var(--cui-form-multi-select-bg-size);
  border: var(--cui-form-multi-select-border);
  border-radius: var(--cui-form-multi-select-border-radius);
}
html:not([dir=rtl]) .form-multi-select {
  padding-right: var(--cui-form-multi-select-indicator-padding);
}
*[dir=rtl] .form-multi-select {
  padding-left: var(--cui-form-multi-select-indicator-padding);
}
html:not([dir=rtl]) .form-multi-select {
  background-position: var(--cui-form-multi-select-bg-position);
}
*[dir=rtl] .form-multi-select {
  background-position: var(--cui-form-multi-select-bg-position);
}
.form-multi-select:disabled, .form-multi-select.disabled {
  color: var(--cui-form-multi-select-disabled-color);
  background-color: var(--cui-form-multi-select-disabled-bg);
}
.form-multi-select:disabled .form-multi-select-search, .form-multi-select.disabled .form-multi-select-search {
  background: transparent;
}
html:not([dir=rtl]) .form-multi-select.form-multi-select-with-cleaner {
  padding-right: 4.5rem;
}
*[dir=rtl] .form-multi-select.form-multi-select-with-cleaner {
  padding-left: 4.5rem;
}
.was-validated .form-multi-select:invalid + .form-multi-select, .form-multi-select.is-invalid {
  --cui-form-multi-select-border-color: #e55353;
}
.was-validated .form-multi-select:valid + .form-multi-select, .form-multi-select.is-valid {
  --cui-form-multi-select-border-color: #2eb85c;
}
.form-multi-select > div:not([class]):first-of-type::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  content: "";
}

.form-multi-select-selection-tags {
  min-height: calc(2.25rem + var(--cui-border-width) * 2);
  padding: var(--cui-form-multi-select-selection-tags-padding-y) var(--cui-form-multi-select-selection-tags-padding-x);
}
html:not([dir=rtl]) .form-multi-select-selection-tags {
  padding-right: var(--cui-form-multi-select-indicator-padding);
}
*[dir=rtl] .form-multi-select-selection-tags {
  padding-left: var(--cui-form-multi-select-indicator-padding);
}
.form-multi-select-selection-tags .form-multi-select-search {
  height: 2rem;
}
html:not([dir=rtl]) .form-multi-select-selection-tags .form-multi-select-search {
  margin-left: var(--cui-form-multi-select-padding-x);
}
*[dir=rtl] .form-multi-select-selection-tags .form-multi-select-search {
  margin-right: var(--cui-form-multi-select-padding-x);
}

.form-multi-select-selection {
  display: inline;
  padding: 0;
}

.form-multi-select-selection-cleaner {
  position: absolute;
  top: 50%;
  box-sizing: content-box;
  width: var(--cui-form-multi-select-cleaner-width);
  height: var(--cui-form-multi-select-cleaner-height);
  padding: var(--cui-form-multi-select-cleaner-padding-y) var(--cui-form-multi-select-cleaner-padding-x);
  background-color: transparent;
  background-image: var(--cui-form-multi-select-cleaner-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: var(--cui-form-multi-select-cleaner-width) auto;
  border: 0;
  transform: translateY(-50%);
}
html:not([dir=rtl]) .form-multi-select-selection-cleaner {
  right: var(--cui-form-multi-select-indicator-padding);
}
*[dir=rtl] .form-multi-select-selection-cleaner {
  left: var(--cui-form-multi-select-indicator-padding);
}
html:not([dir=rtl]) .form-multi-select-selection-cleaner {
  border-right: 1px solid var(--cui-form-multi-select-cleaner-border-color, var(--cui-border-color));
}
*[dir=rtl] .form-multi-select-selection-cleaner {
  border-left: 1px solid var(--cui-form-multi-select-cleaner-border-color, var(--cui-border-color));
}
.form-multi-select-selection-cleaner:hover {
  background-image: var(--cui-form-multi-select-cleaner-hover-bg);
}
.form-multi-select-selection-cleaner:focus {
  background-image: var(--cui-form-multi-select-cleaner-focus-bg);
  outline: 0;
}

.form-multi-select-search {
  width: auto;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  color: var(--cui-form-multi-select-search-color);
  appearance: none;
  background-color: var(--cui-form-multi-select-search-bg);
  border: 0;
  border-radius: var(--cui-form-multi-select-search-border-radius);
}
.form-multi-select-search:focus {
  outline: 0;
}
.form-multi-select-search[size] {
  display: none;
}
html:not([dir=rtl]) .form-multi-select-search[size] {
  margin-left: var(--cui-form-multi-select-padding-x);
}
*[dir=rtl] .form-multi-select-search[size] {
  margin-right: var(--cui-form-multi-select-padding-x);
}
.form-multi-select-search:placeholder-shown {
  width: 100%;
}

.form-multi-select-all {
  display: block;
  width: 100%;
  padding: var(--cui-form-multi-select-select-all-padding-y) var(--cui-form-multi-select-select-all-padding-x);
  color: var(--cui-form-multi-select-select-all-color);
  text-align: start;
  background-color: var(--cui-form-multi-select-select-all-bg);
  border: 0;
  border-bottom: var(--cui-form-multi-select-select-all-border);
}
.form-multi-select-all:hover {
  color: var(--cui-form-multi-select-select-all-hover-color);
  background-color: var(--cui-form-multi-select-select-all-hover-bg);
}

.form-multi-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  width: 100%;
  margin-top: var(--cui-form-multi-select-options-margin-top);
  background-color: var(--cui-form-multi-select-options-bg);
  background-clip: padding-box;
  border: var(--cui-form-multi-select-options-border);
  border-radius: var(--cui-form-multi-select-options-border-radius);
  box-shadow: 0 4px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 1px 10px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 2px 4px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.form-multi-select-dropdown:not([class*=border]) {
  border: 0;
}

.form-multi-select-options {
  padding: var(--cui-form-multi-select-options-padding-y) var(--cui-form-multi-select-options-padding-x);
  font-size: 1rem;
  color: var(--cui-form-multi-select-options-color);
}

.form-multi-select-option {
  position: relative;
  padding: var(--cui-form-multi-select-option-padding-y) var(--cui-form-multi-select-option-padding-x);
  margin-bottom: 2px;
  vertical-align: top;
  cursor: pointer;
  border-radius: var(--cui-form-multi-select-option-border-radius);
}
.form-multi-select-option:hover, .form-multi-select-option:focus {
  color: var(--cui-form-multi-select-option-hover-color);
  text-decoration: none;
  background-color: var(--cui-form-multi-select-option-hover-bg);
}
.form-multi-select-option.disabled, .form-multi-select-option:disabled {
  color: var(--cui-form-multi-select-option-disabled-color);
  pointer-events: none;
  background-color: transparent;
}
.form-multi-select-option.form-multi-select-option-with-checkbox {
  padding: 0.5rem 1.25rem;
}
html:not([dir=rtl]) .form-multi-select-option.form-multi-select-option-with-checkbox {
  padding-left: calc(var(--cui-form-multi-select-option-padding-x) + var(--cui-form-multi-select-option-indicator-width));
}
*[dir=rtl] .form-multi-select-option.form-multi-select-option-with-checkbox {
  padding-right: calc(var(--cui-form-multi-select-option-padding-x) + var(--cui-form-multi-select-option-indicator-width));
}
.form-multi-select-option.form-multi-select-option-with-checkbox::before {
  position: absolute;
  top: 0.7rem;
  display: block;
  width: var(--cui-form-multi-select-option-indicator-width);
  height: var(--cui-form-multi-select-option-indicator-width);
  pointer-events: none;
  content: "";
  background-color: var(--cui-form-multi-select-option-indicator-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-form-multi-select-option-indicator-border);
  border-radius: var(--cui-form-multi-select-option-indicator-border-radius);
}
html:not([dir=rtl]) .form-multi-select-option.form-multi-select-option-with-checkbox::before {
  left: calc(var(--cui-form-multi-select-option-padding-x) * 0.5);
}
*[dir=rtl] .form-multi-select-option.form-multi-select-option-with-checkbox::before {
  right: calc(var(--cui-form-multi-select-option-padding-x) * 0.5);
}
.form-multi-select-option.form-multi-selected {
  background-color: var(--cui-form-multi-select-option-selected-bg);
}
.form-multi-select-option.form-multi-selected::before {
  background-color: var(--cui-form-multi-select-option-selected-indicator-bg);
  background-image: var(--cui-form-multi-select-option-selected-indicator-bg-image);
  border-color: var(--cui-form-multi-select-option-selected-indicator-border-color);
}

.form-multi-select-optgroup-label {
  padding: 0.75rem 0.625rem 0.5rem 0.625rem;
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-tertiary-color);
  text-transform: uppercase;
}

.form-multi-select-options-empty {
  padding: var(--cui-form-multi-select-option-padding-y) var(--cui-form-multi-select-option-padding-x);
}

.form-multi-select-tag {
  display: inline-block;
  padding: var(--cui-form-multi-select-tag-padding-y) var(--cui-form-multi-select-tag-padding-x);
  margin: var(--cui-form-multi-select-tag-margin-y) var(--cui-form-multi-select-tag-margin-x);
  background-color: var(--cui-form-multi-select-tag-bg);
  border: var(--cui-form-multi-select-tag-border);
  border-radius: var(--cui-form-multi-select-tag-border-radius);
}

.form-multi-select-tag-delete {
  padding: 0;
  background-color: transparent;
  border: 0;
}
html:not([dir=rtl]) .form-multi-select-tag-delete {
  margin-left: 0.5rem;
}
*[dir=rtl] .form-multi-select-tag-delete {
  margin-right: 0.5rem;
}

.form-multi-select.show {
  color: var(--cui-form-multi-select-focus-color);
  background-color: var(--cui-form-multi-select-focus-bg);
  border-color: var(--cui-form-multi-select-focus-border-color);
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-multi-select.show .form-multi-select-search[size] {
  display: inline;
}
.form-multi-select.show .form-multi-select-dropdown {
  z-index: 1000;
  display: initial;
}

.form-multi-select-sm {
  --cui-form-multi-select-padding-y: 0.25rem;
  --cui-form-multi-select-padding-x: 0.5rem;
  --cui-form-multi-select-font-size: 0.875rem;
  --cui-form-multi-select-border-radius: var(--cui-border-radius-sm);
  --cui-form-multi-select-selection-tags-padding-x: 0.125rem;
  --cui-form-multi-select-tag-padding-y: 0;
  --cui-form-multi-select-tag-padding-x: 0.5rem;
  --cui-form-multi-select-tag-margin-y: 0.0675rem;
  --cui-form-multi-select-tag-margin-x: 0.0675rem;
  --cui-form-multi-select-tag-border-radius: 0.125rem;
}
.form-multi-select-sm.form-multi-select-selection-tags {
  min-height: calc(1.8125rem + var(--cui-border-width) * 2);
}
.form-multi-select-sm.form-multi-select-selection-tags .form-multi-select-search {
  height: calc(1.6775rem - var(--cui-border-width) * 2);
}

.form-multi-select-lg {
  --cui-form-multi-select-padding-y: 0.5rem;
  --cui-form-multi-select-padding-x: 1rem;
  --cui-form-multi-select-font-size: 1.25rem;
  --cui-form-multi-select-border-radius: var(--cui-border-radius-lg);
  --cui-form-multi-select-selection-tags-padding-x: 0.125rem;
  --cui-form-multi-select-tag-padding-y: calc(0.25rem - (var(--cui-border-width)));
  --cui-form-multi-select-tag-padding-x: 0.5rem;
  --cui-form-multi-select-tag-margin-y: 0.125rem;
  --cui-form-multi-select-tag-margin-x: 0.125rem;
  --cui-form-multi-select-tag-border-radius: 0.375rem;
}
.form-multi-select-lg.form-multi-select-selection-tags {
  min-height: calc(2.875rem + var(--cui-border-width) * 2);
}
.form-multi-select-lg.form-multi-select-selection-tags .form-multi-select-search {
  height: 2.625rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  margin-bottom: 0.125rem;
}
html:not([dir=rtl]) .form-check {
  padding-left: 1.5em;
}
*[dir=rtl] .form-check {
  padding-right: 1.5em;
}
html:not([dir=rtl]) .form-check .form-check-input {
  float: left;
}
*[dir=rtl] .form-check .form-check-input {
  float: right;
}
html:not([dir=rtl]) .form-check .form-check-input {
  margin-left: -1.5em;
}
*[dir=rtl] .form-check .form-check-input {
  margin-right: -1.5em;
}

html:not([dir=rtl]) .form-check-reverse {
  padding-right: 1.5em;
}
*[dir=rtl] .form-check-reverse {
  padding-left: 1.5em;
}
html:not([dir=rtl]) .form-check-reverse {
  padding-left: 0;
}
*[dir=rtl] .form-check-reverse {
  padding-right: 0;
}
html:not([dir=rtl]) .form-check-reverse {
  text-align: right;
}
*[dir=rtl] .form-check-reverse {
  text-align: left;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  float: right;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  float: left;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  margin-right: -1.5em;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  margin-left: -1.5em;
}
html:not([dir=rtl]) .form-check-reverse .form-check-input {
  margin-left: 0;
}
*[dir=rtl] .form-check-reverse .form-check-input {
  margin-right: 0;
}

.form-check-input {
  --cui-form-check-bg: var(--cui-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--cui-form-check-bg);
  background-image: var(--cui-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--cui-border-width) solid var(--cui-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #998fed;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-check-input:checked {
  background-color: var(--cui-form-check-input-checked-bg-color, #321fdb);
  border-color: var(--cui-form-check-input-checked-border-color, #321fdb);
}
.form-check-input:checked[type=checkbox] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:checked[type=radio] {
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #321fdb;
  border-color: #321fdb;
  --cui-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--cui-form-check-label-color, );
}

html:not([dir=rtl]) .form-switch {
  padding-left: 2.5em;
}
*[dir=rtl] .form-switch {
  padding-right: 2.5em;
}
.form-switch .form-check-input {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  width: 2em;
  background-image: var(--cui-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
html:not([dir=rtl]) .form-switch .form-check-input {
  margin-left: -2.5em;
}
*[dir=rtl] .form-switch .form-check-input {
  margin-right: -2.5em;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --cui-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
html:not([dir=rtl]) .form-switch.form-check-reverse {
  padding-right: 1.5em;
}
*[dir=rtl] .form-switch.form-check-reverse {
  padding-left: 1.5em;
}
html:not([dir=rtl]) .form-switch.form-check-reverse {
  padding-left: 0;
}
*[dir=rtl] .form-switch.form-check-reverse {
  padding-right: 0;
}
html:not([dir=rtl]) .form-switch.form-check-reverse .form-check-input {
  margin-right: -1.5em;
}
*[dir=rtl] .form-switch.form-check-reverse .form-check-input {
  margin-left: -1.5em;
}
html:not([dir=rtl]) .form-switch.form-check-reverse .form-check-input {
  margin-left: 0;
}
*[dir=rtl] .form-switch.form-check-reverse .form-check-input {
  margin-right: 0;
}

.form-switch-lg {
  min-height: 1.25em;
}
html:not([dir=rtl]) .form-switch-lg {
  padding-left: 2.25em;
}
*[dir=rtl] .form-switch-lg {
  padding-right: 2.25em;
}
.form-switch-lg .form-check-input {
  width: 1.75em;
  height: 1.25em;
}
html:not([dir=rtl]) .form-switch-lg .form-check-input {
  margin-left: -2.25em;
}
*[dir=rtl] .form-switch-lg .form-check-input {
  margin-right: -2.25em;
}
.form-switch-lg .form-check-label {
  padding-top: calc((1.25em - 1rem) / 2);
}

.form-switch-xl {
  min-height: 1.5em;
}
html:not([dir=rtl]) .form-switch-xl {
  padding-left: 2.5em;
}
*[dir=rtl] .form-switch-xl {
  padding-right: 2.5em;
}
.form-switch-xl .form-check-input {
  width: 2em;
  height: 1.5em;
}
html:not([dir=rtl]) .form-switch-xl .form-check-input {
  margin-left: -2.5em;
}
*[dir=rtl] .form-switch-xl .form-check-input {
  margin-right: -2.5em;
}
.form-switch-xl .form-check-label {
  padding-top: calc((1.5em - 1rem) / 2);
}

.form-check-inline {
  display: inline-block;
}
html:not([dir=rtl]) .form-check-inline {
  margin-right: 1rem;
}
*[dir=rtl] .form-check-inline {
  margin-left: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #321fdb);
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, #c2bcf4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-secondary-bg));
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: var(--cui-form-range-thumb-bg, #321fdb);
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: var(--cui-form-range-thumb-active-bg, #c2bcf4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--cui-form-range-track-bg, var(--cui-secondary-bg));
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--cui-form-range-thumb-disabled-bg, var(--cui-secondary-color));
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--cui-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--cui-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
html:not([dir=rtl]) .form-floating > label {
  left: 0;
}
*[dir=rtl] .form-floating > label {
  right: 0;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--cui-body-bg);
  border-radius: var(--cui-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--cui-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--cui-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #8a93a2;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--cui-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--cui-input-group-addon-color, var(--cui-body-color));
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-input-group-addon-bg, var(--cui-tertiary-bg));
  border: var(--cui-border-width) solid var(--cui-input-group-addon-border-color, var(--cui-border-color));
  border-radius: var(--cui-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--cui-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--cui-border-radius-sm);
}

html:not([dir=rtl]) .input-group-lg > .form-select,
html:not([dir=rtl]) .input-group-sm > .form-select {
  padding-right: 3rem;
}
*[dir=rtl] .input-group-lg > .form-select,
*[dir=rtl] .input-group-sm > .form-select {
  padding-left: 3rem;
}

html:not([dir=rtl]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
}
*[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
html:not([dir=rtl]) .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
*[dir=rtl] .input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
}
*[dir=rtl] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
html:not([dir=rtl]) .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
html:not([dir=rtl]) .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
*[dir=rtl] .input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
*[dir=rtl] .input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-left-radius: 0;
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  border-bottom-right-radius: 0;
}
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-control,
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
}
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-control,
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-select {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-control,
html:not([dir=rtl]) .input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-control,
*[dir=rtl] .input-group > .form-floating:not(:first-child) > .form-select {
  border-bottom-right-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-success);
  border-radius: var(--cui-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--cui-form-valid-border-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-control:valid, html:not([dir=rtl]) .form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated .form-control:valid, *[dir=rtl] .form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated .form-control:valid, html:not([dir=rtl]) .form-control.is-valid {
  background-position: right calc(0.375em + 0.1875rem) center;
}
*[dir=rtl] .was-validated .form-control:valid, *[dir=rtl] .form-control.is-valid {
  background-position: left calc(0.375em + 0.1875rem) center;
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

html:not([dir=rtl]) .was-validated textarea.form-control:valid, html:not([dir=rtl]) textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated textarea.form-control:valid, *[dir=rtl] textarea.form-control.is-valid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated textarea.form-control:valid, html:not([dir=rtl]) textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
*[dir=rtl] .was-validated textarea.form-control:valid, *[dir=rtl] textarea.form-control.is-valid {
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
}
*[dir=rtl] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-valid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-valid:not([multiple])[size="1"] {
  padding-left: 4.125rem;
}
html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:valid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-valid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-valid:not([multiple])[size="1"] {
  background-position: right 0.75rem center, center right 2.25rem;
}
*[dir=rtl] .was-validated .form-select:valid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:valid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-valid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-valid:not([multiple])[size="1"] {
  background-position: left 0.75rem center, center left 2.25rem;
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--cui-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--cui-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--cui-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--cui-form-valid-color);
}

html:not([dir=rtl]) .form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}
*[dir=rtl] .form-check-inline .form-check-input ~ .valid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--cui-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--cui-danger);
  border-radius: var(--cui-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-control:invalid, html:not([dir=rtl]) .form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated .form-control:invalid, *[dir=rtl] .form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated .form-control:invalid, html:not([dir=rtl]) .form-control.is-invalid {
  background-position: right calc(0.375em + 0.1875rem) center;
}
*[dir=rtl] .was-validated .form-control:invalid, *[dir=rtl] .form-control.is-invalid {
  background-position: left calc(0.375em + 0.1875rem) center;
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

html:not([dir=rtl]) .was-validated textarea.form-control:invalid, html:not([dir=rtl]) textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
}
*[dir=rtl] .was-validated textarea.form-control:invalid, *[dir=rtl] textarea.form-control.is-invalid {
  padding-left: calc(1.5em + 0.75rem);
}
html:not([dir=rtl]) .was-validated textarea.form-control:invalid, html:not([dir=rtl]) textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}
*[dir=rtl] .was-validated textarea.form-control:invalid, *[dir=rtl] textarea.form-control.is-invalid {
  background-position: top calc(0.375em + 0.1875rem) left calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --cui-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
}
*[dir=rtl] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-invalid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-invalid:not([multiple])[size="1"] {
  padding-left: 4.125rem;
}
html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple]):not([size]), html:not([dir=rtl]) .was-validated .form-select:invalid:not([multiple])[size="1"], html:not([dir=rtl]) .form-select.is-invalid:not([multiple]):not([size]), html:not([dir=rtl]) .form-select.is-invalid:not([multiple])[size="1"] {
  background-position: right 0.75rem center, center right 2.25rem;
}
*[dir=rtl] .was-validated .form-select:invalid:not([multiple]):not([size]), *[dir=rtl] .was-validated .form-select:invalid:not([multiple])[size="1"], *[dir=rtl] .form-select.is-invalid:not([multiple]):not([size]), *[dir=rtl] .form-select.is-invalid:not([multiple])[size="1"] {
  background-position: left 0.75rem center, center left 2.25rem;
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--cui-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--cui-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--cui-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--cui-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--cui-form-invalid-color);
}

html:not([dir=rtl]) .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}
*[dir=rtl] .form-check-inline .form-check-input ~ .invalid-feedback {
  margin-right: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --cui-btn-padding-x: 0.75rem;
  --cui-btn-padding-y: 0.375rem;
  --cui-btn-font-family: ;
  --cui-btn-font-size: 1rem;
  --cui-btn-font-weight: 400;
  --cui-btn-line-height: 1.5;
  --cui-btn-color: var(--cui-body-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-width: var(--cui-border-width);
  --cui-btn-border-color: transparent;
  --cui-btn-border-radius: var(--cui-border-radius);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 21, 0.075);
  --cui-btn-disabled-opacity: 0.65;
  --cui-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--cui-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--cui-btn-padding-y) var(--cui-btn-padding-x);
  font-family: var(--cui-btn-font-family);
  font-size: var(--cui-btn-font-size);
  font-weight: var(--cui-btn-font-weight);
  line-height: var(--cui-btn-line-height);
  color: var(--cui-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--cui-btn-border-width) solid var(--cui-btn-border-color);
  border-radius: var(--cui-btn-border-radius);
  background-color: var(--cui-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:not(.placeholder):not([class*=link]):not([class*=outline]):not([class*=ghost]):not([class*=transparent]):not([class*=close]) {
  border-color: transparent;
  box-shadow: 0 1px 1px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 2px 1px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 3px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.btn:hover {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
}
.btn:hover:not(.placeholder):not([class*=link]):not([class*=outline]):not([class*=ghost]):not([class*=transparent]):not([class*=close]) {
  border-color: transparent;
  box-shadow: 0 2px 2px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 1px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.btn-check + .btn:hover {
  color: var(--cui-btn-color);
  background-color: var(--cui-btn-bg);
  border-color: var(--cui-btn-border-color);
}
.btn:focus-visible {
  color: var(--cui-btn-hover-color);
  background-color: var(--cui-btn-hover-bg);
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--cui-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--cui-btn-active-color);
  background-color: var(--cui-btn-active-bg);
  border-color: var(--cui-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--cui-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--cui-btn-disabled-color);
  pointer-events: none;
  background-color: var(--cui-btn-disabled-bg);
  border-color: var(--cui-btn-disabled-border-color);
  opacity: var(--cui-btn-disabled-opacity);
}

.btn-primary {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #321fdb;
  --cui-btn-border-color: #321fdb;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #5141e0;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #321fdb;
  --cui-btn-disabled-border-color: #321fdb;
}

.btn-secondary {
  --cui-btn-color: #000015;
  --cui-btn-bg: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 133, 140, 154;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #9da5b1;
  --cui-btn-disabled-border-color: #9da5b1;
}

.btn-success {
  --cui-btn-color: #000015;
  --cui-btn-bg: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 39, 156, 81;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #2eb85c;
  --cui-btn-disabled-border-color: #2eb85c;
}

.btn-danger {
  --cui-btn-color: #000015;
  --cui-btn-bg: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 195, 71, 74;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #e55353;
  --cui-btn-disabled-border-color: #e55353;
}

.btn-warning {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-focus-shadow-rgb: 221, 160, 28;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #f9b115;
  --cui-btn-disabled-border-color: #f9b115;
}

.btn-info {
  --cui-btn-color: #000015;
  --cui-btn-bg: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 43, 130, 220;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #39f;
  --cui-btn-disabled-border-color: #39f;
}

.btn-light {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-focus-shadow-rgb: 209, 212, 216;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #ebedef;
  --cui-btn-disabled-border-color: #ebedef;
}

.btn-dark {
  --cui-btn-color: rgba(255, 255, 255, 0.87);
  --cui-btn-bg: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #697588;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-focus-shadow-rgb: 100, 112, 132;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-bg: #4f5d73;
  --cui-btn-disabled-border-color: #4f5d73;
}

.btn-outline-primary {
  --cui-btn-color: #321fdb;
  --cui-btn-border-color: #321fdb;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-hover-bg: #5b4ce2;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-focus-shadow-rgb: 50, 31, 219;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #321fdb;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-border-color: #9da5b1;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #b1b7c1;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-focus-shadow-rgb: 157, 165, 177;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-border-color: #2eb85c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #58c67d;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-focus-shadow-rgb: 46, 184, 92;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-danger {
  --cui-btn-color: #e55353;
  --cui-btn-border-color: #e55353;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #ea7575;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-focus-shadow-rgb: 229, 83, 83;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #e55353;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-border-color: #f9b115;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #c78e11;
  --cui-btn-hover-border-color: #bb8510;
  --cui-btn-focus-shadow-rgb: 249, 177, 21;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-info {
  --cui-btn-color: #39f;
  --cui-btn-border-color: #39f;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #5cadff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-focus-shadow-rgb: 51, 153, 255;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #39f;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-light {
  --cui-btn-color: #ebedef;
  --cui-btn-border-color: #ebedef;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-hover-bg: #bcbebf;
  --cui-btn-hover-border-color: #b0b2b3;
  --cui-btn-focus-shadow-rgb: 235, 237, 239;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-outline-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-border-color: #4f5d73;
  --cui-btn-hover-color: #fff;
  --cui-btn-hover-bg: #727d8f;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-focus-shadow-rgb: 79, 93, 115;
  --cui-btn-active-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}

.btn-ghost-primary {
  --cui-btn-color: #321fdb;
  --cui-btn-hover-bg: #5141e0;
  --cui-btn-hover-border-color: #4735df;
  --cui-btn-hover-color: rgba(255, 255, 255, 0.87);
  --cui-btn-active-bg: #5b4ce2;
  --cui-btn-active-border-color: #4735df;
  --cui-btn-active-color: rgba(255, 255, 255, 0.87);
  --cui-btn-disabled-color: #321fdb;
  --cui-btn-shadow: rgba(50, 31, 219, 0.5);
}

.btn-ghost-secondary {
  --cui-btn-color: #9da5b1;
  --cui-btn-hover-bg: #acb3bd;
  --cui-btn-hover-border-color: #a7aeb9;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #b1b7c1;
  --cui-btn-active-border-color: #a7aeb9;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #9da5b1;
  --cui-btn-shadow: rgba(157, 165, 177, 0.5);
}

.btn-ghost-success {
  --cui-btn-color: #2eb85c;
  --cui-btn-hover-bg: #4dc374;
  --cui-btn-hover-border-color: #43bf6c;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #58c67d;
  --cui-btn-active-border-color: #43bf6c;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #2eb85c;
  --cui-btn-shadow: rgba(46, 184, 92, 0.5);
}

.btn-ghost-danger {
  --cui-btn-color: #e55353;
  --cui-btn-hover-bg: #e96d6d;
  --cui-btn-hover-border-color: #e86464;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #ea7575;
  --cui-btn-active-border-color: #e86464;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #e55353;
  --cui-btn-shadow: rgba(229, 83, 83, 0.5);
}

.btn-ghost-warning {
  --cui-btn-color: #f9b115;
  --cui-btn-hover-bg: #d49612;
  --cui-btn-hover-border-color: #c78e11;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #c78e11;
  --cui-btn-active-border-color: #bb8510;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #f9b115;
  --cui-btn-shadow: rgba(249, 177, 21, 0.5);
}

.btn-ghost-info {
  --cui-btn-color: #39f;
  --cui-btn-hover-bg: #52a8ff;
  --cui-btn-hover-border-color: #47a3ff;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #5cadff;
  --cui-btn-active-border-color: #47a3ff;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #39f;
  --cui-btn-shadow: rgba(51, 153, 255, 0.5);
}

.btn-ghost-light {
  --cui-btn-color: #ebedef;
  --cui-btn-hover-bg: #c8c9cb;
  --cui-btn-hover-border-color: #bcbebf;
  --cui-btn-hover-color: rgba(44, 56, 74, 0.95);
  --cui-btn-active-bg: #bcbebf;
  --cui-btn-active-border-color: #b0b2b3;
  --cui-btn-active-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-color: #ebedef;
  --cui-btn-shadow: rgba(235, 237, 239, 0.5);
}

.btn-ghost-dark {
  --cui-btn-color: #4f5d73;
  --cui-btn-hover-bg: #697588;
  --cui-btn-hover-border-color: #616d81;
  --cui-btn-hover-color: #fff;
  --cui-btn-active-bg: #727d8f;
  --cui-btn-active-border-color: #616d81;
  --cui-btn-active-color: #fff;
  --cui-btn-disabled-color: #4f5d73;
  --cui-btn-shadow: rgba(79, 93, 115, 0.5);
}

.btn-transparent {
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-hover-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
}

.btn-link {
  --cui-btn-font-weight: 400;
  --cui-btn-color: var(--cui-link-color);
  --cui-btn-bg: transparent;
  --cui-btn-border-color: transparent;
  --cui-btn-hover-color: var(--cui-link-hover-color);
  --cui-btn-hover-border-color: transparent;
  --cui-btn-active-border-color: transparent;
  --cui-btn-disabled-color: #8a93a2;
  --cui-btn-disabled-border-color: transparent;
  --cui-btn-box-shadow: none;
  --cui-btn-focus-shadow-rgb: 75, 58, 223;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--cui-btn-color);
}

.btn-lg, .btn-group-lg > .btn {
  --cui-btn-padding-y: 0.5rem;
  --cui-btn-padding-x: 1rem;
  --cui-btn-font-size: 1.25rem;
  --cui-btn-border-radius: var(--cui-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --cui-btn-padding-y: 0.25rem;
  --cui-btn-padding-x: 0.5rem;
  --cui-btn-font-size: 0.875rem;
  --cui-btn-border-radius: var(--cui-border-radius-sm);
}

.btn-loading {
  position: relative;
  overflow: hidden;
}

.btn-loading-spinner {
  opacity: 0;
  transition: margin 0.15s, opacity 0.15s, border 0.15s;
}
html:not([dir=rtl]) .btn-loading-spinner {
  margin-right: 1rem;
}
*[dir=rtl] .btn-loading-spinner {
  margin-left: 1rem;
}
html:not([dir=rtl]) .btn-loading-spinner {
  margin-left: -2rem;
}
*[dir=rtl] .btn-loading-spinner {
  margin-right: -2rem;
}
@media (prefers-reduced-motion: reduce) {
  .btn-loading-spinner {
    transition: none;
  }
}

.btn-loading.is-loading .btn-loading-spinner {
  width: 1rem;
  opacity: 1;
}
html:not([dir=rtl]) .btn-loading.is-loading .btn-loading-spinner {
  margin-left: 0;
}
*[dir=rtl] .btn-loading.is-loading .btn-loading-spinner {
  margin-right: 0;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropdown-toggle::after {
  margin-right: 0.255em;
}
html:not([dir=rtl]) .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropdown-menu {
  --cui-dropdown-zindex: 1000;
  --cui-dropdown-min-width: 10rem;
  --cui-dropdown-padding-x: 0;
  --cui-dropdown-padding-y: 0.5rem;
  --cui-dropdown-spacer: 0.125rem;
  --cui-dropdown-font-size: 1rem;
  --cui-dropdown-color: var(--cui-body-color);
  --cui-dropdown-bg: var(--cui-body-bg);
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-border-radius: var(--cui-border-radius);
  --cui-dropdown-border-width: var(--cui-border-width);
  --cui-dropdown-inner-border-radius: calc(var(--cui-border-radius) - var(--cui-border-width));
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-divider-margin-y: 0.5rem;
  --cui-dropdown-box-shadow: var(--cui-box-shadow);
  --cui-dropdown-link-color: var(--cui-body-color);
  --cui-dropdown-link-hover-color: var(--cui-body-color);
  --cui-dropdown-link-hover-bg: var(--cui-tertiary-bg);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #321fdb;
  --cui-dropdown-link-disabled-color: var(--cui-tertiary-color);
  --cui-dropdown-item-padding-x: 1rem;
  --cui-dropdown-item-padding-y: 0.25rem;
  --cui-dropdown-header-color: #8a93a2;
  --cui-dropdown-header-padding-x: 1rem;
  --cui-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--cui-dropdown-zindex);
  display: none;
  min-width: var(--cui-dropdown-min-width);
  padding: var(--cui-dropdown-padding-y) var(--cui-dropdown-padding-x);
  margin: 0;
  font-size: var(--cui-dropdown-font-size);
  color: var(--cui-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--cui-dropdown-bg);
  background-clip: padding-box;
  border: var(--cui-dropdown-border-width) solid var(--cui-dropdown-border-color);
  border-radius: var(--cui-dropdown-border-radius);
  box-shadow: 0 4px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 1px 10px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 2px 4px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.dropdown-menu:not([class*=border]) {
  border: 0;
}
.dropdown-menu[data-coreui-popper] {
  top: 100%;
  margin-top: var(--cui-dropdown-spacer);
}
html:not([dir=rtl]) .dropdown-menu[data-coreui-popper] {
  left: 0;
}
*[dir=rtl] .dropdown-menu[data-coreui-popper] {
  right: 0;
}

.dropdown-menu-start {
  --cui-position: start;
}
html:not([dir=rtl]) .dropdown-menu-start[data-coreui-popper] {
  right: auto;
}
*[dir=rtl] .dropdown-menu-start[data-coreui-popper] {
  left: auto;
}
html:not([dir=rtl]) .dropdown-menu-start[data-coreui-popper] {
  left: 0;
}
*[dir=rtl] .dropdown-menu-start[data-coreui-popper] {
  right: 0;
}

.dropdown-menu-end {
  --cui-position: end;
}
html:not([dir=rtl]) .dropdown-menu-end[data-coreui-popper] {
  right: 0;
}
*[dir=rtl] .dropdown-menu-end[data-coreui-popper] {
  left: 0;
}
html:not([dir=rtl]) .dropdown-menu-end[data-coreui-popper] {
  left: auto;
}
*[dir=rtl] .dropdown-menu-end[data-coreui-popper] {
  right: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-sm-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-sm-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-sm-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-sm-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-sm-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-sm-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-md-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-md-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-md-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-md-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-md-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-md-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-md-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-md-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-md-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-lg-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-lg-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-lg-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-lg-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-lg-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-lg-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-xl-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-xl-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-xl-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-xl-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-xl-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-xl-end[data-coreui-popper] {
    right: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --cui-position: start;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-start[data-coreui-popper] {
    right: auto;
  }
  *[dir=rtl] .dropdown-menu-xxl-start[data-coreui-popper] {
    left: auto;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-start[data-coreui-popper] {
    left: 0;
  }
  *[dir=rtl] .dropdown-menu-xxl-start[data-coreui-popper] {
    right: 0;
  }
  .dropdown-menu-xxl-end {
    --cui-position: end;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-end[data-coreui-popper] {
    right: 0;
  }
  *[dir=rtl] .dropdown-menu-xxl-end[data-coreui-popper] {
    left: 0;
  }
  html:not([dir=rtl]) .dropdown-menu-xxl-end[data-coreui-popper] {
    left: auto;
  }
  *[dir=rtl] .dropdown-menu-xxl-end[data-coreui-popper] {
    right: auto;
  }
}
.dropup .dropdown-menu[data-coreui-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--cui-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropup .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropup .dropdown-toggle::after {
  margin-right: 0.255em;
}
html:not([dir=rtl]) .dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropup .dropdown-toggle:empty::after {
  margin-right: 0;
}

.dropend .dropdown-menu[data-coreui-popper] {
  top: 0;
  margin-top: 0;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  right: auto;
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  left: auto;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  left: 100%;
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  right: 100%;
}
html:not([dir=rtl]) .dropend .dropdown-menu[data-coreui-popper] {
  margin-left: var(--cui-dropdown-spacer);
}
*[dir=rtl] .dropend .dropdown-menu[data-coreui-popper] {
  margin-right: var(--cui-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
html:not([dir=rtl]) .dropend .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropend .dropdown-toggle::after {
  margin-right: 0.255em;
}
html:not([dir=rtl]) .dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropend .dropdown-toggle:empty::after {
  margin-right: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-coreui-popper] {
  top: 0;
  margin-top: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  right: 100%;
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  left: 100%;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  left: auto;
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  right: auto;
}
html:not([dir=rtl]) .dropstart .dropdown-menu[data-coreui-popper] {
  margin-right: var(--cui-dropdown-spacer);
}
*[dir=rtl] .dropstart .dropdown-menu[data-coreui-popper] {
  margin-left: var(--cui-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
}
html:not([dir=rtl]) .dropstart .dropdown-toggle::after {
  margin-left: 0.255em;
}
*[dir=rtl] .dropstart .dropdown-toggle::after {
  margin-right: 0.255em;
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle::before {
  margin-right: 0.255em;
}
*[dir=rtl] .dropstart .dropdown-toggle::before {
  margin-left: 0.255em;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
*[dir=rtl] .dropstart .dropdown-toggle:empty::after {
  margin-right: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--cui-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--cui-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--cui-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--cui-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--cui-dropdown-link-hover-color);
  background-color: var(--cui-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--cui-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--cui-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--cui-dropdown-header-padding-y) var(--cui-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--cui-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--cui-dropdown-item-padding-y) var(--cui-dropdown-item-padding-x);
  color: var(--cui-dropdown-link-color);
}

.dropdown-menu-dark {
  --cui-dropdown-color: #c4c9d0;
  --cui-dropdown-bg: #636f83;
  --cui-dropdown-border-color: var(--cui-border-color-translucent);
  --cui-dropdown-box-shadow: ;
  --cui-dropdown-link-color: #c4c9d0;
  --cui-dropdown-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-divider-bg: var(--cui-border-color-translucent);
  --cui-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --cui-dropdown-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-active-bg: #321fdb;
  --cui-dropdown-link-disabled-color: #9da5b1;
  --cui-dropdown-header-color: #9da5b1;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--cui-border-radius);
}
html:not([dir=rtl]) .btn-group > :not(.btn-check:first-child) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .btn-group > :not(.btn-check:first-child) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir=rtl]) .btn-group > .btn.dropdown-toggle-split:first-child,
html:not([dir=rtl]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
}
*[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir=rtl] .btn-group > .btn.dropdown-toggle-split:first-child,
*[dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
html:not([dir=rtl]) .btn-group > .btn.dropdown-toggle-split:first-child,
html:not([dir=rtl]) .btn-group > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
*[dir=rtl] .btn-group > .btn.dropdown-toggle-split:first-child,
*[dir=rtl] .btn-group > .btn-group:not(:last-child) > .btn {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:nth-child(n+3),
html:not([dir=rtl]) .btn-group > :not(.btn-check) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
}
*[dir=rtl] .btn-group > .btn:nth-child(n+3),
*[dir=rtl] .btn-group > :not(.btn-check) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .btn-group > .btn:nth-child(n+3),
html:not([dir=rtl]) .btn-group > :not(.btn-check) + .btn,
html:not([dir=rtl]) .btn-group > .btn-group:not(:first-child) > .btn {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .btn-group > .btn:nth-child(n+3),
*[dir=rtl] .btn-group > :not(.btn-check) + .btn,
*[dir=rtl] .btn-group > .btn-group:not(:first-child) > .btn {
  border-bottom-right-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
html:not([dir=rtl]) .dropdown-toggle-split::after, html:not([dir=rtl]) .dropup .dropdown-toggle-split::after, html:not([dir=rtl]) .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
*[dir=rtl] .dropdown-toggle-split::after, *[dir=rtl] .dropup .dropdown-toggle-split::after, *[dir=rtl] .dropend .dropdown-toggle-split::after {
  margin-right: 0;
}
html:not([dir=rtl]) .dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}
*[dir=rtl] .dropstart .dropdown-toggle-split::before {
  margin-left: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--cui-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --cui-nav-link-padding-x: 1rem;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-link-color);
  --cui-nav-link-hover-color: var(--cui-link-hover-color);
  --cui-nav-link-disabled-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .nav {
  padding-left: 0;
}
*[dir=rtl] .nav {
  padding-right: 0;
}

.nav-link {
  display: block;
  padding: var(--cui-nav-link-padding-y) var(--cui-nav-link-padding-x);
  font-size: var(--cui-nav-link-font-size);
  font-weight: var(--cui-nav-link-font-weight);
  color: var(--cui-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--cui-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--cui-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --cui-nav-tabs-border-width: var(--cui-border-width);
  --cui-nav-tabs-border-color: var(--cui-border-color);
  --cui-nav-tabs-border-radius: var(--cui-border-radius);
  --cui-nav-tabs-link-hover-border-color: var(--cui-secondary-bg) var(--cui-secondary-bg) var(--cui-border-color);
  --cui-nav-tabs-link-active-color: var(--cui-emphasis-color);
  --cui-nav-tabs-link-active-bg: var(--cui-body-bg);
  --cui-nav-tabs-link-active-border-color: var(--cui-border-color) var(--cui-border-color) var(--cui-body-bg);
  border-bottom: var(--cui-nav-tabs-border-width) solid var(--cui-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--cui-nav-tabs-border-width));
  border: var(--cui-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--cui-nav-tabs-border-radius);
  border-top-right-radius: var(--cui-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--cui-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--cui-nav-tabs-link-active-color);
  background-color: var(--cui-nav-tabs-link-active-bg);
  border-color: var(--cui-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--cui-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --cui-nav-pills-border-radius: var(--cui-border-radius);
  --cui-nav-pills-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-pills-link-active-bg: #321fdb;
}
.nav-pills .nav-link {
  border-radius: var(--cui-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--cui-nav-pills-link-active-color);
  background-color: var(--cui-nav-pills-link-active-bg);
}

.nav-underline {
  border-bottom: 2px solid var(--cui-nav-underline-border-color, #c4c9d0);
}
.nav-underline .nav-item {
  margin-bottom: -2px;
}
.nav-underline .nav-link {
  color: var(--cui-nav-underline-link-color, #768192);
  border-bottom: 2px solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-color: var(--cui-nav-underline-link-active-border-color, #321fdb);
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  color: var(--cui-nav-underline-link-active-color, #321fdb);
  background: transparent;
  border-color: var(--cui-nav-underline-link-active-border-color, #321fdb);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --cui-navbar-padding-x: 0;
  --cui-navbar-padding-y: 0.5rem;
  --cui-navbar-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-navbar-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-navbar-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-navbar-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-padding-y: 0.3125rem;
  --cui-navbar-brand-margin-end: 1rem;
  --cui-navbar-brand-font-size: 1.25rem;
  --cui-navbar-brand-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-brand-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-navbar-nav-link-padding-x: 0.5rem;
  --cui-navbar-toggler-padding-y: 0.25rem;
  --cui-navbar-toggler-padding-x: 0.75rem;
  --cui-navbar-toggler-font-size: 1.25rem;
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --cui-navbar-toggler-border-color: rgba(var(--cui-emphasis-color-rgb), 0.15);
  --cui-navbar-toggler-border-radius: var(--cui-border-radius);
  --cui-navbar-toggler-focus-width: 0.25rem;
  --cui-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-navbar-padding-y) var(--cui-navbar-padding-x);
}
.navbar .header > .container,
.navbar .header > .container-fluid,
.navbar .header > .container-sm,
.navbar .header > .container-md,
.navbar .header > .container-lg,
.navbar .header > .container-xl,
.navbar .header > .container-xxl, .navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--cui-navbar-brand-padding-y);
  padding-bottom: var(--cui-navbar-brand-padding-y);
  font-size: var(--cui-navbar-brand-font-size);
  color: var(--cui-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
html:not([dir=rtl]) .navbar-brand {
  margin-right: var(--cui-navbar-brand-margin-end);
}
*[dir=rtl] .navbar-brand {
  margin-left: var(--cui-navbar-brand-margin-end);
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--cui-navbar-brand-hover-color);
}

.navbar-nav {
  --cui-nav-link-padding-x: 0;
  --cui-nav-link-padding-y: 0.5rem;
  --cui-nav-link-font-weight: ;
  --cui-nav-link-color: var(--cui-navbar-color);
  --cui-nav-link-hover-color: var(--cui-navbar-hover-color);
  --cui-nav-link-disabled-color: var(--cui-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .navbar-nav {
  padding-left: 0;
}
*[dir=rtl] .navbar-nav {
  padding-right: 0;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--cui-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--cui-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--cui-navbar-toggler-padding-y) var(--cui-navbar-toggler-padding-x);
  font-size: var(--cui-navbar-toggler-font-size);
  line-height: 1;
  color: var(--cui-navbar-color);
  background-color: transparent;
  border: var(--cui-border-width) solid var(--cui-navbar-toggler-border-color);
  border-radius: var(--cui-navbar-toggler-border-radius);
  transition: var(--cui-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--cui-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--cui-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--cui-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--cui-navbar-nav-link-padding-x);
    padding-left: var(--cui-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--cui-navbar-nav-link-padding-x);
  padding-left: var(--cui-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --cui-navbar-color: rgba(255, 255, 255, 0.55);
  --cui-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --cui-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-navbar-active-color: #fff;
  --cui-navbar-brand-color: #fff;
  --cui-navbar-brand-hover-color: #fff;
  --cui-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.card {
  --cui-card-spacer-y: 1rem;
  --cui-card-spacer-x: 1rem;
  --cui-card-title-spacer-y: 0.5rem;
  --cui-card-title-color: ;
  --cui-card-subtitle-color: ;
  --cui-card-border-width: var(--cui-border-width);
  --cui-card-border-color: var(--cui-border-color-translucent);
  --cui-card-border-radius: var(--cui-border-radius);
  --cui-card-box-shadow: ;
  --cui-card-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-card-cap-padding-y: 0.5rem;
  --cui-card-cap-padding-x: 1rem;
  --cui-card-cap-bg: rgba(var(--cui-body-color-rgb), 0.03);
  --cui-card-cap-color: ;
  --cui-card-height: ;
  --cui-card-color: ;
  --cui-card-bg: var(--cui-body-bg);
  --cui-card-img-overlay-padding: 1rem;
  --cui-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--cui-card-height);
  color: var(--cui-body-color);
  word-wrap: break-word;
  background-color: var(--cui-card-bg);
  background-clip: border-box;
  border: var(--cui-card-border-width) solid var(--cui-card-border-color);
  border-radius: var(--cui-card-border-radius);
  box-shadow: 0 1px 1px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 2px 1px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 3px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.card:not([class*=border]) {
  border: 0;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--cui-card-spacer-y) var(--cui-card-spacer-x);
  color: var(--cui-card-color);
}

.card-title {
  margin-bottom: var(--cui-card-title-spacer-y);
  color: var(--cui-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--cui-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--cui-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

html:not([dir=rtl]) .card-link + .card-link {
  margin-left: var(--cui-card-spacer-x);
}
*[dir=rtl] .card-link + .card-link {
  margin-right: var(--cui-card-spacer-x);
}

.card-header {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-bottom: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-header:first-child {
  border-radius: var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--cui-card-cap-padding-y) var(--cui-card-cap-padding-x);
  color: var(--cui-card-cap-color);
  background-color: var(--cui-card-cap-bg);
  border-top: var(--cui-card-border-width) solid var(--cui-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--cui-card-inner-border-radius) var(--cui-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--cui-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--cui-card-bg);
  border-bottom-color: var(--cui-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--cui-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--cui-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--cui-card-img-overlay-padding);
  border-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--cui-card-inner-border-radius);
  border-top-right-radius: var(--cui-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--cui-card-inner-border-radius);
  border-bottom-left-radius: var(--cui-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--cui-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  html:not([dir=rtl]) .card-group > .card + .card {
    margin-left: 0;
  }
  *[dir=rtl] .card-group > .card + .card {
    margin-right: 0;
  }
  html:not([dir=rtl]) .card-group > .card + .card {
    border-left: 0;
  }
  *[dir=rtl] .card-group > .card + .card {
    border-right: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:last-child) {
    border-bottom-right-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:last-child) {
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:first-child) {
    border-top-right-radius: 0;
  }
  html:not([dir=rtl]) .card-group > .card:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .card-group > .card:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --cui-accordion-color: var(--cui-body-color);
  --cui-accordion-bg: var(--cui-body-bg);
  --cui-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --cui-accordion-border-color: var(--cui-border-color);
  --cui-accordion-border-width: var(--cui-border-width);
  --cui-accordion-border-radius: var(--cui-border-radius);
  --cui-accordion-inner-border-radius: calc(var(--cui-border-radius) - (var(--cui-border-width)));
  --cui-accordion-btn-padding-x: 1.25rem;
  --cui-accordion-btn-padding-y: 1rem;
  --cui-accordion-btn-color: var(--cui-body-color);
  --cui-accordion-btn-bg: var(--cui-accordion-bg);
  --cui-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --cui-accordion-btn-icon-width: 1.25rem;
  --cui-accordion-btn-icon-transform: rotate(-180deg);
  --cui-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --cui-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --cui-accordion-btn-focus-border-color: #998fed;
  --cui-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-accordion-body-padding-x: 1.25rem;
  --cui-accordion-body-padding-y: 1rem;
  --cui-accordion-active-color: #2d1cc5;
  --cui-accordion-active-bg: #ebe9fb;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--cui-accordion-btn-padding-y) var(--cui-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--cui-accordion-btn-color);
  text-align: left;
  background-color: var(--cui-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--cui-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--cui-accordion-active-color);
  background-color: var(--cui-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--cui-accordion-border-width)) 0 var(--cui-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--cui-accordion-btn-active-icon);
  transform: var(--cui-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--cui-accordion-btn-icon-width);
  height: var(--cui-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--cui-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--cui-accordion-btn-icon-width);
  transition: var(--cui-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--cui-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--cui-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--cui-accordion-color);
  background-color: var(--cui-accordion-bg);
  border: var(--cui-accordion-border-width) solid var(--cui-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--cui-accordion-border-radius);
  border-top-right-radius: var(--cui-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--cui-accordion-inner-border-radius);
  border-top-right-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--cui-accordion-inner-border-radius);
  border-bottom-left-radius: var(--cui-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--cui-accordion-border-radius);
  border-bottom-left-radius: var(--cui-accordion-border-radius);
}

.accordion-body {
  padding: var(--cui-accordion-body-padding-y) var(--cui-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --cui-breadcrumb-padding-x: 0;
  --cui-breadcrumb-padding-y: 0;
  --cui-breadcrumb-margin-bottom: 1rem;
  --cui-breadcrumb-bg: ;
  --cui-breadcrumb-border-radius: ;
  --cui-breadcrumb-divider-color: var(--cui-secondary-color);
  --cui-breadcrumb-item-padding-x: 0.5rem;
  --cui-breadcrumb-item-active-color: var(--cui-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--cui-breadcrumb-padding-y) var(--cui-breadcrumb-padding-x);
  margin-bottom: var(--cui-breadcrumb-margin-bottom);
  font-size: var(--cui-breadcrumb-font-size);
  list-style: none;
  background-color: var(--cui-breadcrumb-bg);
  border-radius: var(--cui-breadcrumb-border-radius);
}

html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item {
  padding-right: var(--cui-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  color: var(--cui-breadcrumb-divider-color);
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  float: left;
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  float: right;
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  padding-right: var(--cui-breadcrumb-item-padding-x);
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  padding-left: var(--cui-breadcrumb-item-padding-x);
}
html:not([dir=rtl]) .breadcrumb-item + .breadcrumb-item::before {
  content: var(--cui-breadcrumb-divider, "/");
}
*[dir=rtl] .breadcrumb-item + .breadcrumb-item::before {
  content: var(--cui-breadcrumb-divider-flipped, "/");
}
.breadcrumb-item.active {
  color: var(--cui-breadcrumb-item-active-color);
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: var(--cui-link-color);
  --cui-pagination-bg: var(--cui-body-bg);
  --cui-pagination-border-width: var(--cui-border-width);
  --cui-pagination-border-color: var(--cui-border-color);
  --cui-pagination-border-radius: var(--cui-border-radius);
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: var(--cui-tertiary-bg);
  --cui-pagination-hover-border-color: var(--cui-border-color);
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: var(--cui-secondary-bg);
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-pagination-active-color: rgba(255, 255, 255, 0.87);
  --cui-pagination-active-bg: #321fdb;
  --cui-pagination-active-border-color: #321fdb;
  --cui-pagination-disabled-color: var(--cui-secondary-color);
  --cui-pagination-disabled-bg: var(--cui-secondary-bg);
  --cui-pagination-disabled-border-color: var(--cui-border-color);
  display: flex;
  list-style: none;
}
html:not([dir=rtl]) .pagination {
  padding-left: 0;
}
*[dir=rtl] .pagination {
  padding-right: 0;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--cui-pagination-padding-y) var(--cui-pagination-padding-x);
  font-size: var(--cui-pagination-font-size);
  color: var(--cui-pagination-color);
  text-decoration: none;
  background-color: var(--cui-pagination-bg);
  border: var(--cui-pagination-border-width) solid var(--cui-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--cui-pagination-hover-color);
  background-color: var(--cui-pagination-hover-bg);
  border-color: var(--cui-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--cui-pagination-focus-color);
  background-color: var(--cui-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--cui-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--cui-pagination-active-color);
  background-color: var(--cui-pagination-active-bg);
  border-color: var(--cui-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--cui-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--cui-pagination-disabled-bg);
  border-color: var(--cui-pagination-disabled-border-color);
}

html:not([dir=rtl]) .page-item:not(:first-child) .page-link {
  margin-left: calc(var(--cui-border-width) * -1);
}
*[dir=rtl] .page-item:not(:first-child) .page-link {
  margin-right: calc(var(--cui-border-width) * -1);
}
html:not([dir=rtl]) .page-item:first-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:first-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:first-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:first-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:last-child .page-link {
  border-top-right-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:last-child .page-link {
  border-top-left-radius: var(--cui-pagination-border-radius);
}
html:not([dir=rtl]) .page-item:last-child .page-link {
  border-bottom-right-radius: var(--cui-pagination-border-radius);
}
*[dir=rtl] .page-item:last-child .page-link {
  border-bottom-left-radius: var(--cui-pagination-border-radius);
}

.pagination-lg {
  --cui-pagination-padding-x: 1.5rem;
  --cui-pagination-padding-y: 0.75rem;
  --cui-pagination-font-size: 1.25rem;
  --cui-pagination-border-radius: var(--cui-border-radius-lg);
}

.pagination-sm {
  --cui-pagination-padding-x: 0.5rem;
  --cui-pagination-padding-y: 0.25rem;
  --cui-pagination-font-size: 0.875rem;
  --cui-pagination-border-radius: var(--cui-border-radius-sm);
}

.badge {
  --cui-badge-padding-x: 0.65em;
  --cui-badge-padding-y: 0.35em;
  --cui-badge-font-size: 0.75em;
  --cui-badge-font-weight: 700;
  --cui-badge-color: rgba(255, 255, 255, 0.87);
  --cui-badge-border-radius: var(--cui-border-radius);
  display: inline-block;
  padding: var(--cui-badge-padding-y) var(--cui-badge-padding-x);
  font-size: var(--cui-badge-font-size);
  font-weight: var(--cui-badge-font-weight);
  line-height: 1;
  color: var(--cui-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--cui-badge-border-radius, 0);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-sm {
  --cui-badge-padding-x: 0.5em;
  --cui-badge-padding-y: 0.3em;
  font-size: 0.65em;
}

.alert {
  --cui-alert-bg: transparent;
  --cui-alert-padding-x: 1rem;
  --cui-alert-padding-y: 1rem;
  --cui-alert-margin-bottom: 1rem;
  --cui-alert-color: inherit;
  --cui-alert-border-color: transparent;
  --cui-alert-border: var(--cui-border-width) solid var(--cui-alert-border-color);
  --cui-alert-border-radius: var(--cui-border-radius);
  --cui-alert-link-color: inherit;
  position: relative;
  padding: var(--cui-alert-padding-y) var(--cui-alert-padding-x);
  margin-bottom: var(--cui-alert-margin-bottom);
  color: var(--cui-alert-color);
  background-color: var(--cui-alert-bg);
  border: var(--cui-alert-border);
  border-radius: var(--cui-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--cui-alert-link-color);
}

html:not([dir=rtl]) .alert-dismissible {
  padding-right: 3rem;
}
*[dir=rtl] .alert-dismissible {
  padding-left: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}
html:not([dir=rtl]) .alert-dismissible .btn-close {
  right: 0;
}
*[dir=rtl] .alert-dismissible .btn-close {
  left: 0;
}

.alert-primary {
  --cui-alert-color: #1e1383;
  --cui-alert-bg: #d6d2f8;
  --cui-alert-border-color: #c2bcf4;
  --cui-alert-link-color: #180f69;
}

.alert-secondary {
  --cui-alert-color: #5e636a;
  --cui-alert-bg: #ebedef;
  --cui-alert-border-color: #e2e4e8;
  --cui-alert-link-color: #4b4f55;
}

.alert-success {
  --cui-alert-color: #1c6e37;
  --cui-alert-bg: #d5f1de;
  --cui-alert-border-color: #c0eace;
  --cui-alert-link-color: #16582c;
}

.alert-info {
  --cui-alert-color: #1f5c99;
  --cui-alert-bg: #d6ebff;
  --cui-alert-border-color: #c2e0ff;
  --cui-alert-link-color: #194a7a;
}

.alert-warning {
  --cui-alert-color: #956a0d;
  --cui-alert-bg: #feefd0;
  --cui-alert-border-color: #fde8b9;
  --cui-alert-link-color: #77550a;
}

.alert-danger {
  --cui-alert-color: #893232;
  --cui-alert-bg: #fadddd;
  --cui-alert-border-color: #f7cbcb;
  --cui-alert-link-color: #6e2828;
}

.alert-light {
  --cui-alert-color: #8d8e8f;
  --cui-alert-bg: #fbfbfc;
  --cui-alert-border-color: #f9fafa;
  --cui-alert-link-color: #717272;
}

.alert-dark {
  --cui-alert-color: #2f3845;
  --cui-alert-bg: #dcdfe3;
  --cui-alert-border-color: #caced5;
  --cui-alert-link-color: #262d37;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --cui-progress-height: 1rem;
  --cui-progress-font-size: 0.75rem;
  --cui-progress-bg: var(--cui-secondary-bg);
  --cui-progress-border-radius: var(--cui-border-radius);
  --cui-progress-box-shadow: var(--cui-box-shadow-inset);
  --cui-progress-bar-color: rgba(255, 255, 255, 0.87);
  --cui-progress-bar-bg: var(--cui-primary);
  --cui-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--cui-progress-height);
  overflow: hidden;
  font-size: var(--cui-progress-font-size);
  background-color: var(--cui-progress-bg);
  border-radius: var(--cui-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--cui-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--cui-progress-bar-bg);
  transition: var(--cui-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--cui-progress-height) var(--cui-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.progress-thin {
  height: 4px;
}

.progress.progress-white {
  background-color: rgba(255, 255, 255, 0.2);
}
.progress.progress-white .progress-bar {
  background-color: #fff;
}

.progress-group {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;
}

.progress-group-prepend {
  flex: 0 0 100px;
  align-self: center;
}

.progress-group-header {
  display: flex;
  flex-basis: 100%;
  align-items: center;
  margin-bottom: 0.25rem;
}

.progress-group-bars {
  flex-grow: 1;
  align-self: center;
}
.progress-group-bars .progress:not(:last-child) {
  margin-bottom: 2px;
}

.progress-group-header + .progress-group-bars {
  flex-basis: 100%;
}

.list-group {
  --cui-list-group-color: var(--cui-body-color);
  --cui-list-group-bg: var(--cui-body-bg);
  --cui-list-group-border-color: var(--cui-border-color);
  --cui-list-group-border-width: var(--cui-border-width);
  --cui-list-group-border-radius: var(--cui-border-radius);
  --cui-list-group-item-padding-x: 1rem;
  --cui-list-group-item-padding-y: 0.5rem;
  --cui-list-group-action-color: var(--cui-secondary-color);
  --cui-list-group-action-hover-color: var(--cui-emphasis-color);
  --cui-list-group-action-hover-bg: var(--cui-tertiary-bg);
  --cui-list-group-action-active-color: var(--cui-body-color);
  --cui-list-group-action-active-bg: var(--cui-secondary-bg);
  --cui-list-group-disabled-color: var(--cui-secondary-color);
  --cui-list-group-disabled-bg: var(--cui-body-bg);
  --cui-list-group-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-active-bg: #321fdb;
  --cui-list-group-active-border-color: #321fdb;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  border-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group {
  padding-left: 0;
}
*[dir=rtl] .list-group {
  padding-right: 0;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--cui-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--cui-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--cui-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--cui-list-group-action-active-color);
  background-color: var(--cui-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--cui-list-group-item-padding-y) var(--cui-list-group-item-padding-x);
  color: var(--cui-list-group-color);
  text-decoration: none;
  background-color: var(--cui-list-group-bg);
  border: var(--cui-list-group-border-width) solid var(--cui-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--cui-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--cui-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--cui-list-group-active-color);
  background-color: var(--cui-list-group-active-bg);
  border-color: var(--cui-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--cui-list-group-border-width));
  border-top-width: var(--cui-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--cui-list-group-border-radius);
}
*[dir=rtl] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-right-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-top-right-radius: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--cui-list-group-border-radius);
}
*[dir=rtl] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-left-radius: var(--cui-list-group-border-radius);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-bottom-right-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--cui-list-group-border-width);
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item {
  border-left-width: 0;
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item {
  border-right-width: 0;
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--cui-list-group-border-width));
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-right: calc(-1 * var(--cui-list-group-border-width));
}
html:not([dir=rtl]) .list-group-horizontal > .list-group-item + .list-group-item.active {
  border-left-width: var(--cui-list-group-border-width);
}
*[dir=rtl] .list-group-horizontal > .list-group-item + .list-group-item.active {
  border-right-width: var(--cui-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-right-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-top-right-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-top-left-radius: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--cui-list-group-border-radius);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-left-radius: var(--cui-list-group-border-radius);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-bottom-left-radius: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-bottom-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--cui-list-group-border-width);
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-left-width: 0;
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-right-width: 0;
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--cui-list-group-border-width));
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-right: calc(-1 * var(--cui-list-group-border-width));
  }
  html:not([dir=rtl]) .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    border-left-width: var(--cui-list-group-border-width);
  }
  *[dir=rtl] .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    border-right-width: var(--cui-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--cui-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --cui-list-group-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-bg: #d6d2f8;
  --cui-list-group-hover-bg: #2d1cc5;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1e1383, #d6d2f8, 40%, "primary");
}

.list-group-item-secondary {
  --cui-list-group-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-bg: #ebedef;
  --cui-list-group-hover-bg: #8d959f;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#5e636a, #ebedef, 40%, "secondary");
}

.list-group-item-success {
  --cui-list-group-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-bg: #d5f1de;
  --cui-list-group-hover-bg: #29a653;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1c6e37, #d5f1de, 40%, "success");
}

.list-group-item-danger {
  --cui-list-group-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-bg: #fadddd;
  --cui-list-group-hover-bg: #ce4b4b;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#893232, #fadddd, 40%, "danger");
}

.list-group-item-warning {
  --cui-list-group-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-bg: #feefd0;
  --cui-list-group-hover-bg: #e09f13;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#956a0d, #feefd0, 40%, "warning");
}

.list-group-item-info {
  --cui-list-group-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-bg: #d6ebff;
  --cui-list-group-hover-bg: #2e8ae6;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#1f5c99, #d6ebff, 40%, "info");
}

.list-group-item-light {
  --cui-list-group-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-bg: #fbfbfc;
  --cui-list-group-hover-bg: #d4d5d7;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#8d8e8f, #fbfbfc, 40%, "light");
}

.list-group-item-dark {
  --cui-list-group-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-bg: #dcdfe3;
  --cui-list-group-hover-bg: #475468;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#2f3845, #dcdfe3, 40%, "dark");
}

.btn-close {
  --cui-btn-close-color: rgba(44, 56, 74, 0.95);
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --cui-btn-close-opacity: 0.5;
  --cui-btn-close-hover-opacity: 0.75;
  --cui-btn-close-focus-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-btn-close-focus-opacity: 1;
  --cui-btn-close-disabled-opacity: 0.25;
  --cui-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--cui-btn-close-color);
  background: transparent var(--cui-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--cui-btn-close-opacity);
}
.btn-close:hover {
  color: var(--cui-btn-close-color);
  text-decoration: none;
  opacity: var(--cui-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--cui-btn-close-focus-shadow);
  opacity: var(--cui-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--cui-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--cui-btn-close-white-filter);
}

.toast {
  --cui-toast-zindex: 1090;
  --cui-toast-padding-x: 0.75rem;
  --cui-toast-padding-y: 0.5rem;
  --cui-toast-spacing: 1.5rem;
  --cui-toast-max-width: 350px;
  --cui-toast-font-size: 0.875rem;
  --cui-toast-color: ;
  --cui-toast-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-border-width: var(--cui-border-width);
  --cui-toast-border-color: var(--cui-border-color-translucent);
  --cui-toast-border-radius: var(--cui-border-radius);
  --cui-toast-box-shadow: var(--cui-box-shadow);
  --cui-toast-header-color: var(--cui-secondary-color);
  --cui-toast-header-bg: rgba(var(--cui-body-bg-rgb), 0.85);
  --cui-toast-header-border-color: var(--cui-border-color-translucent);
  width: var(--cui-toast-max-width);
  max-width: 100%;
  font-size: var(--cui-toast-font-size);
  color: var(--cui-toast-color);
  pointer-events: auto;
  background-color: var(--cui-toast-bg);
  background-clip: padding-box;
  border: var(--cui-toast-border-width) solid var(--cui-toast-border-color);
  box-shadow: var(--cui-toast-box-shadow);
  border-radius: var(--cui-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --cui-toast-zindex: 1090;
  position: absolute;
  z-index: var(--cui-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--cui-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--cui-toast-padding-y) var(--cui-toast-padding-x);
  color: var(--cui-toast-header-color);
  background-color: var(--cui-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--cui-toast-border-width) solid var(--cui-toast-header-border-color);
  border-top-left-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
  border-top-right-radius: calc(var(--cui-toast-border-radius) - var(--cui-toast-border-width));
}
html:not([dir=rtl]) .toast-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-toast-padding-x));
}
*[dir=rtl] .toast-header .btn-close {
  margin-left: calc(-0.5 * var(--cui-toast-padding-x));
}
html:not([dir=rtl]) .toast-header .btn-close {
  margin-left: var(--cui-toast-padding-x);
}
*[dir=rtl] .toast-header .btn-close {
  margin-right: var(--cui-toast-padding-x);
}

.toast-body {
  padding: var(--cui-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --cui-modal-zindex: 1055;
  --cui-modal-width: 500px;
  --cui-modal-padding: 1rem;
  --cui-modal-margin: 0.5rem;
  --cui-modal-color: ;
  --cui-modal-bg: var(--cui-body-bg);
  --cui-modal-border-color: var(--cui-border-color-translucent);
  --cui-modal-border-width: var(--cui-border-width);
  --cui-modal-border-radius: var(--cui-border-radius-lg);
  --cui-modal-box-shadow: var(--cui-box-shadow-sm);
  --cui-modal-inner-border-radius: calc(var(--cui-border-radius-lg) - (var(--cui-border-width)));
  --cui-modal-header-padding-x: 1rem;
  --cui-modal-header-padding-y: 1rem;
  --cui-modal-header-padding: 1rem 1rem;
  --cui-modal-header-border-color: var(--cui-border-color);
  --cui-modal-header-border-width: var(--cui-border-width);
  --cui-modal-title-line-height: 1.5;
  --cui-modal-footer-gap: 0.5rem;
  --cui-modal-footer-bg: ;
  --cui-modal-footer-border-color: var(--cui-border-color);
  --cui-modal-footer-border-width: var(--cui-border-width);
  position: fixed;
  top: 0;
  z-index: var(--cui-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}
html:not([dir=rtl]) .modal {
  left: 0;
}
*[dir=rtl] .modal {
  right: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--cui-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--cui-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--cui-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--cui-modal-color);
  pointer-events: auto;
  background-color: var(--cui-modal-bg);
  background-clip: padding-box;
  border: var(--cui-modal-border-width) solid var(--cui-modal-border-color);
  border-radius: var(--cui-modal-border-radius);
  outline: 0;
  box-shadow: 0 24px 38px 3px rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 9px 46px 8px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 11px 15px -7px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.modal-content:not([class*=border]) {
  border: 0;
}

.modal-backdrop {
  --cui-backdrop-zindex: 1050;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--cui-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--cui-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-modal-header-padding);
  border-bottom: var(--cui-modal-header-border-width) solid var(--cui-modal-header-border-color);
  border-top-left-radius: var(--cui-modal-inner-border-radius);
  border-top-right-radius: var(--cui-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--cui-modal-header-padding-y) * 0.5) calc(var(--cui-modal-header-padding-x) * 0.5);
}
html:not([dir=rtl]) .modal-header .btn-close {
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x)) calc(-0.5 * var(--cui-modal-header-padding-y)) auto;
}
*[dir=rtl] .modal-header .btn-close {
  margin: calc(-0.5 * var(--cui-modal-header-padding-y)) auto calc(-0.5 * var(--cui-modal-header-padding-y)) calc(-0.5 * var(--cui-modal-header-padding-x));
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--cui-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--cui-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--cui-modal-padding) - var(--cui-modal-footer-gap) * 0.5);
  background-color: var(--cui-modal-footer-bg);
  border-top: var(--cui-modal-footer-border-width) solid var(--cui-modal-footer-border-color);
  border-bottom-right-radius: var(--cui-modal-inner-border-radius);
  border-bottom-left-radius: var(--cui-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--cui-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --cui-modal-margin: 1.75rem;
    --cui-modal-box-shadow: var(--cui-box-shadow);
  }
  .modal-dialog {
    max-width: var(--cui-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --cui-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --cui-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --cui-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --cui-tooltip-zindex: 1080;
  --cui-tooltip-max-width: 200px;
  --cui-tooltip-padding-x: 0.5rem;
  --cui-tooltip-padding-y: 0.25rem;
  --cui-tooltip-margin: ;
  --cui-tooltip-font-size: 0.875rem;
  --cui-tooltip-color: var(--cui-body-bg);
  --cui-tooltip-bg: var(--cui-emphasis-color);
  --cui-tooltip-border-radius: var(--cui-border-radius);
  --cui-tooltip-opacity: 0.9;
  --cui-tooltip-arrow-width: 0.8rem;
  --cui-tooltip-arrow-height: 0.4rem;
  z-index: var(--cui-tooltip-zindex);
  display: block;
  margin: var(--cui-tooltip-margin);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--cui-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--cui-tooltip-arrow-width);
  height: var(--cui-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height) calc(var(--cui-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--cui-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-bottom-color: var(--cui-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--cui-tooltip-arrow-height));
  width: var(--cui-tooltip-arrow-height);
  height: var(--cui-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--cui-tooltip-arrow-width) * 0.5) 0 calc(var(--cui-tooltip-arrow-width) * 0.5) var(--cui-tooltip-arrow-height);
  border-left-color: var(--cui-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--cui-tooltip-max-width);
  padding: var(--cui-tooltip-padding-y) var(--cui-tooltip-padding-x);
  color: var(--cui-tooltip-color);
  text-align: center;
  background-color: var(--cui-tooltip-bg);
  border-radius: var(--cui-tooltip-border-radius);
}

.popover {
  --cui-popover-zindex: 1070;
  --cui-popover-max-width: 276px;
  --cui-popover-font-size: 0.875rem;
  --cui-popover-bg: var(--cui-body-bg);
  --cui-popover-border-width: var(--cui-border-width);
  --cui-popover-border-color: var(--cui-border-color-translucent);
  --cui-popover-border-radius: var(--cui-border-radius-lg);
  --cui-popover-inner-border-radius: calc(var(--cui-border-radius-lg) - var(--cui-border-width));
  --cui-popover-box-shadow: var(--cui-box-shadow);
  --cui-popover-header-padding-x: 1rem;
  --cui-popover-header-padding-y: 0.5rem;
  --cui-popover-header-font-size: 1rem;
  --cui-popover-header-color: inherit;
  --cui-popover-header-bg: var(--cui-secondary-bg);
  --cui-popover-body-padding-x: 1rem;
  --cui-popover-body-padding-y: 1rem;
  --cui-popover-body-color: var(--cui-body-color);
  --cui-popover-arrow-width: 1rem;
  --cui-popover-arrow-height: 0.5rem;
  --cui-popover-arrow-border: var(--cui-popover-border-color);
  z-index: var(--cui-popover-zindex);
  display: block;
  max-width: var(--cui-popover-max-width);
  font-family: var(--cui-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--cui-popover-font-size);
  word-wrap: break-word;
  background-color: var(--cui-popover-bg);
  background-clip: padding-box;
  border: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-radius: var(--cui-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--cui-popover-arrow-width);
  height: var(--cui-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--cui-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--cui-popover-border-width);
  border-top-color: var(--cui-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height) calc(var(--cui-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--cui-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--cui-popover-border-width);
  border-right-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--cui-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--cui-popover-border-width);
  border-bottom-color: var(--cui-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--cui-popover-arrow-width);
  margin-left: calc(-0.5 * var(--cui-popover-arrow-width));
  content: "";
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--cui-popover-arrow-height)) - var(--cui-popover-border-width));
  width: var(--cui-popover-arrow-height);
  height: var(--cui-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--cui-popover-arrow-width) * 0.5) 0 calc(var(--cui-popover-arrow-width) * 0.5) var(--cui-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--cui-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--cui-popover-border-width);
  border-left-color: var(--cui-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--cui-popover-header-padding-y) var(--cui-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--cui-popover-header-font-size);
  color: var(--cui-popover-header-color);
  background-color: var(--cui-popover-header-bg);
  border-bottom: var(--cui-popover-border-width) solid var(--cui-popover-border-color);
  border-top-left-radius: var(--cui-popover-inner-border-radius);
  border-top-right-radius: var(--cui-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--cui-popover-body-padding-y) var(--cui-popover-body-padding-x);
  color: var(--cui-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: var(--cui-carousel-control-color, rgba(255, 255, 255, 0.87));
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-coreui-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--cui-carousel-indicator-active-bg, #fff);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-coreui-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--cui-carousel-caption-color, rgba(255, 255, 255, 0.87));
  text-align: center;
}

.carousel-dark {
  --cui-carousel-indicator-active-bg: #000015;
  --cui-carousel-caption-color: rgba(44, 56, 74, 0.95);
}
.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-coreui-target] {
  background-color: #000015;
}
.carousel-dark .carousel-caption {
  color: rgba(44, 56, 74, 0.95);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--cui-spinner-width);
  height: var(--cui-spinner-height);
  vertical-align: var(--cui-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--cui-spinner-animation-speed) linear infinite var(--cui-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-border-width: 0.25em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-border;
  border: var(--cui-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
  --cui-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --cui-spinner-width: 2rem;
  --cui-spinner-height: 2rem;
  --cui-spinner-vertical-align: -0.125em;
  --cui-spinner-animation-speed: 0.75s;
  --cui-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --cui-spinner-width: 1rem;
  --cui-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --cui-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --cui-offcanvas-zindex: 1045;
  --cui-offcanvas-width: 400px;
  --cui-offcanvas-height: 30vh;
  --cui-offcanvas-padding-x: 1rem;
  --cui-offcanvas-padding-y: 1rem;
  --cui-offcanvas-color: var(--cui-body-color);
  --cui-offcanvas-bg: var(--cui-body-bg);
  --cui-offcanvas-border-width: var(--cui-border-width);
  --cui-offcanvas-border-color: var(--cui-border-color-translucent);
  --cui-offcanvas-box-shadow: var(--cui-box-shadow-sm);
  --cui-offcanvas-transition: transform 0.3s ease-in-out;
  --cui-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-sm.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-sm.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-md.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-md.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-md.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-lg.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-lg.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-xl.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xl.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--cui-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--cui-offcanvas-color);
    visibility: hidden;
    background-color: var(--cui-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--cui-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    width: var(--cui-offcanvas-width);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    left: 0;
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    right: 0;
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-start {
    transform: translateX(-100%);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-start {
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    width: var(--cui-offcanvas-width);
    transform: translateX(100%);
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-end {
    right: 0;
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-end {
    left: 0;
  }
  html:not([dir=rtl]) .offcanvas-xxl.offcanvas-end {
    border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  *[dir=rtl] .offcanvas-xxl.offcanvas-end {
    border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--cui-offcanvas-height);
    max-height: 100%;
    border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none !important;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --cui-offcanvas-height: auto;
    --cui-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--cui-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--cui-offcanvas-color);
  visibility: hidden;
  background-color: var(--cui-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--cui-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  width: var(--cui-offcanvas-width);
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  left: 0;
}
*[dir=rtl] .offcanvas.offcanvas-start {
  right: 0;
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
*[dir=rtl] .offcanvas.offcanvas-start {
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
html:not([dir=rtl]) .offcanvas.offcanvas-start {
  transform: translateX(-100%);
}
*[dir=rtl] .offcanvas.offcanvas-start {
  transform: translateX(100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  width: var(--cui-offcanvas-width);
  transform: translateX(100%);
}
html:not([dir=rtl]) .offcanvas.offcanvas-end {
  right: 0;
}
*[dir=rtl] .offcanvas.offcanvas-end {
  left: 0;
}
html:not([dir=rtl]) .offcanvas.offcanvas-end {
  border-left: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
*[dir=rtl] .offcanvas.offcanvas-end {
  border-right: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--cui-offcanvas-height);
  max-height: 100%;
  border-top: var(--cui-offcanvas-border-width) solid var(--cui-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none !important;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: var(--cui-offcanvas-backdrop-bg, #000015);
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--cui-offcanvas-padding-y) * 0.5) calc(var(--cui-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--cui-offcanvas-padding-y));
  margin-bottom: calc(-0.5 * var(--cui-offcanvas-padding-y));
}
html:not([dir=rtl]) .offcanvas-header .btn-close {
  margin-right: calc(-0.5 * var(--cui-offcanvas-padding-x));
}
*[dir=rtl] .offcanvas-header .btn-close {
  margin-left: calc(-0.5 * var(--cui-offcanvas-padding-x));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--cui-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--cui-offcanvas-padding-y) var(--cui-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000015 55%, rgba(0, 0, 0, 0.8) 75%, #000015 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 50em;
  transition: margin 0.15s;
  width: 2rem;
  height: 2rem;
  font-size: 0.8rem;
}
@media (prefers-reduced-motion: reduce) {
  .avatar {
    transition: none;
  }
}
.avatar .avatar-status {
  width: 0.5333333333rem;
  height: 0.5333333333rem;
}

.avatar-img {
  width: 100%;
  height: auto;
  border-radius: 50em;
}

.avatar-status {
  position: absolute;
  bottom: 0;
  display: block;
  border: 1px solid #fff;
  border-radius: 50em;
}
html:not([dir=rtl]) .avatar-status {
  right: 0;
}
*[dir=rtl] .avatar-status {
  left: 0;
}

.avatar-sm {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.6rem;
}
.avatar-sm .avatar-status {
  width: 0.4rem;
  height: 0.4rem;
}

.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
}
.avatar-md .avatar-status {
  width: 0.6666666667rem;
  height: 0.6666666667rem;
}

.avatar-lg {
  width: 3rem;
  height: 3rem;
  font-size: 1.2rem;
}
.avatar-lg .avatar-status {
  width: 0.8rem;
  height: 0.8rem;
}

.avatar-xl {
  width: 4rem;
  height: 4rem;
  font-size: 1.6rem;
}
.avatar-xl .avatar-status {
  width: 1.0666666667rem;
  height: 1.0666666667rem;
}

.avatars-stack {
  display: flex;
}
html:not([dir=rtl]) .avatars-stack .avatar {
  margin-right: -0.8rem;
}
*[dir=rtl] .avatars-stack .avatar {
  margin-left: -0.8rem;
}
html:not([dir=rtl]) .avatars-stack .avatar:hover {
  margin-right: 0;
}
*[dir=rtl] .avatars-stack .avatar:hover {
  margin-left: 0;
}
html:not([dir=rtl]) .avatars-stack .avatar-sm {
  margin-right: -0.6rem;
}
*[dir=rtl] .avatars-stack .avatar-sm {
  margin-left: -0.6rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-md {
  margin-right: -1rem;
}
*[dir=rtl] .avatars-stack .avatar-md {
  margin-left: -1rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-lg {
  margin-right: -1.2rem;
}
*[dir=rtl] .avatars-stack .avatar-lg {
  margin-left: -1.2rem;
}
html:not([dir=rtl]) .avatars-stack .avatar-xl {
  margin-right: -1.6rem;
}
*[dir=rtl] .avatars-stack .avatar-xl {
  margin-left: -1.6rem;
}

.calendar {
  --cui-calendar-table-margin: 0.5rem;
  --cui-calendar-table-cell-size: 2.75rem;
  --cui-calendar-nav-padding: 0.5rem;
  --cui-calendar-nav-border: 1px solid var(--cui-border-color);
  --cui-calendar-nav-date-color: var(--cui-body-color);
  --cui-calendar-nav-date-hover-color: var(--cui-primary);
  --cui-calendar-nav-icon-width: 1rem;
  --cui-calendar-nav-icon-height: 1rem;
  --cui-calendar-cell-header-inner-color: var(--cui-secondary-color);
  --cui-calendar-cell-hover-bg: var(--cui-tertiary-bg);
  --cui-calendar-cell-disabled-color: var(--cui-tertiary-color);
  --cui-calendar-cell-selected-color: #fff;
  --cui-calendar-cell-selected-bg: var(--cui-primary);
  --cui-calendar-cell-range-bg: rgba(var(--cui-primary-rgb), 0.125);
  --cui-calendar-cell-range-hover-bg: rgba(var(--cui-primary-rgb), 0.25);
  --cui-calendar-cell-range-hover-border-color: var(--cui-primary);
  --cui-calendar-cell-today-color: var(--cui- #e55353);
  font-weight: initial;
}
.calendar table {
  width: calc(var(--cui-calendar-table-cell-size) * 7);
  margin: var(--cui-calendar-table-margin);
}
.calendar table th,
.calendar table td {
  width: var(--cui-calendar-table-cell-size);
}
.calendar.months ~ .time-picker, .calendar.years ~ .time-picker {
  display: none;
}

.calendars {
  display: flex;
}

.calendar-nav {
  display: flex;
  align-items: baseline;
  padding: var(--cui-calendar-nav-padding);
  border-bottom: var(--cui-calendar-nav-border);
}

.calendar-nav-date {
  flex: 1 1;
  text-align: center;
}
.calendar-nav-date .btn {
  font-weight: 600;
  color: var(--cui-calendar-nav-date-color);
}
.calendar-nav-date .btn:hover {
  color: var(--cui-calendar-nav-date-hover-color);
}

.calendar-nav-icon {
  display: block;
  width: var(--cui-calendar-nav-icon-width);
  height: var(--cui-calendar-nav-icon-height);
  transition: background-image 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .calendar-nav-icon {
    transition: none;
  }
}

html:not([dir=rtl]) .calendar-nav-icon-double-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
*[dir=rtl] .calendar-nav-icon-double-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
html:not([dir=rtl]) .calendar-nav-icon-double-next:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
*[dir=rtl] .calendar-nav-icon-double-next:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

html:not([dir=rtl]) .calendar-nav-icon-double-prev {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
*[dir=rtl] .calendar-nav-icon-double-prev {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
html:not([dir=rtl]) .calendar-nav-icon-double-prev:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
*[dir=rtl] .calendar-nav-icon-double-prev:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

html:not([dir=rtl]) .calendar-nav-icon-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
*[dir=rtl] .calendar-nav-icon-next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
html:not([dir=rtl]) .calendar-nav-icon-next:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
*[dir=rtl] .calendar-nav-icon-next:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

html:not([dir=rtl]) .calendar-nav-icon-prev {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
*[dir=rtl] .calendar-nav-icon-prev {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
html:not([dir=rtl]) .calendar-nav-icon-prev:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
*[dir=rtl] .calendar-nav-icon-prev:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.calendar-header-cell-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--cui-calendar-table-cell-size);
  font-weight: 600;
  color: var(--cui-calendar-cell-header-inner-color);
}

.calendar-cell {
  padding: 1px 0;
  text-align: center;
}
.calendar-cell:not(.disabled):not(.next):not(.previous):hover .calendar-cell-inner, .calendar-cell.clickable:hover .calendar-cell-inner {
  cursor: pointer;
  background-color: var(--cui-calendar-cell-hover-bg);
}
.calendar-cell.today .calendar-cell-inner {
  color: var(--cui-calendar-cell-today-color);
}
.calendar-cell.disabled, .calendar-cell.next, .calendar-cell.previous .calendar-cell-inner {
  color: var(--cui-calendar-cell-disabled-color);
}
.calendar-cell.disabled .calendar-cell-inner {
  cursor: not-allowed;
}
.calendar-cell.range:not(.selected) .calendar-cell-inner {
  background: var(--cui-calendar-cell-range-bg);
  border-radius: 0;
}
.calendar-cell.range:not(.selected):hover .calendar-cell-inner {
  position: relative;
}
.calendar-cell.range:not(.selected):hover .calendar-cell-inner::after {
  position: absolute;
  width: 100%;
  height: 100%;
  content: "";
  background: var(--cui-calendar-cell-range-hover-bg);
  border-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.range:not(.selected):first-child .calendar-cell-inner, html:not([dir=rtl]) .calendar-cell:not(.range) + .range .calendar-cell-inner {
  border-top-left-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range:not(.selected):first-child .calendar-cell-inner, *[dir=rtl] .calendar-cell:not(.range) + .range .calendar-cell-inner {
  border-top-right-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.range:not(.selected):first-child .calendar-cell-inner, html:not([dir=rtl]) .calendar-cell:not(.range) + .range .calendar-cell-inner {
  border-bottom-left-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range:not(.selected):first-child .calendar-cell-inner, *[dir=rtl] .calendar-cell:not(.range) + .range .calendar-cell-inner {
  border-bottom-right-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.range:not(.selected):last-child .calendar-cell-inner, html:not([dir=rtl]) .calendar-cell.range:not(.selected).last .calendar-cell-inner {
  border-top-right-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range:not(.selected):last-child .calendar-cell-inner, *[dir=rtl] .calendar-cell.range:not(.selected).last .calendar-cell-inner {
  border-top-left-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.range:not(.selected):last-child .calendar-cell-inner, html:not([dir=rtl]) .calendar-cell.range:not(.selected).last .calendar-cell-inner {
  border-bottom-right-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range:not(.selected):last-child .calendar-cell-inner, *[dir=rtl] .calendar-cell.range:not(.selected).last .calendar-cell-inner {
  border-bottom-left-radius: 0.375rem;
}
.calendar-cell.range-hover .calendar-cell-inner {
  position: relative;
}
.calendar-cell.range-hover .calendar-cell-inner::before {
  position: absolute;
  width: 100%;
  height: 100%;
  content: "";
}
.calendar-cell.range-hover .calendar-cell-inner::before, .calendar-cell.range-hover.selected .calendar-cell-inner::before {
  border-top: 1px dashed var(--cui-calendar-cell-selected-bg);
  border-bottom: 1px dashed var(--cui-calendar-cell-selected-bg);
  border-radius: 0;
}
.calendar-cell.range-hover:first-child .calendar-cell-inner::before, .calendar-cell:not(.range-hover) + .range-hover .calendar-cell-inner::before {
  border-left: 1px dashed var(--cui-calendar-cell-selected-bg);
}
html:not([dir=rtl]) .calendar-cell.range-hover:first-child .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell:not(.range-hover) + .range-hover .calendar-cell-inner::before {
  border-top-left-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range-hover:first-child .calendar-cell-inner::before, *[dir=rtl] .calendar-cell:not(.range-hover) + .range-hover .calendar-cell-inner::before {
  border-top-right-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.range-hover:first-child .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell:not(.range-hover) + .range-hover .calendar-cell-inner::before {
  border-bottom-left-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range-hover:first-child .calendar-cell-inner::before, *[dir=rtl] .calendar-cell:not(.range-hover) + .range-hover .calendar-cell-inner::before {
  border-bottom-right-radius: 0.375rem;
}
.calendar-cell.range-hover:last-child .calendar-cell-inner::before, .calendar-cell.range-hover.last .calendar-cell-inner::before, .calendar-cell.range-hover + .range-hover:hover .calendar-cell-inner::before, .calendar-cell.range-hover:first-child:hover .calendar-cell-inner::before {
  border-right: 1px dashed var(--cui-calendar-cell-selected-bg);
}
html:not([dir=rtl]) .calendar-cell.range-hover:last-child .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell.range-hover.last .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell.range-hover + .range-hover:hover .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell.range-hover:first-child:hover .calendar-cell-inner::before {
  border-top-right-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range-hover:last-child .calendar-cell-inner::before, *[dir=rtl] .calendar-cell.range-hover.last .calendar-cell-inner::before, *[dir=rtl] .calendar-cell.range-hover + .range-hover:hover .calendar-cell-inner::before, *[dir=rtl] .calendar-cell.range-hover:first-child:hover .calendar-cell-inner::before {
  border-top-left-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.range-hover:last-child .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell.range-hover.last .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell.range-hover + .range-hover:hover .calendar-cell-inner::before, html:not([dir=rtl]) .calendar-cell.range-hover:first-child:hover .calendar-cell-inner::before {
  border-bottom-right-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.range-hover:last-child .calendar-cell-inner::before, *[dir=rtl] .calendar-cell.range-hover.last .calendar-cell-inner::before, *[dir=rtl] .calendar-cell.range-hover + .range-hover:hover .calendar-cell-inner::before, *[dir=rtl] .calendar-cell.range-hover:first-child:hover .calendar-cell-inner::before {
  border-bottom-left-radius: 0.375rem;
}
.calendar-cell.range-hover.selected:hover .calendar-cell-inner::before {
  border: 0;
}
.calendar-cell.selected:not(.previous):not(.next) .calendar-cell-inner, .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner, .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner {
  position: relative;
  color: var(--cui-calendar-cell-selected-color);
  background: var(--cui-calendar-cell-selected-bg);
}
.calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before, .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  content: "";
  background: var(--cui-calendar-cell-range-bg);
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-top-left-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-top-right-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-bottom-left-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-bottom-right-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-top-right-radius: 0;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-top-left-radius: 0;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-bottom-right-radius: 0;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).start .calendar-cell-inner::before {
  border-bottom-left-radius: 0;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-top-left-radius: 0;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-top-right-radius: 0;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-bottom-left-radius: 0;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-bottom-right-radius: 0;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-top-right-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-top-left-radius: 0.375rem;
}
html:not([dir=rtl]) .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-bottom-right-radius: 0.375rem;
}
*[dir=rtl] .calendar-cell.selected:not(.previous):not(.next).end .calendar-cell-inner::before {
  border-bottom-left-radius: 0.375rem;
}

.calendar-cell-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--cui-calendar-table-cell-size);
  border-radius: 0.375rem;
}

.callout {
  --cui-callout-padding-x: 1rem;
  --cui-callout-padding-y: 1rem;
  --cui-callout-margin-x: 0;
  --cui-callout-margin-y: 1rem;
  --cui-callout-border-width: var(--cui-border-width);
  --cui-callout-border-color: var(--cui-border-color);
  --cui-callout-border-left-width: calc(var(--cui-border-width) * 4);
  --cui-callout-border-radius: var(--cui-border-radius);
  padding: var(--cui-callout-padding-y) var(--cui-callout-padding-x);
  margin: var(--cui-callout-margin-y) var(--cui-callout-margin-x);
  border: var(--cui-callout-border-width) solid var(--cui-callout-border-color);
  border-radius: var(--cui-callout-border-radius);
}
html:not([dir=rtl]) .callout {
  border-left-width: var(--cui-callout-border-left-width);
}
*[dir=rtl] .callout {
  border-right-width: var(--cui-callout-border-right-width);
}
html:not([dir=rtl]) .callout {
  border-left-color: var(--cui-callout-border-left-color);
}
*[dir=rtl] .callout {
  border-right-color: var(--cui-callout-border-right-color);
}

.callout-primary {
  --cui-callout-border-left-color: #321fdb;
}

.callout-secondary {
  --cui-callout-border-left-color: #9da5b1;
}

.callout-success {
  --cui-callout-border-left-color: #2eb85c;
}

.callout-danger {
  --cui-callout-border-left-color: #e55353;
}

.callout-warning {
  --cui-callout-border-left-color: #f9b115;
}

.callout-info {
  --cui-callout-border-left-color: #39f;
}

.callout-light {
  --cui-callout-border-left-color: #ebedef;
}

.callout-dark {
  --cui-callout-border-left-color: #4f5d73;
}

.picker {
  --cui-picker-footer-border-top: 1px solid #d8dbe0;
  --cui-picker-footer-padding: 0.5rem;
}
.picker .dropdown-menu {
  padding: 0;
}
.picker.show .input-group {
  color: var(--cui-input-focus-color, var(--cui-body-color));
  background-color: var(--cui-input-focus-bg, var(--cui-body-bg));
  border-color: var(--cui-input-focus-border-color, #998fed);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
}

.picker-input-group:hover .form-control:not(:placeholder-shown) ~ .input-group-text .picker-input-group-indicator:not(:last-child) {
  display: none;
}
.picker-input-group:hover .form-control:not(:placeholder-shown) ~ .input-group-text .picker-input-group-cleaner {
  display: initial;
}
.picker-input-group .form-control.hover {
  color: var(--cui-gray-500);
}
.picker-input-group .form-control:focus {
  border-color: var(--cui-input-border-color, var(--cui-border-color));
  outline: 0;
  box-shadow: none;
}
html:not([dir=rtl]) .picker-input-group .form-control:not(:first-child) {
  border-left: 0;
}
*[dir=rtl] .picker-input-group .form-control:not(:first-child) {
  border-right: 0;
}
html:not([dir=rtl]) .picker-input-group .form-control:not(:last-child) {
  border-right: 0;
}
*[dir=rtl] .picker-input-group .form-control:not(:last-child) {
  border-left: 0;
}
.picker-input-group .form-control[readonly] {
  background-color: var(--cui-input-bg, var(--cui-body-bg));
}
.picker-input-group .form-control.form-control:disabled + .input-group-text {
  background-color: var(--cui-input-disabled-bg, var(--cui-secondary-bg));
}
.picker-input-group.input-group {
  border-radius: var(--cui-border-radius);
}
.picker-input-group.input-group-lg {
  border-radius: var(--cui-border-radius-lg);
}
.picker-input-group.input-group-lg .picker-input-group-icon {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.picker-input-group.input-group-sm {
  border-radius: var(--cui-border-radius-sm);
}
.picker-input-group.input-group-sm .picker-input-group-icon {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}
.picker-input-group .input-group-text {
  color: var(--cui-gray-400);
  background-color: var(--cui-input-bg, var(--cui-body-bg));
}

.picker-input-group-cleaner {
  display: none;
}

.picker-input-group-icon {
  display: block;
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
  transition: background-image 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .picker-input-group-icon {
    transition: none;
  }
}

.picker-footer {
  display: flex;
  justify-content: flex-end;
  padding: var(--cui-picker-footer-padding);
  border-top: var(--cui-picker-footer-border-top);
}
html:not([dir=rtl]) .picker-footer .btn + .btn {
  margin-left: 0.5rem;
}
*[dir=rtl] .picker-footer .btn + .btn {
  margin-right: 0.5rem;
}

.date-picker {
  --cui-date-picker-ranges-width: 10rem;
  --cui-date-picker-ranges-padding: 0.5rem;
  --cui-date-picker-ranges-border: 1px solid var(--cui-border-color);
  --cui-date-picker-timepicker-width: 20.25rem;
  --cui-date-picker-timepicker-border-top: 1px solid var(--cui-border-color);
}
.date-picker .dropdown-menu {
  width: min-content;
}
.date-picker.is-invalid .form-control {
  --cui-input-border-color: #e55353;
}
.date-picker.is-invalid .input-group-text {
  --cui-input-group-addon-border-color: #e55353;
}
.date-picker.is-invalid .picker-input-group-indicator {
  --cui-input-group-addon-color: #e55353;
}
.date-picker.is-invalid .date-picker-input-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.date-picker.is-valid .form-control {
  --cui-input-border-color: #2eb85c;
}
.date-picker.is-valid .input-group-text {
  --cui-input-group-addon-border-color: #2eb85c;
}
.date-picker.is-valid .picker-input-group-indicator {
  --cui-input-group-addon-color: #2eb85c;
}
.date-picker.is-valid .date-picker-input-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

.date-picker-body {
  display: grid;
  grid-template-areas: "ranges calendars" "ranges timepickers";
  grid-template-rows: auto;
  grid-template-columns: auto auto;
}

.date-picker-ranges {
  grid-area: ranges;
  width: var(--cui-date-picker-ranges-width);
  padding: var(--cui-date-picker-ranges-padding);
  border-right: var(--cui-date-picker-ranges-border);
}

.date-picker-calendars {
  display: flex;
  grid-area: calendars;
}
.date-picker-calendars .date-picker-calendar:not(:last-child) .calendar-navigation-next {
  visibility: hidden;
}
.date-picker-calendars .date-picker-calendar:not(:first-child) .calendar-navigation-prev {
  visibility: hidden;
}

html:not([dir=rtl]) .date-picker-arrow-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
*[dir=rtl] .date-picker-arrow-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}

.date-picker-cleaner-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
.date-picker-cleaner-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

.date-picker-input-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
}

.date-picker-timepickers {
  display: flex;
  flex-wrap: wrap;
  grid-area: timepickers;
  justify-content: space-between;
  border-top: var(--cui-date-picker-timepicker-border-top);
}
.date-picker-timepickers .time-picker {
  width: var(--cui-date-picker-timepicker-width);
}
.date-picker-timepickers .time-picker .form-select {
  width: initial;
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
  text-align: right;
  background-image: none !important;
  border: 0;
}
.date-picker-timepickers .time-picker .form-select:disabled {
  color: rgba(44, 56, 74, 0.38);
  background-color: transparent;
}
@media (max-width: 767.98px) {
  .date-picker-timepickers {
    display: block;
  }
  .date-picker-timepickers .time-picker {
    width: 100%;
  }
  .date-picker-timepickers .time-picker + .time-picker {
    border-top: var(--cui-date-picker-timepicker-border-top);
  }
}

.time-picker {
  --cui-time-picker-body-padding: 0.5rem;
  --cui-time-picker-roll-col-border: 1px solid var(--cui-border-color);
}
.time-picker.is-invalid .form-control {
  --cui-input-border-color: #e55353;
}
.time-picker.is-invalid .input-group-text {
  --cui-input-group-addon-border-color: #e55353;
}
.time-picker.is-invalid .picker-input-group-indicator {
  --cui-input-group-addon-color: #e55353;
}
.time-picker.is-invalid .time-picker-input-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}
.time-picker.is-valid .form-control {
  --cui-input-border-color: #2eb85c;
}
.time-picker.is-valid .input-group-text {
  --cui-input-group-addon-border-color: #2eb85c;
}
.time-picker.is-valid .picker-input-group-indicator {
  --cui-input-group-addon-color: #2eb85c;
}
.time-picker.is-valid .time-picker-input-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.time-picker-body {
  display: flex;
  align-items: center;
  padding: var(--cui-time-picker-body-padding);
}
.time-picker-body .form-select {
  padding-right: 1.25rem;
  background-position: right 0.5rem center;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.time-picker-body .form-select + .form-select {
  margin-left: 0.5rem;
}
.time-picker-body .form-select::-webkit-scrollbar {
  width: 10px;
}
.time-picker-body .time-picker-inline-icon {
  display: block;
  width: 40px;
  height: 1.25rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-repeat: no-repeat;
  background-position: center;
}

.time-picker-cleaner-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.time-picker-cleaner-icon:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
}

.time-picker-input-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}

.time-picker-roll {
  padding: 0;
  overflow: hidden;
  border-radius: inherit;
}

.time-picker-roll-col {
  height: 256px;
  overflow: scroll;
  border-right: var(--cui-time-picker-roll-col-border);
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.time-picker-roll-col::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.time-picker-roll-cell {
  width: 50px;
  height: 32px;
  padding: 0 1rem 0 0.5rem;
  line-height: 32px;
}
.time-picker-roll-cell.selected {
  color: var(--cui-white);
  background: var(--cui-primary);
}
.time-picker-roll-cell:last-child::after {
  display: block;
  height: 224px;
  content: "";
}

.footer {
  --cui-footer-min-height: 3rem;
  --cui-footer-padding-x: 1rem;
  --cui-footer-padding-y: 0.5rem;
  --cui-footer-color: var(--cui-body-color);
  --cui-footer-bg: var(--cui-tertiary-bg);
  --cui-footer-border-color: var(--cui-border-color);
  --cui-footer-border: var(--cui-border-width) solid var(--cui-footer-border-color);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-footer-min-height);
  padding: var(--cui-footer-padding-y) var(--cui-footer-padding-x);
  color: var(--cui-footer-color);
  background: var(--cui-footer-bg);
  border-top: var(--cui-footer-border);
}

.footer-sticky {
  position: sticky;
  bottom: 0;
  z-index: 1030;
}
.footer-sticky:not(.placeholder):not(top) {
  border-color: transparent;
  box-shadow: 0 2px 2px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 1px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}

.header {
  --cui-header-min-height: 4rem;
  --cui-header-padding-x: 0.5rem;
  --cui-header-padding-y: 0.5rem;
  --cui-header-bg: var(--cui-body-bg);
  --cui-header-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-border-color: var(--cui-border-color);
  --cui-header-border: var(--cui-border-width) solid var(--cui-header-border-color);
  --cui-header-hover-color: rgba(var(--cui-emphasis-color-rgb), 0.8);
  --cui-header-disabled-color: rgba(var(--cui-emphasis-color-rgb), 0.3);
  --cui-header-active-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-brand-padding-y: 0.3125rem;
  --cui-header-brand-color: #4f5d73;
  --cui-header-brand-hover-color: #475468;
  --cui-header-toggler-padding-x: 0.75rem;
  --cui-header-toggler-padding-y: 0.25rem;
  --cui-header-toggler-bg: transparent;
  --cui-header-toggler-color: rgba(var(--cui-emphasis-color-rgb), 0.65);
  --cui-header-toggler-border-radius: var(--cui-border-radius);
  --cui-header-toggler-hover-color: rgba(var(--cui-emphasis-color-rgb), 1);
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  --cui-header-nav-link-padding-x: 0.5rem;
  --cui-header-nav-link-padding-y: 0.5rem;
  --cui-header-divider-border-color: var(--cui-border-color);
  --cui-header-divider-border: var(--cui-border-width) solid var(--cui-header-divider-border-color);
  --cui-subheader-min-height: 3rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: var(--cui-header-min-height);
  padding: var(--cui-header-padding-y) var(--cui-header-padding-x);
  background: var(--cui-header-bg);
  border-bottom: var(--cui-header-border);
}
.header > .container,
.header > .container-fluid,
.header > .container-sm,
.header > .container-md,
.header > .container-lg,
.header > .container-xl,
.header > .container-xxl, .header .navbar > .container,
.header .navbar > .container-fluid,
.header .navbar > .container-sm,
.header .navbar > .container-md,
.header .navbar > .container-lg,
.header .navbar > .container-xl,
.header .navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.header .container:first-child,
.header .container-fluid:first-child,
.header .container-sm:first-child,
.header .container-md:first-child,
.header .container-lg:first-child,
.header .container-xl:first-child,
.header .container-xxl:first-child {
  min-height: calc(var(--cui-header-min-height) - 2 * var(--cui-header-padding-y));
}
.header .container:nth-child(n+2),
.header .container-fluid:nth-child(n+2),
.header .container-sm:nth-child(n+2),
.header .container-md:nth-child(n+2),
.header .container-lg:nth-child(n+2),
.header .container-xl:nth-child(n+2),
.header .container-xxl:nth-child(n+2) {
  min-height: calc(var(--cui-subheader-min-height) - 2 * var(--cui-header-padding-y));
}
.header.header-sticky {
  position: sticky;
  top: 0;
  z-index: 1029;
  box-shadow: 0 2px 2px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 1px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.header.header-sticky:not([class*=border]) {
  border: 0;
}

.header-divider {
  flex-basis: calc(100% + 2 * var(--cui-header-padding-x));
  height: 0;
  margin: var(--cui-header-padding-y) calc(var(--cui-header-padding-x) * -1);
  border-top: var(--cui-header-divider-border);
}

.header-brand {
  padding-top: var(--cui-header-brand-padding-y);
  padding-bottom: var(--cui-header-brand-padding-y);
  font-size: 1.25rem;
  color: var(--cui-header-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
html:not([dir=rtl]) .header-brand {
  margin-right: 1rem;
}
*[dir=rtl] .header-brand {
  margin-left: 1rem;
}
.header-brand:hover, .header-brand:focus {
  color: var(--cui-header-brand-hover-color);
}

.header-nav {
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .header-nav {
  padding-left: 0;
}
*[dir=rtl] .header-nav {
  padding-right: 0;
}
.header-nav .nav-link {
  padding: var(--cui-header-nav-link-padding-y) var(--cui-header-nav-link-padding-x);
  color: var(--cui-header-color);
}
.header-nav .nav-link:hover, .header-nav .nav-link:focus {
  color: var(--cui-header-hover-color);
}
.header-nav .nav-link.disabled {
  color: var(--cui-header-disabled-color);
}
.header-nav .show > .nav-link,
.header-nav .nav-link.active {
  color: var(--cui-header-active-color);
}
.header-nav .dropdown-menu {
  position: absolute;
}

.header-text {
  padding-top: var(--cui-header-nav-link-padding-y);
  padding-bottom: var(--cui-header-nav-link-padding-y);
  color: var(--cui-header-color);
}
.header-text a {
  color: var(--cui-header-active-color);
}
.header-text a:hover, .header-text a:focus {
  color: var(--cui-header-active-color);
}

.header-toggler {
  padding: var(--cui-header-toggler-padding-y) var(--cui-header-toggler-padding-x);
  font-size: 1.25rem;
  color: var(--cui-header-toggler-color);
  background-color: var(--cui-header-toggler-bg);
  border: 0;
  border-radius: var(--cui-header-toggler-border-radius);
}
.header-toggler:hover {
  color: var(--cui-header-toggler-hover-color);
  text-decoration: none;
}
.header-toggler:focus {
  outline: 0;
}
.header-toggler:not(:disabled) {
  cursor: pointer;
}
.header-toggler.prevent-hide {
  display: block !important;
}

.header-toggler-icon {
  display: block;
  height: 1.5625rem;
  background-image: var(--cui-header-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
}
.header-toggler-icon:hover {
  background-image: var(--cui-header-toggler-hover-icon-bg);
}

.icon {
  display: inline-block;
  color: inherit;
  text-align: center;
  vertical-align: -0.125rem;
  fill: currentcolor;
}
.icon:not(.icon-c-s):not(.icon-custom-size) {
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xxl {
  width: 2rem;
  height: 2rem;
  font-size: 2rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-xl {
  width: 1.5rem;
  height: 1.5rem;
  font-size: 1.5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-lg {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-sm {
  width: 0.875rem;
  height: 0.875rem;
  font-size: 0.875rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-3xl {
  width: 3rem;
  height: 3rem;
  font-size: 3rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-4xl {
  width: 4rem;
  height: 4rem;
  font-size: 4rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-5xl {
  width: 5rem;
  height: 5rem;
  font-size: 5rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-6xl {
  width: 6rem;
  height: 6rem;
  font-size: 6rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-7xl {
  width: 7rem;
  height: 7rem;
  font-size: 7rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-8xl {
  width: 8rem;
  height: 8rem;
  font-size: 8rem;
}
.icon:not(.icon-c-s):not(.icon-custom-size).icon-9xl {
  width: 9rem;
  height: 9rem;
  font-size: 9rem;
}

.sidebar {
  --cui-sidebar-width: 16rem;
  --cui-sidebar-bg: #3c4b64;
  --cui-sidebar-padding-x: 0;
  --cui-sidebar-padding-y: 0;
  --cui-sidebar-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-brand-height: 4rem;
  --cui-sidebar-brand-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-close-button-width: 2rem;
  --cui-sidebar-close-button-height: 4rem;
  --cui-sidebar-header-height: 4rem;
  --cui-sidebar-header-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-header-padding-x: 1rem;
  --cui-sidebar-header-padding-y: 0.75rem;
  --cui-sidebar-footer-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-footer-height: auto;
  --cui-sidebar-footer-padding-x: 1rem;
  --cui-sidebar-footer-padding-y: 0.75rem;
  --cui-sidebar-toggler-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-toggler-height: 3rem;
  --cui-sidebar-toggler-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  --cui-sidebar-toggler-indicator-width: 4rem;
  --cui-sidebar-toggler-indicator-height: 3rem;
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 0, 0.3);
  --cui-sidebar-toggler-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  --cui-sidebar-narrow-width: 4rem;
  --cui-sidebar-nav-title-padding-x: 1rem;
  --cui-sidebar-nav-title-padding-y: 0.75rem;
  --cui-sidebar-nav-title-margin-top: 1rem;
  --cui-sidebar-nav-title-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-padding-x: 1rem;
  --cui-sidebar-nav-link-padding-y: 0.8445rem;
  --cui-sidebar-nav-link-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-border-color: transparent;
  --cui-sidebar-nav-link-border: 0 solid var(--cui-sidebar-nav-link-border-color);
  --cui-sidebar-nav-link-border-radius: 0;
  --cui-sidebar-nav-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-hover-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-icon-width: 4rem;
  --cui-sidebar-nav-icon-height: 1.25rem;
  --cui-sidebar-nav-icon-font-size: 1.25rem;
  --cui-sidebar-nav-link-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.2);
  --cui-sidebar-nav-group-items-padding-y: 0;
  --cui-sidebar-nav-group-items-padding-x: 0;
  --cui-sidebar-nav-group-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  --cui-sidebar-nav-group-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --cui-sidebar-nav-group-toggle-show-color: rgba(255, 255, 255, 0.6);
  position: relative;
  display: flex;
  flex: 0 0 var(--cui-sidebar-width);
  flex-direction: column;
  order: -1;
  width: var(--cui-sidebar-width);
  padding: var(--cui-sidebar-padding-y) var(--cui-sidebar-padding-x);
  color: var(--cui-sidebar-color);
  background: var(--cui-sidebar-bg);
  box-shadow: none;
  transition: margin-left 0.15s, margin-right 0.15s, box-shadow 0.075s, transform 0.15s, width 0.15s, z-index 0s ease 0.15s;
}
html:not([dir=rtl]) .sidebar {
  border-right: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
}
*[dir=rtl] .sidebar {
  border-left: var(--cui-sidebar-border-width) solid var(--cui-sidebar-border-color);
}
@media (prefers-reduced-motion: reduce) {
  .sidebar {
    transition: none;
  }
}
html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
  margin-left: 0;
}
*[dir=rtl] .sidebar:not(.sidebar-end) {
  margin-right: 0;
}
.sidebar:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 16rem;
}
.sidebar.sidebar-end {
  order: 99;
}
html:not([dir=rtl]) .sidebar.sidebar-end {
  margin-right: 0;
}
*[dir=rtl] .sidebar.sidebar-end {
  margin-left: 0;
}
.sidebar.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 16rem;
}
.sidebar[class*=bg-] {
  border-color: rgba(0, 0, 21, 0.1);
}
.sidebar.sidebar-sm {
  --cui-sidebar-width: 12rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-sm:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 12rem;
  }
  .sidebar.sidebar-sm.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 12rem;
  }
}
.sidebar.sidebar-lg {
  --cui-sidebar-width: 20rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-lg:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 20rem;
  }
  .sidebar.sidebar-lg.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 20rem;
  }
}
.sidebar.sidebar-xl {
  --cui-sidebar-width: 24rem;
}
@media (min-width: 768px) {
  .sidebar.sidebar-xl:not(.sidebar-end):not(.hide) ~ * {
    --cui-sidebar-occupy-start: 24rem;
  }
  .sidebar.sidebar-xl.sidebar-end:not(.hide) ~ * {
    --cui-sidebar-occupy-end: 24rem;
  }
}
@media (min-width: 768px) {
  html:not([dir=rtl]) .sidebar.hide:not(.sidebar-end) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.hide:not(.sidebar-end) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0;
  }
  html:not([dir=rtl]) .sidebar.hide.sidebar-end {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.hide.sidebar-end {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  .sidebar.hide.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0;
  }
}
@media (min-width: 768px) {
  .sidebar.sidebar-fixed {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1030;
    box-shadow: 0 2px 2px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 1px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
  }
  .sidebar.sidebar-fixed:not([class*=border]) {
    border: 0;
  }
  html:not([dir=rtl]) .sidebar.sidebar-fixed:not(.sidebar-end) {
    left: 0;
  }
  *[dir=rtl] .sidebar.sidebar-fixed:not(.sidebar-end) {
    right: 0;
  }
  html:not([dir=rtl]) .sidebar.sidebar-fixed.sidebar-end {
    right: 0;
  }
  *[dir=rtl] .sidebar.sidebar-fixed.sidebar-end {
    left: 0;
  }
}
@media (min-width: 768px) {
  .sidebar.sidebar-sticky {
    position: sticky;
    top: 0;
    height: 100vh;
  }
}
.sidebar.sidebar-overlaid {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 1032;
}
.sidebar.sidebar-overlaid:not(.hide) {
  box-shadow: 0 3px 4px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 3px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 8px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.sidebar.sidebar-overlaid:not(.hide):not([class*=border]) {
  border: 0;
}
html:not([dir=rtl]) .sidebar.sidebar-overlaid:not(.sidebar-end) {
  left: 0;
}
*[dir=rtl] .sidebar.sidebar-overlaid:not(.sidebar-end) {
  right: 0;
}
.sidebar.sidebar-overlaid:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 0 !important;
}
html:not([dir=rtl]) .sidebar.sidebar-overlaid.sidebar-end {
  right: 0;
}
*[dir=rtl] .sidebar.sidebar-overlaid.sidebar-end {
  left: 0;
}
.sidebar.sidebar-overlaid.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 0 !important;
}
@media (max-width: 767.98px) {
  .sidebar {
    --cui-is-mobile: true;
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 1031;
  }
  html:not([dir=rtl]) .sidebar:not(.sidebar-end) {
    left: 0;
  }
  *[dir=rtl] .sidebar:not(.sidebar-end) {
    right: 0;
  }
  .sidebar:not(.sidebar-end) ~ * {
    --cui-sidebar-occupy-start: 0 !important;
  }
  html:not([dir=rtl]) .sidebar:not(.sidebar-end):not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar:not(.sidebar-end):not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  html:not([dir=rtl]) .sidebar.sidebar-end {
    right: 0;
  }
  *[dir=rtl] .sidebar.sidebar-end {
    left: 0;
  }
  .sidebar.sidebar-end ~ * {
    --cui-sidebar-occupy-end: 0 !important;
  }
  html:not([dir=rtl]) .sidebar.sidebar-end:not(.show) {
    margin-right: calc(-1 * var(--cui-sidebar-width));
  }
  *[dir=rtl] .sidebar.sidebar-end:not(.show) {
    margin-left: calc(-1 * var(--cui-sidebar-width));
  }
}

.sidebar-close {
  position: absolute;
  top: 0;
  width: var(--cui-sidebar-close-button-width);
  height: var(--cui-sidebar-close-button-height);
  color: var(--cui-sidebar-color);
  background: transparent;
  border: 0;
}
html:not([dir=rtl]) .sidebar-close {
  right: 0;
}
*[dir=rtl] .sidebar-close {
  left: 0;
}
.sidebar-close:hover {
  text-decoration: none;
}
.sidebar-close:focus {
  outline: 0;
}

.sidebar-brand {
  display: flex;
  flex: 0 0 var(--cui-sidebar-brand-height);
  align-items: center;
  justify-content: center;
  color: var(--cui-sidebar-brand-color);
  background: var(--cui-sidebar-brand-bg);
}
.sidebar-brand .sidebar-brand-narrow {
  display: none;
}

.sidebar-header {
  flex: 0 0 var(--cui-sidebar-header-height);
  padding: var(--cui-sidebar-header-padding-y) var(--cui-sidebar-header-padding-x);
  text-align: center;
  background: var(--cui-sidebar-header-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-header {
    transition: none;
  }
}
.sidebar-header .nav-link {
  display: flex;
  align-items: center;
  min-height: var(--cui-sidebar-header-height);
}

.sidebar-footer {
  flex: 0 0 var(--cui-sidebar-footer-height);
  padding: var(--cui-sidebar-footer-padding-y) var(--cui-sidebar-footer-padding-x);
  background: var(--cui-sidebar-footer-bg);
  transition: height 0.15s, padding 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-footer {
    transition: none;
  }
}

.sidebar-toggler {
  display: flex;
  flex: 0 0 var(--cui-sidebar-toggler-height);
  justify-content: flex-end;
  width: inherit;
  padding: 0;
  cursor: pointer;
  background-color: var(--cui-sidebar-toggler-bg);
  border: 0;
}
@media (max-width: 767.98px) {
  .sidebar-toggler {
    display: none;
  }
}
.sidebar-toggler::before {
  display: block;
  width: var(--cui-sidebar-toggler-indicator-width);
  height: var(--cui-sidebar-toggler-indicator-height);
  content: "";
  background-image: var(--cui-sidebar-toggler-indicator);
  background-repeat: no-repeat;
  background-position: center;
  background-size: calc(var(--cui-sidebar-toggler-indicator-height) * 0.25);
  transition: transform 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-toggler::before {
    transition: none;
  }
}
*[dir=rtl] .sidebar-toggler::before {
  transform: rotate(-180deg);
}
.sidebar-toggler:focus {
  outline: 0;
}
.sidebar-toggler:hover {
  background-color: var(--cui-sidebar-toggler-hover-bg);
}
.sidebar-toggler:hover::before {
  background-image: var(--cui-sidebar-toggler-indicator-hover);
}
.sidebar-end .sidebar-toggler {
  justify-content: flex-start;
}
.sidebar-end .sidebar-toggler::before {
  transform: rotate(-180deg);
}

.sidebar-backdrop {
  --cui-backdrop-zindex: 1030;
  --cui-backdrop-bg: #000015;
  --cui-backdrop-opacity: 0.5;
}
@media (max-width: 767.98px) {
  .sidebar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: var(--cui-backdrop-zindex);
    width: 100vw;
    height: 100vh;
    background-color: var(--cui-backdrop-bg);
  }
  .sidebar-backdrop.fade {
    opacity: 0;
  }
  .sidebar-backdrop.show {
    opacity: var(--cui-backdrop-opacity);
  }
}

.sidebar-light {
  --cui-sidebar-color: rgba(44, 56, 74, 0.95);
  --cui-sidebar-bg: #fff;
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: #fff;
  --cui-sidebar-brand-bg: #321fdb;
  --cui-sidebar-header-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-nav-title-color: rgba(44, 56, 74, 0.681);
  --cui-sidebar-nav-link-color: rgba(44, 56, 74, 0.681);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-icon-color: rgba(44, 56, 74, 0.681);
  --cui-sidebar-nav-link-hover-color: rgba(44, 56, 74, 0.95);
  --cui-sidebar-nav-link-hover-bg: theme-color("primary");
  --cui-sidebar-nav-link-hover-icon-color: rgba(44, 56, 74, 0.95);
  --cui-sidebar-nav-link-active-color: rgba(44, 56, 74, 0.95);
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-icon-color: rgba(44, 56, 74, 0.95);
  --cui-sidebar-nav-link-disabled-color: rgba(44, 56, 74, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(44, 56, 74, 0.681);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.05);
  --cui-sidebar-nav-group-toggle-show-color: rgba(44, 56, 74, 0.681);
  --cui-sidebar-nav-group-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  --cui-sidebar-nav-group-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --cui-sidebar-footer-bg: rgba(0, 0, 21, 0.1);
  --cui-sidebar-toggler-bg: rgba(0, 0, 21, 0.1);
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 0, 0.2);
  --cui-sidebar-toggler-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --cui-sidebar-toggler-indicator-hover: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

.sidebar-nav {
  position: relative;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  padding: 0;
  margin-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  list-style: none;
}
.sidebar-nav .nav-title {
  padding: var(--cui-sidebar-nav-title-padding-y) var(--cui-sidebar-nav-title-padding-x);
  margin-top: var(--cui-sidebar-nav-title-margin-top);
  font-size: 80%;
  font-weight: 700;
  color: var(--cui-sidebar-nav-title-color);
  text-transform: uppercase;
  transition: height 0.15s, margin 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-title {
    transition: none;
  }
}
.sidebar-nav .nav-link {
  display: flex;
  flex: 1 1;
  align-items: center;
  padding: var(--cui-sidebar-nav-link-padding-y) var(--cui-sidebar-nav-link-padding-x);
  color: var(--cui-sidebar-nav-link-color);
  text-decoration: none;
  white-space: nowrap;
  background: var(--cui-sidebar-nav-link-bg);
  border: var(--cui-sidebar-nav-link-border);
  border-radius: var(--cui-sidebar-nav-link-border-radius);
  transition: background 0.15s ease, color 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-link {
    transition: none;
  }
}
.sidebar-nav .nav-link.active {
  color: var(--cui-sidebar-nav-link-active-color);
  background: var(--cui-sidebar-nav-link-active-bg);
}
.sidebar-nav .nav-link.active .nav-icon {
  color: var(--cui-sidebar-nav-link-active-icon-color);
}
.sidebar-nav .nav-link.disabled {
  color: var(--cui-sidebar-nav-link-disabled-color);
  pointer-events: none;
  cursor: not-allowed;
  background: transparent;
}
.sidebar-nav .nav-link.disabled .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover {
  color: var(--cui-sidebar-nav-link-disabled-color);
}
.sidebar-nav .nav-link.disabled:hover .nav-icon {
  color: var(--cui-sidebar-nav-link-disabled-icon-color);
}
.sidebar-nav .nav-link.disabled:hover.nav-dropdown-toggle::after {
  background-image: var(--cui-sidebar-nav-group-indicator-hover);
}
@media (hover: hover), (-ms-high-contrast: none) {
  .sidebar-nav .nav-link:hover {
    color: var(--cui-sidebar-nav-link-hover-color);
    text-decoration: none;
    background: var(--cui-sidebar-nav-link-hover-bg);
  }
  .sidebar-nav .nav-link:hover .nav-icon {
    color: var(--cui-sidebar-nav-link-hover-icon-color);
  }
  .sidebar-nav .nav-link:hover.nav-group-toggle::after {
    background-image: var(--cui-sidebar-nav-group-indicator-hover);
  }
}
.sidebar-nav .nav-icon {
  flex: 0 0 var(--cui-sidebar-nav-icon-width);
  height: var(--cui-sidebar-nav-icon-height);
  font-size: var(--cui-sidebar-nav-icon-font-size);
  color: var(--cui-sidebar-nav-link-icon-color);
  text-align: center;
  pointer-events: none;
  fill: currentcolor;
  transition: inherit;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-icon {
    transition: none;
  }
}
html:not([dir=rtl]) .sidebar-nav .nav-icon:first-child {
  margin-left: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
*[dir=rtl] .sidebar-nav .nav-icon:first-child {
  margin-right: calc(var(--cui-sidebar-nav-link-padding-x) * -1);
}
.sidebar-nav svg.nav-icon {
  overflow: hidden;
}
.sidebar-nav .nav-group {
  position: relative;
  transition: background 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group {
    transition: none;
  }
}
.sidebar-nav .nav-group .nav-group-items {
  padding: var(--cui-sidebar-nav-group-items-padding-y) var(--cui-sidebar-nav-group-items-padding-x);
  overflow: hidden;
  transition: height 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group .nav-group-items {
    transition: none;
  }
}
.sidebar-nav .nav-group:not(.show) .nav-group-items {
  display: none;
}
.sidebar-nav .nav-group.show {
  background: var(--cui-sidebar-nav-group-bg);
}
.sidebar-nav .nav-group.show .nav-group-toggle {
  color: var(--cui-sidebar-nav-group-toggle-show-color);
}
.sidebar-nav .nav-group.show > .nav-group-toggle::after {
  transform: rotate(180deg);
}
.sidebar-nav .nav-group.show + .show {
  margin-top: 1px;
}
.sidebar-nav .nav-group-toggle {
  cursor: pointer;
}
.sidebar-nav .nav-group-toggle::after {
  display: block;
  flex: 0 1 12px;
  height: 12px;
  content: "";
  background-image: var(--cui-sidebar-nav-group-indicator);
  background-repeat: no-repeat;
  background-position: center;
  transition: transform 0.15s;
}
html:not([dir=rtl]) .sidebar-nav .nav-group-toggle::after {
  margin-left: auto;
}
*[dir=rtl] .sidebar-nav .nav-group-toggle::after {
  margin-right: auto;
}
@media (prefers-reduced-motion: reduce) {
  .sidebar-nav .nav-group-toggle::after {
    transition: none;
  }
}
.sidebar-nav .nav-group-items {
  padding: 0;
  list-style: none;
}
html:not([dir=rtl]) .sidebar-nav .nav-group-items .nav-link {
  padding-left: var(--cui-sidebar-nav-icon-width);
}
*[dir=rtl] .sidebar-nav .nav-group-items .nav-link {
  padding-right: var(--cui-sidebar-nav-icon-width);
}
html:not([dir=rtl]) .sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-left: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
*[dir=rtl] .sidebar-nav .nav-group-items .nav-link .nav-icon {
  margin-right: calc(var(--cui-sidebar-nav-icon-width) * -1);
}
.sidebar-nav.compact .nav-link,
.sidebar-nav .compact .nav-link {
  padding-top: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
  padding-bottom: calc(var(--cui-sidebar-nav-link-padding-y) * 0.5);
}

@media (min-width: 768px) {
  .sidebar-narrow-unfoldable:not(:hover), .sidebar-narrow {
    z-index: 1031;
    flex: 0 0 var(--cui-sidebar-narrow-width);
    width: var(--cui-sidebar-narrow-width);
    padding-bottom: var(--cui-sidebar-toggler-height);
    overflow: visible;
  }
  .sidebar-fixed.sidebar-narrow-unfoldable:not(:hover), .sidebar-fixed.sidebar-narrow {
    z-index: 1031;
    width: var(--cui-sidebar-narrow-width);
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-full, .sidebar-narrow .sidebar-brand-full {
    display: none;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-brand-narrow, .sidebar-narrow .sidebar-brand-narrow {
    display: block;
  }
  .sidebar-narrow-unfoldable:not(:hover) .d-narrow-none, .sidebar-narrow .d-narrow-none,
  .sidebar-narrow-unfoldable:not(:hover) .nav-label,
  .sidebar-narrow .nav-label,
  .sidebar-narrow-unfoldable:not(:hover) .nav-title,
  .sidebar-narrow .nav-title,
  .sidebar-narrow-unfoldable:not(:hover) .nav-group-items,
  .sidebar-narrow .nav-group-items,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-footer,
  .sidebar-narrow .sidebar-footer,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-form,
  .sidebar-narrow .sidebar-form,
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-header,
  .sidebar-narrow .sidebar-header {
    height: 0 !important;
    padding: 0;
    margin: 0;
    visibility: hidden;
    opacity: 0;
  }
  .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler, .sidebar-narrow .sidebar-toggler {
    position: fixed;
    bottom: 0;
  }
  html:not([dir=rtl]) .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, html:not([dir=rtl]) .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(-180deg);
  }
  *[dir=rtl] .sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, *[dir=rtl] .sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
  .sidebar-end.sidebar-narrow-unfoldable:not(:hover) .sidebar-toggler::before, .sidebar-end.sidebar-narrow .sidebar-toggler::before {
    transform: rotate(0deg);
  }
}

.sidebar-narrow:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}

.sidebar-narrow-unfoldable {
  position: fixed;
  z-index: 1031;
}
.sidebar-narrow-unfoldable:not(.sidebar-end) ~ * {
  --cui-sidebar-occupy-start: 4rem;
}
.sidebar-narrow-unfoldable.sidebar-end ~ * {
  --cui-sidebar-occupy-end: 4rem;
}
html:not([dir=rtl]) .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(-180deg);
}
*[dir=rtl] .sidebar-narrow-unfoldable:hover .sidebar-toggler::before {
  transform: rotate(0deg);
}
.sidebar-narrow-unfoldable:hover.sidebar-end .sidebar-toggler::before {
  transform: rotate(0deg);
}

html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}
*[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable:not(.sidebar-end) {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}
html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
}
*[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding.sidebar-narrow-unfoldable.sidebar-end {
  margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
}

@media (max-width: 575.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-sm.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 767.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-md.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 991.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-lg.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1199.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
@media (max-width: 1399.98px) {
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow:not(.sidebar-end), *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable:not(.sidebar-end) {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, html:not([dir=rtl]) .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-right: calc(var(--cui-sidebar-narrow-width) * -1);
  }
  *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow.sidebar-end, *[dir=rtl] .sidebar:not(.show).sidebar-self-hiding-xxl.sidebar-narrow-unfoldable.sidebar-end {
    margin-left: calc(var(--cui-sidebar-narrow-width) * -1);
  }
}
.subheader {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  min-height: 3rem;
  padding: 0.5rem 1rem;
  background: var(--cui-subheader-bg, #fff);
  border-bottom: var(--cui-subheader-border-width, var(--cui-border-width)) solid var(--cui-subheader-border-color, var(--cui-border-color));
}

.subheader-sticky {
  position: sticky;
  top: 0;
  z-index: 1029;
  box-shadow: 0 2px 2px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 1px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20);
}
.subheader-sticky:not([class*=border]) {
  border: 0;
}

.subheader-nav {
  display: flex;
  flex-direction: row;
  margin-bottom: 0;
  list-style: none;
}
html:not([dir=rtl]) .subheader-nav {
  padding-left: 0;
}
*[dir=rtl] .subheader-nav {
  padding-right: 0;
}
.subheader-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-nav .nav-link:hover, .subheader-nav .nav-link:focus {
  color: var(--cui-subheader-hover-color, var(--cui-body-color));
}
.subheader-nav .nav-link.disabled {
  color: var(--cui-subheader-disabled-color, rgba(44, 56, 74, 0.38));
}
.subheader-nav .show > .nav-link,
.subheader-nav .nav-link.active {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-nav .dropdown-menu {
  position: absolute;
}

.subheader-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--cui-subheader-color, var(--cui-secondary-color));
}
.subheader-text a {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}
.subheader-text a:hover, .subheader-text a:focus {
  color: var(--cui-subheader-active-color, var(--cui-body-color));
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-primary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000015 !important;
  background-color: RGBA(var(--cui-secondary-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000015 !important;
  background-color: RGBA(var(--cui-success-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000015 !important;
  background-color: RGBA(var(--cui-info-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(var(--cui-warning-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000015 !important;
  background-color: RGBA(var(--cui-danger-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: rgba(44, 56, 74, 0.95) !important;
  background-color: RGBA(var(--cui-light-rgb), var(--cui-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: rgba(255, 255, 255, 0.87) !important;
  background-color: RGBA(var(--cui-dark-rgb), var(--cui-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--cui-primary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-primary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(91, 76, 226, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(91, 76, 226, var(--cui-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--cui-secondary-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-secondary-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(177, 183, 193, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(177, 183, 193, var(--cui-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--cui-success-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-success-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(88, 198, 125, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(88, 198, 125, var(--cui-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--cui-info-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-info-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(92, 173, 255, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(92, 173, 255, var(--cui-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--cui-warning-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-warning-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(199, 142, 17, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(199, 142, 17, var(--cui-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--cui-danger-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-danger-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(234, 117, 117, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(234, 117, 117, var(--cui-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--cui-light-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-light-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(188, 190, 191, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(188, 190, 191, var(--cui-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--cui-dark-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-dark-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(114, 125, 143, var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(114, 125, 143, var(--cui-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--cui-emphasis-color-rgb), var(--cui-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--cui-focus-ring-x, 0) var(--cui-focus-ring-y, 0) var(--cui-focus-ring-blur, 0) var(--cui-focus-ring-width) var(--cui-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--cui-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--cui-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
html:not([dir=rtl]) .ratio > * {
  left: 0;
}
*[dir=rtl] .ratio > * {
  right: 0;
}

.ratio-1x1 {
  --cui-aspect-ratio: 100%;
}

.ratio-4x3 {
  --cui-aspect-ratio: 75%;
}

.ratio-16x9 {
  --cui-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --cui-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--cui-border-width);
  min-height: 1em;
  padding: 0;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

html:not([dir=rtl]) .float-start {
  float: left !important;
}
*[dir=rtl] .float-start {
  float: right !important;
}

html:not([dir=rtl]) .float-end {
  float: right !important;
}
*[dir=rtl] .float-end {
  float: left !important;
}

html:not([dir=rtl]) .float-none {
  float: none !important;
}
*[dir=rtl] .float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--cui-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--cui-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--cui-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.elevation-0 {
  box-shadow: none !important;
}

.elevation-1 {
  box-shadow: 0 1px 1px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 2px 1px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 3px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-2 {
  box-shadow: 0 2px 2px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 1px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-3 {
  box-shadow: 0 3px 4px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 3px -2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 1px 8px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-4 {
  box-shadow: 0 4px 5px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 1px 10px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 2px 4px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-6 {
  box-shadow: 0 6px 10px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 1px 18px 0 rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 3px 5px -1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-8 {
  box-shadow: 0 8px 10px 1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 14px 2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 5px 5px -3px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-9 {
  box-shadow: 0 9px 12px 1px rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 3px 16px 2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 5px 6px -3px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-12 {
  box-shadow: 0 12px 17px 2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 5px 22px 4px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 7px 8px -4px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-16 {
  box-shadow: 0 16px 24px 2px rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 6px 30px 5px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 8px 10px -5px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.elevation-24 {
  box-shadow: 0 24px 38px 3px rgba(var(--cui-elevation-base-color, 60, 75, 100), .14), 0 9px 46px 8px rgba(var(--cui-elevation-base-color, 60, 75, 100), .12), 0 11px 15px -7px rgba(var(--cui-elevation-base-color, 60, 75, 100), .20) !important;
}

.focus-ring-primary {
  --cui-focus-ring-color: rgba(var(--cui-primary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-secondary {
  --cui-focus-ring-color: rgba(var(--cui-secondary-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-success {
  --cui-focus-ring-color: rgba(var(--cui-success-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-info {
  --cui-focus-ring-color: rgba(var(--cui-info-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-warning {
  --cui-focus-ring-color: rgba(var(--cui-warning-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-danger {
  --cui-focus-ring-color: rgba(var(--cui-danger-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-light {
  --cui-focus-ring-color: rgba(var(--cui-light-rgb), var(--cui-focus-ring-opacity));
}

.focus-ring-dark {
  --cui-focus-ring-color: rgba(var(--cui-dark-rgb), var(--cui-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

html:not([dir=rtl]) .border-end {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}
*[dir=rtl] .border-end {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

html:not([dir=rtl]) .border-end-0 {
  border-right: 0 !important;
}
*[dir=rtl] .border-end-0 {
  border-left: 0 !important;
}

.border-bottom {
  border-bottom: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

html:not([dir=rtl]) .border-start {
  border-left: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}
*[dir=rtl] .border-start {
  border-right: var(--cui-border-width) var(--cui-border-style) var(--cui-border-color) !important;
}

html:not([dir=rtl]) .border-start-0 {
  border-left: 0 !important;
}
*[dir=rtl] .border-start-0 {
  border-right: 0 !important;
}

.border-primary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-primary-rgb), var(--cui-border-opacity)) !important;
}

.border-secondary {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-secondary-rgb), var(--cui-border-opacity)) !important;
}

.border-success {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-success-rgb), var(--cui-border-opacity)) !important;
}

.border-info {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-info-rgb), var(--cui-border-opacity)) !important;
}

.border-warning {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-warning-rgb), var(--cui-border-opacity)) !important;
}

.border-danger {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-danger-rgb), var(--cui-border-opacity)) !important;
}

.border-light {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-light-rgb), var(--cui-border-opacity)) !important;
}

.border-dark {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-dark-rgb), var(--cui-border-opacity)) !important;
}

.border-white {
  --cui-border-opacity: 1;
  border-color: rgba(var(--cui-white-rgb), var(--cui-border-opacity)) !important;
}

.border-top-primary {
  border-top-color: #321fdb !important;
}

.border-top-secondary {
  border-top-color: #9da5b1 !important;
}

.border-top-success {
  border-top-color: #2eb85c !important;
}

.border-top-info {
  border-top-color: #39f !important;
}

.border-top-warning {
  border-top-color: #f9b115 !important;
}

.border-top-danger {
  border-top-color: #e55353 !important;
}

.border-top-light {
  border-top-color: #ebedef !important;
}

.border-top-dark {
  border-top-color: #4f5d73 !important;
}

.border-top-white {
  border-top-color: #fff !important;
}

html:not([dir=rtl]) .border-end-primary {
  border-right-color: #321fdb !important;
}
*[dir=rtl] .border-end-primary {
  border-left-color: #321fdb !important;
}

html:not([dir=rtl]) .border-end-secondary {
  border-right-color: #9da5b1 !important;
}
*[dir=rtl] .border-end-secondary {
  border-left-color: #9da5b1 !important;
}

html:not([dir=rtl]) .border-end-success {
  border-right-color: #2eb85c !important;
}
*[dir=rtl] .border-end-success {
  border-left-color: #2eb85c !important;
}

html:not([dir=rtl]) .border-end-info {
  border-right-color: #39f !important;
}
*[dir=rtl] .border-end-info {
  border-left-color: #39f !important;
}

html:not([dir=rtl]) .border-end-warning {
  border-right-color: #f9b115 !important;
}
*[dir=rtl] .border-end-warning {
  border-left-color: #f9b115 !important;
}

html:not([dir=rtl]) .border-end-danger {
  border-right-color: #e55353 !important;
}
*[dir=rtl] .border-end-danger {
  border-left-color: #e55353 !important;
}

html:not([dir=rtl]) .border-end-light {
  border-right-color: #ebedef !important;
}
*[dir=rtl] .border-end-light {
  border-left-color: #ebedef !important;
}

html:not([dir=rtl]) .border-end-dark {
  border-right-color: #4f5d73 !important;
}
*[dir=rtl] .border-end-dark {
  border-left-color: #4f5d73 !important;
}

html:not([dir=rtl]) .border-end-white {
  border-right-color: #fff !important;
}
*[dir=rtl] .border-end-white {
  border-left-color: #fff !important;
}

.border-bottom-primary {
  border-bottom-color: #321fdb !important;
}

.border-bottom-secondary {
  border-bottom-color: #9da5b1 !important;
}

.border-bottom-success {
  border-bottom-color: #2eb85c !important;
}

.border-bottom-info {
  border-bottom-color: #39f !important;
}

.border-bottom-warning {
  border-bottom-color: #f9b115 !important;
}

.border-bottom-danger {
  border-bottom-color: #e55353 !important;
}

.border-bottom-light {
  border-bottom-color: #ebedef !important;
}

.border-bottom-dark {
  border-bottom-color: #4f5d73 !important;
}

.border-bottom-white {
  border-bottom-color: #fff !important;
}

html:not([dir=rtl]) .border-start-primary {
  border-left-color: #321fdb !important;
}
*[dir=rtl] .border-start-primary {
  border-right-color: #321fdb !important;
}

html:not([dir=rtl]) .border-start-secondary {
  border-left-color: #9da5b1 !important;
}
*[dir=rtl] .border-start-secondary {
  border-right-color: #9da5b1 !important;
}

html:not([dir=rtl]) .border-start-success {
  border-left-color: #2eb85c !important;
}
*[dir=rtl] .border-start-success {
  border-right-color: #2eb85c !important;
}

html:not([dir=rtl]) .border-start-info {
  border-left-color: #39f !important;
}
*[dir=rtl] .border-start-info {
  border-right-color: #39f !important;
}

html:not([dir=rtl]) .border-start-warning {
  border-left-color: #f9b115 !important;
}
*[dir=rtl] .border-start-warning {
  border-right-color: #f9b115 !important;
}

html:not([dir=rtl]) .border-start-danger {
  border-left-color: #e55353 !important;
}
*[dir=rtl] .border-start-danger {
  border-right-color: #e55353 !important;
}

html:not([dir=rtl]) .border-start-light {
  border-left-color: #ebedef !important;
}
*[dir=rtl] .border-start-light {
  border-right-color: #ebedef !important;
}

html:not([dir=rtl]) .border-start-dark {
  border-left-color: #4f5d73 !important;
}
*[dir=rtl] .border-start-dark {
  border-right-color: #4f5d73 !important;
}

html:not([dir=rtl]) .border-start-white {
  border-left-color: #fff !important;
}
*[dir=rtl] .border-start-white {
  border-right-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

html:not([dir=rtl]) .border-end-1 {
  border-right-width: 1px !important;
}
*[dir=rtl] .border-end-1 {
  border-left-width: 1px !important;
}

html:not([dir=rtl]) .border-end-2 {
  border-right-width: 2px !important;
}
*[dir=rtl] .border-end-2 {
  border-left-width: 2px !important;
}

html:not([dir=rtl]) .border-end-3 {
  border-right-width: 3px !important;
}
*[dir=rtl] .border-end-3 {
  border-left-width: 3px !important;
}

html:not([dir=rtl]) .border-end-4 {
  border-right-width: 4px !important;
}
*[dir=rtl] .border-end-4 {
  border-left-width: 4px !important;
}

html:not([dir=rtl]) .border-end-5 {
  border-right-width: 5px !important;
}
*[dir=rtl] .border-end-5 {
  border-left-width: 5px !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

html:not([dir=rtl]) .border-start-1 {
  border-left-width: 1px !important;
}
*[dir=rtl] .border-start-1 {
  border-right-width: 1px !important;
}

html:not([dir=rtl]) .border-start-2 {
  border-left-width: 2px !important;
}
*[dir=rtl] .border-start-2 {
  border-right-width: 2px !important;
}

html:not([dir=rtl]) .border-start-3 {
  border-left-width: 3px !important;
}
*[dir=rtl] .border-start-3 {
  border-right-width: 3px !important;
}

html:not([dir=rtl]) .border-start-4 {
  border-left-width: 4px !important;
}
*[dir=rtl] .border-start-4 {
  border-right-width: 4px !important;
}

html:not([dir=rtl]) .border-start-5 {
  border-left-width: 5px !important;
}
*[dir=rtl] .border-start-5 {
  border-right-width: 5px !important;
}

.border-opacity-10 {
  --cui-border-opacity: 0.1;
}

.border-opacity-25 {
  --cui-border-opacity: 0.25;
}

.border-opacity-50 {
  --cui-border-opacity: 0.5;
}

.border-opacity-75 {
  --cui-border-opacity: 0.75;
}

.border-opacity-100 {
  --cui-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

html:not([dir=rtl]) .me-0 {
  margin-right: 0 !important;
}
*[dir=rtl] .me-0 {
  margin-left: 0 !important;
}

html:not([dir=rtl]) .me-1 {
  margin-right: 0.25rem !important;
}
*[dir=rtl] .me-1 {
  margin-left: 0.25rem !important;
}

html:not([dir=rtl]) .me-2 {
  margin-right: 0.5rem !important;
}
*[dir=rtl] .me-2 {
  margin-left: 0.5rem !important;
}

html:not([dir=rtl]) .me-3 {
  margin-right: 1rem !important;
}
*[dir=rtl] .me-3 {
  margin-left: 1rem !important;
}

html:not([dir=rtl]) .me-4 {
  margin-right: 1.5rem !important;
}
*[dir=rtl] .me-4 {
  margin-left: 1.5rem !important;
}

html:not([dir=rtl]) .me-5 {
  margin-right: 3rem !important;
}
*[dir=rtl] .me-5 {
  margin-left: 3rem !important;
}

html:not([dir=rtl]) .me-auto {
  margin-right: auto !important;
}
*[dir=rtl] .me-auto {
  margin-left: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

html:not([dir=rtl]) .ms-0 {
  margin-left: 0 !important;
}
*[dir=rtl] .ms-0 {
  margin-right: 0 !important;
}

html:not([dir=rtl]) .ms-1 {
  margin-left: 0.25rem !important;
}
*[dir=rtl] .ms-1 {
  margin-right: 0.25rem !important;
}

html:not([dir=rtl]) .ms-2 {
  margin-left: 0.5rem !important;
}
*[dir=rtl] .ms-2 {
  margin-right: 0.5rem !important;
}

html:not([dir=rtl]) .ms-3 {
  margin-left: 1rem !important;
}
*[dir=rtl] .ms-3 {
  margin-right: 1rem !important;
}

html:not([dir=rtl]) .ms-4 {
  margin-left: 1.5rem !important;
}
*[dir=rtl] .ms-4 {
  margin-right: 1.5rem !important;
}

html:not([dir=rtl]) .ms-5 {
  margin-left: 3rem !important;
}
*[dir=rtl] .ms-5 {
  margin-right: 3rem !important;
}

html:not([dir=rtl]) .ms-auto {
  margin-left: auto !important;
}
*[dir=rtl] .ms-auto {
  margin-right: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

html:not([dir=rtl]) .pe-0 {
  padding-right: 0 !important;
}
*[dir=rtl] .pe-0 {
  padding-left: 0 !important;
}

html:not([dir=rtl]) .pe-1 {
  padding-right: 0.25rem !important;
}
*[dir=rtl] .pe-1 {
  padding-left: 0.25rem !important;
}

html:not([dir=rtl]) .pe-2 {
  padding-right: 0.5rem !important;
}
*[dir=rtl] .pe-2 {
  padding-left: 0.5rem !important;
}

html:not([dir=rtl]) .pe-3 {
  padding-right: 1rem !important;
}
*[dir=rtl] .pe-3 {
  padding-left: 1rem !important;
}

html:not([dir=rtl]) .pe-4 {
  padding-right: 1.5rem !important;
}
*[dir=rtl] .pe-4 {
  padding-left: 1.5rem !important;
}

html:not([dir=rtl]) .pe-5 {
  padding-right: 3rem !important;
}
*[dir=rtl] .pe-5 {
  padding-left: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

html:not([dir=rtl]) .ps-0 {
  padding-left: 0 !important;
}
*[dir=rtl] .ps-0 {
  padding-right: 0 !important;
}

html:not([dir=rtl]) .ps-1 {
  padding-left: 0.25rem !important;
}
*[dir=rtl] .ps-1 {
  padding-right: 0.25rem !important;
}

html:not([dir=rtl]) .ps-2 {
  padding-left: 0.5rem !important;
}
*[dir=rtl] .ps-2 {
  padding-right: 0.5rem !important;
}

html:not([dir=rtl]) .ps-3 {
  padding-left: 1rem !important;
}
*[dir=rtl] .ps-3 {
  padding-right: 1rem !important;
}

html:not([dir=rtl]) .ps-4 {
  padding-left: 1.5rem !important;
}
*[dir=rtl] .ps-4 {
  padding-right: 1.5rem !important;
}

html:not([dir=rtl]) .ps-5 {
  padding-left: 3rem !important;
}
*[dir=rtl] .ps-5 {
  padding-right: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--cui-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

html:not([dir=rtl]) .text-start {
  text-align: left !important;
}
*[dir=rtl] .text-start {
  text-align: right !important;
}

html:not([dir=rtl]) .text-end {
  text-align: right !important;
}
*[dir=rtl] .text-end {
  text-align: left !important;
}

html:not([dir=rtl]) .text-center {
  text-align: center !important;
}
*[dir=rtl] .text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}

.text-secondary {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}

.text-success {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}

.text-info {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}

.text-warning {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}

.text-danger {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}

.text-light {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}

.text-dark {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}

.text-black {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}

.text-white {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}

.text-body {
  --cui-text-opacity: 1;
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}

.text-muted {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-black-50 {
  --cui-text-opacity: 1;
  color: rgba(0, 0, 21, 0.5) !important;
}

.text-white-50 {
  --cui-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --cui-text-opacity: 1;
  color: var(--cui-secondary-color) !important;
}

.text-body-tertiary {
  --cui-text-opacity: 1;
  color: var(--cui-tertiary-color) !important;
}

.text-body-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-emphasis-color) !important;
}

.text-reset {
  --cui-text-opacity: 1;
  color: inherit !important;
}

.text-high-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis-inverse) !important;
}

.text-medium-emphasis-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis-inverse) !important;
}

.text-disabled-inverse {
  --cui-text-opacity: 1;
  color: var(--cui-disabled-inverse) !important;
}

.text-high-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-high-emphasis) !important;
}

.text-medium-emphasis {
  --cui-text-opacity: 1;
  color: var(--cui-medium-emphasis) !important;
}

.text-disabled {
  --cui-text-opacity: 1;
  color: var(--cui-disabled) !important;
}

.text-opacity-25 {
  --cui-text-opacity: 0.25;
}

.text-opacity-50 {
  --cui-text-opacity: 0.5;
}

.text-opacity-75 {
  --cui-text-opacity: 0.75;
}

.text-opacity-100 {
  --cui-text-opacity: 1;
}

.link-opacity-10 {
  --cui-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --cui-link-opacity: 0.1;
}

.link-opacity-25 {
  --cui-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --cui-link-opacity: 0.25;
}

.link-opacity-50 {
  --cui-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --cui-link-opacity: 0.5;
}

.link-opacity-75 {
  --cui-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --cui-link-opacity: 0.75;
}

.link-opacity-100 {
  --cui-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --cui-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-primary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-secondary-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-success {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-success-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-info {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-info-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-warning {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-warning-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-danger {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-danger-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-light {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-light-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline-dark {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-dark-rgb), var(--cui-link-underline-opacity)) !important;
}

.link-underline {
  --cui-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--cui-link-color-rgb), var(--cui-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --cui-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --cui-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --cui-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --cui-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --cui-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --cui-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --cui-link-underline-opacity: 1;
}

.bg-primary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}

.bg-success {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}

.bg-info {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}

.bg-warning {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}

.bg-danger {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}

.bg-light {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}

.bg-dark {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}

.bg-black {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}

.bg-white {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-transparent {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-body-tertiary {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-tertiary-bg-rgb), var(--cui-bg-opacity)) !important;
}

.bg-opacity-10 {
  --cui-bg-opacity: 0.1;
}

.bg-opacity-15 {
  --cui-bg-opacity: 0.15;
}

.bg-opacity-25 {
  --cui-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --cui-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --cui-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --cui-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--cui-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--cui-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--cui-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--cui-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--cui-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--cui-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
  border-top-right-radius: var(--cui-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

html:not([dir=rtl]) .rounded-end {
  border-top-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end {
  border-top-left-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-end {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-end-0 {
  border-top-right-radius: 0 !important;
}
*[dir=rtl] .rounded-end-0 {
  border-top-left-radius: 0 !important;
}
html:not([dir=rtl]) .rounded-end-0 {
  border-bottom-right-radius: 0 !important;
}
*[dir=rtl] .rounded-end-0 {
  border-bottom-left-radius: 0 !important;
}

html:not([dir=rtl]) .rounded-end-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-end-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}
html:not([dir=rtl]) .rounded-end-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-end-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

html:not([dir=rtl]) .rounded-end-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-end-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-end-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-end-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-end-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}
html:not([dir=rtl]) .rounded-end-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-end-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

html:not([dir=rtl]) .rounded-end-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-end-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}
html:not([dir=rtl]) .rounded-end-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-end-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

html:not([dir=rtl]) .rounded-end-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-end-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}
html:not([dir=rtl]) .rounded-end-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-end-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

html:not([dir=rtl]) .rounded-end-circle {
  border-top-right-radius: 50% !important;
}
*[dir=rtl] .rounded-end-circle {
  border-top-left-radius: 50% !important;
}
html:not([dir=rtl]) .rounded-end-circle {
  border-bottom-right-radius: 50% !important;
}
*[dir=rtl] .rounded-end-circle {
  border-bottom-left-radius: 50% !important;
}

html:not([dir=rtl]) .rounded-end-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-end-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}
html:not([dir=rtl]) .rounded-end-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-end-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
  border-bottom-left-radius: var(--cui-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}

html:not([dir=rtl]) .rounded-start {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-start {
  border-top-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start {
  border-top-right-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-start-0 {
  border-bottom-left-radius: 0 !important;
}
*[dir=rtl] .rounded-start-0 {
  border-bottom-right-radius: 0 !important;
}
html:not([dir=rtl]) .rounded-start-0 {
  border-top-left-radius: 0 !important;
}
*[dir=rtl] .rounded-start-0 {
  border-top-right-radius: 0 !important;
}

html:not([dir=rtl]) .rounded-start-1 {
  border-bottom-left-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-start-1 {
  border-bottom-right-radius: var(--cui-border-radius-sm) !important;
}
html:not([dir=rtl]) .rounded-start-1 {
  border-top-left-radius: var(--cui-border-radius-sm) !important;
}
*[dir=rtl] .rounded-start-1 {
  border-top-right-radius: var(--cui-border-radius-sm) !important;
}

html:not([dir=rtl]) .rounded-start-2 {
  border-bottom-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start-2 {
  border-bottom-right-radius: var(--cui-border-radius) !important;
}
html:not([dir=rtl]) .rounded-start-2 {
  border-top-left-radius: var(--cui-border-radius) !important;
}
*[dir=rtl] .rounded-start-2 {
  border-top-right-radius: var(--cui-border-radius) !important;
}

html:not([dir=rtl]) .rounded-start-3 {
  border-bottom-left-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-start-3 {
  border-bottom-right-radius: var(--cui-border-radius-lg) !important;
}
html:not([dir=rtl]) .rounded-start-3 {
  border-top-left-radius: var(--cui-border-radius-lg) !important;
}
*[dir=rtl] .rounded-start-3 {
  border-top-right-radius: var(--cui-border-radius-lg) !important;
}

html:not([dir=rtl]) .rounded-start-4 {
  border-bottom-left-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-start-4 {
  border-bottom-right-radius: var(--cui-border-radius-xl) !important;
}
html:not([dir=rtl]) .rounded-start-4 {
  border-top-left-radius: var(--cui-border-radius-xl) !important;
}
*[dir=rtl] .rounded-start-4 {
  border-top-right-radius: var(--cui-border-radius-xl) !important;
}

html:not([dir=rtl]) .rounded-start-5 {
  border-bottom-left-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-start-5 {
  border-bottom-right-radius: var(--cui-border-radius-xxl) !important;
}
html:not([dir=rtl]) .rounded-start-5 {
  border-top-left-radius: var(--cui-border-radius-xxl) !important;
}
*[dir=rtl] .rounded-start-5 {
  border-top-right-radius: var(--cui-border-radius-xxl) !important;
}

html:not([dir=rtl]) .rounded-start-circle {
  border-bottom-left-radius: 50% !important;
}
*[dir=rtl] .rounded-start-circle {
  border-bottom-right-radius: 50% !important;
}
html:not([dir=rtl]) .rounded-start-circle {
  border-top-left-radius: 50% !important;
}
*[dir=rtl] .rounded-start-circle {
  border-top-right-radius: 50% !important;
}

html:not([dir=rtl]) .rounded-start-pill {
  border-bottom-left-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-start-pill {
  border-bottom-right-radius: var(--cui-border-radius-pill) !important;
}
html:not([dir=rtl]) .rounded-start-pill {
  border-top-left-radius: var(--cui-border-radius-pill) !important;
}
*[dir=rtl] .rounded-start-pill {
  border-top-right-radius: var(--cui-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  html:not([dir=rtl]) .float-sm-start {
    float: left !important;
  }
  *[dir=rtl] .float-sm-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-sm-end {
    float: right !important;
  }
  *[dir=rtl] .float-sm-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-sm-none {
    float: none !important;
  }
  *[dir=rtl] .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-sm-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-sm-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-sm-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-sm-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-sm-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-sm-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-sm-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-sm-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-sm-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-sm-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-sm-auto {
    margin-left: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-sm-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-sm-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-sm-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-sm-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-sm-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-sm-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-sm-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-sm-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-sm-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-sm-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-sm-auto {
    margin-right: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-sm-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-sm-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-sm-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-sm-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-sm-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-sm-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-sm-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-sm-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-sm-5 {
    padding-left: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-sm-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-sm-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-sm-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-sm-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-sm-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-sm-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-sm-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-sm-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-sm-5 {
    padding-right: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-sm-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-sm-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-sm-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-sm-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-sm-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  html:not([dir=rtl]) .float-md-start {
    float: left !important;
  }
  *[dir=rtl] .float-md-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-md-end {
    float: right !important;
  }
  *[dir=rtl] .float-md-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-md-none {
    float: none !important;
  }
  *[dir=rtl] .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-md-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-md-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-md-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-md-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-md-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-md-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-md-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-md-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-md-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-md-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-md-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-md-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-md-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-md-auto {
    margin-left: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-md-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-md-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-md-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-md-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-md-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-md-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-md-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-md-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-md-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-md-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-md-auto {
    margin-right: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-md-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-md-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-md-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-md-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-md-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-md-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-md-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-md-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-md-5 {
    padding-left: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-md-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-md-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-md-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-md-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-md-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-md-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-md-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-md-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-md-5 {
    padding-right: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-md-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-md-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-md-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-md-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-md-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  html:not([dir=rtl]) .float-lg-start {
    float: left !important;
  }
  *[dir=rtl] .float-lg-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-lg-end {
    float: right !important;
  }
  *[dir=rtl] .float-lg-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-lg-none {
    float: none !important;
  }
  *[dir=rtl] .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-lg-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-lg-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-lg-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-lg-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-lg-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-lg-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-lg-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-lg-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-lg-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-lg-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-lg-auto {
    margin-left: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-lg-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-lg-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-lg-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-lg-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-lg-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-lg-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-lg-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-lg-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-lg-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-lg-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-lg-auto {
    margin-right: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-lg-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-lg-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-lg-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-lg-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-lg-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-lg-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-lg-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-lg-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-lg-5 {
    padding-left: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-lg-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-lg-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-lg-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-lg-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-lg-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-lg-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-lg-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-lg-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-lg-5 {
    padding-right: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-lg-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-lg-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-lg-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-lg-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-lg-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  html:not([dir=rtl]) .float-xl-start {
    float: left !important;
  }
  *[dir=rtl] .float-xl-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-xl-end {
    float: right !important;
  }
  *[dir=rtl] .float-xl-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-xl-none {
    float: none !important;
  }
  *[dir=rtl] .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-xl-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-xl-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-xl-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-xl-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-xl-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-xl-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-xl-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-xl-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-xl-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-xl-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-xl-auto {
    margin-left: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-xl-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-xl-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-xl-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-xl-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-xl-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-xl-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-xl-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-xl-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-xl-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-xl-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-xl-auto {
    margin-right: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-xl-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-xl-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-xl-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-xl-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-xl-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-xl-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-xl-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-xl-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-xl-5 {
    padding-left: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-xl-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-xl-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-xl-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-xl-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-xl-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-xl-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-xl-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-xl-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-xl-5 {
    padding-right: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-xl-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-xl-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-xl-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-xl-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-xl-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  html:not([dir=rtl]) .float-xxl-start {
    float: left !important;
  }
  *[dir=rtl] .float-xxl-start {
    float: right !important;
  }
  html:not([dir=rtl]) .float-xxl-end {
    float: right !important;
  }
  *[dir=rtl] .float-xxl-end {
    float: left !important;
  }
  html:not([dir=rtl]) .float-xxl-none {
    float: none !important;
  }
  *[dir=rtl] .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  html:not([dir=rtl]) .me-xxl-0 {
    margin-right: 0 !important;
  }
  *[dir=rtl] .me-xxl-0 {
    margin-left: 0 !important;
  }
  html:not([dir=rtl]) .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  *[dir=rtl] .me-xxl-1 {
    margin-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  *[dir=rtl] .me-xxl-2 {
    margin-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .me-xxl-3 {
    margin-right: 1rem !important;
  }
  *[dir=rtl] .me-xxl-3 {
    margin-left: 1rem !important;
  }
  html:not([dir=rtl]) .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  *[dir=rtl] .me-xxl-4 {
    margin-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .me-xxl-5 {
    margin-right: 3rem !important;
  }
  *[dir=rtl] .me-xxl-5 {
    margin-left: 3rem !important;
  }
  html:not([dir=rtl]) .me-xxl-auto {
    margin-right: auto !important;
  }
  *[dir=rtl] .me-xxl-auto {
    margin-left: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  html:not([dir=rtl]) .ms-xxl-0 {
    margin-left: 0 !important;
  }
  *[dir=rtl] .ms-xxl-0 {
    margin-right: 0 !important;
  }
  html:not([dir=rtl]) .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  *[dir=rtl] .ms-xxl-1 {
    margin-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  *[dir=rtl] .ms-xxl-2 {
    margin-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  *[dir=rtl] .ms-xxl-3 {
    margin-right: 1rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  *[dir=rtl] .ms-xxl-4 {
    margin-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  *[dir=rtl] .ms-xxl-5 {
    margin-right: 3rem !important;
  }
  html:not([dir=rtl]) .ms-xxl-auto {
    margin-left: auto !important;
  }
  *[dir=rtl] .ms-xxl-auto {
    margin-right: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-0 {
    padding-right: 0 !important;
  }
  *[dir=rtl] .pe-xxl-0 {
    padding-left: 0 !important;
  }
  html:not([dir=rtl]) .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  *[dir=rtl] .pe-xxl-1 {
    padding-left: 0.25rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  *[dir=rtl] .pe-xxl-2 {
    padding-left: 0.5rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  *[dir=rtl] .pe-xxl-3 {
    padding-left: 1rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  *[dir=rtl] .pe-xxl-4 {
    padding-left: 1.5rem !important;
  }
  html:not([dir=rtl]) .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  *[dir=rtl] .pe-xxl-5 {
    padding-left: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-0 {
    padding-left: 0 !important;
  }
  *[dir=rtl] .ps-xxl-0 {
    padding-right: 0 !important;
  }
  html:not([dir=rtl]) .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  *[dir=rtl] .ps-xxl-1 {
    padding-right: 0.25rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  *[dir=rtl] .ps-xxl-2 {
    padding-right: 0.5rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  *[dir=rtl] .ps-xxl-3 {
    padding-right: 1rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  *[dir=rtl] .ps-xxl-4 {
    padding-right: 1.5rem !important;
  }
  html:not([dir=rtl]) .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  *[dir=rtl] .ps-xxl-5 {
    padding-right: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  html:not([dir=rtl]) .text-xxl-start {
    text-align: left !important;
  }
  *[dir=rtl] .text-xxl-start {
    text-align: right !important;
  }
  html:not([dir=rtl]) .text-xxl-end {
    text-align: right !important;
  }
  *[dir=rtl] .text-xxl-end {
    text-align: left !important;
  }
  html:not([dir=rtl]) .text-xxl-center {
    text-align: center !important;
  }
  *[dir=rtl] .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.bg-primary-gradient {
  background-color: var(--cui-primary, #1f1498);
  background-image: linear-gradient(45deg, var(--cui-primary-start, #321fdb) 0%, var(--cui-primary-stop, #1f1498 100%));
}

.bg-secondary-gradient {
  background-color: var(--cui-secondary, #fff);
  background-image: linear-gradient(45deg, var(--cui-secondary-start, #c8d2dc) 0%, var(--cui-secondary-stop, #fff 100%));
}

.bg-success-gradient {
  background-color: var(--cui-success, #1b9e3e);
  background-image: linear-gradient(45deg, var(--cui-success-start, #2eb85c) 0%, var(--cui-success-stop, #1b9e3e 100%));
}

.bg-info-gradient {
  background-color: var(--cui-info, #2982cc);
  background-image: linear-gradient(45deg, var(--cui-info-start, #39f) 0%, var(--cui-info-stop, #2982cc 100%));
}

.bg-warning-gradient {
  background-color: var(--cui-warning, #f6960b);
  background-image: linear-gradient(45deg, var(--cui-warning-start, #f9b115) 0%, var(--cui-warning-stop, #f6960b 100%));
}

.bg-danger-gradient {
  background-color: var(--cui-danger, #d93737);
  background-image: linear-gradient(45deg, var(--cui-danger-start, #e55353) 0%, var(--cui-danger-stop, #d93737 100%));
}

.bg-light-gradient {
  background-color: var(--cui-light, #fff);
  background-image: linear-gradient(45deg, var(--cui-light-start, #e3e8ed) 0%, var(--cui-light-stop, #fff 100%));
}

.bg-dark-gradient {
  background-color: var(--cui-dark, #212333);
  background-image: linear-gradient(45deg, var(--cui-dark-start, #3c4b64) 0%, var(--cui-dark-stop, #212333 100%));
}

.dark-theme {
  --cui-body-bg: #181924;
  --cui-body-color: rgba(255, 255, 255, 0.87);
  --cui-elevation-base-color: 0, 0, 0;
  --cui-high-emphasis: rgba(255, 255, 255, 0.87);
  --cui-medium-emphasis: rgba(255, 255, 255, 0.6);
  --cui-disabled: rgba(255, 255, 255, 0.38);
  --cui-border-color: rgba(255, 255, 255, 0.075);
  --cui-link-color: #857dcc;
  --cui-link-hover-color: #9d97d6;
  --cui-bg-primary: #857dcc;
  --cui-bg-secondary: #a7a7a7;
  --cui-bg-success: #519668;
  --cui-bg-info: #5299e0;
  --cui-bg-warning: #d5a439;
  --cui-bg-danger: #c77171;
  --cui-bg-light: rgba(255, 255, 255, 0.1);
  --cui-bg-dark: rgba(0, 0, 21, 0.1);
  --cui-text-primary: #857dcc;
  --cui-text-secondary: #a7a7a7;
  --cui-text-success: #519668;
  --cui-text-info: #5299e0;
  --cui-text-warning: #d5a439;
  --cui-text-danger: #c77171;
  --cui-text-light: rgba(255, 255, 255, 0.1);
  --cui-text-dark: rgba(0, 0, 21, 0.1);
}
.dark-theme {
  --cui-primary: #857dcc;
  --cui-secondary: #a7a7a7;
  --cui-success: #519668;
  --cui-info: #5299e0;
  --cui-warning: #d5a439;
  --cui-danger: #c77171;
  --cui-light: rgba(255, 255, 255, 0.1);
  --cui-dark: rgba(0, 0, 21, 0.1);
  --cui-primary-rgb: 133, 125, 204;
  --cui-secondary-rgb: 167, 167, 167;
  --cui-success-rgb: 81, 150, 104;
  --cui-info-rgb: 82, 153, 224;
  --cui-warning-rgb: 213, 164, 57;
  --cui-danger-rgb: 199, 113, 113;
  --cui-light-rgb: 255, 255, 255;
  --cui-dark-rgb: 0, 0, 21;
  --cui-body-color-rgb: 255, 255, 255;
  --cui-body-bg-rgb: 24, 25, 36;
  --cui-link-color: #857dcc;
  --cui-link-color-rgb: 133, 125, 204;
  --cui-primary-start: #4638c2;
  --cui-primary-stop: #2d2587;
  --cui-secondary-start: #d1d2d3;
  --cui-secondary-stop: white;
  --cui-success-start: #45a164;
  --cui-success-stop: #2e8c47;
  --cui-info-start: #4799eb;
  --cui-info-stop: #4280b4;
  --cui-warning-start: #e1a82d;
  --cui-warning-stop: #dd9124;
  --cui-danger-start: #d16767;
  --cui-danger-stop: #c14f4f;
  --cui-light-start: #e8e8e8;
  --cui-light-stop: white;
  --cui-dark-start: #4c4f54;
  --cui-dark-stop: #292a2b;
}
.dark-theme .accordion {
  --cui-accordion-button-color: rgba(255, 255, 255, 0.87);
  --cui-accordion-button-bg: transparent;
  --cui-accordion-bg: transparent;
  --cui-accordion-color: rgba(255, 255, 255, 0.87);
  --cui-accordion-border-color: rgba(255, 255, 255, 0.125);
  --cui-accordion-button-active-bg: rgba(150, 143, 211, 0.525);
  --cui-accordion-button-active-color: #e6e6e6;
  --cui-accordion-button-focus-border-color: rgba(255, 255, 255, 0.2);
  --cui-accordion-button-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  --cui-accordion-button-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.dark-theme .breadcrumb {
  --cui-breadcrumb-divider-color: rgba(255, 255, 255, 0.87);
  --cui-breadcrumb-active-color: rgba(255, 255, 255, 0.6);
}
.dark-theme .btn-close {
  --cui-btn-close-color: rgba(255, 255, 255, 0.87);
  --cui-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}
.dark-theme .btn-link {
  --cui-btn-link-color: #857dcc;
  --cui-btn-link-hover-color: #9d97d6;
  --cui-btn-link-disabled-color: rgba(255, 255, 255, 0.38);
}
.dark-theme .calendar {
  --cui-calendar-nav-border: 1px solid rgba(255, 255, 255, 0.075);
  --cui-calendar-nav-date-color: rgba(255, 255, 255, 0.87);
  --cui-calendar-nav-date-hover-color: #857dcc;
  --cui-calendar-cell-header-inner-color: rgba(255, 255, 255, 0.6);
  --cui-calendar-cell-hover-bg: rgba(0, 0, 21, 0.25);
  --cui-calendar-cell-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-calendar-cell-selected-bg: #857dcc;
  --cui-calendar-cell-range-bg: #a49ed9;
  --cui-calendar-cell-range-hover-bg: #948dd2;
  --cui-calendar-cell-range-hover-border-color: #857dcc;
}
.dark-theme .date-picker {
  --cui-date-picker-timepicker-border-top: 1px solid rgba(255, 255, 255, 0.075);
}
.dark-theme .card {
  --cui-card-bg: #24252f;
  --cui-card-border-color: rgba(255, 255, 255, 0.075);
  --cui-card-cap-bg: #282933;
}
.dark-theme .dropdown-menu {
  --cui-dropdown-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-border-color: rgba(255, 255, 255, 0.075);
  --cui-dropdown-bg: #34353e;
  --cui-dropdown-divider-bg: rgba(255, 255, 255, 0.075);
  --cui-dropdown-link-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-dropdown-link-hover-bg: #3b3c45;
  --cui-dropdown-link-active-color: #fff;
  --cui-dropdown-link-active-bg: #857dcc;
  --cui-dropdown-link-disabled-color: rgba(255, 255, 255, 0.6);
  --cui-dropdown-header-color: rgba(255, 255, 255, 0.87);
}
.dark-theme .footer {
  --cui-footer-bg: #2a2b36;
  --cui-footer-color: rgba(255, 255, 255, 0.87);
  --cui-footer-border-width: 0;
  --cui-footer-border-color: transparent;
}
.dark-theme .form-control {
  --cui-input-color: rgba(255, 255, 255, 0.87);
  --cui-input-bg: rgba(255, 255, 255, 0.05);
  --cui-input-border-color: rgba(255, 255, 255, 0.09);
  --cui-input-focus-color: rgba(255, 255, 255, 0.87);
  --cui-input-focus-bg: rgba(255, 255, 255, 0.05);
  --cui-input-focus-border-color: rgba(255, 255, 255, 0.2);
  --cui-input-disabled-bg: rgba(0, 0, 21, 0.1);
  --cui-input-placeholder-color: rgba(255, 255, 255, 0.6);
  --cui-input-plaintext-color: rgba(255, 255, 255, 0.87);
  --cui-form-text-color: rgba(255, 255, 255, 0.6);
}
.dark-theme .form-check {
  --cui-form-check-input-checked-color: #fff;
  --cui-form-check-input-checked-bg-color: #857dcc;
  --cui-form-check-input-checked-border-color: #857dcc;
}
.dark-theme .form-select {
  --cui-form-select-color: rgba(255, 255, 255, 0.87);
  --cui-form-select-bg: rgba(255, 255, 255, 0.05);
  --cui-form-select-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-select-focus-border-color: rgba(255, 255, 255, 0.2);
  --cui-form-select-disabled-bg: rgba(0, 0, 21, 0.1);
}
.dark-theme .form-multi-select {
  --cui-form-multi-select-color: rgba(255, 255, 255, 0.87);
  --cui-form-multi-select-bg: rgba(255, 255, 255, 0.05);
  --cui-form-multi-select-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-multi-select-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-form-multi-select-disabled-bg: rgba(0, 0, 21, 0.1);
  --cui-form-multi-select-focus-color: rgba(255, 255, 255, 0.87);
  --cui-form-multi-select-focus-bg: rgba(255, 255, 255, 0.05);
  --cui-form-multi-select-focus-border-color: rgba(255, 255, 255, 0.2);
  --cui-form-multi-select-tag-bg: rgba(255, 255, 255, 0.1);
  --cui-form-multi-select-tag-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-multi-select-search-color: rgba(255, 255, 255, 0.87);
  --cui-form-multi-select-search-bg: transparent;
  --cui-form-multi-select-search-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-multi-select-cleaner-bg: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  --cui-form-multi-select-cleaner-hover-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --cui-form-multi-select-cleaner-focus-bg: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  --cui-form-multi-select-cleaner-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-multi-select-select-all-color: rgba(255, 255, 255, 0.6);
  --cui-form-multi-select-select-all-bg: transparent;
  --cui-form-multi-select-select-all-hover-color: rgba(255, 255, 255, 0.87);
  --cui-form-multi-select-select-all-hover-bg: transparent;
  --cui-form-multi-select-select-all-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-multi-select-options-color: rgba(255, 255, 255, 0.87);
  --cui-form-multi-select-options-bg: #34353e;
  --cui-form-multi-select-options-border-color: rgba(255, 255, 255, 0.09);
  --cui-form-multi-select-option-hover-color: rgba(255, 255, 255, 0.87);
  --cui-form-multi-select-option-hover-bg: rgba(255, 255, 255, 0.1);
  --cui-form-multi-select-option-selected-bg: rgba(255, 255, 255, 0.1);
}
.dark-theme .header {
  --cui-header-bg: #2a2b36;
  --cui-header-color: rgba(255, 255, 255, 0.75);
  --cui-header-hover-color: rgba(255, 255, 255, 0.9);
  --cui-header-active-color: #fff;
  --cui-header-disabled-color: rgba(255, 255, 255, 0.25);
  --cui-header-brand-color: #fff;
  --cui-header-brand-hover-color: #fff;
  --cui-header-toggler-color: rgba(255, 255, 255, 0.75);
  --cui-header-toggler-hover-color: #fff;
  --cui-header-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  --cui-header-toggler-hover-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  --cui-header-toggler-border-color: rgba(255, 255, 255, 0.1);
  --cui-header-divider-border-color: rgba(255, 255, 255, 0.1);
}
.dark-theme .dark\\:header-header-border, .dark-theme .header-header-border:not([class*="dark:"]) {
  --cui-header-bottom: 0;
}

.dark-theme .input-group {
  --cui-input-group-addon-color: rgba(255, 255, 255, 0.87);
  --cui-input-group-addon-bg: rgba(255, 255, 255, 0.09);
  --cui-input-group-addon-border-color: rgba(255, 255, 255, 0.09);
}
.dark-theme .list-group {
  --cui-list-group-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-bg: transparent;
  --cui-list-group-border-color: rgba(255, 255, 255, 0.075);
  --cui-list-group-hover-bg: rgba(255, 255, 255, 0.1);
  --cui-list-group-active-color: #fff;
  --cui-list-group-active-bg: #857dcc;
  --cui-list-group-active-border-color: #857dcc;
  --cui-list-group-disabled-color: rgba(255, 255, 255, 0.5);
  --cui-list-group-disabled-bg: rgba(255, 255, 255, 0.8);
  --cui-list-group-action-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-action-hover-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-action-active-color: rgba(255, 255, 255, 0.87);
  --cui-list-group-action-active-bg: #4f5d73;
}
.dark-theme .modal {
  --cui-modal-bg: #3d3e47;
  --cui-modal-border-color: rgba(0, 0, 0, 0.2);
  --cui-modal-header-border-color: rgba(0, 0, 0, 0.2);
  --cui-modal-footer-border-color: rgba(0, 0, 0, 0.2);
}
.dark-theme .nav {
  --cui-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-nav-pills-link-active-bg: #857dcc;
  --cui-nav-pills-link-active-color: #fff;
  --cui-nav-tabs-border-color: rgba(255, 255, 255, 0.075);
  --cui-nav-tabs-link-active-bg: rgba(255, 255, 255, 0.075);
  --cui-nav-tabs-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-nav-tabs-link-active-border-color: transparent;
  --cui-nav-tabs-link-hover-border-color: rgba(255, 255, 255, 0.075) rgba(255, 255, 255, 0.075) rgba(255, 255, 255, 0.075);
  --cui-nav-underline-border-color: rgba(255, 255, 255, 0.075);
  --cui-nav-underline-link-color: rgba(255, 255, 255, 0.6);
  --cui-nav-underline-link-active-color: #857dcc;
  --cui-nav-underline-link-active-border-color: #857dcc;
}
.dark-theme .offcanvas {
  --cui-offcanvas-bg-color: #383943;
  --cui-offcanvas-border-color: transparent;
}
.dark-theme .pagination {
  --cui-pagination-color: #857dcc;
  --cui-pagination-bg: transparent;
  --cui-pagination-border-color: rgba(255, 255, 255, 0.075);
  --cui-pagination-focus-color: #9d97d6;
  --cui-pagination-focus-bg: rgba(255, 255, 255, 0.075);
  --cui-pagination-hover-color: #9d97d6;
  --cui-pagination-hover-bg: rgba(255, 255, 255, 0.075);
  --cui-pagination-hover-border-color: rgba(255, 255, 255, 0.075);
  --cui-pagination-active-color: #fff;
  --cui-pagination-active-bg-dt: #857dcc;
  --cui-pagination-active-border-color: #857dcc;
  --cui-pagination-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-pagination-disabled-bg: transparent;
  --cui-pagination-disabled-border-color: rgba(255, 255, 255, 0.075);
}
.dark-theme .picker {
  --cui-input-bg: rgba(255, 255, 255, 0.05);
  --cui-input-group-addon-border-color: transparent;
  --cui-picker-footer-border-top: 1px solid rgba(255, 255, 255, 0.075);
}
.dark-theme .popover {
  --cui-popover-bg: #3b3c45;
  --cui-popover-border-color: rgba(255, 255, 255, 0.075);
  --cui-popover-header-bg: #3b3c45;
  --cui-popover-header-color: rgba(255, 255, 255, 0.87);
  --cui-popover-body-color: rgba(255, 255, 255, 0.87);
  --cui-popover-arrow-color: #3b3c45;
  --cui-popover-arrow-outer-color: rgba(255, 255, 255, 0.125);
}
.dark-theme .progress {
  --cui-progress-bg: rgba(255, 255, 255, 0.2);
  --cui-progress-bar-bg: #857dcc;
  --cui-progress-bar-color: #fff;
}
.dark-theme .sidebar {
  --cui-sidebar-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-bg: #2a2b36;
  --cui-sidebar-border-width: 0;
  --cui-sidebar-border-color: transparent;
  --cui-sidebar-brand-color: inherit;
  --cui-sidebar-brand-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-footer-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-header-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-toggler-bg: rgba(0, 0, 21, 0.2);
  --cui-sidebar-toggler-hover-bg: rgba(0, 0, 21, 0.3);
  --cui-sidebar-nav-title-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-bg: transparent;
  --cui-sidebar-nav-link-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-link-hover-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-hover-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-hover-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-active-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-active-bg: rgba(255, 255, 255, 0.05);
  --cui-sidebar-nav-link-active-icon-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-link-disabled-color: rgba(255, 255, 255, 0.38);
  --cui-sidebar-nav-link-disabled-icon-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-bg: rgba(0, 0, 0, 0.2);
  --cui-sidebar-nav-group-toggle-show-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-indicator-color: rgba(255, 255, 255, 0.6);
  --cui-sidebar-nav-group-indicator-icon: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  --cui-sidebar-nav-group-indicator-hover-color: rgba(255, 255, 255, 0.87);
  --cui-sidebar-nav-group-indicator-hover-icon: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}
.dark-theme .table {
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-bg: transparent;
  --cui-table-border-color: rgba(255, 255, 255, 0.075);
  --cui-table-striped-color: rgba(255, 255, 255, 0.87);
  --cui-table-striped-bg: rgba(255, 255, 255, 0.05);
  --cui-table-active-color: rgba(255, 255, 255, 0.87);
  --cui-table-active-bg: rgba(0, 0, 21, 0.1);
  --cui-table-hover-color: rgba(255, 255, 255, 0.87);
  --cui-table-hover-bg: rgba(0, 0, 21, 0.075);
}
.dark-theme .dark\\:table-primary, .dark-theme .table-primary:not([class*="dark:"]) {
  --cui-table-bg: #e7e5f5;
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-border-color: rgba(197, 197, 213, 0.99);
  --cui-table-striped-bg: rgba(223, 221, 237, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(214, 213, 229, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(218, 217, 233, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-secondary, .dark-theme .table-secondary:not([class*="dark:"]) {
  --cui-table-bg: #ededed;
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-border-color: rgba(201, 204, 207, 0.99);
  --cui-table-striped-bg: rgba(228, 229, 230, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(219, 220, 222, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(224, 225, 226, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-success, .dark-theme .table-success:not([class*="dark:"]) {
  --cui-table-bg: #dceae1;
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-border-color: rgba(188, 201, 197, 0.99);
  --cui-table-striped-bg: rgba(212, 226, 218, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(204, 218, 211, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(208, 222, 215, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-info, .dark-theme .table-info:not([class*="dark:"]) {
  --cui-table-bg: #dcebf9;
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-border-color: rgba(188, 202, 217, 0.99);
  --cui-table-striped-bg: rgba(212, 227, 241, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(204, 219, 233, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(208, 223, 237, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-warning, .dark-theme .table-warning:not([class*="dark:"]) {
  --cui-table-bg: #f7edd7;
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-border-color: rgba(210, 204, 189, 0.99);
  --cui-table-striped-bg: rgba(238, 229, 209, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(228, 220, 202, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(233, 225, 205, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-danger, .dark-theme .table-danger:not([class*="dark:"]) {
  --cui-table-bg: #f4e3e3;
  --cui-table-color: rgba(44, 56, 74, 0.95);
  --cui-table-border-color: rgba(207, 195, 199, 0.99);
  --cui-table-striped-bg: rgba(235, 219, 220, 0.9975);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(226, 211, 213, 0.995);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(230, 215, 217, 0.99625);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-light, .dark-theme .table-light:not([class*="dark:"]) {
  --cui-table-bg: rgba(255, 255, 255, 0.1);
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-border-color: rgba(255, 255, 255, 0.254);
  --cui-table-striped-bg: rgba(255, 255, 255, 0.1385);
  --cui-table-striped-color: rgba(44, 56, 74, 0.95);
  --cui-table-active-bg: rgba(255, 255, 255, 0.177);
  --cui-table-active-color: rgba(44, 56, 74, 0.95);
  --cui-table-hover-bg: rgba(255, 255, 255, 0.15775);
  --cui-table-hover-color: rgba(44, 56, 74, 0.95);
}

.dark-theme .dark\\:table-dark, .dark-theme .table-dark:not([class*="dark:"]) {
  --cui-table-bg: rgba(0, 0, 21, 0.1);
  --cui-table-color: rgba(255, 255, 255, 0.87);
  --cui-table-border-color: rgba(168, 168, 175, 0.254);
  --cui-table-striped-bg: rgba(74, 74, 88, 0.1385);
  --cui-table-striped-color: rgba(255, 255, 255, 0.87);
  --cui-table-active-bg: rgba(118, 118, 129, 0.177);
  --cui-table-active-color: #000015;
  --cui-table-hover-bg: rgba(98, 98, 111, 0.15775);
  --cui-table-hover-color: rgba(255, 255, 255, 0.87);
}

.dark-theme .time-picker {
  --cui-time-picker-roll-col-border: 1px solid rgba(255, 255, 255, 0.075);
}
.dark-theme .toast {
  --cui-toast-bg: #3b3c45;
  --cui-toast-color: rgba(255, 255, 255, 0.87);
  --cui-toast-border-color: transparent;
  --cui-toast-header-color: rgba(255, 255, 255, 0.87);
  --cui-toast-header-bg: #3d3e47;
  --cui-toast-header-border-color: rgba(0, 0, 21, 0.2);
}
.dark-theme .alert-primary {
  --cui-alert-color: #1e1383;
  --cui-alert-bg: #d6d2f8;
  --cui-alert-border-color: #c2bcf4;
  --cui-alert-link-color: #180f69;
}
.dark-theme .alert-primary .alert-link {
  color: var(--cui-alert-link-color);
}
.dark-theme .alert-secondary {
  --cui-alert-color: #5e636a;
  --cui-alert-bg: #ebedef;
  --cui-alert-border-color: #e2e4e8;
  --cui-alert-link-color: #4b4f55;
}
.dark-theme .alert-secondary .alert-link {
  color: var(--cui-alert-link-color);
}
.dark-theme .alert-success {
  --cui-alert-color: #1c6e37;
  --cui-alert-bg: #d5f1de;
  --cui-alert-border-color: #c0eace;
  --cui-alert-link-color: #16582c;
}
.dark-theme .alert-success .alert-link {
  color: var(--cui-alert-link-color);
}
.dark-theme .alert-danger {
  --cui-alert-color: #893232;
  --cui-alert-bg: #fadddd;
  --cui-alert-border-color: #f7cbcb;
  --cui-alert-link-color: #6e2828;
}
.dark-theme .alert-danger .alert-link {
  color: var(--cui-alert-link-color);
}
.dark-theme .alert-warning {
  --cui-alert-color: rgba(131, 107, 52, 0.97);
  --cui-alert-bg: #feefd0;
  --cui-alert-border-color: #fde8b9;
  --cui-alert-link-color: rgba(104, 85, 41, 0.976);
}
.dark-theme .alert-warning .alert-link {
  color: var(--cui-alert-link-color);
}
.dark-theme .alert-info {
  --cui-alert-color: #1f5c99;
  --cui-alert-bg: #d6ebff;
  --cui-alert-border-color: #c2e0ff;
  --cui-alert-link-color: #194a7a;
}
.dark-theme .alert-info .alert-link {
  color: var(--cui-alert-link-color);
}
.dark-theme .btn-primary {
  --cui-btn-color: #000015;
  --cui-btn-bg: #857dcc;
  --cui-btn-border-color: #857dcc;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #9791d4;
  --cui-btn-hover-border-color: #918ad1;
  --cui-btn-focus-shadow-rgb: 113, 106, 177;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #9d97d6;
  --cui-btn-active-border-color: #918ad1;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #857dcc;
  --cui-btn-disabled-border-color: #857dcc;
}
.dark-theme .btn-secondary {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #a7a7a7;
  --cui-btn-border-color: #a7a7a7;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #8e8e8e;
  --cui-btn-hover-border-color: #868686;
  --cui-btn-focus-shadow-rgb: 150, 152, 154;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #868686;
  --cui-btn-active-border-color: #7d7d7d;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #a7a7a7;
  --cui-btn-disabled-border-color: #a7a7a7;
}
.dark-theme .btn-success {
  --cui-btn-color: #000015;
  --cui-btn-bg: #519668;
  --cui-btn-border-color: #519668;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #6ba67f;
  --cui-btn-hover-border-color: #62a177;
  --cui-btn-focus-shadow-rgb: 69, 128, 92;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #74ab86;
  --cui-btn-active-border-color: #62a177;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #519668;
  --cui-btn-disabled-border-color: #519668;
}
.dark-theme .btn-danger {
  --cui-btn-color: #000015;
  --cui-btn-bg: #c77171;
  --cui-btn-border-color: #c77171;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #cf8686;
  --cui-btn-hover-border-color: #cd7f7f;
  --cui-btn-focus-shadow-rgb: 169, 96, 99;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #d28d8d;
  --cui-btn-active-border-color: #cd7f7f;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #c77171;
  --cui-btn-disabled-border-color: #c77171;
}
.dark-theme .btn-warning {
  --cui-btn-color: rgba(44, 56, 74, 0.95);
  --cui-btn-bg: #d5a439;
  --cui-btn-border-color: #d5a439;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #b58b30;
  --cui-btn-hover-border-color: #aa832e;
  --cui-btn-focus-shadow-rgb: 190, 149, 59;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #aa832e;
  --cui-btn-active-border-color: #a07b2b;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: rgba(44, 56, 74, 0.95);
  --cui-btn-disabled-bg: #d5a439;
  --cui-btn-disabled-border-color: #d5a439;
}
.dark-theme .btn-info {
  --cui-btn-color: #000015;
  --cui-btn-bg: #5299e0;
  --cui-btn-border-color: #5299e0;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #6ca8e5;
  --cui-btn-hover-border-color: #63a3e3;
  --cui-btn-focus-shadow-rgb: 70, 130, 194;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #75ade6;
  --cui-btn-active-border-color: #63a3e3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #000015;
  --cui-btn-disabled-bg: #5299e0;
  --cui-btn-disabled-border-color: #5299e0;
}
.dark-theme .btn-outline-primary {
  --cui-btn-color: #857dcc;
  --cui-btn-border-color: #857dcc;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #9d97d6;
  --cui-btn-hover-border-color: #918ad1;
  --cui-btn-focus-shadow-rgb: 133, 125, 204;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #9d97d6;
  --cui-btn-active-border-color: #918ad1;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #857dcc;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}
.dark-theme .btn-outline-secondary {
  --cui-btn-color: #a7a7a7;
  --cui-btn-border-color: #a7a7a7;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #868686;
  --cui-btn-hover-border-color: #7d7d7d;
  --cui-btn-focus-shadow-rgb: 167, 167, 167;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #868686;
  --cui-btn-active-border-color: #7d7d7d;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #a7a7a7;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}
.dark-theme .btn-outline-success {
  --cui-btn-color: #519668;
  --cui-btn-border-color: #519668;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #74ab86;
  --cui-btn-hover-border-color: #62a177;
  --cui-btn-focus-shadow-rgb: 81, 150, 104;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #74ab86;
  --cui-btn-active-border-color: #62a177;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #519668;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}
.dark-theme .btn-outline-danger {
  --cui-btn-color: #c77171;
  --cui-btn-border-color: #c77171;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #d28d8d;
  --cui-btn-hover-border-color: #cd7f7f;
  --cui-btn-focus-shadow-rgb: 199, 113, 113;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #d28d8d;
  --cui-btn-active-border-color: #cd7f7f;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #c77171;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}
.dark-theme .btn-outline-warning {
  --cui-btn-color: #d5a439;
  --cui-btn-border-color: #d5a439;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #aa832e;
  --cui-btn-hover-border-color: #a07b2b;
  --cui-btn-focus-shadow-rgb: 213, 164, 57;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #aa832e;
  --cui-btn-active-border-color: #a07b2b;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #d5a439;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}
.dark-theme .btn-outline-info {
  --cui-btn-color: #5299e0;
  --cui-btn-border-color: #5299e0;
  --cui-btn-hover-color: #000015;
  --cui-btn-hover-bg: #75ade6;
  --cui-btn-hover-border-color: #63a3e3;
  --cui-btn-focus-shadow-rgb: 82, 153, 224;
  --cui-btn-active-color: #000015;
  --cui-btn-active-bg: #75ade6;
  --cui-btn-active-border-color: #63a3e3;
  --cui-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 21, 0.125);
  --cui-btn-disabled-color: #5299e0;
  --cui-btn-disabled-bg: transparent;
  --cui-gradient: none;
}
.dark-theme .btn-ghost-primary {
  --cui-btn-color: #857dcc;
  --cui-btn-hover-bg: #9791d4;
  --cui-btn-hover-border-color: #918ad1;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #9d97d6;
  --cui-btn-active-border-color: #918ad1;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #857dcc;
  --cui-btn-shadow: rgba(133, 125, 204, 0.5);
}
.dark-theme .btn-ghost-secondary {
  --cui-btn-color: #a7a7a7;
  --cui-btn-hover-bg: #8e8e8e;
  --cui-btn-hover-border-color: #868686;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #868686;
  --cui-btn-active-border-color: #7d7d7d;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #a7a7a7;
  --cui-btn-shadow: rgba(167, 167, 167, 0.5);
}
.dark-theme .btn-ghost-success {
  --cui-btn-color: #519668;
  --cui-btn-hover-bg: #6ba67f;
  --cui-btn-hover-border-color: #62a177;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #74ab86;
  --cui-btn-active-border-color: #62a177;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #519668;
  --cui-btn-shadow: rgba(81, 150, 104, 0.5);
}
.dark-theme .btn-ghost-danger {
  --cui-btn-color: #c77171;
  --cui-btn-hover-bg: #cf8686;
  --cui-btn-hover-border-color: #cd7f7f;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #d28d8d;
  --cui-btn-active-border-color: #cd7f7f;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #c77171;
  --cui-btn-shadow: rgba(199, 113, 113, 0.5);
}
.dark-theme .btn-ghost-warning {
  --cui-btn-color: #d5a439;
  --cui-btn-hover-bg: #b58b30;
  --cui-btn-hover-border-color: #aa832e;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #aa832e;
  --cui-btn-active-border-color: #a07b2b;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #d5a439;
  --cui-btn-shadow: rgba(213, 164, 57, 0.5);
}
.dark-theme .btn-ghost-info {
  --cui-btn-color: #5299e0;
  --cui-btn-hover-bg: #6ca8e5;
  --cui-btn-hover-border-color: #63a3e3;
  --cui-btn-hover-color: #000015;
  --cui-btn-active-bg: #75ade6;
  --cui-btn-active-border-color: #63a3e3;
  --cui-btn-active-color: #000015;
  --cui-btn-disabled-color: #5299e0;
  --cui-btn-shadow: rgba(82, 153, 224, 0.5);
}
.dark-theme .list-group-item-primary {
  --cui-list-group-color: contrast-ratio-correction(#504b7a, #e7e5f5, 40%, "primary");
  --cui-list-group-bg: #e7e5f5;
  --cui-list-group-hover-bg: #7871b8;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#504b7a, #e7e5f5, 40%, "primary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#504b7a, #e7e5f5, 40%, "primary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#504b7a, #e7e5f5, 40%, "primary");
}
.dark-theme .list-group-item-secondary {
  --cui-list-group-color: contrast-ratio-correction(#646464, #ededed, 40%, "secondary");
  --cui-list-group-bg: #ededed;
  --cui-list-group-hover-bg: #969696;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#646464, #ededed, 40%, "secondary");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#646464, #ededed, 40%, "secondary");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#646464, #ededed, 40%, "secondary");
}
.dark-theme .list-group-item-success {
  --cui-list-group-color: contrast-ratio-correction(#315a3e, #dceae1, 40%, "success");
  --cui-list-group-bg: #dceae1;
  --cui-list-group-hover-bg: #49875e;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#315a3e, #dceae1, 40%, "success");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#315a3e, #dceae1, 40%, "success");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#315a3e, #dceae1, 40%, "success");
}
.dark-theme .list-group-item-danger {
  --cui-list-group-color: contrast-ratio-correction(#774444, #f4e3e3, 40%, "danger");
  --cui-list-group-bg: #f4e3e3;
  --cui-list-group-hover-bg: #b36666;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#774444, #f4e3e3, 40%, "danger");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#774444, #f4e3e3, 40%, "danger");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#774444, #f4e3e3, 40%, "danger");
}
.dark-theme .list-group-item-warning {
  --cui-list-group-color: contrast-ratio-correction(#806222, #f7edd7, 40%, "warning");
  --cui-list-group-bg: #f7edd7;
  --cui-list-group-hover-bg: #c09433;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#806222, #f7edd7, 40%, "warning");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#806222, #f7edd7, 40%, "warning");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#806222, #f7edd7, 40%, "warning");
}
.dark-theme .list-group-item-info {
  --cui-list-group-color: contrast-ratio-correction(#315c86, #dcebf9, 40%, "info");
  --cui-list-group-bg: #dcebf9;
  --cui-list-group-hover-bg: #4a8aca;
  --cui-list-group-action-hover-color: contrast-ratio-correction(#315c86, #dcebf9, 40%, "info");
  --cui-list-group-action-active-color: #fff;
  --cui-list-group-action-active-bg: contrast-ratio-correction(#315c86, #dcebf9, 40%, "info");
  --cui-list-group-action-active-border-color: contrast-ratio-correction(#315c86, #dcebf9, 40%, "info");
}
@-moz-document url-prefix("") {
  .dark-theme select:not([multiple]) option,
  .dark-theme select optgroup {
    color: initial;
  }
}
.dark-theme .form-control:disabled {
  background-color: var(--cui-input-disabled-bg);
}
.dark-theme .form-control::file-selector-button {
  background-color: rgba(0, 0, 21, 0.1);
}
.dark-theme .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgba(0, 0, 21, 0.2);
}
.dark-theme .picker-input-group .form-control:disabled + .input-group-text {
  background-color: var(--cui-input-disabled-bg);
}
.dark-theme .dark\\:text-primary, .dark-theme .text-primary:not([class*="dark:"]) {
  color: rgba(var(--cui-primary-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-secondary, .dark-theme .text-secondary:not([class*="dark:"]) {
  color: rgba(var(--cui-secondary-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-success, .dark-theme .text-success:not([class*="dark:"]) {
  color: rgba(var(--cui-success-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-info, .dark-theme .text-info:not([class*="dark:"]) {
  color: rgba(var(--cui-info-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-warning, .dark-theme .text-warning:not([class*="dark:"]) {
  color: rgba(var(--cui-warning-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-danger, .dark-theme .text-danger:not([class*="dark:"]) {
  color: rgba(var(--cui-danger-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-light, .dark-theme .text-light:not([class*="dark:"]) {
  color: rgba(var(--cui-light-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-dark, .dark-theme .text-dark:not([class*="dark:"]) {
  color: rgba(var(--cui-dark-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-black, .dark-theme .text-black:not([class*="dark:"]) {
  color: rgba(var(--cui-black-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-white, .dark-theme .text-white:not([class*="dark:"]) {
  color: rgba(var(--cui-white-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-body, .dark-theme .text-body:not([class*="dark:"]) {
  color: rgba(var(--cui-body-color-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-high-emphasis, .dark-theme .text-high-emphasis:not([class*="dark:"]) {
  color: rgba(var(--cui-high-emphasis-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-medium-emphasis, .dark-theme .text-medium-emphasis:not([class*="dark:"]) {
  color: rgba(var(--cui-medium-emphasis-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-disabled, .dark-theme .text-disabled:not([class*="dark:"]) {
  color: rgba(var(--cui-disabled-rgb), var(--cui-text-opacity)) !important;
}
.dark-theme .dark\\:text-reset, .dark-theme .text-reset:not([class*="dark:"]) {
  color: inherit !important;
}
.dark-theme .dark\\:bg-primary, .dark-theme .bg-primary:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-primary-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-secondary, .dark-theme .bg-secondary:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-secondary-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-success, .dark-theme .bg-success:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-success-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-info, .dark-theme .bg-info:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-info-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-warning, .dark-theme .bg-warning:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-warning-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-danger, .dark-theme .bg-danger:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-danger-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-light, .dark-theme .bg-light:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-light-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-dark, .dark-theme .bg-dark:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-dark-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-black, .dark-theme .bg-black:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-black-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-white, .dark-theme .bg-white:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-white-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-body, .dark-theme .bg-body:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: rgba(var(--cui-body-bg-rgb), var(--cui-bg-opacity)) !important;
}
.dark-theme .dark\\:bg-transparent, .dark-theme .bg-transparent:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
  background-color: transparent !important;
}
.dark-theme .dark\\:bg-opacity-10, .dark-theme .bg-opacity-10:not([class*="dark:"]) {
  --cui-bg-opacity: 0.1;
}
.dark-theme .dark\\:bg-opacity-25, .dark-theme .bg-opacity-25:not([class*="dark:"]) {
  --cui-bg-opacity: 0.25;
}
.dark-theme .dark\\:bg-opacity-50, .dark-theme .bg-opacity-50:not([class*="dark:"]) {
  --cui-bg-opacity: 0.5;
}
.dark-theme .dark\\:bg-opacity-75, .dark-theme .bg-opacity-75:not([class*="dark:"]) {
  --cui-bg-opacity: 0.75;
}
.dark-theme .dark\\:bg-opacity-100, .dark-theme .bg-opacity-100:not([class*="dark:"]) {
  --cui-bg-opacity: 1;
}
/*!
 * CoreUI Plugins - Chart.js for CoreUI 3
 * @version v3.1.2
 * @link https://coreui.io
 * Copyright (c) 2021 creativeLabs Łukasz Holeczek
 * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)
 */
.chartjs-tooltip {
  position: absolute;
  z-index: 1021;
  padding: 0.25rem 0.5rem;
  color: #fff;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.7);
  opacity: 0;
  transition: all 0.15s ease;
  transform: translate(-50%, 0);
  border-radius: 0.375rem;
}
@media (prefers-reduced-motion: reduce) {
  .chartjs-tooltip {
    transition: none;
  }
}

.chartjs-tooltip-header {
  margin-bottom: 0.5rem;
}

.chartjs-tooltip-header-item {
  font-size: 0.875rem;
  font-weight: 700;
}

.chartjs-tooltip-body-item {
  align-items: center;
  font-size: 0.875rem;
  white-space: nowrap;
}

.wrapper {
  width: 100%;
  will-change: auto;
  transition: padding 0.15s;
}
html:not([dir=rtl]) .wrapper {
  padding-left: var(--cui-sidebar-occupy-start, 0);
}
*[dir=rtl] .wrapper {
  padding-right: var(--cui-sidebar-occupy-start, 0);
}
@media (prefers-reduced-motion: reduce) {
  .wrapper {
    transition: none;
  }
}

.fc {
  --fc-small-font-size: .85em;
  --fc-page-bg-color: #fff;
  --fc-neutral-bg-color: rgba(208, 208, 208, .3);
  --fc-neutral-text-color: #808080;
  --fc-border-color: var(--cui-border-color, #d8dbe0);
  --fc-button-text-color: #fff;
  --fc-button-bg-color: #2c3e50;
  --fc-button-border-color: #2c3e50;
  --fc-button-hover-bg-color: #1e2b37;
  --fc-button-hover-border-color: #1a252f;
  --fc-button-active-bg-color: #1a252f;
  --fc-button-active-border-color: #151e27;
  --fc-event-bg-color: #3788d8;
  --fc-event-border-color: #3788d8;
  --fc-event-text-color: #fff;
  --fc-event-selected-overlay-color: rgba(0, 0, 0, .25);
  --fc-event-resizer-thickness: 8px;
  --fc-event-resizer-dot-total-width: 8px;
  --fc-event-resizer-dot-border-width: 1px;
  --fc-non-business-color: rgba(215, 215, 215, .3);
  --fc-bg-event-color: rgb(143, 223, 130);
  --fc-bg-event-opacity: .3;
  --fc-highlight-color: rgba(188, 232, 241, .3);
  --fc-today-bg-color: rgba(255, 220, 40, .15);
  --fc-now-indicator-color: var(--cui-danger);
}

.example:not(:first-child) {
  margin-top: 1.5rem;
}
.example .tab-content {
  background-color: #f9fafa !important;
}
.dark-theme .example .tab-content {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.example code[class*=language-],
.example pre[class*=language-] {
  font-size: 0.875rem !important;
}
.example :not(pre) > code[class*=language-],
.example pre[class*=language-] {
  background: transparent;
}
.example + p, .example + h2, .example + .h2, .example + h3, .example + .h3, .example + h4, .example + .h4, .example + h5, .example + .h5, .example + h6, .example + .h6 {
  margin-top: 1.5rem;
}
.example .preview + p,
.example .preview .col + p {
  margin-top: 2rem;
}
.example .preview > .form-control + .form-control,
.example .preview .col > .form-control + .form-control {
  margin-top: 0.5rem;
}
.example .preview > .nav + .nav,
.example .preview > .alert + .alert,
.example .preview > .navbar + .navbar,
.example .preview > .progress + .progress,
.example .preview .col > .nav + .nav,
.example .preview .col > .alert + .alert,
.example .preview .col > .navbar + .navbar,
.example .preview .col > .progress + .progress {
  margin-top: 1rem;
}
.example .preview > .dropdown-menu,
.example .preview .col > .dropdown-menu {
  position: static;
  display: block;
}
.example .preview > :last-child,
.example .preview .col > :last-child {
  margin-bottom: 0;
}
.example .preview > svg + svg,
.example .preview > img + img,
.example .preview .col > svg + svg,
.example .preview .col > img + img {
  margin-left: 0.5rem;
}
.example .preview > .btn,
.example .preview > .btn-group,
.example .preview .col > .btn,
.example .preview .col > .btn-group {
  margin: 0.25rem 0.125rem;
}
.example .preview > .btn-toolbar + .btn-toolbar,
.example .preview .col > .btn-toolbar + .btn-toolbar {
  margin-top: 0.5rem;
}
.example .preview > .list-group,
.example .preview .col > .list-group {
  max-width: 400px;
}
.example .preview > [class*=list-group-horizontal],
.example .preview .col > [class*=list-group-horizontal] {
  max-width: 100%;
}
.example .preview .fixed-top,
.example .preview .sticky-top,
.example .preview .col .fixed-top,
.example .preview .col .sticky-top {
  position: static;
  margin: -1rem -1rem 1rem;
}
.example .preview .fixed-bottom,
.example .preview .col .fixed-bottom {
  position: static;
  margin: 1rem -1rem -1rem;
}
@media (min-width: 576px) {
  .example .preview .fixed-top,
  .example .preview .sticky-top,
  .example .preview .col .fixed-top,
  .example .preview .col .sticky-top {
    margin: -1.5rem -1.5rem 1rem;
  }
  .example .preview .fixed-bottom,
  .example .preview .col .fixed-bottom {
    margin: 1rem -1.5rem -1.5rem;
  }
}
.example .preview .pagination,
.example .preview .col .pagination {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.contentSize {
  min-height: 85vh;
  scroll-snap-type: y mandatory;
  min-height: "-webkit-fill-available";
}

.centerContent {
  margin: auto;
  padding: 10px;
}

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
}

.active-scroll-spy {
  background-color: yellowgreen;
  border-radius: 15px;
}

.chartMinHeight {
  min-height: 250px;
  height: 100%;
  max-height: 350px;
}

.chartMinHeightPie {
  min-height: 130px;
  height: 100%;
  max-height: 350px;
}

.chartGauge {
  min-height: 300px;
  height: 100%;
  max-height: 600px;
}

.mycluster {
  width: 40px;
  height: 40px;
  background-color: greenyellow;
  text-align: center;
  font-size: 24px;
}

.custom-marker-cluster {
  background: #ffffff;
  border: 15px solid #f00800;
  border-radius: 50%;
  color: #000000;
  height: 33px;
  line-height: 37px;
  text-align: center;
  width: 33px;
}

hr.vertical {
  height: 100%;
  /* you might need some positioning for this to work, see other questions about 100% height */
  width: 0;
  border: 2px solid black;
}

--btn.disabled {
  /* Make the disabled links grayish*/
  color: gray;
  /* And disable the pointer events */
  pointer-events: none;
}

.tableFixHead {
  overflow-y: auto;
  /* make the table scrollable if height is more than 200 px  */
  height: 70vh;
  /* gives an initial height of 200px to the table */
}

.tableFixHead thead th {
  position: sticky;
  /* make the table heads sticky */
  top: 0px;
  /* table head will be placed from the top of the table and sticks to it */
}

table {
  border-collapse: collapse;
  /* make the table borders collapse to each other */
  width: 100%;
  border-spacing: 10px;
}

th,
td {
  padding: 1px 1px;
  border-bottom: 2px dotted #2596be;
}

th {
  color: #4dd7fb;
  background-color: #012233;
  text-transform: uppercase;
}

table.summaryTable {
  width: 100%;
}

table.summaryTable td,
table.summaryTable th {
  border: 1px solid #aaaaaa;
  padding: 3px 2px;
}

table.summaryTable tbody td {
  font-size: 13px;
}

table.summaryTable thead {
  background: #321fdb;
}

table.summaryTable thead th {
  font-weight: bold;
  color: #ffffff;
  text-align: center;
}

.customDatePickerWidth,
.customDatePickerWidth > div.react-datepicker-wrapper,
.customDatePickerWidth > div > div.react-datepicker__input-container .customDatePickerWidth > div > div.react-datepicker__input-container input {
  width: 100%;
}

.react-datepicker__input-container {
  width: inherit;
}

.react-datepicker-wrapper {
  width: 100%;
}

.custom-map-modal .modal-dialog {
  width: 90%;
  height: 95%;
  margin: 0;
  padding-top: 2em;
}
.custom-map-modal .modal-content {
  height: auto;
  min-height: 95%;
  border-radius: 0;
}

@media all {
  .pagebreak {
    display: none;
  }
}
@media print {
  html,
  body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}
@media print {
  .pagebreak {
    margin-top: 1rem;
    display: block;
    page-break-before: always;
  }
}
@page {
  size: auto;
  margin: 10mm;
}
.parent {
  display: flex;
  flex-wrap: wrap;
}

#range,
#text {
  flex: 1 1;
}

.error {
  flex: 0 0 100%;
  /* flex-grow, flex-shrink, flex-basis */
  border: 1px dashed black;
}

.kioskcard {
  height: 250px;
  font-size: 18px;
  display: flex;
  flex-direction: column;
}

.kioskEnergyOptions {
  box-shadow: 0px 0px;
  height: 400px;
  width: 400px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  column-gap: 10px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 2%;
}

.kioskChoice {
  height: 350px;
  width: 60%;
  padding: 10px;
  display: grid;
  grid-template-columns: 1fr, 1fr;
  row-gap: 10px;
}

table.kioskTable {
  width: 100%;
  border-width: 0.5px;
  border-color: #aaaaaa;
}

table.kioskTable th {
  font-size: 18px;
  background-color: #f9b115;
  color: white;
  text-transform: capitalize;
}

table.kioskTable th,
tr,
td {
  border-top: none;
  border-bottom: solid rgba(0, 0, 0, 0.2);
  border-left: none;
  border-right: none;
  font-size: 16px;
  border-width: 0.5px;
  padding: 0.2em;
}

.kioskUsageWidget {
  width: 100%;
  box-shadow: 0px 0px;
  border-radius: 0%;
}

.kioskUsageCards {
  background-color: #f9b115;
}

.kioskBadge {
  border-radius: 2em;
  padding: 5px;
  font-size: 0.5em;
}
.kioskBadge.positive {
  background-color: #cbedd6;
  color: #2eb85c;
}
.kioskBadge.negative {
  background-color: #f9d4d4;
  color: #e55353;
}
.kioskBadge.neutral {
  background-color: #ccc7f6;
  color: #321fdb;
}

.usageReductionCard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  min-height: 120px;
}
.usageReductionCard.mainValue {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
  border-top: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 0px;
}
.usageReductionCard.subCard {
  border-radius: 10px;
  color: white;
  background-color: #2eb85c;
}

.usageReductionCardBefore {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  min-height: 120px;
}
.usageReductionCardBefore.mainValue {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
  border-top: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 0px;
}
.usageReductionCardBefore.subCard {
  border-radius: 10px;
  color: white;
  background-color: #b82e2e;
}

.usageReductionCard2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  min-height: 120px;
  margin-right: 2px;
  margin-left: 2px;
}
.usageReductionCard2.mainValue {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
  border-top: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 0px;
}
.usageReductionCard2.subCard {
  border-radius: 10px;
  color: white;
  background-color: #2eb85c;
}

.usageReductionCard2Before {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  min-height: 120px;
  margin-right: 2px;
  margin-left: 2px;
}
.usageReductionCard2Before.mainValue {
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
  border-top: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 0px;
}
.usageReductionCard2Before.subCard {
  border-radius: 10px;
  color: white;
  background-color: #b82e2e;
}

#item1 {
  grid-area: item1;
}

#item2 {
  grid-area: item2;
}

.grid {
  grid-template-areas: ". . . ." ". . . item1" "item2 item2 item2 item1" "item2 item2 item2 .";
}

.roundIconContainer {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0;
}
.roundIconContainer.arrowSuccess {
  color: white;
  background-color: #2eb85c;
}
.roundIconContainer.arrowDanger {
  color: white;
  background-color: #e55353;
}
.roundIconContainer.arrowNeutral {
  color: white;
  background-color: #321fdb;
}

.kioskBgImage {
  /* Add the blur effect */
  filter: blur(3px);
  -webkit-filter: blur(3px);
  /* Full height */
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.loginBgImage {
  /* Add the blur effect */
  filter: blur(3px);
  -webkit-filter: blur(3px);
  /* Full height */
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.kioskBgImage2 {
  /* Full height */
  height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.kioskText {
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.5); /* Black w/opacity/see-through */
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 3px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 80%;
  padding: 20px;
  text-align: center;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  flex: content;
  border-radius: 25px;
}

.loginText {
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.5); /* Black w/opacity/see-through */
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 3px solid #f1f1f1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 20px;
  text-align: center;
  font-size: 40px;
  justify-content: center;
  align-items: center;
  flex: content;
  border-radius: 25px;
}`, "",{"version":3,"sources":["webpack://./src/scss/style.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_banner.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_root.scss","webpack://./node_modules/@coreui/coreui-pro/scss/vendor/_rfs.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_reboot.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_variables.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_ltr-rtl.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_border-radius.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_type.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_lists.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_images.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_image.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_containers.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_container.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_breakpoints.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_grid.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_grid.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_tables.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_table-variants.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_labels.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_form-text.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_form-control.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_gradients.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_form-select.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_form-multi-select.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_elevation.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_form-check.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_form-range.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_floating-labels.scss","webpack://./node_modules/@coreui/coreui-pro/scss/forms/_input-group.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_forms.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_buttons.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_buttons.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_loading-button.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_transitions.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_dropdown.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_caret.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_button-group.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_nav.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_navbar.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_card.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_accordion.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_breadcrumb.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_pagination.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_pagination.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_badge.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_alert.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_progress.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_list-group.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_list-group.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_close.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_toasts.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_modal.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_backdrop.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_tooltip.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_reset-text.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_popover.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_carousel.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_clearfix.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_spinners.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_offcanvas.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_placeholders.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_avatar.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_avatar.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_calendar.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_callout.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_picker.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_date-picker.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_time-picker.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_footer.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_header.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_icon.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_icon.scss","webpack://./node_modules/@coreui/coreui-pro/scss/sidebar/_sidebar.scss","webpack://./node_modules/@coreui/coreui-pro/scss/sidebar/_sidebar-nav.scss","webpack://./node_modules/@coreui/coreui-pro/scss/sidebar/_sidebar-narrow.scss","webpack://./node_modules/@coreui/coreui-pro/scss/_subheader.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_color-bg.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_colored-links.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_focus-ring.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_icon-link.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_ratio.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_position.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_stacks.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_visually-hidden.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_stretched-link.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_text-truncation.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_text-truncate.scss","webpack://./node_modules/@coreui/coreui-pro/scss/helpers/_vr.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_utilities.scss","webpack://./node_modules/@coreui/coreui-pro/scss/utilities/_api.scss","webpack://./node_modules/@coreui/coreui-pro/scss/utilities/_bg-gradients.scss","webpack://./node_modules/@coreui/coreui-pro/scss/themes/dark.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_theme.scss","webpack://./node_modules/@coreui/coreui-pro/scss/themes/dark/_root.scss","webpack://./node_modules/@coreui/coreui-pro/scss/mixins/_alert.scss","webpack://./node_modules/@coreui/coreui-pro/scss/themes/dark/_variables.scss","webpack://./node_modules/@coreui/chartjs/scss/coreui-chartjs.scss","webpack://./node_modules/@coreui/chartjs/scss/_tooltips.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_transition.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_border-radius.scss","webpack://./src/scss/_layout.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_ltr-rtl.scss","webpack://./src/scss/_calendar.scss","webpack://./src/scss/_examples.scss","webpack://./node_modules/@coreui/coreui/scss/mixins/_breakpoints.scss","webpack://./src/scss/_custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAGG,wDAAA;AACA,wDAAA;ACHjB;;;;EAAA;ACDF;EAQI,mBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,wBAAA;EAIA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAIA,8BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,2BAAA;EAGF,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,gCAAA;EAMA,sNAAA;EACA,0GAAA;EACA,0FAAA;EAOA,kDAAA;ECsPI,0BALI;ED/OR,2BAAA;EACA,2BAAA;EAKA,wCAAA;EACA,gCAAA;EACA,mBAAA;EACA,gCAAA;EAEA,6BAAA;EACA,kCAAA;EAEA,8CAAA;EACA,qCAAA;EACA,2BAAA;EACA,qCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAGA,2CAAA;EACA,8CAAA;EACA,sCAAA;EAEA,sDAAA;EACA,uDAAA;EACA,iDAAA;EAEA,4BAAA;EAEA,yBAAA;EACA,iCAAA;EACA,gCAAA;EAEA,+BAAA;EACA,uCAAA;EAMA,yBAAA;EACA,6CAAA;EACA,2BAAA;EAGA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,qDAAA;EAEA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qDAAA;EACA,+BAAA;EAGA,oDAAA;EACA,6DAAA;EACA,sDAAA;EACA,6DAAA;EAIA,+BAAA;EACA,8BAAA;EACA,+CAAA;EAIA,+BAAA;EACA,sCAAA;EACA,iCAAA;EACA,wCAAA;AFbF;;AIhGA;;;EAGE,sBAAA;AJmGF;;AIpFI;EANJ;IAOM,uBAAA;EJwFJ;AACF;;AI3EA;EACE,SAAA;EACA,wCAAA;ED6OI,oCALI;ECtOR,wCAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,oCAAA;EACA,8BAAA;EACA,8CAAA;AJ8EF;;AIrEA;EACE,cAAA;EACA,cCwvB4B;EDvvB5B,SAAA;EACA,yCAAA;EACA,aC8vB4B;ALtrB9B;;AI9DA;EACE,aAAA;EACA,qBCqrB4B;EDlrB5B,gBCqrB4B;EDprB5B,gBCqrB4B;EDprB5B,+BAAA;AJ+DF;;AI5DA;EDuMQ,iCAAA;AHvIR;AGrBI;EC3CJ;ID8MQ,iBAAA;EH1IN;AACF;;AIhEA;EDkMQ,iCAAA;AH9HR;AG9BI;ECtCJ;IDyMQ,eAAA;EHjIN;AACF;;AIpEA;ED6LQ,+BAAA;AHrHR;AGvCI;ECjCJ;IDoMQ,kBAAA;EHxHN;AACF;;AIxEA;EDwLQ,iCAAA;AH5GR;AGhDI;EC5BJ;ID+LQ,iBAAA;EH/GN;AACF;;AI5EA;ED+KM,kBALI;AH1FV;;AI3EA;ED0KM,eALI;AHtFV;;AIpEA;EACE,aAAA;EACA,mBCod0B;AL7Y5B;;AI7DA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AJgEF;;AI1DA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJ6DF;;AIlDA;;;EAGE,aAAA;EACA,mBAAA;AJqDF;;AIlDA;;;;EAIE,gBAAA;AJqDF;;AIlDA;EACE,gBC0jB4B;ALrgB9B;;AIhDA;EACE,qBAAA;AJmDF;AMzOI;EAgCE,cAAA;AN4MN;AMpOI;EA+BI,eAAA;ANwMR;;AIlDA;EACE,gBAAA;AJqDF;;AI7CA;;EAEE,mBCmiB4B;ALnf9B;;AIxCA;ED6EM,kBALI;AH5BV;;AIrCA;EACE,iBC0nB4B;EDznB5B,iCAAA;EACA,yCAAA;AJwCF;;AI/BA;;EAEE,kBAAA;EDwDI,iBALI;ECjDR,cAAA;EACA,wBAAA;AJkCF;;AI/BA;EAAM,eAAA;AJmCN;;AIlCA;EAAM,WAAA;AJsCN;;AIjCA;EACE,kEAAA;EACA,0BC4UwC;ALxS1C;AIlCE;EACE,qDAAA;AJoCJ;;AI1BE;EAEE,cAAA;EACA,qBAAA;AJ4BJ;;AIrBA;;;;EAIE,sCC8c4B;EF/bxB,cALI;AHeV;;AIjBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDGI,kBALI;ECIR,6BAAA;AJoBF;AIjBE;EDFI,kBALI;ECSN,cAAA;EACA,kBAAA;AJmBJ;;AIfA;EDTM,kBALI;ECgBR,4BAAA;EACA,qBAAA;AJkBF;AIfE;EACE,cAAA;AJiBJ;;AIbA;EACE,2BAAA;EDrBI,kBALI;EC4BR,+CAAA;EACA,0DAAA;EGpSE,sBAAA;APqTJ;AIdE;EACE,UAAA;ED5BE,cALI;AHkDV;;AINA;EACE,gBAAA;AJSF;;AIHA;;EAEE,sBAAA;AJMF;;AIEA;EACE,oBAAA;EACA,yBAAA;AJCF;;AIEA;EACE,mBCygB4B;EDxgB5B,sBCwgB4B;EDvgB5B,iEAAA;EACA,gBAAA;AJCF;;AIMA;EAEE,mBAAA;EACA,gCAAA;AJJF;;AIOA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AJJF;;AIYA;EACE,qBAAA;AJTF;;AIeA;EAEE,gBAAA;AJbF;;AIqBA;EACE,UAAA;AJlBF;;AIuBA;;;;;EAKE,SAAA;EACA,oBAAA;ED3HI,kBALI;ECkIR,oBAAA;AJpBF;;AIwBA;;EAEE,oBAAA;AJrBF;;AI0BA;EACE,eAAA;AJvBF;;AI0BA;EAGE,iBAAA;AJzBF;AI4BE;EACE,UAAA;AJ1BJ;;AIiCA;EACE,wBAAA;AJ9BF;;AIsCA;;;;EAIE,0BAAA;AJnCF;AIsCI;;;;EACE,eAAA;AJjCN;;AIwCA;EACE,UAAA;EACA,kBAAA;AJrCF;;AI0CA;EACE,gBAAA;AJvCF;;AIiDA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AJ9CF;;AIsDA;EAEE,WAAA;EACA,UAAA;EACA,qBCyV4B;EFziBtB,iCAAA;ECmNN,oBAAA;AJrDF;AM/bI;EAgCE,WAAA;ANkaN;AM1bI;EA+BI,YAAA;AN8ZR;AGhUI;ECwWJ;IDrMQ,iBAAA;EHiKN;AACF;AI4CE;EACE,WAAA;AJ1CJ;;AIiDA;;;;;;;EAOE,UAAA;AJ9CF;;AIiDA;EACE,YAAA;AJ9CF;;AIuDA;EACE,6BAAA;EACA,oBAAA;AJpDF;;AI2DE;;;;EAIE,cAAA;AJxDJ;;AI+DA;EACE,wBAAA;AJ5DF;;AIiEA;EACE,UAAA;AJ9DF;;AIqEA;EACE,aAAA;EACA,0BAAA;AJlEF;;AIuEA;EACE,qBAAA;AJpEF;;AIyEA;EACE,SAAA;AJtEF;;AI6EA;EACE,kBAAA;EACA,eAAA;AJ1EF;;AIkFA;EACE,wBAAA;AJ/EF;;AIuFA;EACE,wBAAA;AJpFF;;AQ/eA;ELmQM,kBALI;EK5PR,gBHqwB8B;ALnRhC;;AQ7eE;ELgQM,iCAAA;EK5PJ,gBHsvBkB;EGrvBlB,gBHquB0B;ALvP9B;AG/YI;EKpGF;ILuQM,eAAA;EHgPN;AACF;;AQxfE;ELgQM,iCAAA;EK5PJ,gBHsvBkB;EGrvBlB,gBHquB0B;AL5O9B;AG1ZI;EKpGF;ILuQM,iBAAA;EH2PN;AACF;;AQngBE;ELgQM,iCAAA;EK5PJ,gBHsvBkB;EGrvBlB,gBHquB0B;ALjO9B;AGraI;EKpGF;ILuQM,eAAA;EHsQN;AACF;;AQ9gBE;ELgQM,iCAAA;EK5PJ,gBHsvBkB;EGrvBlB,gBHquB0B;ALtN9B;AGhbI;EKpGF;ILuQM,iBAAA;EHiRN;AACF;;AQzhBE;ELgQM,iCAAA;EK5PJ,gBHsvBkB;EGrvBlB,gBHquB0B;AL3M9B;AG3bI;EKpGF;ILuQM,eAAA;EH4RN;AACF;;AQpiBE;ELgQM,iCAAA;EK5PJ,gBHsvBkB;EGrvBlB,gBHquB0B;ALhM9B;AGtcI;EKpGF;ILuQM,iBAAA;EHuSN;AACF;;AQvhBA;ECtDE,gBAAA;ATilBF;AMplBI;EAgCE,eAAA;ANujBN;AM/kBI;EA+BI,gBAAA;ANmjBR;;AQ5hBA;EC3DE,gBAAA;AT2lBF;AM9lBI;EAgCE,eAAA;ANikBN;AMzlBI;EA+BI,gBAAA;AN6jBR;;AQniBA;EACE,qBAAA;ARsiBF;AMxmBI;EAgCE,oBAAA;AN2kBN;AMnmBI;EA+BI,mBAAA;ANukBR;;AQ/hBA;EL8MM,kBALI;EKvMR,yBAAA;ARkiBF;;AQ9hBA;EACE,mBH0aO;EFnOH,kBALI;AHgWV;AQ/hBE;EACE,gBAAA;ARiiBJ;;AQ7hBA;EACE,iBAAA;EACA,mBHgaO;EFnOH,kBALI;EKtLR,cHrFU;ALqnBZ;AQ9hBE;EACE,aAAA;ARgiBJ;;AUhoBA;ECIE,eAAA;EAGA,YAAA;AX8nBF;;AU/nBA;EACE,gBLk+DkC;EKj+DlC,6DAAA;EACA,gGAAA;EHGE,uCAAA;EIRF,eAAA;EAGA,YAAA;AXuoBF;;AUznBA;EAEE,qBAAA;AV2nBF;;AUxnBA;EACE,qBAAA;EACA,cAAA;AV2nBF;;AUxnBA;EPyPM,kBALI;EOlPR,kEAAA;AV2nBF;;AY7pBE;;;;;;;ECHA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;Ab0qBF;;AcpnBI;EF5CE;IACE,gBP8lBe;ELsErB;AACF;Ac1nBI;EF5CE;IACE,gBP8lBe;EL2ErB;AACF;Ac/nBI;EF5CE;IACE,gBP8lBe;ELgFrB;AACF;AcpoBI;EF5CE;IACE,iBP8lBe;ELqFrB;AACF;AczoBI;EF5CE;IACE,iBP8lBe;EL0FrB;AACF;AezsBA;EAEI,sBAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAGF,2BAAA;Af6sBF;;AezsBE;ECRA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,0CAAA;EACA,8CAAA;EACA,6CAAA;AhBotBF;AehtBI;ECKF,cAAA;EACA,WAAA;EACA,eAAA;EACA,8CAAA;EACA,6CAAA;EACA,+BAAA;AhB8sBF;;AgB/pBM;EACE,SAAA;AhBkqBR;;AgB/pBM;EApCJ,cAAA;EACA,WAAA;AhBusBF;;AgBzrBE;EACE,cAAA;EACA,WAAA;AhB4rBJ;;AgB9rBE;EACE,cAAA;EACA,UAAA;AhBisBJ;;AgBnsBE;EACE,cAAA;EACA,mBAAA;AhBssBJ;;AgBxsBE;EACE,cAAA;EACA,UAAA;AhB2sBJ;;AgB7sBE;EACE,cAAA;EACA,UAAA;AhBgtBJ;;AgBltBE;EACE,cAAA;EACA,mBAAA;AhBqtBJ;;AgBtrBM;EAhDJ,cAAA;EACA,WAAA;AhB0uBF;;AgBrrBU;EAhEN,cAAA;EACA,kBAAA;AhByvBJ;;AgB1rBU;EAhEN,cAAA;EACA,mBAAA;AhB8vBJ;;AgB/rBU;EAhEN,cAAA;EACA,UAAA;AhBmwBJ;;AgBpsBU;EAhEN,cAAA;EACA,mBAAA;AhBwwBJ;;AgBzsBU;EAhEN,cAAA;EACA,mBAAA;AhB6wBJ;;AgB9sBU;EAhEN,cAAA;EACA,UAAA;AhBkxBJ;;AgBntBU;EAhEN,cAAA;EACA,mBAAA;AhBuxBJ;;AgBxtBU;EAhEN,cAAA;EACA,mBAAA;AhB4xBJ;;AgB7tBU;EAhEN,cAAA;EACA,UAAA;AhBiyBJ;;AgBluBU;EAhEN,cAAA;EACA,mBAAA;AhBsyBJ;;AgBvuBU;EAhEN,cAAA;EACA,mBAAA;AhB2yBJ;;AgB5uBU;EAhEN,cAAA;EACA,WAAA;AhBgzBJ;;AM90BI;EAgCE,wBAAA;ANkzBN;AM10BI;EA+BI,yBAAA;AN8yBR;;AMr1BI;EAgCE,yBAAA;ANyzBN;AMj1BI;EA+BI,0BAAA;ANqzBR;;AM51BI;EAgCE,gBAAA;ANg0BN;AMx1BI;EA+BI,iBAAA;AN4zBR;;AMn2BI;EAgCE,yBAAA;ANu0BN;AM/1BI;EA+BI,0BAAA;ANm0BR;;AM12BI;EAgCE,yBAAA;AN80BN;AMt2BI;EA+BI,0BAAA;AN00BR;;AMj3BI;EAgCE,gBAAA;ANq1BN;AM72BI;EA+BI,iBAAA;ANi1BR;;AMx3BI;EAgCE,yBAAA;AN41BN;AMp3BI;EA+BI,0BAAA;ANw1BR;;AM/3BI;EAgCE,yBAAA;ANm2BN;AM33BI;EA+BI,0BAAA;AN+1BR;;AMt4BI;EAgCE,gBAAA;AN02BN;AMl4BI;EA+BI,iBAAA;ANs2BR;;AM74BI;EAgCE,yBAAA;ANi3BN;AMz4BI;EA+BI,0BAAA;AN62BR;;AMp5BI;EAgCE,yBAAA;ANw3BN;AMh5BI;EA+BI,0BAAA;ANo3BR;;AgB3yBQ;;EAEE,iBAAA;AhB8yBV;;AgB3yBQ;;EAEE,iBAAA;AhB8yBV;;AgBrzBQ;;EAEE,uBAAA;AhBwzBV;;AgBrzBQ;;EAEE,uBAAA;AhBwzBV;;AgB/zBQ;;EAEE,sBAAA;AhBk0BV;;AgB/zBQ;;EAEE,sBAAA;AhBk0BV;;AgBz0BQ;;EAEE,oBAAA;AhB40BV;;AgBz0BQ;;EAEE,oBAAA;AhB40BV;;AgBn1BQ;;EAEE,sBAAA;AhBs1BV;;AgBn1BQ;;EAEE,sBAAA;AhBs1BV;;AgB71BQ;;EAEE,oBAAA;AhBg2BV;;AgB71BQ;;EAEE,oBAAA;AhBg2BV;;Ac15BI;EEUE;IACE,SAAA;EhBo5BN;EgBj5BI;IApCJ,cAAA;IACA,WAAA;EhBw7BA;EgB16BA;IACE,cAAA;IACA,WAAA;EhB46BF;EgB96BA;IACE,cAAA;IACA,UAAA;EhBg7BF;EgBl7BA;IACE,cAAA;IACA,mBAAA;EhBo7BF;EgBt7BA;IACE,cAAA;IACA,UAAA;EhBw7BF;EgB17BA;IACE,cAAA;IACA,UAAA;EhB47BF;EgB97BA;IACE,cAAA;IACA,mBAAA;EhBg8BF;EgBj6BI;IAhDJ,cAAA;IACA,WAAA;EhBo9BA;EgB/5BQ;IAhEN,cAAA;IACA,kBAAA;EhBk+BF;EgBn6BQ;IAhEN,cAAA;IACA,mBAAA;EhBs+BF;EgBv6BQ;IAhEN,cAAA;IACA,UAAA;EhB0+BF;EgB36BQ;IAhEN,cAAA;IACA,mBAAA;EhB8+BF;EgB/6BQ;IAhEN,cAAA;IACA,mBAAA;EhBk/BF;EgBn7BQ;IAhEN,cAAA;IACA,UAAA;EhBs/BF;EgBv7BQ;IAhEN,cAAA;IACA,mBAAA;EhB0/BF;EgB37BQ;IAhEN,cAAA;IACA,mBAAA;EhB8/BF;EgB/7BQ;IAhEN,cAAA;IACA,UAAA;EhBkgCF;EgBn8BQ;IAhEN,cAAA;IACA,mBAAA;EhBsgCF;EgBv8BQ;IAhEN,cAAA;IACA,mBAAA;EhB0gCF;EgB38BQ;IAhEN,cAAA;IACA,WAAA;EhB8gCF;EM5iCE;IAgCE,cAAA;EN+gCJ;EMviCE;IA+BI,eAAA;EN2gCN;EMljCE;IAgCE,wBAAA;ENqhCJ;EM7iCE;IA+BI,yBAAA;ENihCN;EMxjCE;IAgCE,yBAAA;EN2hCJ;EMnjCE;IA+BI,0BAAA;ENuhCN;EM9jCE;IAgCE,gBAAA;ENiiCJ;EMzjCE;IA+BI,iBAAA;EN6hCN;EMpkCE;IAgCE,yBAAA;ENuiCJ;EM/jCE;IA+BI,0BAAA;ENmiCN;EM1kCE;IAgCE,yBAAA;EN6iCJ;EMrkCE;IA+BI,0BAAA;ENyiCN;EMhlCE;IAgCE,gBAAA;ENmjCJ;EM3kCE;IA+BI,iBAAA;EN+iCN;EMtlCE;IAgCE,yBAAA;ENyjCJ;EMjlCE;IA+BI,0BAAA;ENqjCN;EM5lCE;IAgCE,yBAAA;EN+jCJ;EMvlCE;IA+BI,0BAAA;EN2jCN;EMlmCE;IAgCE,gBAAA;ENqkCJ;EM7lCE;IA+BI,iBAAA;ENikCN;EMxmCE;IAgCE,yBAAA;EN2kCJ;EMnmCE;IA+BI,0BAAA;ENukCN;EM9mCE;IAgCE,yBAAA;ENilCJ;EMzmCE;IA+BI,0BAAA;EN6kCN;EgBpgCM;;IAEE,iBAAA;EhBsgCR;EgBngCM;;IAEE,iBAAA;EhBqgCR;EgB5gCM;;IAEE,uBAAA;EhB8gCR;EgB3gCM;;IAEE,uBAAA;EhB6gCR;EgBphCM;;IAEE,sBAAA;EhBshCR;EgBnhCM;;IAEE,sBAAA;EhBqhCR;EgB5hCM;;IAEE,oBAAA;EhB8hCR;EgB3hCM;;IAEE,oBAAA;EhB6hCR;EgBpiCM;;IAEE,sBAAA;EhBsiCR;EgBniCM;;IAEE,sBAAA;EhBqiCR;EgB5iCM;;IAEE,oBAAA;EhB8iCR;EgB3iCM;;IAEE,oBAAA;EhB6iCR;AACF;AcxmCI;EEUE;IACE,SAAA;EhBimCN;EgB9lCI;IApCJ,cAAA;IACA,WAAA;EhBqoCA;EgBvnCA;IACE,cAAA;IACA,WAAA;EhBynCF;EgB3nCA;IACE,cAAA;IACA,UAAA;EhB6nCF;EgB/nCA;IACE,cAAA;IACA,mBAAA;EhBioCF;EgBnoCA;IACE,cAAA;IACA,UAAA;EhBqoCF;EgBvoCA;IACE,cAAA;IACA,UAAA;EhByoCF;EgB3oCA;IACE,cAAA;IACA,mBAAA;EhB6oCF;EgB9mCI;IAhDJ,cAAA;IACA,WAAA;EhBiqCA;EgB5mCQ;IAhEN,cAAA;IACA,kBAAA;EhB+qCF;EgBhnCQ;IAhEN,cAAA;IACA,mBAAA;EhBmrCF;EgBpnCQ;IAhEN,cAAA;IACA,UAAA;EhBurCF;EgBxnCQ;IAhEN,cAAA;IACA,mBAAA;EhB2rCF;EgB5nCQ;IAhEN,cAAA;IACA,mBAAA;EhB+rCF;EgBhoCQ;IAhEN,cAAA;IACA,UAAA;EhBmsCF;EgBpoCQ;IAhEN,cAAA;IACA,mBAAA;EhBusCF;EgBxoCQ;IAhEN,cAAA;IACA,mBAAA;EhB2sCF;EgB5oCQ;IAhEN,cAAA;IACA,UAAA;EhB+sCF;EgBhpCQ;IAhEN,cAAA;IACA,mBAAA;EhBmtCF;EgBppCQ;IAhEN,cAAA;IACA,mBAAA;EhButCF;EgBxpCQ;IAhEN,cAAA;IACA,WAAA;EhB2tCF;EMzvCE;IAgCE,cAAA;EN4tCJ;EMpvCE;IA+BI,eAAA;ENwtCN;EM/vCE;IAgCE,wBAAA;ENkuCJ;EM1vCE;IA+BI,yBAAA;EN8tCN;EMrwCE;IAgCE,yBAAA;ENwuCJ;EMhwCE;IA+BI,0BAAA;ENouCN;EM3wCE;IAgCE,gBAAA;EN8uCJ;EMtwCE;IA+BI,iBAAA;EN0uCN;EMjxCE;IAgCE,yBAAA;ENovCJ;EM5wCE;IA+BI,0BAAA;ENgvCN;EMvxCE;IAgCE,yBAAA;EN0vCJ;EMlxCE;IA+BI,0BAAA;ENsvCN;EM7xCE;IAgCE,gBAAA;ENgwCJ;EMxxCE;IA+BI,iBAAA;EN4vCN;EMnyCE;IAgCE,yBAAA;ENswCJ;EM9xCE;IA+BI,0BAAA;ENkwCN;EMzyCE;IAgCE,yBAAA;EN4wCJ;EMpyCE;IA+BI,0BAAA;ENwwCN;EM/yCE;IAgCE,gBAAA;ENkxCJ;EM1yCE;IA+BI,iBAAA;EN8wCN;EMrzCE;IAgCE,yBAAA;ENwxCJ;EMhzCE;IA+BI,0BAAA;ENoxCN;EM3zCE;IAgCE,yBAAA;EN8xCJ;EMtzCE;IA+BI,0BAAA;EN0xCN;EgBjtCM;;IAEE,iBAAA;EhBmtCR;EgBhtCM;;IAEE,iBAAA;EhBktCR;EgBztCM;;IAEE,uBAAA;EhB2tCR;EgBxtCM;;IAEE,uBAAA;EhB0tCR;EgBjuCM;;IAEE,sBAAA;EhBmuCR;EgBhuCM;;IAEE,sBAAA;EhBkuCR;EgBzuCM;;IAEE,oBAAA;EhB2uCR;EgBxuCM;;IAEE,oBAAA;EhB0uCR;EgBjvCM;;IAEE,sBAAA;EhBmvCR;EgBhvCM;;IAEE,sBAAA;EhBkvCR;EgBzvCM;;IAEE,oBAAA;EhB2vCR;EgBxvCM;;IAEE,oBAAA;EhB0vCR;AACF;AcrzCI;EEUE;IACE,SAAA;EhB8yCN;EgB3yCI;IApCJ,cAAA;IACA,WAAA;EhBk1CA;EgBp0CA;IACE,cAAA;IACA,WAAA;EhBs0CF;EgBx0CA;IACE,cAAA;IACA,UAAA;EhB00CF;EgB50CA;IACE,cAAA;IACA,mBAAA;EhB80CF;EgBh1CA;IACE,cAAA;IACA,UAAA;EhBk1CF;EgBp1CA;IACE,cAAA;IACA,UAAA;EhBs1CF;EgBx1CA;IACE,cAAA;IACA,mBAAA;EhB01CF;EgB3zCI;IAhDJ,cAAA;IACA,WAAA;EhB82CA;EgBzzCQ;IAhEN,cAAA;IACA,kBAAA;EhB43CF;EgB7zCQ;IAhEN,cAAA;IACA,mBAAA;EhBg4CF;EgBj0CQ;IAhEN,cAAA;IACA,UAAA;EhBo4CF;EgBr0CQ;IAhEN,cAAA;IACA,mBAAA;EhBw4CF;EgBz0CQ;IAhEN,cAAA;IACA,mBAAA;EhB44CF;EgB70CQ;IAhEN,cAAA;IACA,UAAA;EhBg5CF;EgBj1CQ;IAhEN,cAAA;IACA,mBAAA;EhBo5CF;EgBr1CQ;IAhEN,cAAA;IACA,mBAAA;EhBw5CF;EgBz1CQ;IAhEN,cAAA;IACA,UAAA;EhB45CF;EgB71CQ;IAhEN,cAAA;IACA,mBAAA;EhBg6CF;EgBj2CQ;IAhEN,cAAA;IACA,mBAAA;EhBo6CF;EgBr2CQ;IAhEN,cAAA;IACA,WAAA;EhBw6CF;EMt8CE;IAgCE,cAAA;ENy6CJ;EMj8CE;IA+BI,eAAA;ENq6CN;EM58CE;IAgCE,wBAAA;EN+6CJ;EMv8CE;IA+BI,yBAAA;EN26CN;EMl9CE;IAgCE,yBAAA;ENq7CJ;EM78CE;IA+BI,0BAAA;ENi7CN;EMx9CE;IAgCE,gBAAA;EN27CJ;EMn9CE;IA+BI,iBAAA;ENu7CN;EM99CE;IAgCE,yBAAA;ENi8CJ;EMz9CE;IA+BI,0BAAA;EN67CN;EMp+CE;IAgCE,yBAAA;ENu8CJ;EM/9CE;IA+BI,0BAAA;ENm8CN;EM1+CE;IAgCE,gBAAA;EN68CJ;EMr+CE;IA+BI,iBAAA;ENy8CN;EMh/CE;IAgCE,yBAAA;ENm9CJ;EM3+CE;IA+BI,0BAAA;EN+8CN;EMt/CE;IAgCE,yBAAA;ENy9CJ;EMj/CE;IA+BI,0BAAA;ENq9CN;EM5/CE;IAgCE,gBAAA;EN+9CJ;EMv/CE;IA+BI,iBAAA;EN29CN;EMlgDE;IAgCE,yBAAA;ENq+CJ;EM7/CE;IA+BI,0BAAA;ENi+CN;EMxgDE;IAgCE,yBAAA;EN2+CJ;EMngDE;IA+BI,0BAAA;ENu+CN;EgB95CM;;IAEE,iBAAA;EhBg6CR;EgB75CM;;IAEE,iBAAA;EhB+5CR;EgBt6CM;;IAEE,uBAAA;EhBw6CR;EgBr6CM;;IAEE,uBAAA;EhBu6CR;EgB96CM;;IAEE,sBAAA;EhBg7CR;EgB76CM;;IAEE,sBAAA;EhB+6CR;EgBt7CM;;IAEE,oBAAA;EhBw7CR;EgBr7CM;;IAEE,oBAAA;EhBu7CR;EgB97CM;;IAEE,sBAAA;EhBg8CR;EgB77CM;;IAEE,sBAAA;EhB+7CR;EgBt8CM;;IAEE,oBAAA;EhBw8CR;EgBr8CM;;IAEE,oBAAA;EhBu8CR;AACF;AclgDI;EEUE;IACE,SAAA;EhB2/CN;EgBx/CI;IApCJ,cAAA;IACA,WAAA;EhB+hDA;EgBjhDA;IACE,cAAA;IACA,WAAA;EhBmhDF;EgBrhDA;IACE,cAAA;IACA,UAAA;EhBuhDF;EgBzhDA;IACE,cAAA;IACA,mBAAA;EhB2hDF;EgB7hDA;IACE,cAAA;IACA,UAAA;EhB+hDF;EgBjiDA;IACE,cAAA;IACA,UAAA;EhBmiDF;EgBriDA;IACE,cAAA;IACA,mBAAA;EhBuiDF;EgBxgDI;IAhDJ,cAAA;IACA,WAAA;EhB2jDA;EgBtgDQ;IAhEN,cAAA;IACA,kBAAA;EhBykDF;EgB1gDQ;IAhEN,cAAA;IACA,mBAAA;EhB6kDF;EgB9gDQ;IAhEN,cAAA;IACA,UAAA;EhBilDF;EgBlhDQ;IAhEN,cAAA;IACA,mBAAA;EhBqlDF;EgBthDQ;IAhEN,cAAA;IACA,mBAAA;EhBylDF;EgB1hDQ;IAhEN,cAAA;IACA,UAAA;EhB6lDF;EgB9hDQ;IAhEN,cAAA;IACA,mBAAA;EhBimDF;EgBliDQ;IAhEN,cAAA;IACA,mBAAA;EhBqmDF;EgBtiDQ;IAhEN,cAAA;IACA,UAAA;EhBymDF;EgB1iDQ;IAhEN,cAAA;IACA,mBAAA;EhB6mDF;EgB9iDQ;IAhEN,cAAA;IACA,mBAAA;EhBinDF;EgBljDQ;IAhEN,cAAA;IACA,WAAA;EhBqnDF;EMnpDE;IAgCE,cAAA;ENsnDJ;EM9oDE;IA+BI,eAAA;ENknDN;EMzpDE;IAgCE,wBAAA;EN4nDJ;EMppDE;IA+BI,yBAAA;ENwnDN;EM/pDE;IAgCE,yBAAA;ENkoDJ;EM1pDE;IA+BI,0BAAA;EN8nDN;EMrqDE;IAgCE,gBAAA;ENwoDJ;EMhqDE;IA+BI,iBAAA;ENooDN;EM3qDE;IAgCE,yBAAA;EN8oDJ;EMtqDE;IA+BI,0BAAA;EN0oDN;EMjrDE;IAgCE,yBAAA;ENopDJ;EM5qDE;IA+BI,0BAAA;ENgpDN;EMvrDE;IAgCE,gBAAA;EN0pDJ;EMlrDE;IA+BI,iBAAA;ENspDN;EM7rDE;IAgCE,yBAAA;ENgqDJ;EMxrDE;IA+BI,0BAAA;EN4pDN;EMnsDE;IAgCE,yBAAA;ENsqDJ;EM9rDE;IA+BI,0BAAA;ENkqDN;EMzsDE;IAgCE,gBAAA;EN4qDJ;EMpsDE;IA+BI,iBAAA;ENwqDN;EM/sDE;IAgCE,yBAAA;ENkrDJ;EM1sDE;IA+BI,0BAAA;EN8qDN;EMrtDE;IAgCE,yBAAA;ENwrDJ;EMhtDE;IA+BI,0BAAA;ENorDN;EgB3mDM;;IAEE,iBAAA;EhB6mDR;EgB1mDM;;IAEE,iBAAA;EhB4mDR;EgBnnDM;;IAEE,uBAAA;EhBqnDR;EgBlnDM;;IAEE,uBAAA;EhBonDR;EgB3nDM;;IAEE,sBAAA;EhB6nDR;EgB1nDM;;IAEE,sBAAA;EhB4nDR;EgBnoDM;;IAEE,oBAAA;EhBqoDR;EgBloDM;;IAEE,oBAAA;EhBooDR;EgB3oDM;;IAEE,sBAAA;EhB6oDR;EgB1oDM;;IAEE,sBAAA;EhB4oDR;EgBnpDM;;IAEE,oBAAA;EhBqpDR;EgBlpDM;;IAEE,oBAAA;EhBopDR;AACF;Ac/sDI;EEUE;IACE,SAAA;EhBwsDN;EgBrsDI;IApCJ,cAAA;IACA,WAAA;EhB4uDA;EgB9tDA;IACE,cAAA;IACA,WAAA;EhBguDF;EgBluDA;IACE,cAAA;IACA,UAAA;EhBouDF;EgBtuDA;IACE,cAAA;IACA,mBAAA;EhBwuDF;EgB1uDA;IACE,cAAA;IACA,UAAA;EhB4uDF;EgB9uDA;IACE,cAAA;IACA,UAAA;EhBgvDF;EgBlvDA;IACE,cAAA;IACA,mBAAA;EhBovDF;EgBrtDI;IAhDJ,cAAA;IACA,WAAA;EhBwwDA;EgBntDQ;IAhEN,cAAA;IACA,kBAAA;EhBsxDF;EgBvtDQ;IAhEN,cAAA;IACA,mBAAA;EhB0xDF;EgB3tDQ;IAhEN,cAAA;IACA,UAAA;EhB8xDF;EgB/tDQ;IAhEN,cAAA;IACA,mBAAA;EhBkyDF;EgBnuDQ;IAhEN,cAAA;IACA,mBAAA;EhBsyDF;EgBvuDQ;IAhEN,cAAA;IACA,UAAA;EhB0yDF;EgB3uDQ;IAhEN,cAAA;IACA,mBAAA;EhB8yDF;EgB/uDQ;IAhEN,cAAA;IACA,mBAAA;EhBkzDF;EgBnvDQ;IAhEN,cAAA;IACA,UAAA;EhBszDF;EgBvvDQ;IAhEN,cAAA;IACA,mBAAA;EhB0zDF;EgB3vDQ;IAhEN,cAAA;IACA,mBAAA;EhB8zDF;EgB/vDQ;IAhEN,cAAA;IACA,WAAA;EhBk0DF;EMh2DE;IAgCE,cAAA;ENm0DJ;EM31DE;IA+BI,eAAA;EN+zDN;EMt2DE;IAgCE,wBAAA;ENy0DJ;EMj2DE;IA+BI,yBAAA;ENq0DN;EM52DE;IAgCE,yBAAA;EN+0DJ;EMv2DE;IA+BI,0BAAA;EN20DN;EMl3DE;IAgCE,gBAAA;ENq1DJ;EM72DE;IA+BI,iBAAA;ENi1DN;EMx3DE;IAgCE,yBAAA;EN21DJ;EMn3DE;IA+BI,0BAAA;ENu1DN;EM93DE;IAgCE,yBAAA;ENi2DJ;EMz3DE;IA+BI,0BAAA;EN61DN;EMp4DE;IAgCE,gBAAA;ENu2DJ;EM/3DE;IA+BI,iBAAA;ENm2DN;EM14DE;IAgCE,yBAAA;EN62DJ;EMr4DE;IA+BI,0BAAA;ENy2DN;EMh5DE;IAgCE,yBAAA;ENm3DJ;EM34DE;IA+BI,0BAAA;EN+2DN;EMt5DE;IAgCE,gBAAA;ENy3DJ;EMj5DE;IA+BI,iBAAA;ENq3DN;EM55DE;IAgCE,yBAAA;EN+3DJ;EMv5DE;IA+BI,0BAAA;EN23DN;EMl6DE;IAgCE,yBAAA;ENq4DJ;EM75DE;IA+BI,0BAAA;ENi4DN;EgBxzDM;;IAEE,iBAAA;EhB0zDR;EgBvzDM;;IAEE,iBAAA;EhByzDR;EgBh0DM;;IAEE,uBAAA;EhBk0DR;EgB/zDM;;IAEE,uBAAA;EhBi0DR;EgBx0DM;;IAEE,sBAAA;EhB00DR;EgBv0DM;;IAEE,sBAAA;EhBy0DR;EgBh1DM;;IAEE,oBAAA;EhBk1DR;EgB/0DM;;IAEE,oBAAA;EhBi1DR;EgBx1DM;;IAEE,sBAAA;EhB01DR;EgBv1DM;;IAEE,sBAAA;EhBy1DR;EgBh2DM;;IAEE,oBAAA;EhBk2DR;EgB/1DM;;IAEE,oBAAA;EhBi2DR;AACF;AiBv9DA;EAEE,+BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EAEA,4CAAA;EACA,kCAAA;EACA,iDAAA;EACA,kCAAA;EACA,oDAAA;EACA,iEAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,gEAAA;EAEA,WAAA;EACA,mBZ2eO;EY1eP,mBZm1B4B;EYl1B5B,2CAAA;AjBs9DF;AiB/8DE;EACE,sBAAA;EAEA,wFAAA;EACA,qCAAA;EACA,4CZ21B0B;EY11B1B,8GAAA;AjBg9DJ;AiB78DE;EACE,uBAAA;AjB+8DJ;AiB58DE;EACE,sBAAA;AjB88DJ;;AiB18DA;EACE,gEAAA;AjB68DF;;AiBt8DA;EACE,iBAAA;AjBy8DF;;AiB/7DE;EACE,wBAAA;AjBk8DJ;;AiBn7DE;EACE,uCAAA;AjBs7DJ;AiBn7DI;EACE,uCAAA;AjBq7DN;;AiB96DE;EACE,sBAAA;AjBi7DJ;AiB96DE;EACE,mBAAA;AjBg7DJ;;AiBt6DE;EACE,sDAAA;EACA,gDAAA;AjBy6DJ;;AiBn6DE;EACE,sDAAA;EACA,gDAAA;AjBs6DJ;;AiB95DA;EACE,sDAAA;EACA,gDAAA;AjBi6DF;;AiBz5DE;EACE,qDAAA;EACA,+CAAA;AjB45DJ;;AkBxiEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBoiEJ;;AkBtjEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBkjEJ;;AkBpkEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBgkEJ;;AkBllEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlB8kEJ;;AkBhmEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlB4lEJ;;AkB9mEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlB0mEJ;;AkB5nEE;EAOE,yCAAA;EACA,uBAAA;EACA,mDAAA;EACA,mDAAA;EACA,iDAAA;EACA,iDAAA;EACA,gDAAA;EACA,kDAAA;EACA,+CAAA;EAEA,6BAAA;EACA,2CAAA;AlBwnEJ;;AkB1oEE;EAOE,4CAAA;EACA,uBAAA;EACA,oDAAA;EACA,iDAAA;EACA,oDAAA;EACA,gDAAA;EACA,mDAAA;EACA,iDAAA;EACA,kDAAA;EAEA,6BAAA;EACA,2CAAA;AlBsoEJ;;AiBr/DI;EACE,gBAAA;EACA,iCAAA;AjBw/DN;;AcnlEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB8/DJ;AACF;Ac1lEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBogEJ;AACF;AchmEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB0gEJ;AACF;ActmEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBghEJ;AACF;Ac5mEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBshEJ;AACF;AmB1rEA;EACE,qBd0gCsC;EctgCtC,oCAAA;AnByrEF;;AmBprEA;EACE,qDAAA;EACA,wDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBd4tB4B;Ec3tB5B,oCAAA;AnBqrEF;;AmBlrEA;EACE,mDAAA;EACA,sDAAA;EhBoQI,kBALI;AHu7DV;;AmBlrEA;EACE,oDAAA;EACA,uDAAA;EhB8PI,mBALI;AH67DV;;AoBntEA;EACE,mBfkgCsC;EFxuBlC,kBALI;EiBjRR,6DAAA;ApBotEF;;AqBztEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBhB+tB4B;EgB9tB5B,gBhBsuB4B;EgBruB5B,oDAAA;EACA,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,4FAAA;EdGE,uCAAA;EeHE,wEDMJ;ArButEF;AsBztEM;EDhBN;ICiBQ,gBAAA;EtB4tEN;AACF;AqB1tEE;EACE,gBAAA;ArB4tEJ;AqB1tEI;EACE,eAAA;ArB4tEN;AqBvtEE;EACE,0DAAA;EACA,+DAAA;EACA,0DAAA;EACA,UAAA;EAKE,iDhB+oBkB;ALskDxB;AqB9sEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBksEJ;AqB7rEE;EACE,cAAA;EACA,UAAA;ArB+rEJ;AqB3rEE;EACE,qEAAA;EAEA,UAAA;ArB4rEJ;AqBprEE;EAEE,yChB88BoC;EgB38BpC,UAAA;ArBmrEJ;AqB/qEE;EACE,yBAAA;EACA,0BAAA;EACA,0BhB6zB0B;EgB5zB1B,+DAAA;EEjGF,wEFkGuB;EACrB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gDhBy0B0B;EgBx0B1B,gBAAA;EC5FE,qID6FF;ArBirEJ;AsB1wEM;ED6EJ;IC5EM,gBAAA;EtB6wEN;AACF;AqBnrEE;EACE,+EAAA;ArBqrEJ;;AqB5qEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBhBknB4B;EgBjnB5B,8DAAA;EACA,6BAAA;EACA,yBAAA;EACA,uCAAA;ArB+qEF;AqB7qEE;EACE,UAAA;ArB+qEJ;AqB5qEE;EAEE,gBAAA;EACA,eAAA;ArB6qEJ;;AqBlqEA;EACE,oEhB46BsC;EgB36BtC,uBAAA;ElBsII,mBALI;EIvQN,0CAAA;AP6yEJ;AqBnqEE;EACE,uBAAA;EACA,wBAAA;EACA,yBhB6wB0B;ALw5C9B;;AqBjqEA;EACE,kEhBg6BsC;EgB/5BtC,oBAAA;ElByHI,kBALI;EIvQN,0CAAA;APyzEJ;AqBlqEE;EACE,oBAAA;EACA,qBAAA;EACA,uBhBowB0B;ALg6C9B;;AqB5pEE;EACE,qEhB64BoC;ALkxCxC;AqB5pEE;EACE,oEhB04BoC;ALoxCxC;AqB3pEE;EACE,kEhBu4BoC;ALsxCxC;;AqBxpEA;EACE,WhBq4BsC;EgBp4BtC,iEhB83BsC;EgB73BtC,iBhB0tB4B;ALi8C9B;AqBzpEE;EACE,eAAA;ArB2pEJ;AqBxpEE;EACE,oBAAA;Ed1LA,uCAAA;APq1EJ;AqBvpEE;EACE,oBAAA;Ed/LA,uCAAA;APy1EJ;AqBtpEE;EAAoB,gEhB82BkB;AL2yCxC;AqBxpEE;EAAoB,8DhB82BkB;AL6yCxC;;AwB72EA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EAEA,uCAAA;ErBoRI,eALI;EqB5QR,gBnB2tB4B;EmB1tB5B,gBnBkuB4B;EmBjuB5B,0DAAA;EACA,gBAAA;EACA,+DAAA;EACA,qFAAA;EACA,4BAAA;EAEA,0BnB8oCkC;EmB7oClC,kGAAA;EjBJE,uCAAA;EeHE,wEEUJ;AxB22EF;AMn4EI;EA+DE,0CAAA;ANu0EN;AM93EI;EA2DI,0CAAA;ANs0ER;AMz4EI;EA+DE,yCAAA;AN60EN;AMp4EI;EA6DI,wCAAA;AN00ER;AsB73EM;EEfN;IFgBQ,gBAAA;EtBg4EN;AACF;AwB13EE;EACE,gEAAA;EACA,UAAA;EAKE,iDnBgpC4B;ALwuClC;AwBp3EE;EAGE,sBAAA;AxBo3EJ;AM55EI;EAgCE,sBAAA;AN+3EN;AMv5EI;EA+BI,qBAAA;AN23ER;AwBv3EE;EACE,8CAAA;EACA,6EAAA;AxBy3EJ;AwBp3EE;EACE,kBAAA;EACA,sEAAA;AxBs3EJ;;AwBl3EA;EACE,oBnBi3B4B;EmBh3B5B,uBnBg3B4B;EF7oBxB,mBALI;EIvQN,0CAAA;APg6EJ;AMj7EI;EAgCE,oBAAA;ANo5EN;AM56EI;EA+BI,qBAAA;ANg5ER;;AwBv3EA;EACE,mBnB62B4B;EmB52B5B,sBnB42B4B;EFjpBxB,kBALI;EIvQN,0CAAA;AP66EJ;AM97EI;EAgCE,kBAAA;ANi6EN;AMz7EI;EA+BI,mBAAA;AN65ER;;AwB33EA;EACE,yBAAA;AxB83EF;;AyB18EA;EAEE,2CAAA;EACA,0CAAA;EACA,qCAAA;EACA,uCAAA;EACA,wCAAA;EACA,wCAAA;EACA,oDAAA;EACA,8CAAA;EACA,yDAAA;EACA,0CAAA;EACA,6DAAA;EACA,uGAAA;EACA,+DAAA;EACA,wCAAA;EACA,4DAAA;EACA,0DAAA;EACA,oDAAA;EACA,mDAAA;EACA,0DAAA;EACA,0DAAA;EAEA,0EAAA;EACA,kDAAA;EAEA,8CAAA;EACA,+CAAA;EACA,iDAAA;EACA,kDAAA;EACA,2EAAA;EACA,iFAAA;EACA,iFAAA;EAEA,2DAAA;EACA,qDAAA;EACA,sDAAA;EAEA,oDAAA;EACA,qDAAA;EACA,yEAAA;EACA,kDAAA;EACA,wEAAA;EACA,6HAAA;EACA,qEAAA;EACA,wDAAA;EAEA,oDAAA;EACA,wCAAA;EACA,qDAAA;EACA,mGAAA;EACA,uDAAA;EAEA,iDAAA;EACA,kDAAA;EACA,4DAAA;EAEA,gDAAA;EACA,iDAAA;EACA,sDAAA;EACA,mDAAA;EACA,iEAAA;EACA,sDAAA;EACA,mDAAA;EACA,+DAAA;EACA,sGAAA;EACA,8DAAA;EACA,mDAAA;EACA,6DAAA;EACA,mGAAA;EACA,uEAAA;EAEA,+EAAA;EACA,6CAAA;EACA,8CAAA;EACA,8CAAA;EACA,uDAAA;EACA,iEAAA;EACA,+GAAA;EACA,kDAAA;EAGA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,sFAAA;EAEA,qDAAA;EtBwMI,iDALI;EsBjMR,qDAAA;EACA,qDAAA;EACA,yCAAA;EACA,gBAAA;EACA,iDAAA;EACA,wDAAA;EACA,4BAAA;EAEA,qDAAA;EACA,2CAAA;ElB/EE,yDAAA;APghFJ;AMjiFI;EAgCE,6DAAA;ANogFN;AM5hFI;EA+BI,4DAAA;ANggFR;AMviFI;EA+DE,6DAAA;AN2+EN;AMliFI;EA6DI,6DAAA;ANw+ER;AyB18EE;EAEE,kDAAA;EACA,0DAAA;AzB28EJ;AyBz8EI;EACE,uBAAA;AzB28EN;AMpjFI;EAgCE,qBAAA;ANuhFN;AM/iFI;EA+BI,oBAAA;ANmhFR;AyBz8EE;EAEE,6CAAA;AzB08EJ;AyBv8EE;EAEE,6CAAA;AzBw8EJ;AyBp8EE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AzBs8EJ;;AyBl8EA;EACE,uDAAA;EACA,oHAAA;AzBq8EF;AM7kFI;EAgCE,6DAAA;ANgjFN;AMxkFI;EA+BI,4DAAA;AN4iFR;AyBx8EE;EACE,YAAA;AzB08EJ;AMtlFI;EAgCE,mDAAA;ANyjFN;AMjlFI;EA+BI,oDAAA;ANqjFR;;AyB38EA;EACE,eAAA;EACA,UAAA;AzB88EF;;AyB38EA;EACE,kBAAA;EACA,QAAA;EAEA,uBAAA;EACA,iDAAA;EACA,mDAAA;EACA,sGAAA;EACA,6BAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,gEAAA;EACA,SAAA;EAEA,2BAAA;AzB48EF;AMjnFI;EAgCE,qDAAA;ANolFN;AM5mFI;EA+BI,oDAAA;ANglFR;AMvnFI;EAgCE,kGAAA;AN0lFN;AMlnFI;EA+BI,iGAAA;ANslFR;AyBt9EE;EACE,+DAAA;AzBw9EJ;AyBr9EE;EACE,+DAAA;EACA,UAAA;AzBu9EJ;;AyBn9EA;EACE,WAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,gDAAA;EACA,gBAAA;EACA,wDAAA;EACA,SAAA;ElB1KE,gEAAA;APioFJ;AyBp9EE;EACE,UAAA;AzBs9EJ;AyBn9EE;EACE,aAAA;AzBq9EJ;AMxpFI;EAgCE,mDAAA;AN2nFN;AMnpFI;EA+BI,oDAAA;ANunFR;AyBv9EE;EACE,WAAA;AzBy9EJ;;AyBr9EA;EACE,cAAA;EACA,WAAA;EACA,4GAAA;EACA,oDAAA;EACA,iBAAA;EACA,4DAAA;EACA,SAAA;EACA,6DAAA;AzBw9EF;AyBt9EE;EACE,0DAAA;EACA,kEAAA;AzBw9EJ;;AyBp9EA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,2DAAA;EACA,yDAAA;EACA,4BAAA;EACA,mDAAA;ElBpNE,iEAAA;EmBbE,6NAAA;A1B0rFN;A0B7rFM;EACE,SAAA;A1B+rFR;;AyBv9EA;EACE,sGAAA;EACA,epBqf4B;EoBpf5B,iDAAA;AzB09EF;;AyBv9EA;EACE,kBAAA;EACA,oGAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;ElBpOE,gEAAA;AP+rFJ;AyBx9EE;EAEE,sDAAA;EACA,qBAAA;EACA,8DAAA;AzBy9EJ;AyBt9EE;EAEE,yDAAA;EACA,oBAAA;EACA,6BAAA;AzBu9EJ;AyBp9EE;EACE,uBAAA;AzBs9EJ;AM7tFI;EAgCE,uHAAA;ANgsFN;AMxtFI;EA+BI,wHAAA;AN4rFR;AyB19EI;EACE,kBAAA;EACA,WAAA;EAEA,cAAA;EACA,0DAAA;EACA,2DAAA;EACA,oBAAA;EACA,WAAA;EACA,kEAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,4DAAA;ElBrQF,0EAAA;APiuFJ;AMlvFI;EAgCE,+DAAA;ANqtFN;AM7uFI;EA+BI,gEAAA;ANitFR;AyB59EE;EACE,iEAAA;AzB89EJ;AyB59EI;EACE,2EAAA;EACA,iFAAA;EACA,iFAAA;AzB89EN;;AyBz9EA;EACE,yCAAA;EACA,cAAA;EACA,gBpBgc4B;EoB/b5B,gCpBs+B8C;EoBr+B9C,yBAAA;AzB49EF;;AyBz9EA;EACE,oGAAA;AzB49EF;;AyBx9EA;EACE,qBAAA;EACA,8FAAA;EACA,2FAAA;EACA,qDAAA;EACA,+CAAA;ElBxSE,6DAAA;APowFJ;;AyBx9EA;EACE,UAAA;EAEA,6BAAA;EACA,SAAA;AzB09EF;AM3xFI;EAgCE,mBAAA;AN8vFN;AMtxFI;EA+BI,oBAAA;AN0vFR;;AyB79EA;EACE,+CAAA;EACA,uDAAA;EACA,6DAAA;EAME,iDpBg5BwC;AL2kD5C;AyBx9EE;EACE,eAAA;AzB09EJ;AyBv9EE;EACE,apBikCgC;EoBhkChC,gBAAA;AzBy9EJ;;AyBr9EA;EACE,0CAAA;EACA,yCAAA;EACA,2CAAA;EACA,kEAAA;EACA,0DAAA;EACA,wCAAA;EACA,6CAAA;EACA,+CAAA;EACA,+CAAA;EACA,mDAAA;AzBw9EF;AyBt9EE;EACE,yDAAA;AzBw9EJ;AyBt9EI;EACE,qDAAA;AzBw9EN;;AyBn9EA;EACE,yCAAA;EACA,uCAAA;EACA,0CAAA;EACA,kEAAA;EACA,0DAAA;EACA,gFAAA;EACA,6CAAA;EACA,8CAAA;EACA,8CAAA;EACA,mDAAA;AzBs9EF;AyBp9EE;EACE,wDAAA;AzBs9EJ;AyBp9EI;EACE,gBAAA;AzBs9EN;;A2Bn1FA;EACE,cAAA;EACA,kBtBwkCwC;EsBtkCxC,uBtBwkCwC;AL6wD1C;AM31FI;EAgCE,mBAAA;AN8zFN;AMt1FI;EA+BI,oBAAA;AN0zFR;AMj2FI;EAgCE,WAAA;ANo0FN;AM51FI;EA+BI,YAAA;ANg0FR;AMv2FI;EAgCE,mBAAA;AN00FN;AMl2FI;EA+BI,oBAAA;ANs0FR;;AM72FI;EAgCE,oBAAA;ANi1FN;AMz2FI;EA+BI,mBAAA;AN60FR;AMp3FI;EAgCE,eAAA;ANu1FN;AM/2FI;EA+BI,gBAAA;ANm1FR;AM13FI;EAgCE,iBAAA;AN61FN;AMr3FI;EA+BI,gBAAA;ANy1FR;AMh4FI;EAgCE,YAAA;ANm2FN;AM33FI;EA+BI,WAAA;AN+1FR;AMt4FI;EAgCE,oBAAA;ANy2FN;AMj4FI;EA+BI,mBAAA;ANq2FR;AM54FI;EAgCE,cAAA;AN+2FN;AMv4FI;EA+BI,eAAA;AN22FR;;A2Bx3FA;EACE,uCAAA;EAEA,cAAA;EACA,UtB6iCwC;EsB5iCxC,WtB4iCwC;EsB3iCxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,gDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,6DtB8iCwC;EsB7iCxC,iCAAA;UAAA,yBAAA;A3B03FF;A2Bv3FE;EpB3BE,qBAAA;APq5FJ;A2Bt3FE;EAEE,kBtBsiCsC;ALi1D1C;A2Bp3FE;EACE,uBtB6hCsC;ALy1D1C;A2Bn3FE;EACE,qBtBy/BoC;EsBx/BpC,UAAA;EACA,iDtB2nBoB;AL0vExB;A2Bl3FE;EACE,uEAAA;EACA,uEAAA;A3Bo3FJ;A2Bl3FI;EAII,kEAAA;A3Bi3FR;A2B72FI;EAII,kEAAA;A3B42FR;A2Bv2FE;EACE,yBtBPY;EsBQZ,qBtBRY;EsBaV,kEAAA;A3Bq2FN;A2Bj2FE;EACE,oBAAA;EACA,YAAA;EACA,YtBqgCuC;AL81D3C;A2B51FI;EACE,eAAA;EACA,YtB4/BqC;ALk2D3C;;A2Bz1FA;EACE,0CAAA;A3B41FF;;AM78FI;EAgCE,mBAAA;ANi7FN;AMz8FI;EA+BI,oBAAA;AN66FR;A2Bx1FE;EACE,6DAAA;EAEA,UtBi/B8B;EsB/+B9B,2CAAA;EACA,gCAAA;EpBjHA,kBAAA;EeHE,iDKsHF;A3Bw1FJ;AM59FI;EAgCE,mBAAA;AN+7FN;AMv9FI;EA+BI,oBAAA;AN27FR;AsBh9FM;EK0GJ;ILzGM,gBAAA;EtBm9FN;AACF;A2Bj2FI;EACE,6DAAA;A3Bm2FN;A2Bh2FI;EACE,iCtBg/B4B;EsB3+B1B,6DAAA;A3B81FR;AM9+FI;EAgCE,oBAAA;ANi9FN;AMz+FI;EA+BI,mBAAA;AN68FR;AMp/FI;EAgCE,eAAA;ANu9FN;AM/+FI;EA+BI,gBAAA;ANm9FR;AM1/FI;EAgCE,oBAAA;AN69FN;AMr/FI;EA+BI,mBAAA;ANy9FR;AMhgGI;EAgCE,cAAA;ANm+FN;AM3/FI;EA+BI,eAAA;AN+9FR;;A2Bl2FE;EACE,kBAHO;A3Bw2FX;AM1gGI;EAgCE,oBAAA;AN6+FN;AMrgGI;EA+BI,qBAAA;ANy+FR;A2Bx2FI;EACE,aARI;EASJ,cARK;A3Bk3FX;AMphGI;EAgCE,oBAAA;ANu/FN;AM/gGI;EA+BI,qBAAA;ANm/FR;A2B52FI;EAEE,sCAAA;A3B62FN;;A2Bz3FE;EACE,iBAHO;A3B+3FX;AMjiGI;EAgCE,mBAAA;ANogGN;AM5hGI;EA+BI,oBAAA;ANggGR;A2B/3FI;EACE,UARI;EASJ,aARK;A3By4FX;AM3iGI;EAgCE,mBAAA;AN8gGN;AMtiGI;EA+BI,oBAAA;AN0gGR;A2Bn4FI;EAEE,qCAAA;A3Bo4FN;;A2B/3FA;EACE,qBAAA;A3Bk4FF;AMxjGI;EAgCE,kBAAA;AN2hGN;AMnjGI;EA+BI,iBAAA;ANuhGR;;A2Bp4FA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3Bu4FF;A2Bn4FI;EACE,oBAAA;EACA,YAAA;EACA,atB6wBwB;ALwnE9B;;A4BrkGA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5BwkGF;A4BtkGE;EACE,UAAA;A5BwkGJ;A4BpkGI;EAA0B,iEvByzCa;AL8wD3C;A4BtkGI;EAA0B,iEvBwzCa;ALixD3C;A4BtkGE;EACE,SAAA;A5BwkGJ;A4BrkGE;EACE,WvB0yCuC;EuBzyCvC,YvByyCuC;EuBxyCvC,oBAAA;EACA,gBAAA;EL1BF,yDK2BuB;EACrB,SvBwyCuC;EErzCvC,mBAAA;EeHE,oHMmBF;ENnBE,4GMmBF;A5BskGJ;AsBrlGM;EMMJ;INLM,wBAAA;IAAA,gBAAA;EtBwlGN;AACF;A4BzkGI;ELjCF,gEKkCyB;A5B2kG3B;A4BvkGE;EACE,WvBmxC8B;EuBlxC9B,cvBmxC8B;EuBlxC9B,kBAAA;EACA,evBkxC8B;EuBjxC9B,yEAAA;EACA,yBAAA;ErB7BA,mBAAA;APumGJ;A4BrkGE;EACE,WvB+wCuC;EuB9wCvC,YvB8wCuC;EuB7wCvC,gBAAA;ELpDF,yDKqDuB;EACrB,SvB8wCuC;EErzCvC,mBAAA;EeHE,iHM6CF;EN7CE,4GM6CF;A5BskGJ;AsB/mGM;EMiCJ;INhCM,qBAAA;IAAA,gBAAA;EtBknGN;AACF;A4BzkGI;EL3DF,gEK4DyB;A5B2kG3B;A4BvkGE;EACE,WvByvC8B;EuBxvC9B,cvByvC8B;EuBxvC9B,kBAAA;EACA,evBwvC8B;EuBvvC9B,yEAAA;EACA,yBAAA;ErBvDA,mBAAA;APioGJ;A4BrkGE;EACE,oBAAA;A5BukGJ;A4BrkGI;EACE,qFAAA;A5BukGN;A4BpkGI;EACE,qFAAA;A5BskGN;;A6B7pGA;EACE,kBAAA;A7BgqGF;A6B9pGE;;;EAGE,wDxBm1CoC;EwBl1CpC,4DxBk1CoC;EwBj1CpC,iBxBk1CoC;AL80DxC;A6B7pGE;EACE,kBAAA;EACA,MAAA;EAEA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,qBAAA;EPRE,gEOSF;A7B8pGJ;AMrrGI;EAgCE,OAAA;ANwpGN;AMhrGI;EA+BI,QAAA;ANopGR;AsBzqGM;EOTJ;IPUM,gBAAA;EtB4qGN;AACF;A6BtqGE;;EAEE,qBAAA;A7BwqGJ;A6BtqGI;;EACE,kBAAA;A7ByqGN;A6BtqGI;;;EAEE,qBxBuzCkC;EwBtzClC,wBxBuzCkC;ALk3DxC;A6BtqGI;;EACE,qBxBkzCkC;EwBjzClC,wBxBkzCkC;ALu3DxC;A6BrqGE;EACE,qBxB4yCoC;EwB3yCpC,wBxB4yCoC;AL23DxC;A6BhqGI;;;;EACE,4CAAA;EACA,8DxBsyCkC;AL+3DxC;A6BnqGM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,axB8xCgC;EwB7xChC,WAAA;EACA,oCxBm+BgC;EEnhCpC,uCAAA;APytGJ;A6BlqGI;EACE,4CAAA;EACA,8DxBqxCkC;AL+4DxC;A6B/pGI;EACE,uCAAA;A7BiqGN;A6B7pGE;;EAEE,cxBzEQ;ALwuGZ;A6B7pGI;;EACE,yCxB68BkC;ALmtExC;;A8BvvGA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9B0vGF;A8BxvGE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9B0vGJ;A8BtvGE;;;EAGE,UAAA;A9BwvGJ;A8BlvGE;EACE,kBAAA;EACA,UAAA;A9BovGJ;A8BlvGI;EACE,UAAA;A9BovGN;;A8BzuGA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;E3B8OI,eALI;E2BvOR,gBzBsrB4B;EyBrrB5B,gBzB6rB4B;EyB5rB5B,gEAAA;EACA,kBAAA;EACA,mBAAA;EACA,yEAAA;EACA,wGAAA;EvBtCE,uCAAA;APmxGJ;;A8BnuGA;;;;EAIE,oBAAA;E3BwNI,kBALI;EIvQN,0CAAA;AP4xGJ;;A8BnuGA;;;;EAIE,uBAAA;E3B+MI,mBALI;EIvQN,0CAAA;APqyGJ;;AMtzGI;;EAgCE,mBAAA;AN2xGN;AMnzGI;;EA+BI,kBAAA;ANwxGR;;AM/zGI;;;;EAgCE,0BAAA;ANsyGN;AM9zGI;;;;EA+BI,yBAAA;ANqyGR;AM50GI;;;;EAgCE,6BAAA;ANkzGN;AM10GI;;;;EA+BI,4BAAA;ANizGR;AMx1GI;;;;EAgCE,0BAAA;AN8zGN;AMt1GI;;;;EA+BI,yBAAA;AN6zGR;AMp2GI;;;;EAgCE,6BAAA;AN00GN;AMl2GI;;;;EA+BI,4BAAA;ANy0GR;AMh3GI;EAgCE,+CAAA;ANm1GN;AM32GI;EA+BI,gDAAA;AN+0GR;AMt3GI;EAgCE,yBAAA;ANy1GN;AMj3GI;EA+BI,0BAAA;ANq1GR;AM53GI;EAgCE,4BAAA;AN+1GN;AMv3GI;EA+BI,6BAAA;AN21GR;AMl4GI;;EAgCE,yBAAA;ANs2GN;AM93GI;;EA+BI,0BAAA;ANm2GR;AM14GI;;EAgCE,4BAAA;AN82GN;AMt4GI;;EA+BI,6BAAA;AN22GR;;A+B13GE;EACE,aAAA;EACA,WAAA;EACA,mB1B0+BoC;EFxuBlC,kBALI;E4B1PN,kC1B61CqB;AL+hEzB;;A+Bz3GE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E5BqPE,mBALI;E4B7ON,W1Bg1CqB;E0B/0CrB,oC1B+0CqB;EE12CrB,uCAAA;APu5GJ;;A+Bv3GI;;;;EAEE,cAAA;A/B43GN;;A+B36GI;EAqDE,gD1Bk0CmB;E0B9zCjB,0DAAA;EACA,4BAAA;EAEA,gEAAA;A/Bs3GR;AMt7GI;EAgCE,oCAAA;ANy5GN;AMj7GI;EA+BI,mCAAA;ANq5GR;AM57GI;EA+DE,2DAAA;ANg4GN;AMv7GI;EA2DI,0DAAA;AN+3GR;A+B/3GM;EACE,gD1BuzCiB;E0BtzCjB,4D1BszCiB;AL2kEzB;;AMt8GI;EAgCE,oCAAA;AN06GN;AMl8GI;EA+BI,mCAAA;ANs6GR;AM78GI;EA+DE,kFAAA;ANi5GN;AMx8GI;EA2DI,iFAAA;ANg5GR;;A+B/8GI;EAkFE,gD1BqyCmB;AL4lEzB;A+B93GQ;EAEE,mEAAA;EAGA,2EAAA;A/B63GV;AM39GI;EAgCE,uBAAA;AN87GN;AMt9GI;EA+BI,sBAAA;AN07GR;AMj+GI;EA+DE,+DAAA;ANq6GN;AM59GI;EA6DI,6DAAA;ANk6GR;A+Br4GM;EACE,gD1BwxCiB;E0BvxCjB,4D1BuxCiB;ALgnEzB;;A+Bv+GI;EAwGI,yCAAA;A/Bm4GR;;A+B3+GI;EA+GE,gD1BwwCmB;ALwnEzB;A+B93GM;EACE,6C1BqwCiB;AL2nEzB;A+B73GM;EACE,4D1BiwCiB;AL8nEzB;A+B53GM;EACE,kC1B6vCiB;ALioEzB;;AM5/GI;EAgCE,kBAAA;ANg+GN;AMx/GI;EA+BI,mBAAA;AN49GR;;A+B//GI;;;;;EA0IM,UAAA;A/B63GV;;A+Bn/GE;EACE,aAAA;EACA,WAAA;EACA,mB1B0+BoC;EFxuBlC,kBALI;E4B1PN,oC1B61CqB;ALwpEzB;;A+Bl/GE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E5BqPE,mBALI;E4B7ON,W1Bg1CqB;E0B/0CrB,mC1B+0CqB;EE12CrB,uCAAA;APghHJ;;A+Bh/GI;;;;EAEE,cAAA;A/Bq/GN;;A+BpiHI;EAqDE,kD1Bk0CmB;E0B9zCjB,0DAAA;EACA,4BAAA;EAEA,gEAAA;A/B++GR;AM/iHI;EAgCE,oCAAA;ANkhHN;AM1iHI;EA+BI,mCAAA;AN8gHR;AMrjHI;EA+DE,2DAAA;ANy/GN;AMhjHI;EA2DI,0DAAA;ANw/GR;A+Bx/GM;EACE,kD1BuzCiB;E0BtzCjB,2D1BszCiB;ALosEzB;;AM/jHI;EAgCE,oCAAA;ANmiHN;AM3jHI;EA+BI,mCAAA;AN+hHR;AMtkHI;EA+DE,kFAAA;AN0gHN;AMjkHI;EA2DI,iFAAA;ANygHR;;A+BxkHI;EAkFE,kD1BqyCmB;ALqtEzB;A+Bv/GQ;EAEE,mEAAA;EAGA,2EAAA;A/Bs/GV;AMplHI;EAgCE,uBAAA;ANujHN;AM/kHI;EA+BI,sBAAA;ANmjHR;AM1lHI;EA+DE,+DAAA;AN8hHN;AMrlHI;EA6DI,6DAAA;AN2hHR;A+B9/GM;EACE,kD1BwxCiB;E0BvxCjB,2D1BuxCiB;ALyuEzB;;A+BhmHI;EAwGI,yCAAA;A/B4/GR;;A+BpmHI;EA+GE,kD1BwwCmB;ALivEzB;A+Bv/GM;EACE,+C1BqwCiB;ALovEzB;A+Bt/GM;EACE,2D1BiwCiB;ALuvEzB;A+Br/GM;EACE,oC1B6vCiB;AL0vEzB;;AMrnHI;EAgCE,kBAAA;ANylHN;AMjnHI;EA+BI,mBAAA;ANqlHR;;A+BxnHI;;;;;EA4IM,UAAA;A/Bo/GV;;AgCloHA;EAEE,4BAAA;EACA,6BAAA;EACA,uBAAA;E7BuRI,yBALI;E6BhRR,0BAAA;EACA,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,+CAAA;EACA,mCAAA;EACA,iDAAA;EACA,yCAAA;EACA,8FAAA;EACA,gCAAA;EACA,mFAAA;EAGA,qBAAA;EACA,0DAAA;EACA,uCAAA;E7BsQI,mCALI;E6B/PR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qEAAA;EzBjBE,2CAAA;EgBfF,mCSkCqB;EVtBjB,qIUwBJ;AhCgoHF;AsBppHM;EUhBN;IViBQ,gBAAA;EtBupHN;AACF;A0B/pHQ;EACE,yBAAA;EACA,4NAAA;A1BiqHV;AgCtoHE;EACE,iCAAA;EAEA,yCAAA;EACA,+CAAA;AhCuoHJ;A0BxqHQ;EACE,yBAAA;EACA,4NAAA;A1B0qHV;AgCvoHE;EAEE,2BAAA;EACA,mCAAA;EACA,yCAAA;AhCwoHJ;AgCroHE;EACE,iCAAA;ETvDF,yCSwDuB;EACrB,+CAAA;EACA,UAAA;EAKE,2CAAA;AhCmoHN;AgC/nHE;EACE,+CAAA;EACA,UAAA;EAKE,2CAAA;AhC6nHN;AgCznHE;EAKE,kCAAA;EACA,0CAAA;EAGA,gDAAA;AhCqnHJ;AgClnHI;EAKI,2CAAA;AhCgnHR;AgC3mHE;EAGE,oCAAA;EACA,oBAAA;EACA,4CAAA;EAEA,kDAAA;EACA,wCAAA;AhC0mHJ;;AgC9lHE;ECvGA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,gDAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;AjCysHF;;AgC/mHE;ECvGA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC0tHF;;AgChoHE;ECvGA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC2uHF;;AgCjpHE;ECvGA,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC4vHF;;AgClqHE;ECvGA,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;AjC6wHF;;AgCnrHE;ECvGA,wBAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,2BAAA;EACA,qCAAA;AjC8xHF;;AgCpsHE;ECvGA,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;AjC+yHF;;AgCrtHE;ECvGA,0CAAA;EACA,qBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,mDAAA;EACA,8BAAA;EACA,wCAAA;AjCg0HF;;AgChuHE;EChFA,wBAAA;EACA,+BAAA;EACA,gDAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,iDAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCozHF;;AgChvHE;EChFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCo0HF;;AgChwHE;EChFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCo1HF;;AgChxHE;EChFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCo2HF;;AgChyHE;EChFA,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCo3HF;;AgChzHE;EChFA,qBAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;AjCo4HF;;AgCh0HE;EChFA,wBAAA;EACA,+BAAA;EACA,6CAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCo5HF;;AgCh1HE;EChFA,wBAAA;EACA,+BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,4BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCo6HF;;AgC11HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,gDAAA;EACA,4BAAA;EACA,sCAAA;EACA,iDAAA;EACA,iCAAA;EACA,wCAAA;AjCw5HF;;AgCt2HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;AjCo6HF;;AgCl3HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,wCAAA;AjCg7HF;;AgC93HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,wCAAA;AjC47HF;;AgC14HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AjCw8HF;;AgCt5HE;EC1DA,qBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,8BAAA;EACA,yCAAA;AjCo9HF;;AgCl6HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,6CAAA;EACA,4BAAA;EACA,sCAAA;EACA,8CAAA;EACA,iCAAA;EACA,0CAAA;AjCg+HF;;AgC96HE;EC1DA,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iCAAA;EACA,wCAAA;AjC4+HF;;AgCp7HA;EACE,0CAAA;EACA,4CAAA;EACA,yCAAA;EACA,0BAAA;EACA,uCAAA;AhCu7HF;;AgC36HA;EACE,0BAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,kDAAA;EACA,yCAAA;EACA,0CAAA;EACA,iCAAA;EACA,4CAAA;EACA,0BAAA;EACA,uCAAA;EAEA,0B3BqZwC;ALwhH1C;AgCn6HE;EACE,2BAAA;AhCq6HJ;;AgC15HA;ECrGE,2BAAA;EACA,yBAAA;E9BiMI,4BALI;E8B1LR,oDAAA;AjCmgIF;;AgC75HA;ECzGE,4BAAA;EACA,2BAAA;E9BiMI,6BALI;E8B1LR,oDAAA;AjC0gIF;;AkCtmIA;EACE,kBAAA;EACA,gBAAA;AlCymIF;;AkCtmIA;EAGE,UAAA;EZII,qDYHJ;AlCumIF;AMlnII;EAgCE,kBAAA;ANqlIN;AM7mII;EA+BI,iBAAA;ANilIR;AMxnII;EAgCE,kBAAA;AN2lIN;AMnnII;EA+BI,mBAAA;ANulIR;AsB5mIM;EYXN;IZYQ,gBAAA;EtB+mIN;AACF;;AkCpnIE;EACE,WAAA;EAEA,UAAA;AlCsnIJ;AMxoII;EAgCE,cAAA;AN2mIN;AMnoII;EA+BI,eAAA;ANumIR;;AmChpIA;EbgBM,gCafJ;AnCmpIF;AsBhoIM;EapBN;IbqBQ,gBAAA;EtBmoIN;AACF;AmCtpIE;EACE,UAAA;AnCwpIJ;;AmClpIE;EACE,aAAA;AnCqpIJ;;AmCjpIA;EACE,SAAA;EACA,gBAAA;EbDI,6BaEJ;AnCopIF;AsBlpIM;EaLN;IbMQ,gBAAA;EtBqpIN;AACF;AmCvpIE;EACE,QAAA;EACA,YAAA;EbNE,4BaOF;AnCypIJ;AsB5pIM;EaAJ;IbCM,gBAAA;EtB+pIN;AACF;;AoCprIA;;;;;;EAME,kBAAA;ApCurIF;;AoCprIA;EACE,mBAAA;ApCurIF;AqC/pII;EACE,qBAAA;EAEA,uBhCwpBwB;EgCvpBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ArCssIF;AMzsII;EAgCE,oBAAA;AN4qIN;AMpsII;EA+BI,qBAAA;ANwqIR;AM/sII;EAgCE,cAAA;ANkrIN;AM1sII;EA+BI,eAAA;AN8qIR;;AoCrsIA;EAEE,2BAAA;EACA,+BAAA;EACA,2BAAA;EACA,gCAAA;EACA,+BAAA;EjCuQI,8BALI;EiChQR,2CAAA;EACA,qCAAA;EACA,gEAAA;EACA,sDAAA;EACA,oDAAA;EACA,4FAAA;EACA,8DAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,sDAAA;EACA,oDAAA;EACA,2DAAA;EACA,sCAAA;EACA,6DAAA;EACA,mCAAA;EACA,sCAAA;EACA,oCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,kBAAA;EACA,mCAAA;EACA,aAAA;EACA,wCAAA;EACA,oEAAA;EACA,SAAA;EjC0OI,wCALI;EiCnOR,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+EAAA;E7BzCE,gDAAA;EmBbE,6NAAA;A1B6vIN;A0BhwIM;EACE,SAAA;A1BkwIR;AoCrsIE;EACE,SAAA;EAEA,sCAAA;ApCssIJ;AMxwII;EAgCE,OAAA;AN2uIN;AMnwII;EA+BI,QAAA;ANuuIR;;AoCprII;EACE,qBAAA;ApCurIN;AMlxII;EAgCE,WAAA;ANqvIN;AM7wII;EA+BI,UAAA;ANivIR;AMxxII;EAgCE,OAAA;AN2vIN;AMnxII;EA+BI,QAAA;ANuvIR;;AoC3rII;EACE,mBAAA;ApC8rIN;AMlyII;EAgCE,QAAA;ANqwIN;AM7xII;EA+BI,OAAA;ANiwIR;AMxyII;EAgCE,UAAA;AN2wIN;AMnyII;EA+BI,WAAA;ANuwIR;;AcjvII;EsB6BA;IACE,qBAAA;EpCwtIJ;EMnzIE;IAgCE,WAAA;ENsxIJ;EM9yIE;IA+BI,UAAA;ENkxIN;EMzzIE;IAgCE,OAAA;EN4xIJ;EMpzIE;IA+BI,QAAA;ENwxIN;EoC5tIE;IACE,mBAAA;EpC8tIJ;EMl0IE;IAgCE,QAAA;ENqyIJ;EM7zIE;IA+BI,OAAA;ENiyIN;EMx0IE;IAgCE,UAAA;EN2yIJ;EMn0IE;IA+BI,WAAA;ENuyIN;AACF;AclxII;EsB6BA;IACE,qBAAA;EpCwvIJ;EMn1IE;IAgCE,WAAA;ENszIJ;EM90IE;IA+BI,UAAA;ENkzIN;EMz1IE;IAgCE,OAAA;EN4zIJ;EMp1IE;IA+BI,QAAA;ENwzIN;EoC5vIE;IACE,mBAAA;EpC8vIJ;EMl2IE;IAgCE,QAAA;ENq0IJ;EM71IE;IA+BI,OAAA;ENi0IN;EMx2IE;IAgCE,UAAA;EN20IJ;EMn2IE;IA+BI,WAAA;ENu0IN;AACF;AclzII;EsB6BA;IACE,qBAAA;EpCwxIJ;EMn3IE;IAgCE,WAAA;ENs1IJ;EM92IE;IA+BI,UAAA;ENk1IN;EMz3IE;IAgCE,OAAA;EN41IJ;EMp3IE;IA+BI,QAAA;ENw1IN;EoC5xIE;IACE,mBAAA;EpC8xIJ;EMl4IE;IAgCE,QAAA;ENq2IJ;EM73IE;IA+BI,OAAA;ENi2IN;EMx4IE;IAgCE,UAAA;EN22IJ;EMn4IE;IA+BI,WAAA;ENu2IN;AACF;Acl1II;EsB6BA;IACE,qBAAA;EpCwzIJ;EMn5IE;IAgCE,WAAA;ENs3IJ;EM94IE;IA+BI,UAAA;ENk3IN;EMz5IE;IAgCE,OAAA;EN43IJ;EMp5IE;IA+BI,QAAA;ENw3IN;EoC5zIE;IACE,mBAAA;EpC8zIJ;EMl6IE;IAgCE,QAAA;ENq4IJ;EM75IE;IA+BI,OAAA;ENi4IN;EMx6IE;IAgCE,UAAA;EN24IJ;EMn6IE;IA+BI,WAAA;ENu4IN;AACF;Acl3II;EsB6BA;IACE,qBAAA;EpCw1IJ;EMn7IE;IAgCE,WAAA;ENs5IJ;EM96IE;IA+BI,UAAA;ENk5IN;EMz7IE;IAgCE,OAAA;EN45IJ;EMp7IE;IA+BI,QAAA;ENw5IN;EoC51IE;IACE,mBAAA;EpC81IJ;EMl8IE;IAgCE,QAAA;ENq6IJ;EM77IE;IA+BI,OAAA;ENi6IN;EMx8IE;IAgCE,UAAA;EN26IJ;EMn8IE;IA+BI,WAAA;ENu6IN;AACF;AoC71IE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yCAAA;ApC+1IJ;AqCp7II;EACE,qBAAA;EAEA,uBhCwpBwB;EgCvpBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ArCo9IF;AM99II;EAgCE,oBAAA;ANi8IN;AMz9II;EA+BI,qBAAA;AN67IR;AMp+II;EAgCE,cAAA;ANu8IN;AM/9II;EA+BI,eAAA;ANm8IR;;AoC32IE;EACE,MAAA;EAGA,aAAA;ApC42IJ;AM/+II;EAgCE,WAAA;ANk9IN;AM1+II;EA+BI,UAAA;AN88IR;AMr/II;EAgCE,UAAA;ANw9IN;AMh/II;EA+BI,WAAA;ANo9IR;AM3/II;EAgCE,uCAAA;AN89IN;AMt/II;EA+BI,wCAAA;AN09IR;AqCh+II;EACE,qBAAA;EAEA,uBhCwpBwB;EgCvpBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ArCy/IF;AM1gJI;EAgCE,oBAAA;AN6+IN;AMrgJI;EA+BI,qBAAA;ANy+IR;AMhhJI;EAgCE,cAAA;ANm/IN;AM3gJI;EA+BI,eAAA;AN++IR;AoC74II;EACE,iBAAA;ApC+4IN;;AoCz4IE;EACE,MAAA;EAGA,aAAA;ApC04IJ;AM9hJI;EAgCE,WAAA;ANigJN;AMzhJI;EA+BI,UAAA;AN6/IR;AMpiJI;EAgCE,UAAA;ANugJN;AM/hJI;EA+BI,WAAA;ANmgJR;AM1iJI;EAgCE,wCAAA;AN6gJN;AMriJI;EA+BI,uCAAA;ANygJR;AqC/gJI;EACE,qBAAA;EAEA,uBhCwpBwB;EgCvpBxB,WAAA;ArCghJN;AMrjJI;EAgCE,oBAAA;ANwhJN;AMhjJI;EA+BI,qBAAA;ANohJR;AqC3gJM;EACE,aAAA;ArC6gJR;AqC1gJM;EACE,qBAAA;EAEA,uBhCqoBsB;EgCpoBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ArC+iJF;AMtkJI;EAgCE,qBAAA;ANyiJN;AMjkJI;EA+BI,oBAAA;ANqiJR;AM5kJI;EAgCE,cAAA;AN+iJN;AMvkJI;EA+BI,eAAA;AN2iJR;AoCx7II;EACE,iBAAA;ApC07IN;;AoCn7IA;EACE,SAAA;EACA,8CAAA;EACA,gBAAA;EACA,oDAAA;EACA,UAAA;ApCs7IF;;AoCh7IA;EACE,cAAA;EACA,WAAA;EACA,8EAAA;EACA,WAAA;EACA,gB/BqjB4B;E+BpjB5B,qCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E7BvKE,wDAAA;AP2lJJ;AoCj7IE;EAEE,2CAAA;Eb3LF,mDa6LuB;ApCi7IzB;AoC96IE;EAEE,4CAAA;EACA,qBAAA;EbnMF,oDaoMuB;ApC+6IzB;AoC56IE;EAEE,8CAAA;EACA,oBAAA;EACA,6BAAA;ApC66IJ;;AoCv6IA;EACE,cAAA;ApC06IF;;AoCt6IA;EACE,cAAA;EACA,kFAAA;EACA,gBAAA;EjCkEI,mBALI;EiC3DR,uCAAA;EACA,mBAAA;ApCy6IF;;AoCr6IA;EACE,cAAA;EACA,8EAAA;EACA,qCAAA;ApCw6IF;;AoCp6IA;EAEE,6BAAA;EACA,0BAAA;EACA,gEAAA;EACA,2BAAA;EACA,kCAAA;EACA,0DAAA;EACA,8DAAA;EACA,uDAAA;EACA,2DAAA;EACA,sCAAA;EACA,2CAAA;EACA,oCAAA;ApCs6IF;;AsC7pJA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AtCgqJF;AsC9pJE;;EACE,kBAAA;EACA,cAAA;AtCiqJJ;AsC5pJE;;;;;;;;;;;;EAME,UAAA;AtCoqJJ;;AsC/pJA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AtCkqJF;AsChqJE;EACE,WAAA;AtCkqJJ;;AsC9pJA;E/BhBI,uCAAA;APkrJJ;AMnsJI;;EAgCE,+CAAA;ANuqJN;AM/rJI;;EA+BI,gDAAA;ANoqJR;AM3sJI;;;EAgCE,0BAAA;ANgrJN;AMxsJI;;;EA+BI,yBAAA;AN8qJR;AMrtJI;;;EAgCE,6BAAA;AN0rJN;AMltJI;;;EA+BI,4BAAA;ANwrJR;AM/tJI;;;EAgCE,yBAAA;ANosJN;AM5tJI;;;EA+BI,0BAAA;ANksJR;AMzuJI;;;EAgCE,4BAAA;AN8sJN;AMtuJI;;;EA+BI,6BAAA;AN4sJR;;AsC3qJA;EACE,wBAAA;EACA,uBAAA;AtC8qJF;AMxvJI;EAgCE,cAAA;AN2tJN;AMnvJI;EA+BI,eAAA;ANutJR;AM9vJI;EAgCE,eAAA;ANiuJN;AMzvJI;EA+BI,cAAA;AN6tJR;;AsC7qJA;EACE,uBAAA;EACA,sBAAA;AtCgrJF;;AsC7qJA;EACE,sBAAA;EACA,qBAAA;AtCgrJF;;AsC5pJA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AtC+pJF;AsC7pJE;;EAEE,WAAA;AtC+pJJ;AsC5pJE;;EAEE,8CAAA;AtC8pJJ;AsC1pJE;;E/B1FE,6BAAA;EACA,4BAAA;APwvJJ;AsC1pJE;;E/B7GE,yBAAA;EACA,0BAAA;AP2wJJ;;AuCnyJA;EAEE,8BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,2CAAA;EACA,uDAAA;EACA,yDAAA;EAGA,aAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;AvCiyJF;AMnzJI;EAgCE,eAAA;ANsxJN;AM9yJI;EA+BI,gBAAA;ANkxJR;;AuCpyJA;EACE,cAAA;EACA,oEAAA;EpCsQI,wCALI;EoC/PR,4CAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EjBfI,uGiBgBJ;AvCuyJF;AsBnzJM;EiBGN;IjBFQ,gBAAA;EtBszJN;AACF;AuC1yJE;EAEE,sCAAA;AvC2yJJ;AuCvyJE;EACE,UAAA;EACA,iDlC+oBoB;AL0pIxB;AuCryJE;EAEE,yCAAA;EACA,oBAAA;EACA,eAAA;AvCsyJJ;;AuC9xJA;EAEE,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,+GAAA;EACA,2DAAA;EACA,iDAAA;EACA,2GAAA;EAGA,sFAAA;AvC8xJF;AuC5xJE;EACE,0DAAA;EACA,0DAAA;EhC7CA,yDAAA;EACA,0DAAA;AP40JJ;AuC7xJI;EAGE,kBAAA;EACA,yDAAA;AvC6xJN;AuCzxJE;;EAEE,4CAAA;EACA,oDAAA;EACA,0DAAA;AvC2xJJ;AuCxxJE;EAEE,uDAAA;EhCjEA,yBAAA;EACA,0BAAA;AP21JJ;;AuChxJA;EAEE,uDAAA;EACA,4DAAA;EACA,uCAAA;AvCkxJF;AuC/wJE;EhC5FE,iDAAA;AP82JJ;AuC9wJE;;EAEE,6CAAA;EhBjHF,qDgBkHuB;AvCgxJzB;;AuCxwJA;EACE,uEAAA;AvC2wJF;AuCzwJE;EACE,mBAAA;AvC2wJJ;AuCxwJE;EACE,mDAAA;EACA,oCAAA;AvC0wJJ;AuCxwJI;EAEE,wEAAA;AvCywJN;AuCrwJE;;EAEE,0DAAA;EACA,uBAAA;EACA,wEAAA;AvCuwJJ;;AuC9vJE;;EAEE,cAAA;EACA,kBAAA;AvCiwJJ;;AuC5vJE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AvC+vJJ;;AuCzvJE;;EACE,WAAA;AvC6vJJ;;AuCnvJE;EACE,aAAA;AvCsvJJ;AuCpvJE;EACE,cAAA;AvCsvJJ;;AwC96JA;EAEE,yBAAA;EACA,8BAAA;EACA,6DAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gEAAA;EACA,sEAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,sEAAA;EACA,4EAAA;EACA,4DAAA;EACA,yCAAA;EACA,6DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;AxC86JF;AwCx6JE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AxCs7JJ;AwCl6JA;EACE,8CAAA;EACA,iDAAA;ErC6NI,4CALI;EqCrNR,oCAAA;EACA,qBAAA;EACA,mBAAA;AxCm6JF;AMx+JI;EAgCE,gDAAA;AN28JN;AMn+JI;EA+BI,+CAAA;ANu8JR;AwCv6JE;EAEE,0CAAA;AxCw6JJ;;AwC95JA;EAEE,2BAAA;EACA,gCAAA;EAEA,4BAAA;EACA,6CAAA;EACA,yDAAA;EACA,+DAAA;EAGA,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,gBAAA;AxC45JF;AM9/JI;EAgCE,eAAA;ANi+JN;AMz/JI;EA+BI,gBAAA;AN69JR;AwC/5JI;EAEE,qCAAA;AxCg6JN;AwC55JE;EACE,gBAAA;AxC85JJ;;AwCt5JA;EACE,mBnC4zCkC;EmC3zClC,sBnC2zCkC;EmC1zClC,8BAAA;AxCy5JF;AwCv5JE;;;EAGE,qCAAA;AxCy5JJ;;AwC54JA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AxC64JF;;AwCz4JA;EACE,gFAAA;ErC0II,8CALI;EqCnIR,cAAA;EACA,8BAAA;EACA,6BAAA;EACA,4EAAA;EjCvIE,sDAAA;EeHE,gDkB4IJ;AxC44JF;AsBphKM;EkBgIN;IlB/HQ,gBAAA;EtBuhKN;AACF;AwC/4JE;EACE,qBAAA;AxCi5JJ;AwC94JE;EACE,qBAAA;EACA,UAAA;EACA,uDAAA;AxCg5JJ;;AwC14JA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AxC64JF;;AwC14JA;EACE,0CAAA;EACA,gBAAA;AxC64JF;;ActgKI;E0BqIA;IAEI,iBAAA;IACA,2BAAA;ExCo4JN;EwCl4JM;IACE,mBAAA;ExCo4JR;EwCl4JQ;IACE,kBAAA;ExCo4JV;EwCj4JQ;IACE,mDAAA;IACA,kDAAA;ExCm4JV;EwC/3JM;IACE,iBAAA;ExCi4JR;EwC93JM;IACE,wBAAA;IACA,gBAAA;ExCg4JR;EwC73JM;IACE,aAAA;ExC+3JR;EwC53JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IlB7NJ,gBkB+NI;ExC43JR;EwCz3JQ;IACE,aAAA;ExC23JV;EwCx3JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExC03JV;AACF;ActjKI;E0BqIA;IAEI,iBAAA;IACA,2BAAA;ExCm7JN;EwCj7JM;IACE,mBAAA;ExCm7JR;EwCj7JQ;IACE,kBAAA;ExCm7JV;EwCh7JQ;IACE,mDAAA;IACA,kDAAA;ExCk7JV;EwC96JM;IACE,iBAAA;ExCg7JR;EwC76JM;IACE,wBAAA;IACA,gBAAA;ExC+6JR;EwC56JM;IACE,aAAA;ExC86JR;EwC36JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IlB7NJ,gBkB+NI;ExC26JR;EwCx6JQ;IACE,aAAA;ExC06JV;EwCv6JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCy6JV;AACF;AcrmKI;E0BqIA;IAEI,iBAAA;IACA,2BAAA;ExCk+JN;EwCh+JM;IACE,mBAAA;ExCk+JR;EwCh+JQ;IACE,kBAAA;ExCk+JV;EwC/9JQ;IACE,mDAAA;IACA,kDAAA;ExCi+JV;EwC79JM;IACE,iBAAA;ExC+9JR;EwC59JM;IACE,wBAAA;IACA,gBAAA;ExC89JR;EwC39JM;IACE,aAAA;ExC69JR;EwC19JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IlB7NJ,gBkB+NI;ExC09JR;EwCv9JQ;IACE,aAAA;ExCy9JV;EwCt9JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCw9JV;AACF;AcppKI;E0BqIA;IAEI,iBAAA;IACA,2BAAA;ExCihKN;EwC/gKM;IACE,mBAAA;ExCihKR;EwC/gKQ;IACE,kBAAA;ExCihKV;EwC9gKQ;IACE,mDAAA;IACA,kDAAA;ExCghKV;EwC5gKM;IACE,iBAAA;ExC8gKR;EwC3gKM;IACE,wBAAA;IACA,gBAAA;ExC6gKR;EwC1gKM;IACE,aAAA;ExC4gKR;EwCzgKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IlB7NJ,gBkB+NI;ExCygKR;EwCtgKQ;IACE,aAAA;ExCwgKV;EwCrgKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCugKV;AACF;AcnsKI;E0BqIA;IAEI,iBAAA;IACA,2BAAA;ExCgkKN;EwC9jKM;IACE,mBAAA;ExCgkKR;EwC9jKQ;IACE,kBAAA;ExCgkKV;EwC7jKQ;IACE,mDAAA;IACA,kDAAA;ExC+jKV;EwC3jKM;IACE,iBAAA;ExC6jKR;EwC1jKM;IACE,wBAAA;IACA,gBAAA;ExC4jKR;EwCzjKM;IACE,aAAA;ExC2jKR;EwCxjKM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IlB7NJ,gBkB+NI;ExCwjKR;EwCrjKQ;IACE,aAAA;ExCujKV;EwCpjKQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ExCsjKV;AACF;AwC7mKI;EAEI,iBAAA;EACA,2BAAA;AxC8mKR;AwC5mKQ;EACE,mBAAA;AxC8mKV;AwC5mKU;EACE,kBAAA;AxC8mKZ;AwC3mKU;EACE,mDAAA;EACA,kDAAA;AxC6mKZ;AwCzmKQ;EACE,iBAAA;AxC2mKV;AwCxmKQ;EACE,wBAAA;EACA,gBAAA;AxC0mKV;AwCvmKQ;EACE,aAAA;AxCymKV;AwCtmKQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;ElB7NJ,gBkB+NI;AxCsmKV;AwCnmKU;EACE,aAAA;AxCqmKZ;AwClmKU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AxComKZ;;AwCnlKA;EAEE,6CAAA;EACA,mDAAA;EACA,sDAAA;EACA,+BAAA;EACA,8BAAA;EACA,oCAAA;EACA,2DAAA;EACA,sEAAA;AxCqlKF;;AyCr2KA;EAEE,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,gDAAA;EACA,4DAAA;EACA,kDAAA;EACA,uBAAA;EACA,0FAAA;EACA,gCAAA;EACA,8BAAA;EACA,wDAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,4BAAA;EACA,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,uEAAA;ElCjBE,4CAAA;EmBbE,4NAAA;A1Bq4KN;A0Bx4KM;EACE,SAAA;A1B04KR;AyCr2KE;EACE,eAAA;EACA,cAAA;AzCu2KJ;AyCp2KE;EACE,mBAAA;EACA,sBAAA;AzCs2KJ;AyCp2KI;EACE,mBAAA;ElCvBF,2DAAA;EACA,4DAAA;AP83KJ;AyCp2KI;EACE,sBAAA;ElCdF,+DAAA;EACA,8DAAA;APq3KJ;AyCj2KE;;EAEE,aAAA;AzCm2KJ;;AyC/1KA;EAGE,cAAA;EACA,0DAAA;EACA,4BAAA;AzCg2KF;;AyC71KA;EACE,6CAAA;EACA,kCAAA;AzCg2KF;;AyC71KA;EACE,uDAAA;EACA,gBAAA;EACA,qCAAA;AzCg2KF;;AyC71KA;EACE,gBAAA;AzCg2KF;;AMv7KI;EAgCE,qCAAA;AN25KN;AMn7KI;EA+BI,sCAAA;ANu5KR;;AyCt1KA;EACE,oEAAA;EACA,gBAAA;EACA,gCAAA;EACA,wCAAA;EACA,8EAAA;AzCy1KF;AyCv1KE;ElC9FE,0FAAA;APw7KJ;;AyCr1KA;EACE,oEAAA;EACA,gCAAA;EACA,wCAAA;EACA,2EAAA;AzCw1KF;AyCt1KE;ElCzGE,0FAAA;APk8KJ;;AyC/0KA;EACE,wDAAA;EACA,uDAAA;EACA,uDAAA;EACA,gBAAA;AzCk1KF;AyCh1KE;EACE,oCAAA;EACA,uCAAA;AzCk1KJ;;AyC90KA;EACE,wDAAA;EACA,uDAAA;AzCi1KF;;AyC70KA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,4CAAA;ElC3IE,kDAAA;AP49KJ;;AyC70KA;;;EAGE,WAAA;AzCg1KF;;AyC70KA;;ElC5II,2DAAA;EACA,4DAAA;AP89KJ;;AyC90KA;;ElCnII,+DAAA;EACA,8DAAA;APs9KJ;;AyCv0KE;EACE,2CAAA;AzC00KJ;Act8KI;E2BwHJ;IAQI,aAAA;IACA,mBAAA;EzC00KF;EyCv0KE;IAEE,SAAA;IACA,gBAAA;EzCw0KJ;EM5gLE;IAgCE,cAAA;EN++KJ;EMvgLE;IA+BI,eAAA;EN2+KN;EMlhLE;IAgCE,cAAA;ENq/KJ;EM7gLE;IA+BI,eAAA;ENi/KN;EMxhLE;IAgCE,0BAAA;EN2/KJ;EMnhLE;IA+BI,yBAAA;ENu/KN;EM9hLE;IAgCE,6BAAA;ENigLJ;EMzhLE;IA+BI,4BAAA;EN6/KN;EyCp1KQ;;IAGE,0BAAA;EzCq1KV;EyCn1KQ;;IAGE,6BAAA;EzCo1KV;EM5iLE;IAgCE,yBAAA;EN+gLJ;EMviLE;IA+BI,0BAAA;EN2gLN;EMljLE;IAgCE,4BAAA;ENqhLJ;EM7iLE;IA+BI,6BAAA;ENihLN;EyCz1KQ;;IAGE,yBAAA;EzC01KV;EyCx1KQ;;IAGE,4BAAA;EzCy1KV;AACF;;A0C/jLA;EAEE,4CAAA;EACA,sCAAA;EACA,+KAAA;EACA,qDAAA;EACA,qDAAA;EACA,uDAAA;EACA,+FAAA;EACA,sCAAA;EACA,mCAAA;EACA,gDAAA;EACA,+CAAA;EACA,kEAAA;EACA,uCAAA;EACA,mDAAA;EACA,+DAAA;EACA,yEAAA;EACA,+CAAA;EACA,2EAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,kCAAA;A1CikLF;;A0C7jLA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8EAAA;EvC2PI,eALI;EuCpPR,qCAAA;EACA,gBAAA;EACA,6CAAA;EACA,SAAA;EnCtBE,gBAAA;EmCwBF,qBAAA;EpB3BI,2CoB4BJ;A1CgkLF;AsBxlLM;EoBWN;IpBVQ,gBAAA;EtB2lLN;AACF;A0CnkLE;EACE,wCAAA;EACA,gDAAA;EACA,oGAAA;A1CqkLJ;A0CnkLI;EACE,sDAAA;EACA,kDAAA;A1CqkLN;A0ChkLE;EACE,cAAA;EACA,0CAAA;EACA,2CAAA;EACA,iBAAA;EACA,WAAA;EACA,+CAAA;EACA,4BAAA;EACA,oDAAA;EpBlDE,oDoBmDF;A1CkkLJ;AsBjnLM;EoBsCJ;IpBrCM,gBAAA;EtBonLN;AACF;A0CpkLE;EACE,UAAA;A1CskLJ;A0CnkLE;EACE,UAAA;EACA,yDAAA;EACA,UAAA;EACA,qDAAA;A1CqkLJ;;A0CjkLA;EACE,gBAAA;A1CokLF;;A0CjkLA;EACE,iCAAA;EACA,yCAAA;EACA,iFAAA;A1CokLF;A0ClkLE;EnC/DE,0DAAA;EACA,2DAAA;APooLJ;A0CnkLI;EnClEA,gEAAA;EACA,iEAAA;APwoLJ;A0ClkLE;EACE,aAAA;A1CokLJ;A0ChkLE;EnC9DE,8DAAA;EACA,6DAAA;APioLJ;A0ChkLM;EnClEF,oEAAA;EACA,mEAAA;APqoLJ;A0C/jLI;EnCvEA,8DAAA;EACA,6DAAA;APyoLJ;;A0C7jLA;EACE,gFAAA;A1CgkLF;;A0CvjLE;EACE,eAAA;A1C0jLJ;A0CvjLE;EACE,eAAA;EACA,cAAA;EnCpHA,gBAAA;AP8qLJ;A0CvjLI;EAAgB,aAAA;A1C0jLpB;A0CzjLI;EAAe,gBAAA;A1C4jLnB;A0CzjLM;EnC3HF,gBAAA;APurLJ;;A2C1sLA;EAEE,6BAAA;EACA,6BAAA;EACA,oCAAA;EAEA,qBAAA;EACA,gCAAA;EACA,0DAAA;EACA,uCAAA;EACA,8DAAA;EAGA,aAAA;EACA,eAAA;EACA,wEAAA;EACA,kDAAA;ExC+QI,0CALI;EwCxQR,gBAAA;EACA,0CAAA;EpCAE,kDAAA;AP0sLJ;;AM3tLI;EAgCE,kDAAA;AN+rLN;AMvtLI;EA+BI,mDAAA;AN2rLR;A2CxsLI;EAGE,0CAAA;A3CwsLN;AMruLI;EAgCE,WAAA;ANwsLN;AMhuLI;EA+BI,YAAA;ANosLR;AM3uLI;EAgCE,mDAAA;AN8sLN;AMtuLI;EA+BI,kDAAA;AN0sLR;AMjvLI;EAgCE,2CAAA;ANotLN;AM5uLI;EA4BI,mDAAA;ANmtLR;A2ChtLE;EACE,8CAAA;A3CktLJ;;A4C5vLA;EAEE,mCAAA;EACA,oCAAA;EzC4RI,gCALI;EyCrRR,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iDAAA;EACA,4DAAA;EACA,yDAAA;EACA,kDAAA;EACA,wEAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EACA,2DAAA;EACA,qDAAA;EACA,+DAAA;EAGA,aAAA;EnCnBA,gBAAA;ATgxLF;AMnxLI;EAgCE,eAAA;ANsvLN;AM9wLI;EA+BI,gBAAA;ANkvLR;;A4C/vLA;EACE,kBAAA;EACA,cAAA;EACA,wEAAA;EzCgQI,0CALI;EyCzPR,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;EtBpBI,qIsBqBJ;A5CkwLF;AsBnxLM;EsBQN;ItBPQ,gBAAA;EtBsxLN;AACF;A4CrwLE;EACE,UAAA;EACA,wCAAA;EAEA,gDAAA;EACA,sDAAA;A5CswLJ;A4CnwLE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,UvCyhDgC;EuCxhDhC,kDAAA;A5CqwLJ;A4ClwLE;EAEE,UAAA;EACA,yCAAA;ErBtDF,iDqBuDuB;EACrB,uDAAA;A5CmwLJ;A4ChwLE;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;EACA,yDAAA;A5CiwLJ;;AMn0LI;EAgCE,+CAAA;ANuyLN;AM/zLI;EA+BI,gDAAA;ANmyLR;AM10LI;EAgCE,2DAAA;AN6yLN;AMr0LI;EA+BI,4DAAA;ANyyLR;AMh1LI;EAgCE,8DAAA;ANmzLN;AM30LI;EA+BI,+DAAA;AN+yLR;AMt1LI;EAgCE,4DAAA;ANyzLN;AMj1LI;EA+BI,2DAAA;ANqzLR;AM51LI;EAgCE,+DAAA;AN+zLN;AMv1LI;EA+BI,8DAAA;AN2zLR;;A4C9vLA;EClGE,kCAAA;EACA,mCAAA;E1C0RI,mCALI;E0CnRR,2DAAA;A7Co2LF;;A4CjwLA;ECtGE,kCAAA;EACA,mCAAA;E1C0RI,oCALI;E0CnRR,2DAAA;A7C22LF;;A8C72LA;EAEE,6BAAA;EACA,6BAAA;E3CuRI,6BALI;E2ChRR,4BAAA;EACA,4CAAA;EACA,mDAAA;EAGA,qBAAA;EACA,8DAAA;E3C+QI,qCALI;E2CxQR,yCAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gDAAA;A9C62LF;A8Cz2LE;EACE,aAAA;A9C22LJ;;A8Ct2LA;EACE,kBAAA;EACA,SAAA;A9Cy2LF;;A8Cl2LA;EACE,4BAAA;EACA,4BAAA;E3CkPI,iBALI;AHynLV;;A+C/4LA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,0BAAA;EACA,qCAAA;EACA,+EAAA;EACA,mDAAA;EACA,+BAAA;EAGA,kBAAA;EACA,8DAAA;EACA,6CAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;ExCHE,6CAAA;APm5LJ;;A+C34LA;EAEE,cAAA;A/C64LF;;A+Cz4LA;EACE,gB1C0sB4B;E0CzsB5B,kCAAA;A/C44LF;;AM76LI;EAgCE,mBAAA;ANi5LN;AMz6LI;EA+BI,kBAAA;AN64LR;A+Cv4LE;EACE,kBAAA;EACA,MAAA;EAEA,UAAA;EACA,qBAAA;A/Cw4LJ;AM17LI;EAgCE,QAAA;AN65LN;AMr7LI;EA+BI,OAAA;ANy5LR;;A+Ct4LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/Cy4LJ;;A+C74LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/Cg5LJ;;A+Cp5LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/Cu5LJ;;A+C35LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/C85LJ;;A+Cl6LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/Cq6LJ;;A+Cz6LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/C46LJ;;A+Ch7LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/Cm7LJ;;A+Cv7LE;EACE,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;A/C07LJ;;AgDt/LE;EACE;IAAK,2B3Ci3D2B;ELyoIlC;AACF;AgDt/LA;;EAGE,2BAAA;E7CkRI,iCALI;E6C3QR,0CAAA;EACA,sDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yCAAA;EACA,8CAAA;EAGA,aAAA;EACA,kCAAA;EACA,gBAAA;E7CsQI,wCALI;E6C/PR,wCAAA;EzCRE,gDAAA;AP8/LJ;;AgDj/LA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;E1BxBI,8C0ByBJ;AhDo/LF;AsBzgMM;E0BYN;I1BXQ,gBAAA;EtB4gMN;AACF;;AgDt/LA;EzBAE,qMAAA;EyBEA,sEAAA;AhDy/LF;;AgDt/LA;EACE,iBAAA;AhDy/LF;;AgDt/LA;EACE,WAAA;AhDy/LF;;AgDr/LE;EACE,kDAAA;AhDw/LJ;AgDr/LM;EAJJ;IAKM,eAAA;EhDw/LN;AACF;;AgDn/LA;EACE,WAAA;AhDs/LF;;AgDl/LA;EACE,0CAAA;AhDq/LF;AgDp/LE;EACE,sB3CrEQ;AL2jMZ;;AgDl/LA;EACE,aAAA;EACA,mBAAA;EACA,mB3C8aO;ALukLT;;AgDl/LA;EACE,eAAA;EACA,kBAAA;AhDq/LF;;AgDl/LA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,sB3CiyDqC;ALotIvC;;AgDl/LA;EACE,YAAA;EACA,kBAAA;AhDq/LF;AgDn/LE;EACE,kBAAA;AhDq/LJ;;AgDj/LA;EACE,gBAAA;AhDo/LF;;AiD7lMA;EAEE,6CAAA;EACA,uCAAA;EACA,sDAAA;EACA,sDAAA;EACA,wDAAA;EACA,qCAAA;EACA,uCAAA;EACA,yDAAA;EACA,8DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,2DAAA;EACA,gDAAA;EACA,wDAAA;EACA,mCAAA;EACA,6CAAA;EAGA,aAAA;EACA,sBAAA;EAIA,gBAAA;E1CXE,kDAAA;APsmMJ;AMvnMI;EAgCE,eAAA;AN0lMN;AMlnMI;EA+BI,gBAAA;ANslMR;;AiD7lMA;EACE,qBAAA;EACA,sBAAA;AjDgmMF;AiD9lME;EAEE,oCAAA;EACA,0BAAA;AjD+lMJ;;AiDtlMA;EACE,WAAA;EACA,yCAAA;EACA,mBAAA;AjDylMF;AiDtlME;EAEE,UAAA;EACA,+CAAA;EACA,qBAAA;EACA,uDAAA;AjDulMJ;AiDplME;EACE,gDAAA;EACA,wDAAA;AjDslMJ;;AiD9kMA;EACE,kBAAA;EACA,cAAA;EACA,kFAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;EACA,mFAAA;AjDilMF;AiD/kME;E1CvDE,+BAAA;EACA,gCAAA;APyoMJ;AiD/kME;E1C7CE,mCAAA;EACA,kCAAA;AP+nMJ;AiD/kME;EAEE,2CAAA;EACA,oBAAA;EACA,mDAAA;AjDglMJ;AiD5kME;EACE,UAAA;EACA,yCAAA;EACA,iDAAA;EACA,uDAAA;AjD8kMJ;AiD1kME;EACE,mBAAA;AjD4kMJ;AiD1kMI;EACE,yDAAA;EACA,oDAAA;AjD4kMN;;AiD/jMI;EACE,mBAAA;AjDkkMN;AM9rMI;EAgCE,8DAAA;ANiqMN;AMzrMI;EA+BI,+DAAA;AN6pMR;AMpsMI;EAgCE,0BAAA;ANuqMN;AM/rMI;EA+BI,yBAAA;ANmqMR;AM1sMI;EAgCE,4DAAA;AN6qMN;AMrsMI;EA+BI,2DAAA;ANyqMR;AMhtMI;EAgCE,4BAAA;ANmrMN;AM3sMI;EA+BI,6BAAA;AN+qMR;AiD7kMQ;EACE,aAAA;AjD+kMV;AiD5kMQ;EACE,oDAAA;AjD8kMV;AM5tMI;EAgCE,oBAAA;AN+rMN;AMvtMI;EA+BI,qBAAA;AN2rMR;AMluMI;EAgCE,0DAAA;ANqsMN;AM7tMI;EA+BI,2DAAA;ANisMR;AMxuMI;EAgCE,qDAAA;AN2sMN;AMnuMI;EA+BI,sDAAA;ANusMR;;AcjrMI;EmC8DA;IACE,mBAAA;EjDunMJ;EMnvME;IAgCE,8DAAA;ENstMJ;EM9uME;IA+BI,+DAAA;ENktMN;EMzvME;IAgCE,0BAAA;EN4tMJ;EMpvME;IA+BI,yBAAA;ENwtMN;EM/vME;IAgCE,4DAAA;ENkuMJ;EM1vME;IA+BI,2DAAA;EN8tMN;EMrwME;IAgCE,4BAAA;ENwuMJ;EMhwME;IA+BI,6BAAA;ENouMN;EiDloMM;IACE,aAAA;EjDooMR;EiDjoMM;IACE,oDAAA;EjDmoMR;EMjxME;IAgCE,oBAAA;ENovMJ;EM5wME;IA+BI,qBAAA;ENgvMN;EMvxME;IAgCE,0DAAA;EN0vMJ;EMlxME;IA+BI,2DAAA;ENsvMN;EM7xME;IAgCE,qDAAA;ENgwMJ;EMxxME;IA+BI,sDAAA;EN4vMN;AACF;AcvuMI;EmC8DA;IACE,mBAAA;EjD4qMJ;EMxyME;IAgCE,8DAAA;EN2wMJ;EMnyME;IA+BI,+DAAA;ENuwMN;EM9yME;IAgCE,0BAAA;ENixMJ;EMzyME;IA+BI,yBAAA;EN6wMN;EMpzME;IAgCE,4DAAA;ENuxMJ;EM/yME;IA+BI,2DAAA;ENmxMN;EM1zME;IAgCE,4BAAA;EN6xMJ;EMrzME;IA+BI,6BAAA;ENyxMN;EiDvrMM;IACE,aAAA;EjDyrMR;EiDtrMM;IACE,oDAAA;EjDwrMR;EMt0ME;IAgCE,oBAAA;ENyyMJ;EMj0ME;IA+BI,qBAAA;ENqyMN;EM50ME;IAgCE,0DAAA;EN+yMJ;EMv0ME;IA+BI,2DAAA;EN2yMN;EMl1ME;IAgCE,qDAAA;ENqzMJ;EM70ME;IA+BI,sDAAA;ENizMN;AACF;Ac5xMI;EmC8DA;IACE,mBAAA;EjDiuMJ;EM71ME;IAgCE,8DAAA;ENg0MJ;EMx1ME;IA+BI,+DAAA;EN4zMN;EMn2ME;IAgCE,0BAAA;ENs0MJ;EM91ME;IA+BI,yBAAA;ENk0MN;EMz2ME;IAgCE,4DAAA;EN40MJ;EMp2ME;IA+BI,2DAAA;ENw0MN;EM/2ME;IAgCE,4BAAA;ENk1MJ;EM12ME;IA+BI,6BAAA;EN80MN;EiD5uMM;IACE,aAAA;EjD8uMR;EiD3uMM;IACE,oDAAA;EjD6uMR;EM33ME;IAgCE,oBAAA;EN81MJ;EMt3ME;IA+BI,qBAAA;EN01MN;EMj4ME;IAgCE,0DAAA;ENo2MJ;EM53ME;IA+BI,2DAAA;ENg2MN;EMv4ME;IAgCE,qDAAA;EN02MJ;EMl4ME;IA+BI,sDAAA;ENs2MN;AACF;Acj1MI;EmC8DA;IACE,mBAAA;EjDsxMJ;EMl5ME;IAgCE,8DAAA;ENq3MJ;EM74ME;IA+BI,+DAAA;ENi3MN;EMx5ME;IAgCE,0BAAA;EN23MJ;EMn5ME;IA+BI,yBAAA;ENu3MN;EM95ME;IAgCE,4DAAA;ENi4MJ;EMz5ME;IA+BI,2DAAA;EN63MN;EMp6ME;IAgCE,4BAAA;ENu4MJ;EM/5ME;IA+BI,6BAAA;ENm4MN;EiDjyMM;IACE,aAAA;EjDmyMR;EiDhyMM;IACE,oDAAA;EjDkyMR;EMh7ME;IAgCE,oBAAA;ENm5MJ;EM36ME;IA+BI,qBAAA;EN+4MN;EMt7ME;IAgCE,0DAAA;ENy5MJ;EMj7ME;IA+BI,2DAAA;ENq5MN;EM57ME;IAgCE,qDAAA;EN+5MJ;EMv7ME;IA+BI,sDAAA;EN25MN;AACF;Act4MI;EmC8DA;IACE,mBAAA;EjD20MJ;EMv8ME;IAgCE,8DAAA;EN06MJ;EMl8ME;IA+BI,+DAAA;ENs6MN;EM78ME;IAgCE,0BAAA;ENg7MJ;EMx8ME;IA+BI,yBAAA;EN46MN;EMn9ME;IAgCE,4DAAA;ENs7MJ;EM98ME;IA+BI,2DAAA;ENk7MN;EMz9ME;IAgCE,4BAAA;EN47MJ;EMp9ME;IA+BI,6BAAA;ENw7MN;EiDt1MM;IACE,aAAA;EjDw1MR;EiDr1MM;IACE,oDAAA;EjDu1MR;EMr+ME;IAgCE,oBAAA;ENw8MJ;EMh+ME;IA+BI,qBAAA;ENo8MN;EM3+ME;IAgCE,0DAAA;EN88MJ;EMt+ME;IA+BI,2DAAA;EN08MN;EMj/ME;IAgCE,qDAAA;ENo9MJ;EM5+ME;IA+BI,sDAAA;ENg9MN;AACF;AiDv1MA;E1ChJI,gBAAA;AP0+MJ;AiDv1ME;EACE,oDAAA;AjDy1MJ;AiDv1MI;EACE,sBAAA;AjDy1MN;;AiD50ME;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlD8/MF;;AiDt1ME;EC9KA,qFAAA;EACA,4BAAA;EACA,kCAAA;EACA,kGAAA;EACA,0CAAA;EACA,gGAAA;EACA,0GAAA;AlDwgNF;;AiDh2ME;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlDkhNF;;AiD12ME;EC9KA,kFAAA;EACA,4BAAA;EACA,kCAAA;EACA,+FAAA;EACA,0CAAA;EACA,6FAAA;EACA,uGAAA;AlD4hNF;;AiDp3ME;EC9KA,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlDsiNF;;AiD93ME;EC9KA,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,0CAAA;EACA,2FAAA;EACA,qGAAA;AlDgjNF;;AiDx4ME;EC9KA,iFAAA;EACA,4BAAA;EACA,kCAAA;EACA,8FAAA;EACA,0CAAA;EACA,4FAAA;EACA,sGAAA;AlD0jNF;;AiDl5ME;EC9KA,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,0CAAA;EACA,2FAAA;EACA,qGAAA;AlDokNF;;AmD9kNA;EAEE,6CAAA;EACA,4DAAA;EACA,4BAAA;EACA,mCAAA;EACA,mEAAA;EACA,gCAAA;EACA,sCAAA;EACA,wEAAA;EAGA,uBAAA;EACA,U9C4sE2B;E8C3sE3B,W9C2sE2B;E8C1sE3B,sBAAA;EACA,iCAAA;EACA,yEAAA;EACA,SAAA;E5CJE,uBAAA;E4CMF,qCAAA;AnD8kNF;AmD3kNE;EACE,iCAAA;EACA,qBAAA;EACA,2CAAA;AnD6kNJ;AmD1kNE;EACE,UAAA;EACA,6CAAA;EACA,2CAAA;AnD4kNJ;AmDzkNE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AnD0kNJ;;AmDtkNA;EACE,yCAAA;AnDykNF;;AoD1nNA;EAEE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EjDyRI,+BALI;EiDlRR,mBAAA;EACA,kDAAA;EACA,iDAAA;EACA,6DAAA;EACA,mDAAA;EACA,6CAAA;EACA,oDAAA;EACA,yDAAA;EACA,oEAAA;EAGA,iCAAA;EACA,eAAA;EjD2QI,qCALI;EiDpQR,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;EACA,uCAAA;E7CRE,6CAAA;APmoNJ;AoDxnNE;EACE,UAAA;ApD0nNJ;AoDvnNE;EACE,aAAA;ApDynNJ;;AoDrnNA;EACE,wBAAA;EAEA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;ApDunNF;AoDrnNE;EACE,uCAAA;ApDunNJ;;AoDnnNA;EACE,aAAA;EACA,mBAAA;EACA,8DAAA;EACA,oCAAA;EACA,4CAAA;EACA,4BAAA;EACA,uFAAA;E7ChCE,4FAAA;EACA,6FAAA;APupNJ;AMlrNI;EAgCE,qDAAA;ANqpNN;AM7qNI;EA+BI,oDAAA;ANipNR;AMxrNI;EAgCE,uCAAA;AN2pNN;AMnrNI;EA+BI,wCAAA;ANupNR;;AoD3nNA;EACE,mCAAA;EACA,qBAAA;ApD8nNF;;AqD5rNA;EAEE,wBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kCAAA;EACA,6DAAA;EACA,iDAAA;EACA,sDAAA;EACA,gDAAA;EACA,8FAAA;EACA,kCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wDAAA;EACA,wDAAA;EACA,kCAAA;EACA,8BAAA;EACA,uBAAA;EACA,wDAAA;EACA,wDAAA;EAGA,eAAA;EACA,MAAA;EAEA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ArDyrNF;AMpuNI;EAgCE,OAAA;ANusNN;AM/tNI;EA+BI,QAAA;ANmsNR;;AqDxrNA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EAEA,oBAAA;ArD0rNF;AqDvrNE;E/B5CI,mC+B6CF;EACA,8BhDgvDgC;ALy8JpC;AsBnuNM;E+BwCJ;I/BvCM,gBAAA;EtBsuNN;AACF;AqD5rNE;EACE,ehD8uDgC;ALg9JpC;AqD1rNE;EACE,sBhD2uDgC;ALi9JpC;;AqDxrNA;EACE,gDAAA;ArD2rNF;AqDzrNE;EACE,gBAAA;EACA,gBAAA;ArD2rNJ;AqDxrNE;EACE,gBAAA;ArD0rNJ;;AqDtrNA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;ArDyrNF;;AqDrrNA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,6BAAA;EACA,oBAAA;EACA,qCAAA;EACA,4BAAA;EACA,yEAAA;E9CrFE,6CAAA;E8CyFF,UAAA;E3BtGI,qOAAA;A1B4xNN;A0B/xNM;EACE,SAAA;A1BiyNR;;AqDprNA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;ECnHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,mCDmH0B;EClH1B,YAAA;EACA,aAAA;EACA,wCDgH4D;ArD0rN9D;AsDvyNE;EAAS,UAAA;AtD0yNX;AsDzyNE;EAAS,oCD4GiF;ArDgsN5F;;AqD3rNA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,8FAAA;E9CvGE,4DAAA;EACA,6DAAA;APsyNJ;AqD7rNE;EACE,oGAAA;ArD+rNJ;AMp0NI;EA+DE,yJAAA;ANwwNN;AM/zNI;EA2DI,yJAAA;ANuwNR;;AqD/rNA;EACE,gBAAA;EACA,+CAAA;ArDksNF;;AqD7rNA;EACE,kBAAA;EAGA,cAAA;EACA,iCAAA;ArD8rNF;;AqD1rNA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,2EAAA;EACA,4CAAA;EACA,2FAAA;E9C3HE,gEAAA;EACA,+DAAA;APyzNJ;AqDzrNE;EACE,+CAAA;ArD2rNJ;;AcxyNI;EuCmHF;IACE,2BAAA;IACA,6CAAA;ErDyrNF;EqDrrNA;IACE,iCAAA;IACA,kBAAA;IACA,iBAAA;ErDurNF;EqDprNA;IACE,wBAAA;ErDsrNF;AACF;AcvzNI;EuCqIF;;IAEE,wBAAA;ErDqrNF;AACF;Ac7zNI;EuC4IF;IACE,yBAAA;ErDorNF;AACF;AqD3qNI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ArD6qNN;AqD3qNM;EACE,YAAA;EACA,SAAA;E9C3MJ,gBAAA;APy3NJ;AqD1qNM;;E9C/MF,gBAAA;AP63NJ;AqDzqNM;EACE,gBAAA;ArD2qNR;;Acv0NI;EuC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDisNJ;EqD/rNI;IACE,YAAA;IACA,SAAA;I9C3MJ,gBAAA;EP64NF;EqD9rNI;;I9C/MF,gBAAA;EPi5NF;EqD7rNI;IACE,gBAAA;ErD+rNN;AACF;Ac51NI;EuC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDqtNJ;EqDntNI;IACE,YAAA;IACA,SAAA;I9C3MJ,gBAAA;EPi6NF;EqDltNI;;I9C/MF,gBAAA;EPq6NF;EqDjtNI;IACE,gBAAA;ErDmtNN;AACF;Ach3NI;EuC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDyuNJ;EqDvuNI;IACE,YAAA;IACA,SAAA;I9C3MJ,gBAAA;EPq7NF;EqDtuNI;;I9C/MF,gBAAA;EPy7NF;EqDruNI;IACE,gBAAA;ErDuuNN;AACF;Acp4NI;EuC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErD6vNJ;EqD3vNI;IACE,YAAA;IACA,SAAA;I9C3MJ,gBAAA;EPy8NF;EqD1vNI;;I9C/MF,gBAAA;EP68NF;EqDzvNI;IACE,gBAAA;ErD2vNN;AACF;Acx5NI;EuC0IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ErDixNJ;EqD/wNI;IACE,YAAA;IACA,SAAA;I9C3MJ,gBAAA;EP69NF;EqD9wNI;;I9C/MF,gBAAA;EPi+NF;EqD7wNI;IACE,gBAAA;ErD+wNN;AACF;AuDv/NA;EAEE,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,sBAAA;EpDwRI,iCALI;EoDjRR,uCAAA;EACA,2CAAA;EACA,qDAAA;EACA,0BAAA;EACA,iCAAA;EACA,kCAAA;EAGA,kCAAA;EACA,cAAA;EACA,iCAAA;EClBA,uCnD4tB4B;EmD1tB5B,kBAAA;EACA,gBnDquB4B;EmDpuB5B,gBnD4uB4B;EmD3uB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ErDgRI,uCALI;EoDhQR,qBAAA;EACA,UAAA;AvD+/NF;AuD7/NE;EAAS,mCAAA;AvDggOX;AuD9/NE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AvDggOJ;AuD9/NI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvDggON;;AuD3/NA;EACE,kDAAA;AvD8/NF;AuD5/NE;EACE,SAAA;EACA,0FAAA;EACA,uCAAA;AvD8/NJ;;AuD1/NA,qBAAA;AACA;EACE,gDAAA;EACA,sCAAA;EACA,sCAAA;AvD6/NF;AuD3/NE;EACE,WAAA;EACA,qIAAA;EACA,yCAAA;AvD6/NJ;;AuDz/NA,mBAAA;AAEA;EACE,+CAAA;AvD2/NF;AuDz/NE;EACE,YAAA;EACA,0FAAA;EACA,0CAAA;AvD2/NJ;;AuDv/NA,qBAAA;AACA;EACE,iDAAA;EACA,sCAAA;EACA,sCAAA;AvD0/NF;AuDx/NE;EACE,UAAA;EACA,qIAAA;EACA,wCAAA;AvD0/NJ;;AuDt/NA,mBAAA;AAkBA;EACE,uCAAA;EACA,kEAAA;EACA,+BAAA;EACA,kBAAA;EACA,uCAAA;EhDjGE,+CAAA;AP0kOJ;;AyD7lOA;EAEE,0BAAA;EACA,8BAAA;EtD4RI,iCALI;EsDrRR,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,wDAAA;EACA,8FAAA;EACA,+CAAA;EACA,oCAAA;EACA,sCAAA;EtDmRI,oCALI;EsD5QR,mCAAA;EACA,gDAAA;EACA,kCAAA;EACA,kCAAA;EACA,+CAAA;EACA,+BAAA;EACA,kCAAA;EACA,2DAAA;EAGA,kCAAA;EACA,cAAA;EACA,uCAAA;EDzBA,uCnD4tB4B;EmD1tB5B,kBAAA;EACA,gBnDquB4B;EmDpuB5B,gBnD4uB4B;EmD3uB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ErDgRI,uCALI;EsD1PR,qBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;ElDhBE,+CAAA;APwnOJ;AyDpmOE;EACE,cAAA;EACA,qCAAA;EACA,uCAAA;AzDsmOJ;AyDpmOI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AzDqmON;;AyD/lOE;EACE,sFAAA;AzDkmOJ;AyDhmOI;EAEE,0FAAA;AzDimON;AyD9lOI;EACE,SAAA;EACA,iDAAA;AzDgmON;AyD7lOI;EACE,uCAAA;EACA,uCAAA;AzD+lON;;AyD1lOA,qBAAA;AAEE;EACE,oFAAA;EACA,sCAAA;EACA,sCAAA;AzD4lOJ;AyD1lOI;EAEE,qIAAA;AzD2lON;AyDxlOI;EACE,OAAA;EACA,mDAAA;AzD0lON;AyDvlOI;EACE,qCAAA;EACA,yCAAA;AzDylON;;AyDplOA,mBAAA;AAGE;EACE,mFAAA;AzDqlOJ;AyDnlOI;EAEE,0FAAA;AzDolON;AyDjlOI;EACE,MAAA;EACA,oDAAA;AzDmlON;AyDhlOI;EACE,oCAAA;EACA,0CAAA;AzDklON;AyD7kOE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,wDAAA;EACA,WAAA;EACA,iFAAA;AzD+kOJ;;AyD3kOA,qBAAA;AAEE;EACE,qFAAA;EACA,sCAAA;EACA,sCAAA;AzD6kOJ;AyD3kOI;EAEE,qIAAA;AzD4kON;AyDzkOI;EACE,QAAA;EACA,kDAAA;AzD2kON;AyDxkOI;EACE,sCAAA;EACA,wCAAA;AzD0kON;;AyDrkOA,mBAAA;AAkBA;EACE,gFAAA;EACA,gBAAA;EtD2GI,8CALI;EsDpGR,sCAAA;EACA,8CAAA;EACA,oFAAA;ElD5JE,8DAAA;EACA,+DAAA;APotOJ;AyDtjOE;EACE,aAAA;AzDwjOJ;;AyDpjOA;EACE,4EAAA;EACA,oCAAA;AzDujOF;;A0D5uOA;EACE,kBAAA;A1D+uOF;;A0D5uOA;EACE,mBAAA;A1D+uOF;;A0D5uOA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A1D+uOF;A2DrwOE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3DuwOJ;;A0DhvOA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EpClBI,sCoCmBJ;A1DmvOF;AsBlwOM;EoCQN;IpCPQ,gBAAA;EtBqwON;AACF;;A0DrvOA;;;EAGE,cAAA;A1DwvOF;;A0DrvOA;;EAEE,2BAAA;A1DwvOF;;A0DrvOA;;EAEE,4BAAA;A1DwvOF;;A0D/uOE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A1DkvOJ;A0D/uOE;;;EAGE,UAAA;EACA,UAAA;A1DivOJ;A0D9uOE;;EAEE,UAAA;EACA,UAAA;EpC5DE,2BoC6DF;A1DgvOJ;AsBzyOM;EoCqDJ;;IpCpDM,gBAAA;EtB6yON;AACF;;A0D7uOA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UrDm7DmC;EqDl7DnC,UAAA;EACA,mEAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YrD86DmC;EiBpgE/B,8BoCuFJ;A1D+uOF;AsBl0OM;EoCkEN;;IpCjEQ,gBAAA;EtBs0ON;AACF;A0DlvOE;;;EAEE,mEAAA;EACA,qBAAA;EACA,UAAA;EACA,YrDs6DiC;AL+0KrC;;A0DlvOA;EACE,OAAA;A1DqvOF;;A0DlvOA;EACE,QAAA;A1DqvOF;;A0DhvOA;;EAEE,qBAAA;EACA,WrDu6DmC;EqDt6DnC,YrDs6DmC;EqDr6DnC,4BAAA;EACA,wBAAA;EACA,0BAAA;A1DmvOF;;A0DhvOA;;;;;;;GAAA;AAQA;EACE,0DAAA;A1DmvOF;;A0DjvOA;EACE,0DAAA;A1DovOF;;A0D5uOA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBrD+2DmC;EqD92DnC,mBAAA;EACA,gBrD62DmC;EqD52DnC,gBAAA;A1D8uOF;A0D5uOE;EACE,uBAAA;EACA,cAAA;EACA,WrD42DiC;EqD32DjC,WrD42DiC;EqD32DjC,UAAA;EACA,iBrD42DiC;EqD32DjC,gBrD22DiC;EqD12DjC,mBAAA;EACA,eAAA;EACA,+DAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YrDm2DiC;EiB5gE/B,6BoC0KF;A1D6uOJ;AsBn5OM;EoCqJJ;IpCpJM,gBAAA;EtBs5ON;AACF;A0D/uOE;EACE,UrDg2DiC;ALi5KrC;;A0DxuOA;EACE,kBAAA;EACA,UAAA;EACA,erD01DmC;EqDz1DnC,SAAA;EACA,oBrDu1DmC;EqDt1DnC,uBrDs1DmC;EqDr1DnC,mEAAA;EACA,kBAAA;A1D2uOF;;A0DtuOA;EACE,2CAAA;EACA,oDAAA;A1DyuOF;A0DxuOE;;EAEE,gCrDy1DiC;ALi5KrC;A0DvuOE;EACE,yBrD1MQ;ALm7OZ;A0DtuOE;EACE,6BrD3LuB;ALm6O3B;;A4Dr8OA;;EAEE,qBAAA;EACA,+BAAA;EACA,iCAAA;EACA,iDAAA;EAEA,kBAAA;EACA,+FAAA;A5Du8OF;;A4Dn8OA;EACE;IAAK,0CAAA;E5Du8OL;AACF;A4Dp8OA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,4CAAA;EAGA,0DAAA;EACA,+BAAA;A5Dm8OF;;A4Dh8OA;EAEE,yBAAA;EACA,0BAAA;EACA,iCAAA;A5Dk8OF;;A4Dz7OA;EACE;IACE,mBAAA;E5D47OF;E4D17OA;IACE,UAAA;IACA,eAAA;E5D47OF;AACF;A4Dx7OA;EAEE,yBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EAGA,8BAAA;EACA,UAAA;A5Du7OF;;A4Dp7OA;EACE,yBAAA;EACA,0BAAA;A5Du7OF;;A4Dn7OE;EACE;;IAEE,mCAAA;E5Ds7OJ;AACF;A6DtgPA;EAEE,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sCAAA;EACA,qDAAA;EACA,iEAAA;EACA,oDAAA;EACA,sDAAA;EACA,sCAAA;A7DugPF;;Ac18OI;E+C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IvC5BA,2CuC8BA;E7Dw/OJ;AACF;AsBnhPM;EuCYJ;IvCXM,gBAAA;EtBshPN;AACF;Ach+OI;E+C5BE;IACE,MAAA;IAEA,iCAAA;E7D8/ON;EM/iPE;IAgCE,OAAA;ENkhPJ;EM1iPE;IA+BI,QAAA;EN8gPN;EMrjPE;IAgCE,uFAAA;ENwhPJ;EMhjPE;IA+BI,sFAAA;ENohPN;EM3jPE;IA+DE,4BAAA;EN+/OJ;EMtjPE;IA2DI,2BAAA;EN8/ON;E6D3gPI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E7D2gPN;EMtkPE;IAgCE,QAAA;ENyiPJ;EMjkPE;IA+BI,OAAA;ENqiPN;EM5kPE;IAgCE,sFAAA;EN+iPJ;EMvkPE;IA+BI,uFAAA;EN2iPN;E6DphPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7DshPN;E6DnhPI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7DqhPN;E6DlhPI;IAEE,0BAAA;E7DmhPN;E6DhhPI;IAGE,mBAAA;E7DghPN;AACF;Ac7iPI;E+C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7D+gPN;E6D7gPM;IACE,aAAA;E7D+gPR;E6D5gPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D6gPR;AACF;;AcjjPI;E+C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IvC5BA,2CuC8BA;E7D+lPJ;AACF;AsB1nPM;EuCYJ;IvCXM,gBAAA;EtB6nPN;AACF;AcvkPI;E+C5BE;IACE,MAAA;IAEA,iCAAA;E7DqmPN;EMtpPE;IAgCE,OAAA;ENynPJ;EMjpPE;IA+BI,QAAA;ENqnPN;EM5pPE;IAgCE,uFAAA;EN+nPJ;EMvpPE;IA+BI,sFAAA;EN2nPN;EMlqPE;IA+DE,4BAAA;ENsmPJ;EM7pPE;IA2DI,2BAAA;ENqmPN;E6DlnPI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E7DknPN;EM7qPE;IAgCE,QAAA;ENgpPJ;EMxqPE;IA+BI,OAAA;EN4oPN;EMnrPE;IAgCE,sFAAA;ENspPJ;EM9qPE;IA+BI,uFAAA;ENkpPN;E6D3nPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7D6nPN;E6D1nPI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7D4nPN;E6DznPI;IAEE,0BAAA;E7D0nPN;E6DvnPI;IAGE,mBAAA;E7DunPN;AACF;AcppPI;E+C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7DsnPN;E6DpnPM;IACE,aAAA;E7DsnPR;E6DnnPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7DonPR;AACF;;AcxpPI;E+C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IvC5BA,2CuC8BA;E7DssPJ;AACF;AsBjuPM;EuCYJ;IvCXM,gBAAA;EtBouPN;AACF;Ac9qPI;E+C5BE;IACE,MAAA;IAEA,iCAAA;E7D4sPN;EM7vPE;IAgCE,OAAA;ENguPJ;EMxvPE;IA+BI,QAAA;EN4tPN;EMnwPE;IAgCE,uFAAA;ENsuPJ;EM9vPE;IA+BI,sFAAA;ENkuPN;EMzwPE;IA+DE,4BAAA;EN6sPJ;EMpwPE;IA2DI,2BAAA;EN4sPN;E6DztPI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E7DytPN;EMpxPE;IAgCE,QAAA;ENuvPJ;EM/wPE;IA+BI,OAAA;ENmvPN;EM1xPE;IAgCE,sFAAA;EN6vPJ;EMrxPE;IA+BI,uFAAA;ENyvPN;E6DluPI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7DouPN;E6DjuPI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7DmuPN;E6DhuPI;IAEE,0BAAA;E7DiuPN;E6D9tPI;IAGE,mBAAA;E7D8tPN;AACF;Ac3vPI;E+C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7D6tPN;E6D3tPM;IACE,aAAA;E7D6tPR;E6D1tPM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7D2tPR;AACF;;Ac/vPI;E+C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IvC5BA,2CuC8BA;E7D6yPJ;AACF;AsBx0PM;EuCYJ;IvCXM,gBAAA;EtB20PN;AACF;AcrxPI;E+C5BE;IACE,MAAA;IAEA,iCAAA;E7DmzPN;EMp2PE;IAgCE,OAAA;ENu0PJ;EM/1PE;IA+BI,QAAA;ENm0PN;EM12PE;IAgCE,uFAAA;EN60PJ;EMr2PE;IA+BI,sFAAA;ENy0PN;EMh3PE;IA+DE,4BAAA;ENozPJ;EM32PE;IA2DI,2BAAA;ENmzPN;E6Dh0PI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E7Dg0PN;EM33PE;IAgCE,QAAA;EN81PJ;EMt3PE;IA+BI,OAAA;EN01PN;EMj4PE;IAgCE,sFAAA;ENo2PJ;EM53PE;IA+BI,uFAAA;ENg2PN;E6Dz0PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7D20PN;E6Dx0PI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7D00PN;E6Dv0PI;IAEE,0BAAA;E7Dw0PN;E6Dr0PI;IAGE,mBAAA;E7Dq0PN;AACF;Acl2PI;E+C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7Do0PN;E6Dl0PM;IACE,aAAA;E7Do0PR;E6Dj0PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7Dk0PR;AACF;;Act2PI;E+C5CF;IAEI,eAAA;IACA,SAAA;IACA,oCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,iCAAA;IACA,kBAAA;IACA,yCAAA;IACA,4BAAA;IACA,UAAA;IvC5BA,2CuC8BA;E7Do5PJ;AACF;AsB/6PM;EuCYJ;IvCXM,gBAAA;EtBk7PN;AACF;Ac53PI;E+C5BE;IACE,MAAA;IAEA,iCAAA;E7D05PN;EM38PE;IAgCE,OAAA;EN86PJ;EMt8PE;IA+BI,QAAA;EN06PN;EMj9PE;IAgCE,uFAAA;ENo7PJ;EM58PE;IA+BI,sFAAA;ENg7PN;EMv9PE;IA+DE,4BAAA;EN25PJ;EMl9PE;IA2DI,2BAAA;EN05PN;E6Dv6PI;IACE,MAAA;IAEA,iCAAA;IAEA,2BAAA;E7Du6PN;EMl+PE;IAgCE,QAAA;ENq8PJ;EM79PE;IA+BI,OAAA;ENi8PN;EMx+PE;IAgCE,sFAAA;EN28PJ;EMn+PE;IA+BI,uFAAA;ENu8PN;E6Dh7PI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,wFAAA;IACA,4BAAA;E7Dk7PN;E6D/6PI;IACE,QAAA;IACA,OAAA;IACA,mCAAA;IACA,gBAAA;IACA,qFAAA;IACA,2BAAA;E7Di7PN;E6D96PI;IAEE,0BAAA;E7D+6PN;E6D56PI;IAGE,mBAAA;E7D46PN;AACF;Acz8PI;E+C/BF;IAiEM,4BAAA;IACA,+BAAA;IACA,wCAAA;E7D26PN;E6Dz6PM;IACE,aAAA;E7D26PR;E6Dx6PM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E7Dy6PR;AACF;;A6Dz/PE;EAEI,eAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,yCAAA;EACA,4BAAA;EACA,UAAA;EvC5BA,2CuC8BA;A7D0/PN;AsBphQM;EuCYJ;IvCXM,gBAAA;EtBuhQN;AACF;A6D7/PM;EACE,MAAA;EAEA,iCAAA;A7D8/PR;AM/iQI;EAgCE,OAAA;ANkhQN;AM1iQI;EA+BI,QAAA;AN8gQR;AMrjQI;EAgCE,uFAAA;ANwhQN;AMhjQI;EA+BI,sFAAA;ANohQR;AM3jQI;EA+DE,4BAAA;AN+/PN;AMtjQI;EA2DI,2BAAA;AN8/PR;A6D3gQM;EACE,MAAA;EAEA,iCAAA;EAEA,2BAAA;A7D2gQR;AMtkQI;EAgCE,QAAA;ANyiQN;AMjkQI;EA+BI,OAAA;ANqiQR;AM5kQI;EAgCE,sFAAA;AN+iQN;AMvkQI;EA+BI,uFAAA;AN2iQR;A6DphQM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,wFAAA;EACA,4BAAA;A7DshQR;A6DnhQM;EACE,QAAA;EACA,OAAA;EACA,mCAAA;EACA,gBAAA;EACA,qFAAA;EACA,2BAAA;A7DqhQR;A6DlhQM;EAEE,0BAAA;A7DmhQR;A6DhhQM;EAGE,mBAAA;A7DghQR;;A6Dr/PA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,ajDu5CkC;EiDt5ClC,YAAA;EACA,aAAA;EACA,2DO+GsD;A7D8/PxD;AsD1mQE;EAAS,UAAA;AtD6mQX;AsD5mQE;EAAS,YjDixDyB;AL81MpC;;A6DjgQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sEAAA;A7DogQF;A6DlgQE;EACE,8FAAA;EACA,uDAAA;EAEA,0DAAA;A7DmgQJ;AMroQI;EAgCE,yDAAA;ANwmQN;AMhoQI;EA+BI,wDAAA;ANomQR;;A6DrgQA;EACE,gBAAA;EACA,mDAAA;A7DwgQF;;A6DrgQA;EACE,YAAA;EACA,sEAAA;EACA,gBAAA;A7DwgQF;;A8DxpQA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YzD8lDkC;AL6jNpC;A8DzpQE;EACE,qBAAA;EACA,WAAA;A9D2pQJ;;A8DtpQA;EACE,iBAAA;A9DypQF;;A8DtpQA;EACE,iBAAA;A9DypQF;;A8DtpQA;EACE,iBAAA;A9DypQF;;A8DppQE;EACE,mDAAA;A9DupQJ;;A8DnpQA;EACE;IACE,YzDikDgC;ELqlNlC;AACF;A8DnpQA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A9DqpQF;;A8DlpQA;EACE;IACE,uBAAA;E9DqpQF;AACF;A+DtsQA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;ExDcE,mBAAA;EeHE,wByCTJ;ECNA,W3DszDc;E2DrzDd,Y3DqzDc;E2DpzDd,iBAAA;AhE+sQF;AsB9rQM;EyCpBN;IzCqBQ,gBAAA;EtBisQN;AACF;AgEltQE;EACE,sBAAA;EACA,uBAAA;AhEotQJ;;A+DhtQA;EACE,WAAA;EACA,YAAA;ExDME,mBAAA;AP8sQJ;;A+DhtQA;EACE,kBAAA;EAEA,SAAA;EACA,cAAA;EACA,sBAAA;ExDHE,mBAAA;APstQJ;AMvuQI;EAgCE,QAAA;AN0sQN;AMluQI;EA+BI,OAAA;ANssQR;;A+DptQE;EC1BA,a3DwzDc;E2DvzDd,c3DuzDc;E2DtzDd,iBAAA;AhEkvQF;AgEhvQE;EACE,aAAA;EACA,cAAA;AhEkvQJ;;A+D9tQE;EC1BA,a3DwzDc;E2DvzDd,c3DuzDc;E2DtzDd,eAAA;AhE4vQF;AgE1vQE;EACE,sBAAA;EACA,uBAAA;AhE4vQJ;;A+DxuQE;EC1BA,W3DwzDc;E2DvzDd,Y3DuzDc;E2DtzDd,iBAAA;AhEswQF;AgEpwQE;EACE,aAAA;EACA,cAAA;AhEswQJ;;A+DlvQE;EC1BA,W3DwzDc;E2DvzDd,Y3DuzDc;E2DtzDd,iBAAA;AhEgxQF;AgE9wQE;EACE,sBAAA;EACA,uBAAA;AhEgxQJ;;A+DvvQA;EACE,aAAA;A/D0vQF;AMzxQI;EAgCE,qBAAA;AN4vQN;AMpxQI;EA+BI,oBAAA;ANwvQR;AM/xQI;EAgCE,eAAA;ANkwQN;AM1xQI;EA+BI,cAAA;AN8vQR;AMryQI;EAgCE,qBAAA;ANwwQN;AMhyQI;EA+BI,oBAAA;ANowQR;AM3yQI;EAgCE,mBAAA;AN8wQN;AMtyQI;EA+BI,kBAAA;AN0wQR;AMjzQI;EAgCE,qBAAA;ANoxQN;AM5yQI;EA+BI,oBAAA;ANgxQR;AMvzQI;EAgCE,qBAAA;AN0xQN;AMlzQI;EA+BI,oBAAA;ANsxQR;;AiE/zQA;EAEE,mCAAA;EACA,uCAAA;EACA,kCAAA;EACA,4DAAA;EACA,oDAAA;EACA,uDAAA;EACA,mCAAA;EACA,oCAAA;EACA,kEAAA;EACA,oDAAA;EACA,6DAAA;EACA,wCAAA;EACA,mDAAA;EACA,iEAAA;EACA,sEAAA;EACA,gEAAA;EACA,oDAAA;EAGA,oBAAA;AjE+zQF;AiE7zQE;EACE,oDAAA;EACA,wCAAA;AjE+zQJ;AiE7zQI;;EAEE,0CAAA;AjE+zQN;AiE3zQE;EAEE,aAAA;AjE4zQJ;;AiExzQA;EACE,aAAA;AjE2zQF;;AiExzQA;EACE,aAAA;EACA,qBAAA;EACA,wCAAA;EACA,6CAAA;AjE2zQF;;AiExzQA;EACE,SAAA;EACA,kBAAA;AjE2zQF;AiEzzQE;EACE,gBAAA;EACA,yCAAA;AjE2zQJ;AiEzzQI;EACE,+CAAA;AjE2zQN;;AiEtzQA;EACE,cAAA;EACA,yCAAA;EACA,2CAAA;E3CnDI,8C2CoDJ;AjEyzQF;AsBz2QM;E2C4CN;I3C3CQ,gBAAA;EtB42QN;AACF;;AMh4QI;EA+DE,0DAAA;ANq0QN;AM53QI;EA2DI,0DAAA;ANo0QR;AMv4QI;EA+DE,0DAAA;AN20QN;AMl4QI;EA2DI,0DAAA;AN00QR;;AM74QI;EA+DE,0DAAA;ANk1QN;AMz4QI;EA2DI,0DAAA;ANi1QR;AMp5QI;EA+DE,0DAAA;ANw1QN;AM/4QI;EA2DI,0DAAA;ANu1QR;;AM15QI;EA+DE,0DAAA;AN+1QN;AMt5QI;EA2DI,0DAAA;AN81QR;AMj6QI;EA+DE,0DAAA;ANq2QN;AM55QI;EA2DI,0DAAA;ANo2QR;;AMv6QI;EA+DE,0DAAA;AN42QN;AMn6QI;EA2DI,0DAAA;AN22QR;AM96QI;EA+DE,0DAAA;ANk3QN;AMz6QI;EA2DI,0DAAA;ANi3QR;;AiEn1QA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;EACA,gBAAA;EACA,kDAAA;AjEs1QF;;AiEn1QA;EACE,cAAA;EACA,kBAAA;AjEs1QF;AiEp1QE;EAEE,eAAA;EACA,mDAAA;AjEq1QJ;AiEl1QE;EACE,2CAAA;AjEo1QJ;AiEj1QE;EAGE,8CAAA;AjEi1QJ;AiE90QE;EACE,mBAAA;AjEg1QJ;AiE70QE;EACE,6CAAA;E1DlHA,gBAAA;APk8QJ;AiE50QE;EACE,kBAAA;AjE80QJ;AiE70QI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mDAAA;E1D7HF,uBAAA;AP68QJ;AM99QI;EAgCE,gCAAA;ANi8QN;AMz9QI;EA+BI,iCAAA;AN67QR;AMp+QI;EAgCE,mCAAA;ANu8QN;AM/9QI;EA+BI,oCAAA;ANm8QR;AM1+QI;EAgCE,iCAAA;AN68QN;AMr+QI;EA+BI,gCAAA;ANy8QR;AMh/QI;EAgCE,oCAAA;ANm9QN;AM3+QI;EA+BI,mCAAA;AN+8QR;AiEz1QE;EACE,kBAAA;AjE21QJ;AiE11QI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AjE41QN;AiEt1QI;EACE,2DAAA;EACA,8DAAA;E1D1JF,gBAAA;APm/QJ;AiEl1QI;EACE,4DAAA;AjEo1QN;AMvgRI;EAgCE,gCAAA;AN0+QN;AMlgRI;EA+BI,iCAAA;ANs+QR;AM7gRI;EAgCE,mCAAA;ANg/QN;AMxgRI;EA+BI,oCAAA;AN4+QR;AiEv1QI;EACE,6DAAA;AjEy1QN;AMthRI;EAgCE,iCAAA;ANy/QN;AMjhRI;EA+BI,gCAAA;ANq/QR;AM5hRI;EAgCE,oCAAA;AN+/QN;AMvhRI;EA+BI,mCAAA;AN2/QR;AiE/1QI;EACE,SAAA;AjEi2QN;AiE71QE;EAGE,kBAAA;EACA,8CAAA;EACA,gDAAA;AjE61QJ;AiEx1QI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6CAAA;AjE01QN;AMpjRI;EAgCE,gCAAA;ANuhRN;AM/iRI;EA+BI,iCAAA;ANmhRR;AM1jRI;EAgCE,mCAAA;AN6hRN;AMrjRI;EA+BI,oCAAA;ANyhRR;AMhkRI;EAgCE,0BAAA;ANmiRN;AM3jRI;EA+BI,yBAAA;AN+hRR;AMtkRI;EAgCE,6BAAA;ANyiRN;AMjkRI;EA+BI,4BAAA;ANqiRR;AM5kRI;EAgCE,yBAAA;AN+iRN;AMvkRI;EA+BI,0BAAA;AN2iRR;AMllRI;EAgCE,4BAAA;ANqjRN;AM7kRI;EA+BI,6BAAA;ANijRR;AMxlRI;EAgCE,iCAAA;AN2jRN;AMnlRI;EA+BI,gCAAA;ANujRR;AM9lRI;EAgCE,oCAAA;ANikRN;AMzlRI;EA+BI,mCAAA;AN6jRR;;AiE53QA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2CAAA;E1D3NE,uBAAA;AP2lRJ;;AkE9mRA;EAEE,6BAAA;EACA,6BAAA;EACA,yBAAA;EACA,4BAAA;EACA,mDAAA;EACA,mDAAA;EACA,kEAAA;EACA,qDAAA;EAGA,kEAAA;EACA,+DAAA;EACA,6EAAA;E3DKE,+CAAA;AP0mRJ;AM3nRI;EAgCE,uDAAA;AN8lRN;AMtnRI;EA+BI,yDAAA;AN0lRR;AMjoRI;EAgCE,uDAAA;ANomRN;AM5nRI;EA+BI,yDAAA;ANgmRR;;AkElnRE;EACE,wCAAA;AlEqnRJ;;AkEtnRE;EACE,wCAAA;AlEynRJ;;AkE1nRE;EACE,wCAAA;AlE6nRJ;;AkE9nRE;EACE,wCAAA;AlEioRJ;;AkEloRE;EACE,wCAAA;AlEqoRJ;;AkEtoRE;EACE,qCAAA;AlEyoRJ;;AkE1oRE;EACE,wCAAA;AlE6oRJ;;AkE9oRE;EACE,wCAAA;AlEipRJ;;AmEzqRA;EAEE,iDAAA;EACA,mCAAA;AnE2qRF;AmExqRE;EACE,UAAA;AnE0qRJ;AmEtqRI;EACE,0DAAA;EACA,+DAAA;EACA,0DAAA;EACA,UAAA;EAKE,iD9DqqBgB;AL+/PxB;;AmE3pRM;EACE,aAAA;AnE8pRR;AmE5pRM;EACE,gBAAA;AnE8pRR;AmExpRI;EACE,0BAAA;AnE0pRN;AmEvpRI;EACE,oEAAA;EACA,UAAA;EACA,gBAAA;AnEypRN;AMrsRI;EAgCE,cAAA;ANwqRN;AMhsRI;EA+BI,eAAA;ANoqRR;AM3sRI;EAgCE,eAAA;AN8qRN;AMtsRI;EA+BI,cAAA;AN0qRR;AmE1pRI;EACE,yDAAA;AnE4pRN;AmEzpRI;EACE,uEAAA;AnE2pRN;AmEvpRE;E5D/CE,uCAAA;APysRJ;AmEtpRE;E5DnDE,0CAAA;AP4sRJ;AmEtpRI;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AnEwpRN;AmEppRE;E5D7DE,0CAAA;APotRJ;AmEppRI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AnEspRN;AmElpRE;EACE,0BAAA;EACA,yDAAA;AnEopRJ;;AmEhpRA;EACE,aAAA;AnEmpRF;;AmEhpRA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;E7CxFI,8C6CyFJ;AnEmpRF;AsBxuRM;E6CgFN;I7C/EQ,gBAAA;EtB2uRN;AACF;;AmErpRA;EACE,aAAA;EACA,yBAAA;EACA,yCAAA;EACA,+CAAA;AnEwpRF;AMtwRI;EAgCE,mBAAA;ANyuRN;AMjwRI;EA+BI,oBAAA;ANquRR;;AoE9wRA;EAEE,qCAAA;EACA,wCAAA;EACA,kEAAA;EACA,4CAAA;EACA,0EAAA;ApEgxRF;AoE7wRE;EACE,kBAAA;ApE+wRJ;AoE3wRI;EACE,iCAAA;ApE6wRN;AoE1wRI;EACE,6CAAA;ApE4wRN;AoEzwRI;EACE,sCAAA;ApE2wRN;AoExwRI;EACE,0DAAA;ApE0wRN;AoErwRI;EACE,iCAAA;ApEuwRN;AoEpwRI;EACE,6CAAA;ApEswRN;AoEnwRI;EACE,sCAAA;ApEqwRN;AoElwRI;EACE,0DAAA;ApEowRN;;AoE/vRA;EACE,aAAA;EACA,4DACE;EAEF,wBAAA;EACA,gCAAA;ApEgwRF;;AoE5vRA;EACE,iBAAA;EACA,0CAAA;EACA,8CAAA;EACA,kDAAA;ApE+vRF;;AoE5vRA;EACE,aAAA;EACA,oBAAA;ApE+vRF;AoE3vRM;EACE,kBAAA;ApE6vRR;AoEzvRM;EACE,kBAAA;ApE2vRR;;AMx0RI;EA+DE,0DAAA;AN6wRN;AMp0RI;EA2DI,0DAAA;AN4wRR;;AoExvRA;EACE,0DAAA;ApE2vRF;AoEzvRE;EACE,0DAAA;ApE2vRJ;;AoEvvRA;EACE,0DAAA;ApE0vRF;;AoEvvRA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;EACA,wDAAA;ApE0vRF;AoExvRE;EACE,8CAAA;ApE0vRJ;AoExvRI;EACE,cAAA;EACA,iCAAA;EACA,gCAAA;EACA,iBAAA;EACA,iCAAA;EACA,SAAA;ApE0vRN;AoExvRM;EACE,6B/DhFmB;E+DiFnB,6BAAA;ApE0vRR;AcvyRI;EsDyBJ;IA0BI,cAAA;EpEwvRF;EoEtvRE;IACE,WAAA;EpEwvRJ;EoEtvRI;IACE,wDAAA;EpEwvRN;AACF;;AqE93RA;EAEE,sCAAA;EACA,oEAAA;ArEg4RF;AqE53RI;EACE,iCAAA;ArE83RN;AqE33RI;EACE,6CAAA;ArE63RN;AqE13RI;EACE,sCAAA;ArE43RN;AqEz3RI;EACE,0DAAA;ArE23RN;AqEt3RI;EACE,iCAAA;ArEw3RN;AqEr3RI;EACE,6CAAA;ArEu3RN;AqEp3RI;EACE,sCAAA;ArEs3RN;AqEn3RI;EACE,0DAAA;ArEq3RN;;AqEh3RA;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;ArEm3RF;AqEj3RE;EACE,sBAAA;EACA,wCAAA;EAMA,wBAAA,EAAA,0BAAA;EACA,qBAAA,EAAA,YAAA;ArE82RJ;AqEn3RI;EACE,mBAAA;ArEq3RN;AqE/2RI;EACE,WAAA;ArEi3RN;AqE72RE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;ArE+2RJ;;AqE32RA;EACE,0DAAA;ArE82RF;AqE52RE;EACE,0DAAA;ArE82RJ;;AqE12RA;EACE,0DAAA;ArE62RF;;AqE12RA;EACE,UAAA;EACA,gBAAA;EACA,sBAAA;ArE62RF;;AqE12RA;EACE,aAAA;EACA,gBAAA;EACA,oDAAA;EAEA,wBAAA,EAAA,0BAAA;EACA,qBAAA,EAAA,YAAA;ArE42RF;AqE12RE;EACE,aAAA,EAAA,sBAAA;ArE42RJ;;AqEx2RA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;ArE22RF;AqEz2RE;EACE,uBAAA;EACA,8BAAA;ArE22RJ;AqEx2RE;EACE,cAAA;EACA,aAAA;EACA,WAAA;ArE02RJ;;AsEj+RA;EAEE,6BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yCAAA;EACA,uCAAA;EACA,kDAAA;EACA,iFAAA;EAGA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,8BAAA;EACA,gCAAA;EACA,oCAAA;AtEi+RF;;AsE99RA;EACE,gBAAA;EACA,SAAA;EACA,ajEi4CkC;ALgmPpC;A0B5+RQ;EACE,yBAAA;EACA,4NAAA;A1B8+RV;;AuE9/RA;EAEE,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,mCAAA;EACA,6DAAA;EACA,kDAAA;EACA,iFAAA;EACA,kEAAA;EACA,qEAAA;EACA,iEAAA;EACA,uCAAA;EACA,iCAAA;EACA,uCAAA;EACA,uCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qEAAA;EACA,4DAAA;EACA,wEAAA;EACA,sEAAA;EACA,4EAAA;EACA,uCAAA;EACA,uCAAA;EACA,0DAAA;EACA,iGAAA;EACA,gCAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,wCAAA;EACA,gEAAA;EACA,gCAAA;EACA,uCAAA;AvE8/RF;AuEz/RE;;;;;;;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvEugSJ;AuEz/RE;;;;;;;EAEE,gFAAA;AvEggSJ;AuE7/RE;;;;;;;EAEE,mFAAA;AvEogSJ;AuEjgSE;EACE,gBAAA;EACA,MAAA;EACA,aAAA;E7CpEE,4NAAA;A1BwkSN;A0B3kSM;EACE,SAAA;A1B6kSR;;AuElgSA;EACE,wDAAA;EACA,SAAA;EACA,0EAAA;EACA,4CAAA;AvEqgSF;;AuE9/RA;EACE,8CAAA;EACA,iDAAA;EpEmMI,kBALI;EoE3LR,oCAAA;EACA,qBAAA;EACA,mBAAA;AvEggSF;AM/lSI;EAgCE,kBAAA;ANkkSN;AM1lSI;EA+BI,iBAAA;AN8jSR;AuEpgSE;EAEE,0CAAA;AvEqgSJ;;AuE5/RA;EACE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,gBAAA;AvE8/RF;AM/mSI;EAgCE,eAAA;ANklSN;AM1mSI;EA+BI,gBAAA;AN8kSR;AuElgSE;EACE,kFAAA;EACA,8BAAA;AvEogSJ;AuElgSI;EAEE,oCAAA;AvEmgSN;AuEhgSI;EACE,uCAAA;AvEkgSN;AuE9/RE;;EAEE,qCAAA;AvEggSJ;AuE7/RE;EACE,kBAAA;AvE+/RJ;;AuEt/RA;EACE,iDAAA;EACA,oDAAA;EACA,8BAAA;AvEy/RF;AuEv/RE;EACE,qCAAA;AvEy/RJ;AuEv/RI;EAEE,qCAAA;AvEw/RN;;AuEn/RA;EACE,gFAAA;EpE6HI,kBALI;EoEtHR,sCAAA;EACA,8CAAA;EACA,SAAA;EhEnJE,sDAAA;AP0oSJ;AuEp/RE;EACE,4CAAA;EACA,qBAAA;AvEs/RJ;AuEn/RE;EACE,UAAA;AvEq/RJ;AuEj/RE;EACE,eAAA;AvEm/RJ;AuEh/RE;EACE,yBAAA;AvEk/RJ;;AuE9+RA;EACE,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,4BAAA;EACA,kCAAA;EACA,0BAAA;AvEi/RF;AuE/+RE;EACE,yDAAA;AvEi/RJ;;AwEtrSA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AxEyrSF;AwExrSE;ECJA,WpEw1BgB;EoEv1BhB,YpEu1BgB;EoEt1BhB,epEs1BgB;ALy2QlB;AwE1rSI;ECPF,WpE41BgB;EoE31BhB,YpE21BgB;EoE11BhB,epE01BgB;AL02QlB;AwE3rSI;ECXF,apE21BgB;EoE11BhB,cpE01BgB;EoEz1BhB,iBpEy1BgB;ALg3QlB;AwE5rSI;ECfF,cpE01BgB;EoEz1BhB,epEy1BgB;EoEx1BhB,kBpEw1BgB;ALs3QlB;AwE7rSI;ECnBF,epEy1BgB;EoEx1BhB,gBpEw1BgB;EoEv1BhB,mBpEu1BgB;AL43QlB;AwE7rSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxEisS3B;AwElsSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxEssS3B;AwEvsSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxE2sS3B;AwE5sSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxEgtS3B;AwEjtSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxEqtS3B;AwEttSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxE0tS3B;AwE3tSM;ECxBJ,WDyByB;ECxBzB,YDwByB;ECvBzB,eDuByB;AxE+tS3B;;A0E1vSA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,8CAAA;EACA,6BAAA;EACA,uCAAA;EACA,oDAAA;EACA,gCAAA;EACA,2CAAA;EACA,sCAAA;EACA,uCAAA;EACA,iCAAA;EACA,4CAAA;EACA,oCAAA;EACA,uCAAA;EACA,4CAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;EACA,6CAAA;EACA,kCAAA;EACA,yEAAA;EACA,2CAAA;EACA,4CAAA;EACA,kDAAA;EACA,+EAAA;EAEA,gCAAA;EAEA,uCAAA;EACA,0CAAA;EACA,wCAAA;EACA,uDAAA;EACA,sCAAA;EACA,2CAAA;EACA,sDAAA;EACA,sCAAA;EACA,gDAAA;EACA,+EAAA;EACA,uCAAA;EACA,8DAAA;EACA,2DAAA;EACA,mEAAA;EACA,gEAAA;EACA,oEAAA;EACA,6DAAA;EACA,0DAAA;EACA,kEAAA;EACA,kCAAA;EACA,sCAAA;EACA,yCAAA;EACA,2DAAA;EACA,8CAAA;EACA,0CAAA;EACA,0CAAA;EACA,2EAAA;EACA,iFAAA;EACA,mEAAA;EAGA,kBAAA;EACA,aAAA;EAEA,kCAAA;EACA,sBAAA;EAEA,SAAA;EACA,+BAAA;EACA,kEAAA;EACA,+BAAA;EACA,iCAAA;EAEA,gBAAA;EpD3DI,yHoD4DJ;A1EqvSF;AM/zSI;EAgCE,mFAAA;ANkySN;AM1zSI;EA+BI,kFAAA;AN8xSR;AsBnzSM;EoDpBN;IpDqBQ,gBAAA;EtBszSN;AACF;AM10SI;EAgCE,cAAA;AN6ySN;AMr0SI;EA+BI,eAAA;ANyySR;A0ElwSI;EACE,iCAAA;A1EowSN;A0EhwSE;EACE,SAAA;A1EkwSJ;AMt1SI;EAgCE,eAAA;ANyzSN;AMj1SI;EA+BI,cAAA;ANqzSR;A0EtwSI;EACE,+BAAA;A1EwwSN;A0EpwSE;EACE,iCAAA;A1EswSJ;A0ElwSI;EACE,0BAAA;A1EowSN;AcxySI;E4DuCM;IACE,iCAAA;E1EowSV;E0EhwSQ;IACE,+BAAA;E1EkwSV;AACF;A0E7wSI;EACE,0BAAA;A1E+wSN;AcnzSI;E4DuCM;IACE,iCAAA;E1E+wSV;E0E3wSQ;IACE,+BAAA;E1E6wSV;AACF;A0ExxSI;EACE,0BAAA;A1E0xSN;Ac9zSI;E4DuCM;IACE,iCAAA;E1E0xSV;E0EtxSQ;IACE,+BAAA;E1EwxSV;AACF;Act0SI;ER7DA;IAgCE,gDAAA;ENu2SJ;EM/3SE;IA+BI,iDAAA;ENm2SN;E0ErxSM;IACE,6BAAA;E1EuxSR;EM74SE;IAgCE,iDAAA;ENg3SJ;EMx4SE;IA+BI,gDAAA;EN42SN;E0ExxSM;IACE,2BAAA;E1E0xSR;AACF;Ac11SI;E4DqEF;IAEI,eAAA;IACA,MAAA;IACA,SAAA;IACA,arEixC8B;IqBp5C9B,4NAAA;E1B25SJ;E0B95SI;IACE,SAAA;E1Bg6SN;EMl6SE;IAgCE,OAAA;ENq4SJ;EM75SE;IA+BI,QAAA;ENi4SN;EMx6SE;IAgCE,QAAA;EN24SJ;EMn6SE;IA+BI,OAAA;ENu4SN;AACF;Acl3SI;E4DuFF;IAEI,gBAAA;IACA,MAAA;IACA,aAAA;E1E6xSJ;AACF;A0E1xSE;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;A1E4xSJ;A0E1xSI;EhD9JE,4NAAA;A1B27SN;A0B97SM;EACE,SAAA;A1Bg8SR;AMl8SI;EAgCE,OAAA;ANq6SN;AM77SI;EA+BI,QAAA;ANi6SR;A0EhySM;EACE,wCAAA;A1EkySR;AM38SI;EAgCE,QAAA;AN86SN;AMt8SI;EA+BI,OAAA;AN06SR;A0ElySM;EACE,sCAAA;A1EoySR;Ac14SI;E4D5EJ;IAyLI,qBAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,aAAA;E1EiySF;EM59SE;IAgCE,OAAA;EN+7SJ;EMv9SE;IA+BI,QAAA;EN27SN;E0EnySI;IACE,wCAAA;E1EqySN;EMr+SE;IAgCE,gDAAA;ENw8SJ;EMh+SE;IA+BI,iDAAA;ENo8SN;EM3+SE;IAgCE,QAAA;EN88SJ;EMt+SE;IA+BI,OAAA;EN08SN;E0ExySI;IACE,sCAAA;E1E0ySN;EMp/SE;IAgCE,iDAAA;ENu9SJ;EM/+SE;IA+BI,gDAAA;ENm9SN;AACF;;A0EvySA;EACE,kBAAA;EACA,MAAA;EAEA,4CAAA;EACA,8CAAA;EACA,+BAAA;EACA,uBAAA;EACA,SAAA;A1EyySF;AMrgTI;EAgCE,QAAA;ANw+SN;AMhgTI;EA+BI,OAAA;ANo+SR;A0E7ySE;EACE,qBAAA;A1E+ySJ;A0E5ySE;EACE,UAAA;A1E8ySJ;;A0E1ySA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,uCAAA;A1E6ySF;A0E3ySE;EACE,aAAA;A1E6ySJ;;A0EzySA;EACE,0CAAA;EACA,gFAAA;EACA,kBAAA;EACA,wCAAA;EpD1OI,uCoD2OJ;A1E4ySF;AsBnhTM;EoDkON;IpDjOQ,gBAAA;EtBshTN;AACF;A0E/ySE;EACE,aAAA;EACA,mBAAA;EACA,4CAAA;A1EizSJ;;A0E7ySA;EACE,0CAAA;EACA,gFAAA;EACA,wCAAA;EpDvPI,uCoDwPJ;A1EgzSF;AsBpiTM;EoDgPN;IpD/OQ,gBAAA;EtBuiTN;AACF;;A0ElzSA;EACE,aAAA;EACA,2CAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,+CAAA;EACA,SAAA;A1EqzSF;Ac5/SI;E4D+LJ;IAWI,aAAA;E1EszSF;AACF;A0EpzSE;EACE,cAAA;EACA,iDAAA;EACA,mDAAA;EACA,WAAA;EACA,sDAAA;EACA,4BAAA;EACA,2BAAA;EACA,yEAAA;EpDjRE,2BoDkRF;A1EszSJ;AsBpkTM;EoDqQJ;IpDpQM,gBAAA;EtBukTN;AACF;AMnlTI;EoE0RE,0BAAA;A1E4zSN;A0ExzSE;EACE,UAAA;A1E0zSJ;A0EvzSE;EACE,qDAAA;A1EyzSJ;A0ExzSI;EACE,4DAAA;A1E0zSN;A0EtzSE;EACE,2BAAA;A1EwzSJ;A0EvzSI;EACE,0BAAA;A1EyzSN;;A0ElzSA;EAEE,2BAAA;EACA,0BAAA;EACA,2BAAA;A1EozSF;AcziTI;E4DiPJ;IpB3TE,eAAA;IACA,MAAA;IACA,OAAA;IACA,mCoBgU4B;IpB/T5B,YAAA;IACA,aAAA;IACA,wCoB6T8D;E1E0zS9D;EsDpnTA;IAAS,UAAA;EtDunTT;EsDtnTA;IAAS,oCoByTmF;E1Eg0S5F;AACF;;A0E1zSA;EACE,2CAAA;EACA,sBAAA;EACA,6BAAA;EACA,uCAAA;EACA,+BAAA;EACA,+BAAA;EACA,4CAAA;EACA,sDAAA;EACA,qDAAA;EACA,sCAAA;EACA,0DAAA;EACA,0DAAA;EACA,uDAAA;EACA,+DAAA;EACA,2DAAA;EACA,2DAAA;EACA,gEAAA;EACA,6DAAA;EACA,mEAAA;EACA,+CAAA;EACA,kEAAA;EACA,2EAAA;EACA,iFAAA;EACA,4CAAA;EACA,6CAAA;EACA,kDAAA;EACA,yEAAA;EACA,+EAAA;A1E6zSF;;A2EnqTA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;A3EsqTF;A2EpqTE;EACE,sFAAA;EACA,mDAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,yBAAA;ErDHE,sCqDIF;A3EsqTJ;AsBtqTM;EqDPJ;IrDQM,gBAAA;EtByqTN;AACF;A2ExqTE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,oFAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;EACA,0CAAA;EACA,0CAAA;EpEbA,wDAAA;EeHE,mDqDkBF;A3E0qTJ;AsBxrTM;EqDGJ;IrDFM,gBAAA;EtB2rTN;AACF;A2E7qTI;EACE,+CAAA;EACA,iDAAA;A3E+qTN;A2E7qTM;EACE,oDAAA;A3E+qTR;A2E3qTI;EACE,iDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;A3E6qTN;A2E3qTM;EACE,sDAAA;A3E6qTR;A2E1qTM;EACE,iDAAA;A3E4qTR;A2E1qTQ;EACE,sDAAA;A3E4qTV;A2EzqTQ;EACE,8DAAA;A3E2qTV;A2EtqTI;EACE;IACE,8CAAA;IACA,qBAAA;IACA,gDAAA;E3EwqTN;E2EtqTM;IACE,mDAAA;E3EwqTR;E2ErqTM;IACE,8DAAA;E3EuqTR;AACF;A2ElqTE;EACE,2CAAA;EACA,0CAAA;EACA,gDAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;ErD5EE,mBqD6EF;A3EoqTJ;AsB7uTM;EqDiEJ;IrDhEM,gBAAA;EtBgvTN;AACF;AMpwTI;EAgCE,6DAAA;ANuuTN;AM/vTI;EA+BI,8DAAA;ANmuTR;A2ExqTE;EACE,gBAAA;A3E0qTJ;A2EvqTE;EACE,kBAAA;ErDzFE,wCqD0FF;A3EyqTJ;AsB/vTM;EqDoFJ;IrDnFM,gBAAA;EtBkwTN;AACF;A2E5qTI;EACE,kGAAA;EACA,gBAAA;ErD9FA,6BqD+FA;A3E8qTN;AsBzwTM;EqDwFF;IrDvFI,gBAAA;EtB4wTN;AACF;A2EhrTI;EACE,aAAA;A3EkrTN;A2E/qTI;EACE,2CAAA;A3EirTN;A2E/qTM;EACE,qDAAA;A3EirTR;A2E9qTM;EACE,yBAAA;A3EgrTR;A2E7qTM;EACE,eAAA;A3E+qTR;A2E1qTE;EACE,eAAA;A3E4qTJ;A2E1qTI;EACE,cAAA;EACA,cAAA;EACA,YAAA;EAEA,WAAA;EACA,wDAAA;EACA,4BAAA;EACA,2BAAA;ErDlIA,2BqDmIA;A3E2qTN;AM5zTI;EAgCE,iBAAA;AN+xTN;AMvzTI;EA+BI,kBAAA;AN2xTR;AsBhzTM;EqDsHF;IrDrHI,gBAAA;EtBmzTN;AACF;A2ElrTE;EACE,UAAA;EACA,gBAAA;A3EorTJ;AM30TI;EAgCE,+CAAA;AN8yTN;AMt0TI;EA+BI,gDAAA;AN0yTR;AMj1TI;EAgCE,yDAAA;ANozTN;AM50TI;EA+BI,0DAAA;ANgzTR;A2EnrTI;;EACE,8DAAA;EACA,iEAAA;A3EsrTN;;Ac/xTI;E8D/DJ;IAEI,aAAA;IACA,yCAAA;IACA,sCAAA;IACA,iDAAA;IACA,iBAAA;E5Ei2TF;E4E/1TE;IACE,aAAA;IACA,sCAAA;E5Ei2TJ;E4E91TE;IACE,aAAA;E5Eg2TJ;E4E71TE;IACE,cAAA;E5E+1TJ;E4E51TE;;;;;;;;;;;;;IAQE,oBAAA;IACA,UAAA;IACA,SAAA;IACA,kBAAA;IACA,UAAA;E5Em2TJ;E4Eh2TE;IACE,eAAA;IACA,SAAA;E5Ek2TJ;EMt4TE;IAgCE,0BAAA;ENy2TJ;EMj4TE;IA4BI,uBAAA;ENw2TN;E4Ej2TE;IACE,uBAAA;E5Em2TJ;AACF;;A4E71TE;EACE,gCAAA;A5Eg2TJ;A4E91TE;EACE,8BAAA;A5Eg2TJ;;A4E51TA;EACE,eAAA;EACA,aAAA;A5E+1TF;A4E71TE;EACE,gCAAA;A5E+1TJ;A4E71TE;EACE,8BAAA;A5E+1TJ;AMl6TI;EAgCE,0BAAA;ANq4TN;AM75TI;EA4BI,uBAAA;ANo4TR;A4Ev1TI;EACE,uBAAA;A5Ey1TN;;AM36TI;EAgCE,uDAAA;AN+4TN;AMv6TI;EA+BI,wDAAA;AN24TR;AMl7TI;EAgCE,wDAAA;ANq5TN;AM76TI;EA+BI,uDAAA;ANi5TR;;Ac92TI;ER1EA;IAgCE,uDAAA;EN65TJ;EMr7TE;IA+BI,wDAAA;ENy5TN;EMh8TE;IAgCE,wDAAA;ENm6TJ;EM37TE;IA+BI,uDAAA;EN+5TN;AACF;Ac73TI;ER1EA;IAgCE,uDAAA;EN26TJ;EMn8TE;IA+BI,wDAAA;ENu6TN;EM98TE;IAgCE,wDAAA;ENi7TJ;EMz8TE;IA+BI,uDAAA;EN66TN;AACF;Ac34TI;ER1EA;IAgCE,uDAAA;ENy7TJ;EMj9TE;IA+BI,wDAAA;ENq7TN;EM59TE;IAgCE,wDAAA;EN+7TJ;EMv9TE;IA+BI,uDAAA;EN27TN;AACF;Acz5TI;ER1EA;IAgCE,uDAAA;ENu8TJ;EM/9TE;IA+BI,wDAAA;ENm8TN;EM1+TE;IAgCE,wDAAA;EN68TJ;EMr+TE;IA+BI,uDAAA;ENy8TN;AACF;Acv6TI;ER1EA;IAgCE,uDAAA;ENq9TJ;EM7+TE;IA+BI,wDAAA;ENi9TN;EMx/TE;IAgCE,wDAAA;EN29TJ;EMn/TE;IA+BI,uDAAA;ENu9TN;AACF;A6EjgUA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBxEo9D+B;EwEn9D/B,oBAAA;EACA,yCAAA;EACA,0IAAA;A7EmgUF;;A6EhgUA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EnDTI,4NAAA;A1B6gUN;A0BhhUM;EACE,SAAA;A1BkhUR;;A6E//TA;EACE,aAAA;EACA,mBAAA;EAEA,gBAAA;EACA,gBAAA;A7EigUF;AM3hUI;EAgCE,eAAA;AN8/TN;AMthUI;EA+BI,gBAAA;AN0/TR;A6ErgUE;EACE,qBxEi8D4B;EwEh8D5B,oBxEg8D4B;EwE/7D5B,6DAAA;A7EugUJ;A6ErgUI;EAEE,8DAAA;A7EsgUN;A6EngUI;EACE,kEAAA;A7EqgUN;A6EjgUE;;EAEE,+DAAA;A7EmgUJ;A6EhgUE;EACE,kBAAA;A7EkgUJ;;A6E1/TA;EACE,mBxEu3CkC;EwEt3ClC,sBxEs3CkC;EwEr3ClC,6DAAA;A7E6/TF;A6E3/TE;EACE,+DAAA;A7E6/TJ;A6E3/TI;EAEE,+DAAA;A7E4/TN;;A2D/jUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A3DkkUJ;;A8ErkUE;EACE,2CAAA;EACA,mFAAA;A9EwkUJ;;A8E1kUE;EACE,yBAAA;EACA,qFAAA;A9E6kUJ;;A8E/kUE;EACE,yBAAA;EACA,mFAAA;A9EklUJ;;A8EplUE;EACE,yBAAA;EACA,gFAAA;A9EulUJ;;A8EzlUE;EACE,wCAAA;EACA,mFAAA;A9E4lUJ;;A8E9lUE;EACE,yBAAA;EACA,kFAAA;A9EimUJ;;A8EnmUE;EACE,wCAAA;EACA,iFAAA;A9EsmUJ;;A8ExmUE;EACE,2CAAA;EACA,gFAAA;A9E2mUJ;;A+E7mUE;EACE,0EAAA;EACA,oGAAA;A/EgnUJ;A+E7mUM;EAGE,+DAAA;EACA,yFAAA;A/E6mUR;;A+EtnUE;EACE,4EAAA;EACA,sGAAA;A/EynUJ;A+EtnUM;EAGE,iEAAA;EACA,2FAAA;A/EsnUR;;A+E/nUE;EACE,0EAAA;EACA,oGAAA;A/EkoUJ;A+E/nUM;EAGE,gEAAA;EACA,0FAAA;A/E+nUR;;A+ExoUE;EACE,uEAAA;EACA,iGAAA;A/E2oUJ;A+ExoUM;EAGE,gEAAA;EACA,0FAAA;A/EwoUR;;A+EjpUE;EACE,0EAAA;EACA,oGAAA;A/EopUJ;A+EjpUM;EAGE,gEAAA;EACA,0FAAA;A/EipUR;;A+E1pUE;EACE,yEAAA;EACA,mGAAA;A/E6pUJ;A+E1pUM;EAGE,iEAAA;EACA,2FAAA;A/E0pUR;;A+EnqUE;EACE,wEAAA;EACA,kGAAA;A/EsqUJ;A+EnqUM;EAGE,iEAAA;EACA,2FAAA;A/EmqUR;;A+E5qUE;EACE,uEAAA;EACA,iGAAA;A/E+qUJ;A+E5qUM;EAGE,iEAAA;EACA,2FAAA;A/E4qUR;;A+ErqUA;EACE,iFAAA;EACA,2GAAA;A/EwqUF;A+ErqUI;EAEE,oFAAA;EACA,8GAAA;A/EsqUN;;AgFhsUA;EACE,UAAA;EAEA,uJAAA;AhFksUF;;AiFrsUA;EACE,oBAAA;EACA,a5EykB4B;E4ExkB5B,mBAAA;EACA,oFAAA;EACA,6B5EukB4B;E4EtkB5B,2BAAA;AjFwsUF;AiFtsUE;EACE,cAAA;EACA,U5EmkB0B;E4ElkB1B,W5EkkB0B;E4EjkB1B,kBAAA;E3DIE,sC2DHF;AjFwsUJ;AsBjsUM;E2DZJ;I3DaM,gBAAA;EtBosUN;AACF;;AiFtsUI;EACE,oEAAA;AjFysUN;;AkF5tUA;EACE,kBAAA;EACA,WAAA;AlF+tUF;AkF7tUE;EACE,cAAA;EACA,oCAAA;EACA,WAAA;AlF+tUJ;AkF5tUE;EACE,kBAAA;EACA,MAAA;EAEA,WAAA;EACA,YAAA;AlF6tUJ;AM5uUI;EAgCE,OAAA;AN+sUN;AMvuUI;EA+BI,QAAA;AN2sUR;;AkF9tUE;EACE,wBAAA;AlFiuUJ;;AkFluUE;EACE,uBAAA;AlFquUJ;;AkFtuUE;EACE,0BAAA;AlFyuUJ;;AkF1uUE;EACE,kCAAA;AlF6uUJ;;AmFlwUA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a9Em5CkC;ALk3RpC;;AmFlwUA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a9E24CkC;AL03RpC;;AmF7vUI;EACE,gBAAA;EACA,MAAA;EACA,a9E+3C8B;ALi4RpC;;AmF7vUI;EACE,gBAAA;EACA,SAAA;EACA,a9Ey3C8B;ALu4RpC;;AcjuUI;EqExCA;IACE,gBAAA;IACA,MAAA;IACA,a9E+3C8B;EL84RlC;EmF1wUE;IACE,gBAAA;IACA,SAAA;IACA,a9Ey3C8B;ELm5RlC;AACF;Ac9uUI;EqExCA;IACE,gBAAA;IACA,MAAA;IACA,a9E+3C8B;EL05RlC;EmFtxUE;IACE,gBAAA;IACA,SAAA;IACA,a9Ey3C8B;EL+5RlC;AACF;Ac1vUI;EqExCA;IACE,gBAAA;IACA,MAAA;IACA,a9E+3C8B;ELs6RlC;EmFlyUE;IACE,gBAAA;IACA,SAAA;IACA,a9Ey3C8B;EL26RlC;AACF;ActwUI;EqExCA;IACE,gBAAA;IACA,MAAA;IACA,a9E+3C8B;ELk7RlC;EmF9yUE;IACE,gBAAA;IACA,SAAA;IACA,a9Ey3C8B;ELu7RlC;AACF;AclxUI;EqExCA;IACE,gBAAA;IACA,MAAA;IACA,a9E+3C8B;EL87RlC;EmF1zUE;IACE,gBAAA;IACA,SAAA;IACA,a9Ey3C8B;ELm8RlC;AACF;AoF51UA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ApF81UF;;AoF31UA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ApF81UF;;AqFt2UA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AtFu2UF;AsFp2UE;;EACE,6BAAA;AtFu2UJ;;AuFr3UE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UlF4jBsC;EkF3jBtC,WAAA;AvFw3UJ;;AwFh4UA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AzFo4UF;;A0F14UA;EACE,qBAAA;EACA,mBAAA;EACA,8BrFs0B4B;EqFr0B5B,eAAA;EACA,UAAA;EACA,8BAAA;EACA,arF+zB4B;AL8kT9B;;A2F50UQ;EAUM,mCAAA;A3Fs0Ud;;A2Fh1UQ;EAUM,8BAAA;A3F00Ud;;A2Fp1UQ;EAUM,iCAAA;A3F80Ud;;A2Fx1UQ;EAUM,iCAAA;A3Fk1Ud;;A2F51UQ;EAUM,sCAAA;A3Fs1Ud;;A2Fh2UQ;EAUM,mCAAA;A3F01Ud;;AM16UI;EAgCE,sBAAA;AN84UN;AMt6UI;EA+BI,uBAAA;AN04UR;;AMj7UI;EAgCE,uBAAA;ANq5UN;AM76UI;EA+BI,sBAAA;ANi5UR;;AMx7UI;EAgCE,sBAAA;AN45UN;AMp7UI;EA+BI,sBAAA;ANw5UR;;A2Fz3UQ;EAUM,8BAAA;A3Fm3Ud;;A2F73UQ;EAUM,4BAAA;A3Fu3Ud;;A2Fj4UQ;EAUM,2BAAA;A3F23Ud;;A2Fr4UQ;EAUM,iCAAA;A3F+3Ud;;A2Fz4UQ;EAUM,2BAAA;A3Fm4Ud;;A2F74UQ;EAUM,qBAAA;A3Fu4Ud;;A2Fj5UQ;EAUM,wBAAA;A3F24Ud;;A2Fr5UQ;EAUM,uBAAA;A3F+4Ud;;A2Fz5UQ;EAUM,wBAAA;A3Fm5Ud;;A2F75UQ;EAUM,qBAAA;A3Fu5Ud;;A2Fj6UQ;EAUM,yBAAA;A3F25Ud;;A2Fr6UQ;EAUM,2BAAA;A3F+5Ud;;A2Fz6UQ;EAUM,4BAAA;A3Fm6Ud;;A2F76UQ;EAUM,2BAAA;A3Fu6Ud;;A2Fj7UQ;EAUM,2BAAA;A3F26Ud;;A2Fr7UQ;EAUM,6BAAA;A3F+6Ud;;A2Fz7UQ;EAUM,8BAAA;A3Fm7Ud;;A2F77UQ;EAUM,6BAAA;A3Fu7Ud;;A2Fj8UQ;EAUM,2BAAA;A3F27Ud;;A2Fr8UQ;EAUM,6BAAA;A3F+7Ud;;A2Fz8UQ;EAUM,8BAAA;A3Fm8Ud;;A2F78UQ;EAUM,6BAAA;A3Fu8Ud;;A2Fj9UQ;EAUM,0BAAA;A3F28Ud;;A2Fr9UQ;EAUM,gCAAA;A3F+8Ud;;A2Fz9UQ;EAUM,yBAAA;A3Fm9Ud;;A2F79UQ;EAUM,wBAAA;A3Fu9Ud;;A2Fj+UQ;EAUM,+BAAA;A3F29Ud;;A2Fr+UQ;EAUM,yBAAA;A3F+9Ud;;A2Fz+UQ;EAUM,6BAAA;A3Fm+Ud;;A2F7+UQ;EAUM,8BAAA;A3Fu+Ud;;A2Fj/UQ;EAUM,wBAAA;A3F2+Ud;;A2Fr/UQ;EAUM,+BAAA;A3F++Ud;;A2Fz/UQ;EAUM,wBAAA;A3Fm/Ud;;A2F7/UQ;EAUM,4CAAA;A3Fu/Ud;;A2FjgVQ;EAUM,+CAAA;A3F2/Ud;;A2FrgVQ;EAUM,+CAAA;A3F+/Ud;;A2FzgVQ;EAUM,2BAAA;A3FmgVd;;A2F7gVQ;EAUM,2BAAA;A3FugVd;;A2FjhVQ;EAUM,uOAAA;A3F2gVd;;A2FrhVQ;EAUM,uOAAA;A3F+gVd;;A2FzhVQ;EAUM,uOAAA;A3FmhVd;;A2F7hVQ;EAUM,wOAAA;A3FuhVd;;A2FjiVQ;EAUM,yOAAA;A3F2hVd;;A2FriVQ;EAUM,6OAAA;A3F+hVd;;A2FziVQ;EAUM,6OAAA;A3FmiVd;;A2F7iVQ;EAUM,8OAAA;A3FuiVd;;A2FjjVQ;EAUM,+OAAA;A3F2iVd;;A2FrjVQ;EAUM,gPAAA;A3F+iVd;;A2FnkVQ;EACE,mFAAA;A3FskVV;;A2FvkVQ;EACE,qFAAA;A3F0kVV;;A2F3kVQ;EACE,mFAAA;A3F8kVV;;A2F/kVQ;EACE,gFAAA;A3FklVV;;A2FnlVQ;EACE,mFAAA;A3FslVV;;A2FvlVQ;EACE,kFAAA;A3F0lVV;;A2F3lVQ;EACE,iFAAA;A3F8lVV;;A2F/lVQ;EACE,gFAAA;A3FkmVV;;A2FzlVQ;EAUM,2BAAA;A3FmlVd;;A2F7lVQ;EAUM,6BAAA;A3FulVd;;A2FjmVQ;EAUM,6BAAA;A3F2lVd;;A2FrmVQ;EAUM,0BAAA;A3F+lVd;;A2FzmVQ;EAUM,2BAAA;A3FmmVd;;A2F7mVQ;EAUM,iBAAA;A3FumVd;;A2FjnVQ;EAUM,mBAAA;A3F2mVd;;A2FrnVQ;EAUM,oBAAA;A3F+mVd;;A2FznVQ;EAUM,oBAAA;A3FmnVd;;A2F7nVQ;EAUM,sBAAA;A3FunVd;;A2FjoVQ;EAUM,uBAAA;A3F2nVd;;A2FroVQ;EAUM,kBAAA;A3F+nVd;;A2FzoVQ;EAUM,oBAAA;A3FmoVd;;A2F7oVQ;EAUM,qBAAA;A3FuoVd;;A2FjpVQ;EAUM,mBAAA;A3F2oVd;;A2FrpVQ;EAUM,qBAAA;A3F+oVd;;A2FzpVQ;EAUM,sBAAA;A3FmpVd;;A2F7pVQ;EAUM,2CAAA;A3FupVd;;A2FjqVQ;EAUM,sCAAA;A3F2pVd;;A2FrqVQ;EAUM,sCAAA;A3F+pVd;;A2FzqVQ;EAUM,0FAAA;A3FmqVd;;A2F7qVQ;EAUM,oBAAA;A3FuqVd;;A2FjrVQ;EAUM,8FAAA;A3F2qVd;;A2FrrVQ;EAUM,wBAAA;A3F+qVd;;AM/vVI;EAgCE,gGAAA;ANmuVN;AM3vVI;EA+BI,+FAAA;AN+tVR;;AMtwVI;EAgCE,0BAAA;AN0uVN;AMlwVI;EA+BI,yBAAA;ANsuVR;;A2FvsVQ;EAUM,iGAAA;A3FisVd;;A2F3sVQ;EAUM,2BAAA;A3FqsVd;;AMrxVI;EAgCE,+FAAA;ANyvVN;AMjxVI;EA+BI,gGAAA;ANqvVR;;AM5xVI;EAgCE,yBAAA;ANgwVN;AMxxVI;EA+BI,0BAAA;AN4vVR;;A2F7tVQ;EAIQ,uBAAA;EAMF,gFAAA;A3FwtVd;;A2FluVQ;EAIQ,uBAAA;EAMF,kFAAA;A3F6tVd;;A2FvuVQ;EAIQ,uBAAA;EAMF,gFAAA;A3FkuVd;;A2F5uVQ;EAIQ,uBAAA;EAMF,6EAAA;A3FuuVd;;A2FjvVQ;EAIQ,uBAAA;EAMF,gFAAA;A3F4uVd;;A2FtvVQ;EAIQ,uBAAA;EAMF,+EAAA;A3FivVd;;A2F3vVQ;EAIQ,uBAAA;EAMF,8EAAA;A3FsvVd;;A2FhwVQ;EAIQ,uBAAA;EAMF,6EAAA;A3F2vVd;;A2FrwVQ;EAIQ,uBAAA;EAMF,8EAAA;A3FgwVd;;A2F1wVQ;EAUM,oCAAA;A3FowVd;;A2F9wVQ;EAUM,oCAAA;A3FwwVd;;A2FlxVQ;EAUM,oCAAA;A3F4wVd;;A2FtxVQ;EAUM,iCAAA;A3FgxVd;;A2F1xVQ;EAUM,oCAAA;A3FoxVd;;A2F9xVQ;EAUM,oCAAA;A3FwxVd;;A2FlyVQ;EAUM,oCAAA;A3F4xVd;;A2FtyVQ;EAUM,oCAAA;A3FgyVd;;A2F1yVQ;EAUM,iCAAA;A3FoyVd;;AMp3VI;EAgCE,sCAAA;ANw1VN;AMh3VI;EA+BI,qCAAA;ANo1VR;;AM33VI;EAgCE,sCAAA;AN+1VN;AMv3VI;EA+BI,qCAAA;AN21VR;;AMl4VI;EAgCE,sCAAA;ANs2VN;AM93VI;EA+BI,qCAAA;ANk2VR;;AMz4VI;EAgCE,mCAAA;AN62VN;AMr4VI;EA+BI,kCAAA;ANy2VR;;AMh5VI;EAgCE,sCAAA;ANo3VN;AM54VI;EA+BI,qCAAA;ANg3VR;;AMv5VI;EAgCE,sCAAA;AN23VN;AMn5VI;EA+BI,qCAAA;ANu3VR;;AM95VI;EAgCE,sCAAA;ANk4VN;AM15VI;EA+BI,qCAAA;AN83VR;;AMr6VI;EAgCE,sCAAA;ANy4VN;AMj6VI;EA+BI,qCAAA;ANq4VR;;AM56VI;EAgCE,mCAAA;ANg5VN;AMx6VI;EA+BI,kCAAA;AN44VR;;A2F72VQ;EAUM,uCAAA;A3Fu2Vd;;A2Fj3VQ;EAUM,uCAAA;A3F22Vd;;A2Fr3VQ;EAUM,uCAAA;A3F+2Vd;;A2Fz3VQ;EAUM,oCAAA;A3Fm3Vd;;A2F73VQ;EAUM,uCAAA;A3Fu3Vd;;A2Fj4VQ;EAUM,uCAAA;A3F23Vd;;A2Fr4VQ;EAUM,uCAAA;A3F+3Vd;;A2Fz4VQ;EAUM,uCAAA;A3Fm4Vd;;A2F74VQ;EAUM,oCAAA;A3Fu4Vd;;AMv9VI;EAgCE,qCAAA;AN27VN;AMn9VI;EA+BI,sCAAA;ANu7VR;;AM99VI;EAgCE,qCAAA;ANk8VN;AM19VI;EA+BI,sCAAA;AN87VR;;AMr+VI;EAgCE,qCAAA;ANy8VN;AMj+VI;EA+BI,sCAAA;ANq8VR;;AM5+VI;EAgCE,kCAAA;ANg9VN;AMx+VI;EA+BI,mCAAA;AN48VR;;AMn/VI;EAgCE,qCAAA;ANu9VN;AM/+VI;EA+BI,sCAAA;ANm9VR;;AM1/VI;EAgCE,qCAAA;AN89VN;AMt/VI;EA+BI,sCAAA;AN09VR;;AMjgWI;EAgCE,qCAAA;ANq+VN;AM7/VI;EA+BI,sCAAA;ANi+VR;;AMxgWI;EAgCE,qCAAA;AN4+VN;AMpgWI;EA+BI,sCAAA;ANw+VR;;AM/gWI;EAgCE,kCAAA;ANm/VN;AM3gWI;EA+BI,mCAAA;AN++VR;;A2Fh9VQ;EAUM,4BAAA;A3F08Vd;;A2Fp9VQ;EAUM,4BAAA;A3F88Vd;;A2Fx9VQ;EAUM,4BAAA;A3Fk9Vd;;A2F59VQ;EAUM,4BAAA;A3Fs9Vd;;A2Fh+VQ;EAUM,4BAAA;A3F09Vd;;A2Fp+VQ;EAUM,gCAAA;A3F89Vd;;A2Fx+VQ;EAUM,gCAAA;A3Fk+Vd;;A2F5+VQ;EAUM,gCAAA;A3Fs+Vd;;A2Fh/VQ;EAUM,gCAAA;A3F0+Vd;;A2Fp/VQ;EAUM,gCAAA;A3F8+Vd;;AM9jWI;EAgCE,kCAAA;ANkiWN;AM1jWI;EA+BI,iCAAA;AN8hWR;;AMrkWI;EAgCE,kCAAA;ANyiWN;AMjkWI;EA+BI,iCAAA;ANqiWR;;AM5kWI;EAgCE,kCAAA;ANgjWN;AMxkWI;EA+BI,iCAAA;AN4iWR;;AMnlWI;EAgCE,kCAAA;ANujWN;AM/kWI;EA+BI,iCAAA;ANmjWR;;AM1lWI;EAgCE,kCAAA;AN8jWN;AMtlWI;EA+BI,iCAAA;AN0jWR;;A2F3hWQ;EAUM,mCAAA;A3FqhWd;;A2F/hWQ;EAUM,mCAAA;A3FyhWd;;A2FniWQ;EAUM,mCAAA;A3F6hWd;;A2FviWQ;EAUM,mCAAA;A3FiiWd;;A2F3iWQ;EAUM,mCAAA;A3FqiWd;;AMrnWI;EAgCE,iCAAA;ANylWN;AMjnWI;EA+BI,kCAAA;ANqlWR;;AM5nWI;EAgCE,iCAAA;ANgmWN;AMxnWI;EA+BI,kCAAA;AN4lWR;;AMnoWI;EAgCE,iCAAA;ANumWN;AM/nWI;EA+BI,kCAAA;ANmmWR;;AM1oWI;EAgCE,iCAAA;AN8mWN;AMtoWI;EA+BI,kCAAA;AN0mWR;;AMjpWI;EAgCE,iCAAA;ANqnWN;AM7oWI;EA+BI,kCAAA;ANinWR;;A2F5lWQ;EACE,yBAAA;A3F+lWV;;A2FhmWQ;EACE,0BAAA;A3FmmWV;;A2FpmWQ;EACE,yBAAA;A3FumWV;;A2FxmWQ;EACE,0BAAA;A3F2mWV;;A2F5mWQ;EACE,uBAAA;A3F+mWV;;A2FtmWQ;EAUM,qBAAA;A3FgmWd;;A2F1mWQ;EAUM,qBAAA;A3FomWd;;A2F9mWQ;EAUM,qBAAA;A3FwmWd;;A2FlnWQ;EAUM,sBAAA;A3F4mWd;;A2FtnWQ;EAUM,sBAAA;A3FgnWd;;A2F1nWQ;EAUM,0BAAA;A3FonWd;;A2F9nWQ;EAUM,uBAAA;A3FwnWd;;A2FloWQ;EAUM,2BAAA;A3F4nWd;;A2FtoWQ;EAUM,sBAAA;A3FgoWd;;A2F1oWQ;EAUM,sBAAA;A3FooWd;;A2F9oWQ;EAUM,sBAAA;A3FwoWd;;A2FlpWQ;EAUM,uBAAA;A3F4oWd;;A2FtpWQ;EAUM,uBAAA;A3FgpWd;;A2F1pWQ;EAUM,2BAAA;A3FopWd;;A2F9pWQ;EAUM,wBAAA;A3FwpWd;;A2FlqWQ;EAUM,4BAAA;A3F4pWd;;A2FtqWQ;EAUM,yBAAA;A3FgqWd;;A2F1qWQ;EAUM,8BAAA;A3FoqWd;;A2F9qWQ;EAUM,iCAAA;A3FwqWd;;A2FlrWQ;EAUM,sCAAA;A3F4qWd;;A2FtrWQ;EAUM,yCAAA;A3FgrWd;;A2F1rWQ;EAUM,uBAAA;A3ForWd;;A2F9rWQ;EAUM,uBAAA;A3FwrWd;;A2FlsWQ;EAUM,yBAAA;A3F4rWd;;A2FtsWQ;EAUM,yBAAA;A3FgsWd;;A2F1sWQ;EAUM,0BAAA;A3FosWd;;A2F9sWQ;EAUM,4BAAA;A3FwsWd;;A2FltWQ;EAUM,kCAAA;A3F4sWd;;A2FttWQ;EAUM,sCAAA;A3FgtWd;;A2F1tWQ;EAUM,oCAAA;A3FotWd;;A2F9tWQ;EAUM,kCAAA;A3FwtWd;;A2FluWQ;EAUM,yCAAA;A3F4tWd;;A2FtuWQ;EAUM,wCAAA;A3FguWd;;A2F1uWQ;EAUM,wCAAA;A3FouWd;;A2F9uWQ;EAUM,kCAAA;A3FwuWd;;A2FlvWQ;EAUM,gCAAA;A3F4uWd;;A2FtvWQ;EAUM,8BAAA;A3FgvWd;;A2F1vWQ;EAUM,gCAAA;A3FovWd;;A2F9vWQ;EAUM,+BAAA;A3FwvWd;;A2FlwWQ;EAUM,oCAAA;A3F4vWd;;A2FtwWQ;EAUM,kCAAA;A3FgwWd;;A2F1wWQ;EAUM,gCAAA;A3FowWd;;A2F9wWQ;EAUM,uCAAA;A3FwwWd;;A2FlxWQ;EAUM,sCAAA;A3F4wWd;;A2FtxWQ;EAUM,iCAAA;A3FgxWd;;A2F1xWQ;EAUM,2BAAA;A3FoxWd;;A2F9xWQ;EAUM,iCAAA;A3FwxWd;;A2FlyWQ;EAUM,+BAAA;A3F4xWd;;A2FtyWQ;EAUM,6BAAA;A3FgyWd;;A2F1yWQ;EAUM,+BAAA;A3FoyWd;;A2F9yWQ;EAUM,8BAAA;A3FwyWd;;A2FlzWQ;EAUM,oBAAA;A3F4yWd;;A2FtzWQ;EAUM,mBAAA;A3FgzWd;;A2F1zWQ;EAUM,mBAAA;A3FozWd;;A2F9zWQ;EAUM,mBAAA;A3FwzWd;;A2Fl0WQ;EAUM,mBAAA;A3F4zWd;;A2Ft0WQ;EAUM,mBAAA;A3Fg0Wd;;A2F10WQ;EAUM,mBAAA;A3Fo0Wd;;A2F90WQ;EAUM,mBAAA;A3Fw0Wd;;A2Fl1WQ;EAUM,oBAAA;A3F40Wd;;A2Ft1WQ;EAUM,0BAAA;A3Fg1Wd;;A2F11WQ;EAUM,yBAAA;A3Fo1Wd;;A2F91WQ;EAUM,uBAAA;A3Fw1Wd;;A2Fl2WQ;EAUM,yBAAA;A3F41Wd;;A2Ft2WQ;EAUM,uBAAA;A3Fg2Wd;;A2F12WQ;EAUM,uBAAA;A3Fo2Wd;;A2F92WQ;EAUM,0BAAA;EAAA,yBAAA;A3Fy2Wd;;A2Fn3WQ;EAUM,gCAAA;EAAA,+BAAA;A3F82Wd;;A2Fx3WQ;EAUM,+BAAA;EAAA,8BAAA;A3Fm3Wd;;A2F73WQ;EAUM,6BAAA;EAAA,4BAAA;A3Fw3Wd;;A2Fl4WQ;EAUM,+BAAA;EAAA,8BAAA;A3F63Wd;;A2Fv4WQ;EAUM,6BAAA;EAAA,4BAAA;A3Fk4Wd;;A2F54WQ;EAUM,6BAAA;EAAA,4BAAA;A3Fu4Wd;;A2Fj5WQ;EAUM,wBAAA;EAAA,2BAAA;A3F44Wd;;A2Ft5WQ;EAUM,8BAAA;EAAA,iCAAA;A3Fi5Wd;;A2F35WQ;EAUM,6BAAA;EAAA,gCAAA;A3Fs5Wd;;A2Fh6WQ;EAUM,2BAAA;EAAA,8BAAA;A3F25Wd;;A2Fr6WQ;EAUM,6BAAA;EAAA,gCAAA;A3Fg6Wd;;A2F16WQ;EAUM,2BAAA;EAAA,8BAAA;A3Fq6Wd;;A2F/6WQ;EAUM,2BAAA;EAAA,8BAAA;A3F06Wd;;A2Fp7WQ;EAUM,wBAAA;A3F86Wd;;A2Fx7WQ;EAUM,8BAAA;A3Fk7Wd;;A2F57WQ;EAUM,6BAAA;A3Fs7Wd;;A2Fh8WQ;EAUM,2BAAA;A3F07Wd;;A2Fp8WQ;EAUM,6BAAA;A3F87Wd;;A2Fx8WQ;EAUM,2BAAA;A3Fk8Wd;;A2F58WQ;EAUM,2BAAA;A3Fs8Wd;;AMthXI;EAgCE,0BAAA;AN0/WN;AMlhXI;EA+BI,yBAAA;ANs/WR;;AM7hXI;EAgCE,gCAAA;ANigXN;AMzhXI;EA+BI,+BAAA;AN6/WR;;AMpiXI;EAgCE,+BAAA;ANwgXN;AMhiXI;EA+BI,8BAAA;ANogXR;;AM3iXI;EAgCE,6BAAA;AN+gXN;AMviXI;EA+BI,4BAAA;AN2gXR;;AMljXI;EAgCE,+BAAA;ANshXN;AM9iXI;EA+BI,8BAAA;ANkhXR;;AMzjXI;EAgCE,6BAAA;AN6hXN;AMrjXI;EA+BI,4BAAA;ANyhXR;;AMhkXI;EAgCE,6BAAA;ANoiXN;AM5jXI;EA+BI,4BAAA;ANgiXR;;A2FjgXQ;EAUM,2BAAA;A3F2/Wd;;A2FrgXQ;EAUM,iCAAA;A3F+/Wd;;A2FzgXQ;EAUM,gCAAA;A3FmgXd;;A2F7gXQ;EAUM,8BAAA;A3FugXd;;A2FjhXQ;EAUM,gCAAA;A3F2gXd;;A2FrhXQ;EAUM,8BAAA;A3F+gXd;;A2FzhXQ;EAUM,8BAAA;A3FmhXd;;AMnmXI;EAgCE,yBAAA;ANukXN;AM/lXI;EA+BI,0BAAA;ANmkXR;;AM1mXI;EAgCE,+BAAA;AN8kXN;AMtmXI;EA+BI,gCAAA;AN0kXR;;AMjnXI;EAgCE,8BAAA;ANqlXN;AM7mXI;EA+BI,+BAAA;ANilXR;;AMxnXI;EAgCE,4BAAA;AN4lXN;AMpnXI;EA+BI,6BAAA;ANwlXR;;AM/nXI;EAgCE,8BAAA;ANmmXN;AM3nXI;EA+BI,+BAAA;AN+lXR;;AMtoXI;EAgCE,4BAAA;AN0mXN;AMloXI;EA+BI,6BAAA;ANsmXR;;AM7oXI;EAgCE,4BAAA;ANinXN;AMzoXI;EA+BI,6BAAA;AN6mXR;;A2F9kXQ;EAUM,qBAAA;A3FwkXd;;A2FllXQ;EAUM,2BAAA;A3F4kXd;;A2FtlXQ;EAUM,0BAAA;A3FglXd;;A2F1lXQ;EAUM,wBAAA;A3FolXd;;A2F9lXQ;EAUM,0BAAA;A3FwlXd;;A2FlmXQ;EAUM,wBAAA;A3F4lXd;;A2FtmXQ;EAUM,2BAAA;EAAA,0BAAA;A3FimXd;;A2F3mXQ;EAUM,iCAAA;EAAA,gCAAA;A3FsmXd;;A2FhnXQ;EAUM,gCAAA;EAAA,+BAAA;A3F2mXd;;A2FrnXQ;EAUM,8BAAA;EAAA,6BAAA;A3FgnXd;;A2F1nXQ;EAUM,gCAAA;EAAA,+BAAA;A3FqnXd;;A2F/nXQ;EAUM,8BAAA;EAAA,6BAAA;A3F0nXd;;A2FpoXQ;EAUM,yBAAA;EAAA,4BAAA;A3F+nXd;;A2FzoXQ;EAUM,+BAAA;EAAA,kCAAA;A3FooXd;;A2F9oXQ;EAUM,8BAAA;EAAA,iCAAA;A3FyoXd;;A2FnpXQ;EAUM,4BAAA;EAAA,+BAAA;A3F8oXd;;A2FxpXQ;EAUM,8BAAA;EAAA,iCAAA;A3FmpXd;;A2F7pXQ;EAUM,4BAAA;EAAA,+BAAA;A3FwpXd;;A2FlqXQ;EAUM,yBAAA;A3F4pXd;;A2FtqXQ;EAUM,+BAAA;A3FgqXd;;A2F1qXQ;EAUM,8BAAA;A3FoqXd;;A2F9qXQ;EAUM,4BAAA;A3FwqXd;;A2FlrXQ;EAUM,8BAAA;A3F4qXd;;A2FtrXQ;EAUM,4BAAA;A3FgrXd;;AMhwXI;EAgCE,2BAAA;ANouXN;AM5vXI;EA+BI,0BAAA;ANguXR;;AMvwXI;EAgCE,iCAAA;AN2uXN;AMnwXI;EA+BI,gCAAA;ANuuXR;;AM9wXI;EAgCE,gCAAA;ANkvXN;AM1wXI;EA+BI,+BAAA;AN8uXR;;AMrxXI;EAgCE,8BAAA;ANyvXN;AMjxXI;EA+BI,6BAAA;ANqvXR;;AM5xXI;EAgCE,gCAAA;ANgwXN;AMxxXI;EA+BI,+BAAA;AN4vXR;;AMnyXI;EAgCE,8BAAA;ANuwXN;AM/xXI;EA+BI,6BAAA;ANmwXR;;A2FpuXQ;EAUM,4BAAA;A3F8tXd;;A2FxuXQ;EAUM,kCAAA;A3FkuXd;;A2F5uXQ;EAUM,iCAAA;A3FsuXd;;A2FhvXQ;EAUM,+BAAA;A3F0uXd;;A2FpvXQ;EAUM,iCAAA;A3F8uXd;;A2FxvXQ;EAUM,+BAAA;A3FkvXd;;AMl0XI;EAgCE,0BAAA;ANsyXN;AM9zXI;EA+BI,2BAAA;ANkyXR;;AMz0XI;EAgCE,gCAAA;AN6yXN;AMr0XI;EA+BI,iCAAA;ANyyXR;;AMh1XI;EAgCE,+BAAA;ANozXN;AM50XI;EA+BI,gCAAA;ANgzXR;;AMv1XI;EAgCE,6BAAA;AN2zXN;AMn1XI;EA+BI,8BAAA;ANuzXR;;AM91XI;EAgCE,+BAAA;ANk0XN;AM11XI;EA+BI,gCAAA;AN8zXR;;AMr2XI;EAgCE,6BAAA;ANy0XN;AMj2XI;EA+BI,8BAAA;ANq0XR;;A2FtyXQ;EAUM,iBAAA;A3FgyXd;;A2F1yXQ;EAUM,uBAAA;A3FoyXd;;A2F9yXQ;EAUM,sBAAA;A3FwyXd;;A2FlzXQ;EAUM,oBAAA;A3F4yXd;;A2FtzXQ;EAUM,sBAAA;A3FgzXd;;A2F1zXQ;EAUM,oBAAA;A3FozXd;;A2F9zXQ;EAUM,qBAAA;A3FwzXd;;A2Fl0XQ;EAUM,2BAAA;A3F4zXd;;A2Ft0XQ;EAUM,0BAAA;A3Fg0Xd;;A2F10XQ;EAUM,wBAAA;A3Fo0Xd;;A2F90XQ;EAUM,0BAAA;A3Fw0Xd;;A2Fl1XQ;EAUM,wBAAA;A3F40Xd;;A2Ft1XQ;EAUM,wBAAA;A3Fg1Xd;;A2F11XQ;EAUM,8BAAA;A3Fo1Xd;;A2F91XQ;EAUM,6BAAA;A3Fw1Xd;;A2Fl2XQ;EAUM,2BAAA;A3F41Xd;;A2Ft2XQ;EAUM,6BAAA;A3Fg2Xd;;A2F12XQ;EAUM,2BAAA;A3Fo2Xd;;A2F92XQ;EAUM,iDAAA;A3Fw2Xd;;A2Fl3XQ;EAUM,4CAAA;A3F42Xd;;A2Ft3XQ;EAUM,4CAAA;A3Fg3Xd;;A2F13XQ;EAUM,0CAAA;A3Fo3Xd;;A2F93XQ;EAUM,4CAAA;A3Fw3Xd;;A2Fl4XQ;EAUM,6BAAA;A3F43Xd;;A2Ft4XQ;EAUM,0BAAA;A3Fg4Xd;;A2F14XQ;EAUM,6BAAA;A3Fo4Xd;;A2F94XQ;EAUM,6BAAA;A3Fw4Xd;;A2Fl5XQ;EAUM,+BAAA;A3F44Xd;;A2Ft5XQ;EAUM,2BAAA;A3Fg5Xd;;A2F15XQ;EAUM,2BAAA;A3Fo5Xd;;A2F95XQ;EAUM,2BAAA;A3Fw5Xd;;A2Fl6XQ;EAUM,2BAAA;A3F45Xd;;A2Ft6XQ;EAUM,2BAAA;A3Fg6Xd;;A2F16XQ;EAUM,8BAAA;A3Fo6Xd;;A2F96XQ;EAUM,yBAAA;A3Fw6Xd;;A2Fl7XQ;EAUM,4BAAA;A3F46Xd;;A2Ft7XQ;EAUM,2BAAA;A3Fg7Xd;;A2F17XQ;EAUM,yBAAA;A3Fo7Xd;;AMpgYI;EAgCE,2BAAA;ANw+XN;AMhgYI;EA+BI,4BAAA;ANo+XR;;AM3gYI;EAgCE,4BAAA;AN++XN;AMvgYI;EA+BI,2BAAA;AN2+XR;;AMlhYI;EAgCE,6BAAA;ANs/XN;AM9gYI;EA+BI,6BAAA;ANk/XR;;A2Fn9XQ;EAUM,gCAAA;A3F68Xd;;A2Fv9XQ;EAUM,qCAAA;A3Fi9Xd;;A2F39XQ;EAUM,wCAAA;A3Fq9Xd;;A2F/9XQ;EAUM,oCAAA;A3Fy9Xd;;A2Fn+XQ;EAUM,oCAAA;A3F69Xd;;A2Fv+XQ;EAUM,qCAAA;A3Fi+Xd;;A2F3+XQ;EAUM,8BAAA;A3Fq+Xd;;A2F/+XQ;EAUM,8BAAA;A3Fy+Xd;;A2FjgYQ,qBAAA;AAcA;EAUM,gCAAA;EAAA,iCAAA;A3F++Xd;;A2F39XQ,mBAAA;AA9BA;EAIQ,qBAAA;EAMF,uEAAA;A3Fq/Xd;;A2F//XQ;EAIQ,qBAAA;EAMF,yEAAA;A3F0/Xd;;A2FpgYQ;EAIQ,qBAAA;EAMF,uEAAA;A3F+/Xd;;A2FzgYQ;EAIQ,qBAAA;EAMF,oEAAA;A3FogYd;;A2F9gYQ;EAIQ,qBAAA;EAMF,uEAAA;A3FygYd;;A2FnhYQ;EAIQ,qBAAA;EAMF,sEAAA;A3F8gYd;;A2FxhYQ;EAIQ,qBAAA;EAMF,qEAAA;A3FmhYd;;A2F7hYQ;EAIQ,qBAAA;EAMF,oEAAA;A3FwhYd;;A2FliYQ;EAIQ,qBAAA;EAMF,qEAAA;A3F6hYd;;A2FviYQ;EAIQ,qBAAA;EAMF,qEAAA;A3FkiYd;;A2F5iYQ;EAIQ,qBAAA;EAMF,0EAAA;A3FuiYd;;A2FjjYQ;EAIQ,qBAAA;EAMF,4CAAA;A3F4iYd;;A2FtjYQ;EAIQ,qBAAA;EAMF,qCAAA;A3FijYd;;A2F3jYQ;EAIQ,qBAAA;EAMF,0CAAA;A3FsjYd;;A2FhkYQ;EAIQ,qBAAA;EAMF,4CAAA;A3F2jYd;;A2FrkYQ;EAIQ,qBAAA;EAMF,2CAAA;A3FgkYd;;A2F1kYQ;EAIQ,qBAAA;EAMF,2CAAA;A3FqkYd;;A2F/kYQ;EAIQ,qBAAA;EAMF,yBAAA;A3F0kYd;;A2FplYQ;EAIQ,qBAAA;EAMF,kDAAA;A3F+kYd;;A2FzlYQ;EAIQ,qBAAA;EAMF,oDAAA;A3FolYd;;A2F9lYQ;EAIQ,qBAAA;EAMF,6CAAA;A3FylYd;;A2FnmYQ;EAIQ,qBAAA;EAMF,0CAAA;A3F8lYd;;A2FxmYQ;EAIQ,qBAAA;EAMF,4CAAA;A3FmmYd;;A2F7mYQ;EAIQ,qBAAA;EAMF,qCAAA;A3FwmYd;;A2F5nYQ;EACE,wBAAA;A3F+nYV;;A2FhoYQ;EACE,uBAAA;A3FmoYV;;A2FpoYQ;EACE,wBAAA;A3FuoYV;;A2FxoYQ;EACE,qBAAA;A3F2oYV;;A2F5oYQ;EACE,uBAAA;A3F+oYV;;A2F3oYU;EACE,uBAAA;A3F8oYZ;;A2FppYQ;EACE,wBAAA;A3FupYV;;A2FnpYU;EACE,wBAAA;A3FspYZ;;A2F5pYQ;EACE,uBAAA;A3F+pYV;;A2F3pYU;EACE,uBAAA;A3F8pYZ;;A2FpqYQ;EACE,wBAAA;A3FuqYV;;A2FnqYU;EACE,wBAAA;A3FsqYZ;;A2F5qYQ;EACE,qBAAA;A3F+qYV;;A2F3qYU;EACE,qBAAA;A3F8qYZ;;A2F1qYQ;EAUM,yCAAA;A3FoqYd;;A2F9pYU;EAOI,yCAAA;A3F2pYd;;A2FlrYQ;EAUM,wCAAA;A3F4qYd;;A2FtqYU;EAOI,wCAAA;A3FmqYd;;A2F1rYQ;EAUM,yCAAA;A3ForYd;;A2F9qYU;EAOI,yCAAA;A3F2qYd;;A2FlsYQ;EAIQ,+BAAA;EAMF,iGAAA;A3F6rYd;;A2FvsYQ;EAIQ,+BAAA;EAMF,mGAAA;A3FksYd;;A2F5sYQ;EAIQ,+BAAA;EAMF,iGAAA;A3FusYd;;A2FjtYQ;EAIQ,+BAAA;EAMF,8FAAA;A3F4sYd;;A2FttYQ;EAIQ,+BAAA;EAMF,iGAAA;A3FitYd;;A2F3tYQ;EAIQ,+BAAA;EAMF,gGAAA;A3FstYd;;A2FhuYQ;EAIQ,+BAAA;EAMF,+FAAA;A3F2tYd;;A2FruYQ;EAIQ,+BAAA;EAMF,8FAAA;A3FguYd;;A2F1uYQ;EAIQ,+BAAA;EAMF,uGAAA;A3FquYd;;A2FzvYQ;EACE,+BAAA;A3F4vYV;;A2FxvYU;EACE,+BAAA;A3F2vYZ;;A2FjwYQ;EACE,iCAAA;A3FowYV;;A2FhwYU;EACE,iCAAA;A3FmwYZ;;A2FzwYQ;EACE,kCAAA;A3F4wYV;;A2FxwYU;EACE,kCAAA;A3F2wYZ;;A2FjxYQ;EACE,iCAAA;A3FoxYV;;A2FhxYU;EACE,iCAAA;A3FmxYZ;;A2FzxYQ;EACE,kCAAA;A3F4xYV;;A2FxxYU;EACE,kCAAA;A3F2xYZ;;A2FjyYQ;EACE,+BAAA;A3FoyYV;;A2FhyYU;EACE,+BAAA;A3FmyYZ;;A2F/xYQ;EAIQ,mBAAA;EAMF,gFAAA;A3F0xYd;;A2FpyYQ;EAIQ,mBAAA;EAMF,kFAAA;A3F+xYd;;A2FzyYQ;EAIQ,mBAAA;EAMF,gFAAA;A3FoyYd;;A2F9yYQ;EAIQ,mBAAA;EAMF,6EAAA;A3FyyYd;;A2FnzYQ;EAIQ,mBAAA;EAMF,gFAAA;A3F8yYd;;A2FxzYQ;EAIQ,mBAAA;EAMF,+EAAA;A3FmzYd;;A2F7zYQ;EAIQ,mBAAA;EAMF,8EAAA;A3FwzYd;;A2Fl0YQ;EAIQ,mBAAA;EAMF,6EAAA;A3F6zYd;;A2Fv0YQ;EAIQ,mBAAA;EAMF,8EAAA;A3Fk0Yd;;A2F50YQ;EAIQ,mBAAA;EAMF,8EAAA;A3Fu0Yd;;A2Fj1YQ;EAIQ,mBAAA;EAMF,gFAAA;A3F40Yd;;A2Ft1YQ;EAIQ,mBAAA;EAMF,wCAAA;A3Fi1Yd;;A2F31YQ;EAIQ,mBAAA;EAMF,qFAAA;A3Fs1Yd;;A2Fh2YQ;EAIQ,mBAAA;EAMF,oFAAA;A3F21Yd;;A2F/2YQ;EACE,qBAAA;A3Fk3YV;;A2Fn3YQ;EACE,sBAAA;A3Fs3YV;;A2Fv3YQ;EACE,sBAAA;A3F03YV;;A2F33YQ;EACE,qBAAA;A3F83YV;;A2F/3YQ;EACE,sBAAA;A3Fk4YV;;A2Fn4YQ;EACE,mBAAA;A3Fs4YV;;A2F73YQ;EAUM,gDAAA;A3Fu3Yd;;A2Fj4YQ;EAUM,mCAAA;UAAA,2BAAA;A3F23Yd;;A2Fr4YQ;EAUM,oCAAA;UAAA,4BAAA;A3F+3Yd;;A2Fz4YQ;EAUM,oCAAA;UAAA,4BAAA;A3Fm4Yd;;A2F74YQ;EAUM,+BAAA;A3Fu4Yd;;A2Fj5YQ;EAUM,+BAAA;A3F24Yd;;A2Fr5YQ;EAUM,kDAAA;A3F+4Yd;;A2Fz5YQ;EAUM,2BAAA;A3Fm5Yd;;A2F75YQ;EAUM,qDAAA;A3Fu5Yd;;A2Fj6YQ;EAUM,kDAAA;A3F25Yd;;A2Fr6YQ;EAUM,qDAAA;A3F+5Yd;;A2Fz6YQ;EAUM,qDAAA;A3Fm6Yd;;A2F76YQ;EAUM,sDAAA;A3Fu6Yd;;A2Fj7YQ;EAUM,6BAAA;A3F26Yd;;A2Fr7YQ;EAUM,uDAAA;A3F+6Yd;;A2Fz7YQ;EAUM,2DAAA;EAAA,4DAAA;A3Fo7Yd;;A2F97YQ;EAUM,oCAAA;EAAA,qCAAA;A3Fy7Yd;;A2Fn8YQ;EAUM,8DAAA;EAAA,+DAAA;A3F87Yd;;A2Fx8YQ;EAUM,2DAAA;EAAA,4DAAA;A3Fm8Yd;;A2F78YQ;EAUM,8DAAA;EAAA,+DAAA;A3Fw8Yd;;A2Fl9YQ;EAUM,8DAAA;EAAA,+DAAA;A3F68Yd;;A2Fv9YQ;EAUM,+DAAA;EAAA,gEAAA;A3Fk9Yd;;A2F59YQ;EAUM,sCAAA;EAAA,uCAAA;A3Fu9Yd;;A2Fj+YQ;EAUM,gEAAA;EAAA,iEAAA;A3F49Yd;;AM5iZI;EAgCE,4DAAA;ANghZN;AMxiZI;EA+BI,2DAAA;AN4gZR;AMnjZI;EAgCE,+DAAA;ANshZN;AM9iZI;EA+BI,8DAAA;ANkhZR;;AMzjZI;EAgCE,qCAAA;AN6hZN;AMrjZI;EA+BI,oCAAA;ANyhZR;AMhkZI;EAgCE,wCAAA;ANmiZN;AM3jZI;EA+BI,uCAAA;AN+hZR;;AMtkZI;EAgCE,+DAAA;AN0iZN;AMlkZI;EA+BI,8DAAA;ANsiZR;AM7kZI;EAgCE,kEAAA;ANgjZN;AMxkZI;EA+BI,iEAAA;AN4iZR;;AMnlZI;EAgCE,4DAAA;ANujZN;AM/kZI;EA+BI,2DAAA;ANmjZR;AM1lZI;EAgCE,+DAAA;AN6jZN;AMrlZI;EA+BI,8DAAA;ANyjZR;;AMhmZI;EAgCE,+DAAA;ANokZN;AM5lZI;EA+BI,8DAAA;ANgkZR;AMvmZI;EAgCE,kEAAA;AN0kZN;AMlmZI;EA+BI,iEAAA;ANskZR;;AM7mZI;EAgCE,+DAAA;ANilZN;AMzmZI;EA+BI,8DAAA;AN6kZR;AMpnZI;EAgCE,kEAAA;ANulZN;AM/mZI;EA+BI,iEAAA;ANmlZR;;AM1nZI;EAgCE,gEAAA;AN8lZN;AMtnZI;EA+BI,+DAAA;AN0lZR;AMjoZI;EAgCE,mEAAA;ANomZN;AM5nZI;EA+BI,kEAAA;ANgmZR;;AMvoZI;EAgCE,uCAAA;AN2mZN;AMnoZI;EA+BI,sCAAA;ANumZR;AM9oZI;EAgCE,0CAAA;ANinZN;AMzoZI;EA+BI,yCAAA;AN6mZR;;AMppZI;EAgCE,iEAAA;ANwnZN;AMhpZI;EA+BI,gEAAA;ANonZR;AM3pZI;EAgCE,oEAAA;AN8nZN;AMtpZI;EA+BI,mEAAA;AN0nZR;;A2F3lZQ;EAUM,+DAAA;EAAA,8DAAA;A3FslZd;;A2FhmZQ;EAUM,wCAAA;EAAA,uCAAA;A3F2lZd;;A2FrmZQ;EAUM,kEAAA;EAAA,iEAAA;A3FgmZd;;A2F1mZQ;EAUM,+DAAA;EAAA,8DAAA;A3FqmZd;;A2F/mZQ;EAUM,kEAAA;EAAA,iEAAA;A3F0mZd;;A2FpnZQ;EAUM,kEAAA;EAAA,iEAAA;A3F+mZd;;A2FznZQ;EAUM,mEAAA;EAAA,kEAAA;A3FonZd;;A2F9nZQ;EAUM,0CAAA;EAAA,yCAAA;A3FynZd;;A2FnoZQ;EAUM,oEAAA;EAAA,mEAAA;A3F8nZd;;AM9sZI;EAgCE,8DAAA;ANkrZN;AM1sZI;EA+BI,+DAAA;AN8qZR;AMrtZI;EAgCE,2DAAA;ANwrZN;AMhtZI;EA+BI,4DAAA;ANorZR;;AM3tZI;EAgCE,uCAAA;AN+rZN;AMvtZI;EA+BI,wCAAA;AN2rZR;AMluZI;EAgCE,oCAAA;ANqsZN;AM7tZI;EA+BI,qCAAA;ANisZR;;AMxuZI;EAgCE,iEAAA;AN4sZN;AMpuZI;EA+BI,kEAAA;ANwsZR;AM/uZI;EAgCE,8DAAA;ANktZN;AM1uZI;EA+BI,+DAAA;AN8sZR;;AMrvZI;EAgCE,8DAAA;ANytZN;AMjvZI;EA+BI,+DAAA;ANqtZR;AM5vZI;EAgCE,2DAAA;AN+tZN;AMvvZI;EA+BI,4DAAA;AN2tZR;;AMlwZI;EAgCE,iEAAA;ANsuZN;AM9vZI;EA+BI,kEAAA;ANkuZR;AMzwZI;EAgCE,8DAAA;AN4uZN;AMpwZI;EA+BI,+DAAA;ANwuZR;;AM/wZI;EAgCE,iEAAA;ANmvZN;AM3wZI;EA+BI,kEAAA;AN+uZR;AMtxZI;EAgCE,8DAAA;ANyvZN;AMjxZI;EA+BI,+DAAA;ANqvZR;;AM5xZI;EAgCE,kEAAA;ANgwZN;AMxxZI;EA+BI,mEAAA;AN4vZR;AMnyZI;EAgCE,+DAAA;ANswZN;AM9xZI;EA+BI,gEAAA;ANkwZR;;AMzyZI;EAgCE,yCAAA;AN6wZN;AMryZI;EA+BI,0CAAA;ANywZR;AMhzZI;EAgCE,sCAAA;ANmxZN;AM3yZI;EA+BI,uCAAA;AN+wZR;;AMtzZI;EAgCE,mEAAA;AN0xZN;AMlzZI;EA+BI,oEAAA;ANsxZR;AM7zZI;EAgCE,gEAAA;ANgyZN;AMxzZI;EA+BI,iEAAA;AN4xZR;;A2F7vZQ;EAUM,8BAAA;A3FuvZd;;A2FjwZQ;EAUM,6BAAA;A3F2vZd;;A2FrwZQ;EAUM,sBAAA;A3F+vZd;;A2FzwZQ;EAUM,qBAAA;A3FmwZd;;A2F7wZQ;EAUM,qBAAA;A3FuwZd;;A2FjxZQ;EAUM,qBAAA;A3F2wZd;;A2FrxZQ;EAUM,qBAAA;A3F+wZd;;AclyZI;ER7DA;IAgCE,sBAAA;ENo0ZJ;EM51ZE;IA+BI,uBAAA;ENg0ZN;EMv2ZE;IAgCE,uBAAA;EN00ZJ;EMl2ZE;IA+BI,sBAAA;ENs0ZN;EM72ZE;IAgCE,sBAAA;ENg1ZJ;EMx2ZE;IA+BI,sBAAA;EN40ZN;E2F7yZM;IAUM,8BAAA;E3FsyZZ;E2FhzZM;IAUM,4BAAA;E3FyyZZ;E2FnzZM;IAUM,2BAAA;E3F4yZZ;E2FtzZM;IAUM,iCAAA;E3F+yZZ;E2FzzZM;IAUM,2BAAA;E3FkzZZ;E2F5zZM;IAUM,0BAAA;E3FqzZZ;E2F/zZM;IAUM,gCAAA;E3FwzZZ;E2Fl0ZM;IAUM,yBAAA;E3F2zZZ;E2Fr0ZM;IAUM,wBAAA;E3F8zZZ;E2Fx0ZM;IAUM,+BAAA;E3Fi0ZZ;E2F30ZM;IAUM,yBAAA;E3Fo0ZZ;E2F90ZM;IAUM,6BAAA;E3Fu0ZZ;E2Fj1ZM;IAUM,8BAAA;E3F00ZZ;E2Fp1ZM;IAUM,wBAAA;E3F60ZZ;E2Fv1ZM;IAUM,+BAAA;E3Fg1ZZ;E2F11ZM;IAUM,wBAAA;E3Fm1ZZ;E2F71ZM;IAUM,yBAAA;E3Fs1ZZ;E2Fh2ZM;IAUM,8BAAA;E3Fy1ZZ;E2Fn2ZM;IAUM,iCAAA;E3F41ZZ;E2Ft2ZM;IAUM,sCAAA;E3F+1ZZ;E2Fz2ZM;IAUM,yCAAA;E3Fk2ZZ;E2F52ZM;IAUM,uBAAA;E3Fq2ZZ;E2F/2ZM;IAUM,uBAAA;E3Fw2ZZ;E2Fl3ZM;IAUM,yBAAA;E3F22ZZ;E2Fr3ZM;IAUM,yBAAA;E3F82ZZ;E2Fx3ZM;IAUM,0BAAA;E3Fi3ZZ;E2F33ZM;IAUM,4BAAA;E3Fo3ZZ;E2F93ZM;IAUM,kCAAA;E3Fu3ZZ;E2Fj4ZM;IAUM,sCAAA;E3F03ZZ;E2Fp4ZM;IAUM,oCAAA;E3F63ZZ;E2Fv4ZM;IAUM,kCAAA;E3Fg4ZZ;E2F14ZM;IAUM,yCAAA;E3Fm4ZZ;E2F74ZM;IAUM,wCAAA;E3Fs4ZZ;E2Fh5ZM;IAUM,wCAAA;E3Fy4ZZ;E2Fn5ZM;IAUM,kCAAA;E3F44ZZ;E2Ft5ZM;IAUM,gCAAA;E3F+4ZZ;E2Fz5ZM;IAUM,8BAAA;E3Fk5ZZ;E2F55ZM;IAUM,gCAAA;E3Fq5ZZ;E2F/5ZM;IAUM,+BAAA;E3Fw5ZZ;E2Fl6ZM;IAUM,oCAAA;E3F25ZZ;E2Fr6ZM;IAUM,kCAAA;E3F85ZZ;E2Fx6ZM;IAUM,gCAAA;E3Fi6ZZ;E2F36ZM;IAUM,uCAAA;E3Fo6ZZ;E2F96ZM;IAUM,sCAAA;E3Fu6ZZ;E2Fj7ZM;IAUM,iCAAA;E3F06ZZ;E2Fp7ZM;IAUM,2BAAA;E3F66ZZ;E2Fv7ZM;IAUM,iCAAA;E3Fg7ZZ;E2F17ZM;IAUM,+BAAA;E3Fm7ZZ;E2F77ZM;IAUM,6BAAA;E3Fs7ZZ;E2Fh8ZM;IAUM,+BAAA;E3Fy7ZZ;E2Fn8ZM;IAUM,8BAAA;E3F47ZZ;E2Ft8ZM;IAUM,oBAAA;E3F+7ZZ;E2Fz8ZM;IAUM,mBAAA;E3Fk8ZZ;E2F58ZM;IAUM,mBAAA;E3Fq8ZZ;E2F/8ZM;IAUM,mBAAA;E3Fw8ZZ;E2Fl9ZM;IAUM,mBAAA;E3F28ZZ;E2Fr9ZM;IAUM,mBAAA;E3F88ZZ;E2Fx9ZM;IAUM,mBAAA;E3Fi9ZZ;E2F39ZM;IAUM,mBAAA;E3Fo9ZZ;E2F99ZM;IAUM,oBAAA;E3Fu9ZZ;E2Fj+ZM;IAUM,0BAAA;E3F09ZZ;E2Fp+ZM;IAUM,yBAAA;E3F69ZZ;E2Fv+ZM;IAUM,uBAAA;E3Fg+ZZ;E2F1+ZM;IAUM,yBAAA;E3Fm+ZZ;E2F7+ZM;IAUM,uBAAA;E3Fs+ZZ;E2Fh/ZM;IAUM,uBAAA;E3Fy+ZZ;E2Fn/ZM;IAUM,0BAAA;IAAA,yBAAA;E3F6+ZZ;E2Fv/ZM;IAUM,gCAAA;IAAA,+BAAA;E3Fi/ZZ;E2F3/ZM;IAUM,+BAAA;IAAA,8BAAA;E3Fq/ZZ;E2F//ZM;IAUM,6BAAA;IAAA,4BAAA;E3Fy/ZZ;E2FngaM;IAUM,+BAAA;IAAA,8BAAA;E3F6/ZZ;E2FvgaM;IAUM,6BAAA;IAAA,4BAAA;E3FigaZ;E2F3gaM;IAUM,6BAAA;IAAA,4BAAA;E3FqgaZ;E2F/gaM;IAUM,wBAAA;IAAA,2BAAA;E3FygaZ;E2FnhaM;IAUM,8BAAA;IAAA,iCAAA;E3F6gaZ;E2FvhaM;IAUM,6BAAA;IAAA,gCAAA;E3FihaZ;E2F3haM;IAUM,2BAAA;IAAA,8BAAA;E3FqhaZ;E2F/haM;IAUM,6BAAA;IAAA,gCAAA;E3FyhaZ;E2FniaM;IAUM,2BAAA;IAAA,8BAAA;E3F6haZ;E2FviaM;IAUM,2BAAA;IAAA,8BAAA;E3FiiaZ;E2F3iaM;IAUM,wBAAA;E3FoiaZ;E2F9iaM;IAUM,8BAAA;E3FuiaZ;E2FjjaM;IAUM,6BAAA;E3F0iaZ;E2FpjaM;IAUM,2BAAA;E3F6iaZ;E2FvjaM;IAUM,6BAAA;E3FgjaZ;E2F1jaM;IAUM,2BAAA;E3FmjaZ;E2F7jaM;IAUM,2BAAA;E3FsjaZ;EMtoaE;IAgCE,0BAAA;ENymaJ;EMjoaE;IA+BI,yBAAA;ENqmaN;EM5oaE;IAgCE,gCAAA;EN+maJ;EMvoaE;IA+BI,+BAAA;EN2maN;EMlpaE;IAgCE,+BAAA;ENqnaJ;EM7oaE;IA+BI,8BAAA;ENinaN;EMxpaE;IAgCE,6BAAA;EN2naJ;EMnpaE;IA+BI,4BAAA;ENunaN;EM9paE;IAgCE,+BAAA;ENioaJ;EMzpaE;IA+BI,8BAAA;EN6naN;EMpqaE;IAgCE,6BAAA;ENuoaJ;EM/paE;IA+BI,4BAAA;ENmoaN;EM1qaE;IAgCE,6BAAA;EN6oaJ;EMrqaE;IA+BI,4BAAA;ENyoaN;E2F1maM;IAUM,2BAAA;E3FmmaZ;E2F7maM;IAUM,iCAAA;E3FsmaZ;E2FhnaM;IAUM,gCAAA;E3FymaZ;E2FnnaM;IAUM,8BAAA;E3F4maZ;E2FtnaM;IAUM,gCAAA;E3F+maZ;E2FznaM;IAUM,8BAAA;E3FknaZ;E2F5naM;IAUM,8BAAA;E3FqnaZ;EMrsaE;IAgCE,yBAAA;ENwqaJ;EMhsaE;IA+BI,0BAAA;ENoqaN;EM3saE;IAgCE,+BAAA;EN8qaJ;EMtsaE;IA+BI,gCAAA;EN0qaN;EMjtaE;IAgCE,8BAAA;ENoraJ;EM5saE;IA+BI,+BAAA;ENgraN;EMvtaE;IAgCE,4BAAA;EN0raJ;EMltaE;IA+BI,6BAAA;ENsraN;EM7taE;IAgCE,8BAAA;ENgsaJ;EMxtaE;IA+BI,+BAAA;EN4raN;EMnuaE;IAgCE,4BAAA;ENssaJ;EM9taE;IA+BI,6BAAA;ENksaN;EMzuaE;IAgCE,4BAAA;EN4saJ;EMpuaE;IA+BI,6BAAA;ENwsaN;E2FzqaM;IAUM,qBAAA;E3FkqaZ;E2F5qaM;IAUM,2BAAA;E3FqqaZ;E2F/qaM;IAUM,0BAAA;E3FwqaZ;E2FlraM;IAUM,wBAAA;E3F2qaZ;E2FrraM;IAUM,0BAAA;E3F8qaZ;E2FxraM;IAUM,wBAAA;E3FiraZ;E2F3raM;IAUM,2BAAA;IAAA,0BAAA;E3FqraZ;E2F/raM;IAUM,iCAAA;IAAA,gCAAA;E3FyraZ;E2FnsaM;IAUM,gCAAA;IAAA,+BAAA;E3F6raZ;E2FvsaM;IAUM,8BAAA;IAAA,6BAAA;E3FisaZ;E2F3saM;IAUM,gCAAA;IAAA,+BAAA;E3FqsaZ;E2F/saM;IAUM,8BAAA;IAAA,6BAAA;E3FysaZ;E2FntaM;IAUM,yBAAA;IAAA,4BAAA;E3F6saZ;E2FvtaM;IAUM,+BAAA;IAAA,kCAAA;E3FitaZ;E2F3taM;IAUM,8BAAA;IAAA,iCAAA;E3FqtaZ;E2F/taM;IAUM,4BAAA;IAAA,+BAAA;E3FytaZ;E2FnuaM;IAUM,8BAAA;IAAA,iCAAA;E3F6taZ;E2FvuaM;IAUM,4BAAA;IAAA,+BAAA;E3FiuaZ;E2F3uaM;IAUM,yBAAA;E3FouaZ;E2F9uaM;IAUM,+BAAA;E3FuuaZ;E2FjvaM;IAUM,8BAAA;E3F0uaZ;E2FpvaM;IAUM,4BAAA;E3F6uaZ;E2FvvaM;IAUM,8BAAA;E3FgvaZ;E2F1vaM;IAUM,4BAAA;E3FmvaZ;EMn0aE;IAgCE,2BAAA;ENsyaJ;EM9zaE;IA+BI,0BAAA;ENkyaN;EMz0aE;IAgCE,iCAAA;EN4yaJ;EMp0aE;IA+BI,gCAAA;ENwyaN;EM/0aE;IAgCE,gCAAA;ENkzaJ;EM10aE;IA+BI,+BAAA;EN8yaN;EMr1aE;IAgCE,8BAAA;ENwzaJ;EMh1aE;IA+BI,6BAAA;ENozaN;EM31aE;IAgCE,gCAAA;EN8zaJ;EMt1aE;IA+BI,+BAAA;EN0zaN;EMj2aE;IAgCE,8BAAA;ENo0aJ;EM51aE;IA+BI,6BAAA;ENg0aN;E2FjyaM;IAUM,4BAAA;E3F0xaZ;E2FpyaM;IAUM,kCAAA;E3F6xaZ;E2FvyaM;IAUM,iCAAA;E3FgyaZ;E2F1yaM;IAUM,+BAAA;E3FmyaZ;E2F7yaM;IAUM,iCAAA;E3FsyaZ;E2FhzaM;IAUM,+BAAA;E3FyyaZ;EMz3aE;IAgCE,0BAAA;EN41aJ;EMp3aE;IA+BI,2BAAA;ENw1aN;EM/3aE;IAgCE,gCAAA;ENk2aJ;EM13aE;IA+BI,iCAAA;EN81aN;EMr4aE;IAgCE,+BAAA;ENw2aJ;EMh4aE;IA+BI,gCAAA;ENo2aN;EM34aE;IAgCE,6BAAA;EN82aJ;EMt4aE;IA+BI,8BAAA;EN02aN;EMj5aE;IAgCE,+BAAA;ENo3aJ;EM54aE;IA+BI,gCAAA;ENg3aN;EMv5aE;IAgCE,6BAAA;EN03aJ;EMl5aE;IA+BI,8BAAA;ENs3aN;E2Fv1aM;IAUM,iBAAA;E3Fg1aZ;E2F11aM;IAUM,uBAAA;E3Fm1aZ;E2F71aM;IAUM,sBAAA;E3Fs1aZ;E2Fh2aM;IAUM,oBAAA;E3Fy1aZ;E2Fn2aM;IAUM,sBAAA;E3F41aZ;E2Ft2aM;IAUM,oBAAA;E3F+1aZ;E2Fz2aM;IAUM,qBAAA;E3Fk2aZ;E2F52aM;IAUM,2BAAA;E3Fq2aZ;E2F/2aM;IAUM,0BAAA;E3Fw2aZ;E2Fl3aM;IAUM,wBAAA;E3F22aZ;E2Fr3aM;IAUM,0BAAA;E3F82aZ;E2Fx3aM;IAUM,wBAAA;E3Fi3aZ;E2F33aM;IAUM,wBAAA;E3Fo3aZ;E2F93aM;IAUM,8BAAA;E3Fu3aZ;E2Fj4aM;IAUM,6BAAA;E3F03aZ;E2Fp4aM;IAUM,2BAAA;E3F63aZ;E2Fv4aM;IAUM,6BAAA;E3Fg4aZ;E2F14aM;IAUM,2BAAA;E3Fm4aZ;EMn9aE;IAgCE,2BAAA;ENs7aJ;EM98aE;IA+BI,4BAAA;ENk7aN;EMz9aE;IAgCE,4BAAA;EN47aJ;EMp9aE;IA+BI,2BAAA;ENw7aN;EM/9aE;IAgCE,6BAAA;ENk8aJ;EM19aE;IA+BI,6BAAA;EN87aN;AACF;Acz6aI;ER7DA;IAgCE,sBAAA;EN08aJ;EMl+aE;IA+BI,uBAAA;ENs8aN;EM7+aE;IAgCE,uBAAA;ENg9aJ;EMx+aE;IA+BI,sBAAA;EN48aN;EMn/aE;IAgCE,sBAAA;ENs9aJ;EM9+aE;IA+BI,sBAAA;ENk9aN;E2Fn7aM;IAUM,8BAAA;E3F46aZ;E2Ft7aM;IAUM,4BAAA;E3F+6aZ;E2Fz7aM;IAUM,2BAAA;E3Fk7aZ;E2F57aM;IAUM,iCAAA;E3Fq7aZ;E2F/7aM;IAUM,2BAAA;E3Fw7aZ;E2Fl8aM;IAUM,0BAAA;E3F27aZ;E2Fr8aM;IAUM,gCAAA;E3F87aZ;E2Fx8aM;IAUM,yBAAA;E3Fi8aZ;E2F38aM;IAUM,wBAAA;E3Fo8aZ;E2F98aM;IAUM,+BAAA;E3Fu8aZ;E2Fj9aM;IAUM,yBAAA;E3F08aZ;E2Fp9aM;IAUM,6BAAA;E3F68aZ;E2Fv9aM;IAUM,8BAAA;E3Fg9aZ;E2F19aM;IAUM,wBAAA;E3Fm9aZ;E2F79aM;IAUM,+BAAA;E3Fs9aZ;E2Fh+aM;IAUM,wBAAA;E3Fy9aZ;E2Fn+aM;IAUM,yBAAA;E3F49aZ;E2Ft+aM;IAUM,8BAAA;E3F+9aZ;E2Fz+aM;IAUM,iCAAA;E3Fk+aZ;E2F5+aM;IAUM,sCAAA;E3Fq+aZ;E2F/+aM;IAUM,yCAAA;E3Fw+aZ;E2Fl/aM;IAUM,uBAAA;E3F2+aZ;E2Fr/aM;IAUM,uBAAA;E3F8+aZ;E2Fx/aM;IAUM,yBAAA;E3Fi/aZ;E2F3/aM;IAUM,yBAAA;E3Fo/aZ;E2F9/aM;IAUM,0BAAA;E3Fu/aZ;E2FjgbM;IAUM,4BAAA;E3F0/aZ;E2FpgbM;IAUM,kCAAA;E3F6/aZ;E2FvgbM;IAUM,sCAAA;E3FggbZ;E2F1gbM;IAUM,oCAAA;E3FmgbZ;E2F7gbM;IAUM,kCAAA;E3FsgbZ;E2FhhbM;IAUM,yCAAA;E3FygbZ;E2FnhbM;IAUM,wCAAA;E3F4gbZ;E2FthbM;IAUM,wCAAA;E3F+gbZ;E2FzhbM;IAUM,kCAAA;E3FkhbZ;E2F5hbM;IAUM,gCAAA;E3FqhbZ;E2F/hbM;IAUM,8BAAA;E3FwhbZ;E2FlibM;IAUM,gCAAA;E3F2hbZ;E2FribM;IAUM,+BAAA;E3F8hbZ;E2FxibM;IAUM,oCAAA;E3FiibZ;E2F3ibM;IAUM,kCAAA;E3FoibZ;E2F9ibM;IAUM,gCAAA;E3FuibZ;E2FjjbM;IAUM,uCAAA;E3F0ibZ;E2FpjbM;IAUM,sCAAA;E3F6ibZ;E2FvjbM;IAUM,iCAAA;E3FgjbZ;E2F1jbM;IAUM,2BAAA;E3FmjbZ;E2F7jbM;IAUM,iCAAA;E3FsjbZ;E2FhkbM;IAUM,+BAAA;E3FyjbZ;E2FnkbM;IAUM,6BAAA;E3F4jbZ;E2FtkbM;IAUM,+BAAA;E3F+jbZ;E2FzkbM;IAUM,8BAAA;E3FkkbZ;E2F5kbM;IAUM,oBAAA;E3FqkbZ;E2F/kbM;IAUM,mBAAA;E3FwkbZ;E2FllbM;IAUM,mBAAA;E3F2kbZ;E2FrlbM;IAUM,mBAAA;E3F8kbZ;E2FxlbM;IAUM,mBAAA;E3FilbZ;E2F3lbM;IAUM,mBAAA;E3FolbZ;E2F9lbM;IAUM,mBAAA;E3FulbZ;E2FjmbM;IAUM,mBAAA;E3F0lbZ;E2FpmbM;IAUM,oBAAA;E3F6lbZ;E2FvmbM;IAUM,0BAAA;E3FgmbZ;E2F1mbM;IAUM,yBAAA;E3FmmbZ;E2F7mbM;IAUM,uBAAA;E3FsmbZ;E2FhnbM;IAUM,yBAAA;E3FymbZ;E2FnnbM;IAUM,uBAAA;E3F4mbZ;E2FtnbM;IAUM,uBAAA;E3F+mbZ;E2FznbM;IAUM,0BAAA;IAAA,yBAAA;E3FmnbZ;E2F7nbM;IAUM,gCAAA;IAAA,+BAAA;E3FunbZ;E2FjobM;IAUM,+BAAA;IAAA,8BAAA;E3F2nbZ;E2FrobM;IAUM,6BAAA;IAAA,4BAAA;E3F+nbZ;E2FzobM;IAUM,+BAAA;IAAA,8BAAA;E3FmobZ;E2F7obM;IAUM,6BAAA;IAAA,4BAAA;E3FuobZ;E2FjpbM;IAUM,6BAAA;IAAA,4BAAA;E3F2obZ;E2FrpbM;IAUM,wBAAA;IAAA,2BAAA;E3F+obZ;E2FzpbM;IAUM,8BAAA;IAAA,iCAAA;E3FmpbZ;E2F7pbM;IAUM,6BAAA;IAAA,gCAAA;E3FupbZ;E2FjqbM;IAUM,2BAAA;IAAA,8BAAA;E3F2pbZ;E2FrqbM;IAUM,6BAAA;IAAA,gCAAA;E3F+pbZ;E2FzqbM;IAUM,2BAAA;IAAA,8BAAA;E3FmqbZ;E2F7qbM;IAUM,2BAAA;IAAA,8BAAA;E3FuqbZ;E2FjrbM;IAUM,wBAAA;E3F0qbZ;E2FprbM;IAUM,8BAAA;E3F6qbZ;E2FvrbM;IAUM,6BAAA;E3FgrbZ;E2F1rbM;IAUM,2BAAA;E3FmrbZ;E2F7rbM;IAUM,6BAAA;E3FsrbZ;E2FhsbM;IAUM,2BAAA;E3FyrbZ;E2FnsbM;IAUM,2BAAA;E3F4rbZ;EM5wbE;IAgCE,0BAAA;EN+ubJ;EMvwbE;IA+BI,yBAAA;EN2ubN;EMlxbE;IAgCE,gCAAA;ENqvbJ;EM7wbE;IA+BI,+BAAA;ENivbN;EMxxbE;IAgCE,+BAAA;EN2vbJ;EMnxbE;IA+BI,8BAAA;ENuvbN;EM9xbE;IAgCE,6BAAA;ENiwbJ;EMzxbE;IA+BI,4BAAA;EN6vbN;EMpybE;IAgCE,+BAAA;ENuwbJ;EM/xbE;IA+BI,8BAAA;ENmwbN;EM1ybE;IAgCE,6BAAA;EN6wbJ;EMrybE;IA+BI,4BAAA;ENywbN;EMhzbE;IAgCE,6BAAA;ENmxbJ;EM3ybE;IA+BI,4BAAA;EN+wbN;E2FhvbM;IAUM,2BAAA;E3FyubZ;E2FnvbM;IAUM,iCAAA;E3F4ubZ;E2FtvbM;IAUM,gCAAA;E3F+ubZ;E2FzvbM;IAUM,8BAAA;E3FkvbZ;E2F5vbM;IAUM,gCAAA;E3FqvbZ;E2F/vbM;IAUM,8BAAA;E3FwvbZ;E2FlwbM;IAUM,8BAAA;E3F2vbZ;EM30bE;IAgCE,yBAAA;EN8ybJ;EMt0bE;IA+BI,0BAAA;EN0ybN;EMj1bE;IAgCE,+BAAA;ENozbJ;EM50bE;IA+BI,gCAAA;ENgzbN;EMv1bE;IAgCE,8BAAA;EN0zbJ;EMl1bE;IA+BI,+BAAA;ENszbN;EM71bE;IAgCE,4BAAA;ENg0bJ;EMx1bE;IA+BI,6BAAA;EN4zbN;EMn2bE;IAgCE,8BAAA;ENs0bJ;EM91bE;IA+BI,+BAAA;ENk0bN;EMz2bE;IAgCE,4BAAA;EN40bJ;EMp2bE;IA+BI,6BAAA;ENw0bN;EM/2bE;IAgCE,4BAAA;ENk1bJ;EM12bE;IA+BI,6BAAA;EN80bN;E2F/ybM;IAUM,qBAAA;E3FwybZ;E2FlzbM;IAUM,2BAAA;E3F2ybZ;E2FrzbM;IAUM,0BAAA;E3F8ybZ;E2FxzbM;IAUM,wBAAA;E3FizbZ;E2F3zbM;IAUM,0BAAA;E3FozbZ;E2F9zbM;IAUM,wBAAA;E3FuzbZ;E2Fj0bM;IAUM,2BAAA;IAAA,0BAAA;E3F2zbZ;E2Fr0bM;IAUM,iCAAA;IAAA,gCAAA;E3F+zbZ;E2Fz0bM;IAUM,gCAAA;IAAA,+BAAA;E3Fm0bZ;E2F70bM;IAUM,8BAAA;IAAA,6BAAA;E3Fu0bZ;E2Fj1bM;IAUM,gCAAA;IAAA,+BAAA;E3F20bZ;E2Fr1bM;IAUM,8BAAA;IAAA,6BAAA;E3F+0bZ;E2Fz1bM;IAUM,yBAAA;IAAA,4BAAA;E3Fm1bZ;E2F71bM;IAUM,+BAAA;IAAA,kCAAA;E3Fu1bZ;E2Fj2bM;IAUM,8BAAA;IAAA,iCAAA;E3F21bZ;E2Fr2bM;IAUM,4BAAA;IAAA,+BAAA;E3F+1bZ;E2Fz2bM;IAUM,8BAAA;IAAA,iCAAA;E3Fm2bZ;E2F72bM;IAUM,4BAAA;IAAA,+BAAA;E3Fu2bZ;E2Fj3bM;IAUM,yBAAA;E3F02bZ;E2Fp3bM;IAUM,+BAAA;E3F62bZ;E2Fv3bM;IAUM,8BAAA;E3Fg3bZ;E2F13bM;IAUM,4BAAA;E3Fm3bZ;E2F73bM;IAUM,8BAAA;E3Fs3bZ;E2Fh4bM;IAUM,4BAAA;E3Fy3bZ;EMz8bE;IAgCE,2BAAA;EN46bJ;EMp8bE;IA+BI,0BAAA;ENw6bN;EM/8bE;IAgCE,iCAAA;ENk7bJ;EM18bE;IA+BI,gCAAA;EN86bN;EMr9bE;IAgCE,gCAAA;ENw7bJ;EMh9bE;IA+BI,+BAAA;ENo7bN;EM39bE;IAgCE,8BAAA;EN87bJ;EMt9bE;IA+BI,6BAAA;EN07bN;EMj+bE;IAgCE,gCAAA;ENo8bJ;EM59bE;IA+BI,+BAAA;ENg8bN;EMv+bE;IAgCE,8BAAA;EN08bJ;EMl+bE;IA+BI,6BAAA;ENs8bN;E2Fv6bM;IAUM,4BAAA;E3Fg6bZ;E2F16bM;IAUM,kCAAA;E3Fm6bZ;E2F76bM;IAUM,iCAAA;E3Fs6bZ;E2Fh7bM;IAUM,+BAAA;E3Fy6bZ;E2Fn7bM;IAUM,iCAAA;E3F46bZ;E2Ft7bM;IAUM,+BAAA;E3F+6bZ;EM//bE;IAgCE,0BAAA;ENk+bJ;EM1/bE;IA+BI,2BAAA;EN89bN;EMrgcE;IAgCE,gCAAA;ENw+bJ;EMhgcE;IA+BI,iCAAA;ENo+bN;EM3gcE;IAgCE,+BAAA;EN8+bJ;EMtgcE;IA+BI,gCAAA;EN0+bN;EMjhcE;IAgCE,6BAAA;ENo/bJ;EM5gcE;IA+BI,8BAAA;ENg/bN;EMvhcE;IAgCE,+BAAA;EN0/bJ;EMlhcE;IA+BI,gCAAA;ENs/bN;EM7hcE;IAgCE,6BAAA;ENggcJ;EMxhcE;IA+BI,8BAAA;EN4/bN;E2F79bM;IAUM,iBAAA;E3Fs9bZ;E2Fh+bM;IAUM,uBAAA;E3Fy9bZ;E2Fn+bM;IAUM,sBAAA;E3F49bZ;E2Ft+bM;IAUM,oBAAA;E3F+9bZ;E2Fz+bM;IAUM,sBAAA;E3Fk+bZ;E2F5+bM;IAUM,oBAAA;E3Fq+bZ;E2F/+bM;IAUM,qBAAA;E3Fw+bZ;E2Fl/bM;IAUM,2BAAA;E3F2+bZ;E2Fr/bM;IAUM,0BAAA;E3F8+bZ;E2Fx/bM;IAUM,wBAAA;E3Fi/bZ;E2F3/bM;IAUM,0BAAA;E3Fo/bZ;E2F9/bM;IAUM,wBAAA;E3Fu/bZ;E2FjgcM;IAUM,wBAAA;E3F0/bZ;E2FpgcM;IAUM,8BAAA;E3F6/bZ;E2FvgcM;IAUM,6BAAA;E3FggcZ;E2F1gcM;IAUM,2BAAA;E3FmgcZ;E2F7gcM;IAUM,6BAAA;E3FsgcZ;E2FhhcM;IAUM,2BAAA;E3FygcZ;EMzlcE;IAgCE,2BAAA;EN4jcJ;EMplcE;IA+BI,4BAAA;ENwjcN;EM/lcE;IAgCE,4BAAA;ENkkcJ;EM1lcE;IA+BI,2BAAA;EN8jcN;EMrmcE;IAgCE,6BAAA;ENwkcJ;EMhmcE;IA+BI,6BAAA;ENokcN;AACF;Ac/icI;ER7DA;IAgCE,sBAAA;ENglcJ;EMxmcE;IA+BI,uBAAA;EN4kcN;EMnncE;IAgCE,uBAAA;ENslcJ;EM9mcE;IA+BI,sBAAA;ENklcN;EMzncE;IAgCE,sBAAA;EN4lcJ;EMpncE;IA+BI,sBAAA;ENwlcN;E2FzjcM;IAUM,8BAAA;E3FkjcZ;E2F5jcM;IAUM,4BAAA;E3FqjcZ;E2F/jcM;IAUM,2BAAA;E3FwjcZ;E2FlkcM;IAUM,iCAAA;E3F2jcZ;E2FrkcM;IAUM,2BAAA;E3F8jcZ;E2FxkcM;IAUM,0BAAA;E3FikcZ;E2F3kcM;IAUM,gCAAA;E3FokcZ;E2F9kcM;IAUM,yBAAA;E3FukcZ;E2FjlcM;IAUM,wBAAA;E3F0kcZ;E2FplcM;IAUM,+BAAA;E3F6kcZ;E2FvlcM;IAUM,yBAAA;E3FglcZ;E2F1lcM;IAUM,6BAAA;E3FmlcZ;E2F7lcM;IAUM,8BAAA;E3FslcZ;E2FhmcM;IAUM,wBAAA;E3FylcZ;E2FnmcM;IAUM,+BAAA;E3F4lcZ;E2FtmcM;IAUM,wBAAA;E3F+lcZ;E2FzmcM;IAUM,yBAAA;E3FkmcZ;E2F5mcM;IAUM,8BAAA;E3FqmcZ;E2F/mcM;IAUM,iCAAA;E3FwmcZ;E2FlncM;IAUM,sCAAA;E3F2mcZ;E2FrncM;IAUM,yCAAA;E3F8mcZ;E2FxncM;IAUM,uBAAA;E3FincZ;E2F3ncM;IAUM,uBAAA;E3FoncZ;E2F9ncM;IAUM,yBAAA;E3FuncZ;E2FjocM;IAUM,yBAAA;E3F0ncZ;E2FpocM;IAUM,0BAAA;E3F6ncZ;E2FvocM;IAUM,4BAAA;E3FgocZ;E2F1ocM;IAUM,kCAAA;E3FmocZ;E2F7ocM;IAUM,sCAAA;E3FsocZ;E2FhpcM;IAUM,oCAAA;E3FyocZ;E2FnpcM;IAUM,kCAAA;E3F4ocZ;E2FtpcM;IAUM,yCAAA;E3F+ocZ;E2FzpcM;IAUM,wCAAA;E3FkpcZ;E2F5pcM;IAUM,wCAAA;E3FqpcZ;E2F/pcM;IAUM,kCAAA;E3FwpcZ;E2FlqcM;IAUM,gCAAA;E3F2pcZ;E2FrqcM;IAUM,8BAAA;E3F8pcZ;E2FxqcM;IAUM,gCAAA;E3FiqcZ;E2F3qcM;IAUM,+BAAA;E3FoqcZ;E2F9qcM;IAUM,oCAAA;E3FuqcZ;E2FjrcM;IAUM,kCAAA;E3F0qcZ;E2FprcM;IAUM,gCAAA;E3F6qcZ;E2FvrcM;IAUM,uCAAA;E3FgrcZ;E2F1rcM;IAUM,sCAAA;E3FmrcZ;E2F7rcM;IAUM,iCAAA;E3FsrcZ;E2FhscM;IAUM,2BAAA;E3FyrcZ;E2FnscM;IAUM,iCAAA;E3F4rcZ;E2FtscM;IAUM,+BAAA;E3F+rcZ;E2FzscM;IAUM,6BAAA;E3FkscZ;E2F5scM;IAUM,+BAAA;E3FqscZ;E2F/scM;IAUM,8BAAA;E3FwscZ;E2FltcM;IAUM,oBAAA;E3F2scZ;E2FrtcM;IAUM,mBAAA;E3F8scZ;E2FxtcM;IAUM,mBAAA;E3FitcZ;E2F3tcM;IAUM,mBAAA;E3FotcZ;E2F9tcM;IAUM,mBAAA;E3FutcZ;E2FjucM;IAUM,mBAAA;E3F0tcZ;E2FpucM;IAUM,mBAAA;E3F6tcZ;E2FvucM;IAUM,mBAAA;E3FgucZ;E2F1ucM;IAUM,oBAAA;E3FmucZ;E2F7ucM;IAUM,0BAAA;E3FsucZ;E2FhvcM;IAUM,yBAAA;E3FyucZ;E2FnvcM;IAUM,uBAAA;E3F4ucZ;E2FtvcM;IAUM,yBAAA;E3F+ucZ;E2FzvcM;IAUM,uBAAA;E3FkvcZ;E2F5vcM;IAUM,uBAAA;E3FqvcZ;E2F/vcM;IAUM,0BAAA;IAAA,yBAAA;E3FyvcZ;E2FnwcM;IAUM,gCAAA;IAAA,+BAAA;E3F6vcZ;E2FvwcM;IAUM,+BAAA;IAAA,8BAAA;E3FiwcZ;E2F3wcM;IAUM,6BAAA;IAAA,4BAAA;E3FqwcZ;E2F/wcM;IAUM,+BAAA;IAAA,8BAAA;E3FywcZ;E2FnxcM;IAUM,6BAAA;IAAA,4BAAA;E3F6wcZ;E2FvxcM;IAUM,6BAAA;IAAA,4BAAA;E3FixcZ;E2F3xcM;IAUM,wBAAA;IAAA,2BAAA;E3FqxcZ;E2F/xcM;IAUM,8BAAA;IAAA,iCAAA;E3FyxcZ;E2FnycM;IAUM,6BAAA;IAAA,gCAAA;E3F6xcZ;E2FvycM;IAUM,2BAAA;IAAA,8BAAA;E3FiycZ;E2F3ycM;IAUM,6BAAA;IAAA,gCAAA;E3FqycZ;E2F/ycM;IAUM,2BAAA;IAAA,8BAAA;E3FyycZ;E2FnzcM;IAUM,2BAAA;IAAA,8BAAA;E3F6ycZ;E2FvzcM;IAUM,wBAAA;E3FgzcZ;E2F1zcM;IAUM,8BAAA;E3FmzcZ;E2F7zcM;IAUM,6BAAA;E3FszcZ;E2Fh0cM;IAUM,2BAAA;E3FyzcZ;E2Fn0cM;IAUM,6BAAA;E3F4zcZ;E2Ft0cM;IAUM,2BAAA;E3F+zcZ;E2Fz0cM;IAUM,2BAAA;E3Fk0cZ;EMl5cE;IAgCE,0BAAA;ENq3cJ;EM74cE;IA+BI,yBAAA;ENi3cN;EMx5cE;IAgCE,gCAAA;EN23cJ;EMn5cE;IA+BI,+BAAA;ENu3cN;EM95cE;IAgCE,+BAAA;ENi4cJ;EMz5cE;IA+BI,8BAAA;EN63cN;EMp6cE;IAgCE,6BAAA;ENu4cJ;EM/5cE;IA+BI,4BAAA;ENm4cN;EM16cE;IAgCE,+BAAA;EN64cJ;EMr6cE;IA+BI,8BAAA;ENy4cN;EMh7cE;IAgCE,6BAAA;ENm5cJ;EM36cE;IA+BI,4BAAA;EN+4cN;EMt7cE;IAgCE,6BAAA;ENy5cJ;EMj7cE;IA+BI,4BAAA;ENq5cN;E2Ft3cM;IAUM,2BAAA;E3F+2cZ;E2Fz3cM;IAUM,iCAAA;E3Fk3cZ;E2F53cM;IAUM,gCAAA;E3Fq3cZ;E2F/3cM;IAUM,8BAAA;E3Fw3cZ;E2Fl4cM;IAUM,gCAAA;E3F23cZ;E2Fr4cM;IAUM,8BAAA;E3F83cZ;E2Fx4cM;IAUM,8BAAA;E3Fi4cZ;EMj9cE;IAgCE,yBAAA;ENo7cJ;EM58cE;IA+BI,0BAAA;ENg7cN;EMv9cE;IAgCE,+BAAA;EN07cJ;EMl9cE;IA+BI,gCAAA;ENs7cN;EM79cE;IAgCE,8BAAA;ENg8cJ;EMx9cE;IA+BI,+BAAA;EN47cN;EMn+cE;IAgCE,4BAAA;ENs8cJ;EM99cE;IA+BI,6BAAA;ENk8cN;EMz+cE;IAgCE,8BAAA;EN48cJ;EMp+cE;IA+BI,+BAAA;ENw8cN;EM/+cE;IAgCE,4BAAA;ENk9cJ;EM1+cE;IA+BI,6BAAA;EN88cN;EMr/cE;IAgCE,4BAAA;ENw9cJ;EMh/cE;IA+BI,6BAAA;ENo9cN;E2Fr7cM;IAUM,qBAAA;E3F86cZ;E2Fx7cM;IAUM,2BAAA;E3Fi7cZ;E2F37cM;IAUM,0BAAA;E3Fo7cZ;E2F97cM;IAUM,wBAAA;E3Fu7cZ;E2Fj8cM;IAUM,0BAAA;E3F07cZ;E2Fp8cM;IAUM,wBAAA;E3F67cZ;E2Fv8cM;IAUM,2BAAA;IAAA,0BAAA;E3Fi8cZ;E2F38cM;IAUM,iCAAA;IAAA,gCAAA;E3Fq8cZ;E2F/8cM;IAUM,gCAAA;IAAA,+BAAA;E3Fy8cZ;E2Fn9cM;IAUM,8BAAA;IAAA,6BAAA;E3F68cZ;E2Fv9cM;IAUM,gCAAA;IAAA,+BAAA;E3Fi9cZ;E2F39cM;IAUM,8BAAA;IAAA,6BAAA;E3Fq9cZ;E2F/9cM;IAUM,yBAAA;IAAA,4BAAA;E3Fy9cZ;E2Fn+cM;IAUM,+BAAA;IAAA,kCAAA;E3F69cZ;E2Fv+cM;IAUM,8BAAA;IAAA,iCAAA;E3Fi+cZ;E2F3+cM;IAUM,4BAAA;IAAA,+BAAA;E3Fq+cZ;E2F/+cM;IAUM,8BAAA;IAAA,iCAAA;E3Fy+cZ;E2Fn/cM;IAUM,4BAAA;IAAA,+BAAA;E3F6+cZ;E2Fv/cM;IAUM,yBAAA;E3Fg/cZ;E2F1/cM;IAUM,+BAAA;E3Fm/cZ;E2F7/cM;IAUM,8BAAA;E3Fs/cZ;E2FhgdM;IAUM,4BAAA;E3Fy/cZ;E2FngdM;IAUM,8BAAA;E3F4/cZ;E2FtgdM;IAUM,4BAAA;E3F+/cZ;EM/kdE;IAgCE,2BAAA;ENkjdJ;EM1kdE;IA+BI,0BAAA;EN8idN;EMrldE;IAgCE,iCAAA;ENwjdJ;EMhldE;IA+BI,gCAAA;ENojdN;EM3ldE;IAgCE,gCAAA;EN8jdJ;EMtldE;IA+BI,+BAAA;EN0jdN;EMjmdE;IAgCE,8BAAA;ENokdJ;EM5ldE;IA+BI,6BAAA;ENgkdN;EMvmdE;IAgCE,gCAAA;EN0kdJ;EMlmdE;IA+BI,+BAAA;ENskdN;EM7mdE;IAgCE,8BAAA;ENgldJ;EMxmdE;IA+BI,6BAAA;EN4kdN;E2F7idM;IAUM,4BAAA;E3FsidZ;E2FhjdM;IAUM,kCAAA;E3FyidZ;E2FnjdM;IAUM,iCAAA;E3F4idZ;E2FtjdM;IAUM,+BAAA;E3F+idZ;E2FzjdM;IAUM,iCAAA;E3FkjdZ;E2F5jdM;IAUM,+BAAA;E3FqjdZ;EMrodE;IAgCE,0BAAA;ENwmdJ;EMhodE;IA+BI,2BAAA;ENomdN;EM3odE;IAgCE,gCAAA;EN8mdJ;EMtodE;IA+BI,iCAAA;EN0mdN;EMjpdE;IAgCE,+BAAA;ENondJ;EM5odE;IA+BI,gCAAA;ENgndN;EMvpdE;IAgCE,6BAAA;EN0ndJ;EMlpdE;IA+BI,8BAAA;ENsndN;EM7pdE;IAgCE,+BAAA;ENgodJ;EMxpdE;IA+BI,gCAAA;EN4ndN;EMnqdE;IAgCE,6BAAA;ENsodJ;EM9pdE;IA+BI,8BAAA;ENkodN;E2FnmdM;IAUM,iBAAA;E3F4ldZ;E2FtmdM;IAUM,uBAAA;E3F+ldZ;E2FzmdM;IAUM,sBAAA;E3FkmdZ;E2F5mdM;IAUM,oBAAA;E3FqmdZ;E2F/mdM;IAUM,sBAAA;E3FwmdZ;E2FlndM;IAUM,oBAAA;E3F2mdZ;E2FrndM;IAUM,qBAAA;E3F8mdZ;E2FxndM;IAUM,2BAAA;E3FindZ;E2F3ndM;IAUM,0BAAA;E3FondZ;E2F9ndM;IAUM,wBAAA;E3FundZ;E2FjodM;IAUM,0BAAA;E3F0ndZ;E2FpodM;IAUM,wBAAA;E3F6ndZ;E2FvodM;IAUM,wBAAA;E3FgodZ;E2F1odM;IAUM,8BAAA;E3FmodZ;E2F7odM;IAUM,6BAAA;E3FsodZ;E2FhpdM;IAUM,2BAAA;E3FyodZ;E2FnpdM;IAUM,6BAAA;E3F4odZ;E2FtpdM;IAUM,2BAAA;E3F+odZ;EM/tdE;IAgCE,2BAAA;ENksdJ;EM1tdE;IA+BI,4BAAA;EN8rdN;EMrudE;IAgCE,4BAAA;ENwsdJ;EMhudE;IA+BI,2BAAA;ENosdN;EM3udE;IAgCE,6BAAA;EN8sdJ;EMtudE;IA+BI,6BAAA;EN0sdN;AACF;AcrrdI;ER7DA;IAgCE,sBAAA;ENstdJ;EM9udE;IA+BI,uBAAA;ENktdN;EMzvdE;IAgCE,uBAAA;EN4tdJ;EMpvdE;IA+BI,sBAAA;ENwtdN;EM/vdE;IAgCE,sBAAA;ENkudJ;EM1vdE;IA+BI,sBAAA;EN8tdN;E2F/rdM;IAUM,8BAAA;E3FwrdZ;E2FlsdM;IAUM,4BAAA;E3F2rdZ;E2FrsdM;IAUM,2BAAA;E3F8rdZ;E2FxsdM;IAUM,iCAAA;E3FisdZ;E2F3sdM;IAUM,2BAAA;E3FosdZ;E2F9sdM;IAUM,0BAAA;E3FusdZ;E2FjtdM;IAUM,gCAAA;E3F0sdZ;E2FptdM;IAUM,yBAAA;E3F6sdZ;E2FvtdM;IAUM,wBAAA;E3FgtdZ;E2F1tdM;IAUM,+BAAA;E3FmtdZ;E2F7tdM;IAUM,yBAAA;E3FstdZ;E2FhudM;IAUM,6BAAA;E3FytdZ;E2FnudM;IAUM,8BAAA;E3F4tdZ;E2FtudM;IAUM,wBAAA;E3F+tdZ;E2FzudM;IAUM,+BAAA;E3FkudZ;E2F5udM;IAUM,wBAAA;E3FqudZ;E2F/udM;IAUM,yBAAA;E3FwudZ;E2FlvdM;IAUM,8BAAA;E3F2udZ;E2FrvdM;IAUM,iCAAA;E3F8udZ;E2FxvdM;IAUM,sCAAA;E3FivdZ;E2F3vdM;IAUM,yCAAA;E3FovdZ;E2F9vdM;IAUM,uBAAA;E3FuvdZ;E2FjwdM;IAUM,uBAAA;E3F0vdZ;E2FpwdM;IAUM,yBAAA;E3F6vdZ;E2FvwdM;IAUM,yBAAA;E3FgwdZ;E2F1wdM;IAUM,0BAAA;E3FmwdZ;E2F7wdM;IAUM,4BAAA;E3FswdZ;E2FhxdM;IAUM,kCAAA;E3FywdZ;E2FnxdM;IAUM,sCAAA;E3F4wdZ;E2FtxdM;IAUM,oCAAA;E3F+wdZ;E2FzxdM;IAUM,kCAAA;E3FkxdZ;E2F5xdM;IAUM,yCAAA;E3FqxdZ;E2F/xdM;IAUM,wCAAA;E3FwxdZ;E2FlydM;IAUM,wCAAA;E3F2xdZ;E2FrydM;IAUM,kCAAA;E3F8xdZ;E2FxydM;IAUM,gCAAA;E3FiydZ;E2F3ydM;IAUM,8BAAA;E3FoydZ;E2F9ydM;IAUM,gCAAA;E3FuydZ;E2FjzdM;IAUM,+BAAA;E3F0ydZ;E2FpzdM;IAUM,oCAAA;E3F6ydZ;E2FvzdM;IAUM,kCAAA;E3FgzdZ;E2F1zdM;IAUM,gCAAA;E3FmzdZ;E2F7zdM;IAUM,uCAAA;E3FszdZ;E2Fh0dM;IAUM,sCAAA;E3FyzdZ;E2Fn0dM;IAUM,iCAAA;E3F4zdZ;E2Ft0dM;IAUM,2BAAA;E3F+zdZ;E2Fz0dM;IAUM,iCAAA;E3Fk0dZ;E2F50dM;IAUM,+BAAA;E3Fq0dZ;E2F/0dM;IAUM,6BAAA;E3Fw0dZ;E2Fl1dM;IAUM,+BAAA;E3F20dZ;E2Fr1dM;IAUM,8BAAA;E3F80dZ;E2Fx1dM;IAUM,oBAAA;E3Fi1dZ;E2F31dM;IAUM,mBAAA;E3Fo1dZ;E2F91dM;IAUM,mBAAA;E3Fu1dZ;E2Fj2dM;IAUM,mBAAA;E3F01dZ;E2Fp2dM;IAUM,mBAAA;E3F61dZ;E2Fv2dM;IAUM,mBAAA;E3Fg2dZ;E2F12dM;IAUM,mBAAA;E3Fm2dZ;E2F72dM;IAUM,mBAAA;E3Fs2dZ;E2Fh3dM;IAUM,oBAAA;E3Fy2dZ;E2Fn3dM;IAUM,0BAAA;E3F42dZ;E2Ft3dM;IAUM,yBAAA;E3F+2dZ;E2Fz3dM;IAUM,uBAAA;E3Fk3dZ;E2F53dM;IAUM,yBAAA;E3Fq3dZ;E2F/3dM;IAUM,uBAAA;E3Fw3dZ;E2Fl4dM;IAUM,uBAAA;E3F23dZ;E2Fr4dM;IAUM,0BAAA;IAAA,yBAAA;E3F+3dZ;E2Fz4dM;IAUM,gCAAA;IAAA,+BAAA;E3Fm4dZ;E2F74dM;IAUM,+BAAA;IAAA,8BAAA;E3Fu4dZ;E2Fj5dM;IAUM,6BAAA;IAAA,4BAAA;E3F24dZ;E2Fr5dM;IAUM,+BAAA;IAAA,8BAAA;E3F+4dZ;E2Fz5dM;IAUM,6BAAA;IAAA,4BAAA;E3Fm5dZ;E2F75dM;IAUM,6BAAA;IAAA,4BAAA;E3Fu5dZ;E2Fj6dM;IAUM,wBAAA;IAAA,2BAAA;E3F25dZ;E2Fr6dM;IAUM,8BAAA;IAAA,iCAAA;E3F+5dZ;E2Fz6dM;IAUM,6BAAA;IAAA,gCAAA;E3Fm6dZ;E2F76dM;IAUM,2BAAA;IAAA,8BAAA;E3Fu6dZ;E2Fj7dM;IAUM,6BAAA;IAAA,gCAAA;E3F26dZ;E2Fr7dM;IAUM,2BAAA;IAAA,8BAAA;E3F+6dZ;E2Fz7dM;IAUM,2BAAA;IAAA,8BAAA;E3Fm7dZ;E2F77dM;IAUM,wBAAA;E3Fs7dZ;E2Fh8dM;IAUM,8BAAA;E3Fy7dZ;E2Fn8dM;IAUM,6BAAA;E3F47dZ;E2Ft8dM;IAUM,2BAAA;E3F+7dZ;E2Fz8dM;IAUM,6BAAA;E3Fk8dZ;E2F58dM;IAUM,2BAAA;E3Fq8dZ;E2F/8dM;IAUM,2BAAA;E3Fw8dZ;EMxheE;IAgCE,0BAAA;EN2/dJ;EMnheE;IA+BI,yBAAA;ENu/dN;EM9heE;IAgCE,gCAAA;ENigeJ;EMzheE;IA+BI,+BAAA;EN6/dN;EMpieE;IAgCE,+BAAA;ENugeJ;EM/heE;IA+BI,8BAAA;ENmgeN;EM1ieE;IAgCE,6BAAA;EN6geJ;EMrieE;IA+BI,4BAAA;ENygeN;EMhjeE;IAgCE,+BAAA;ENmheJ;EM3ieE;IA+BI,8BAAA;EN+geN;EMtjeE;IAgCE,6BAAA;ENyheJ;EMjjeE;IA+BI,4BAAA;ENqheN;EM5jeE;IAgCE,6BAAA;EN+heJ;EMvjeE;IA+BI,4BAAA;EN2heN;E2F5/dM;IAUM,2BAAA;E3Fq/dZ;E2F//dM;IAUM,iCAAA;E3Fw/dZ;E2FlgeM;IAUM,gCAAA;E3F2/dZ;E2FrgeM;IAUM,8BAAA;E3F8/dZ;E2FxgeM;IAUM,gCAAA;E3FigeZ;E2F3geM;IAUM,8BAAA;E3FogeZ;E2F9geM;IAUM,8BAAA;E3FugeZ;EMvleE;IAgCE,yBAAA;EN0jeJ;EMlleE;IA+BI,0BAAA;ENsjeN;EM7leE;IAgCE,+BAAA;ENgkeJ;EMxleE;IA+BI,gCAAA;EN4jeN;EMnmeE;IAgCE,8BAAA;ENskeJ;EM9leE;IA+BI,+BAAA;ENkkeN;EMzmeE;IAgCE,4BAAA;EN4keJ;EMpmeE;IA+BI,6BAAA;ENwkeN;EM/meE;IAgCE,8BAAA;ENkleJ;EM1meE;IA+BI,+BAAA;EN8keN;EMrneE;IAgCE,4BAAA;ENwleJ;EMhneE;IA+BI,6BAAA;ENoleN;EM3neE;IAgCE,4BAAA;EN8leJ;EMtneE;IA+BI,6BAAA;EN0leN;E2F3jeM;IAUM,qBAAA;E3FojeZ;E2F9jeM;IAUM,2BAAA;E3FujeZ;E2FjkeM;IAUM,0BAAA;E3F0jeZ;E2FpkeM;IAUM,wBAAA;E3F6jeZ;E2FvkeM;IAUM,0BAAA;E3FgkeZ;E2F1keM;IAUM,wBAAA;E3FmkeZ;E2F7keM;IAUM,2BAAA;IAAA,0BAAA;E3FukeZ;E2FjleM;IAUM,iCAAA;IAAA,gCAAA;E3F2keZ;E2FrleM;IAUM,gCAAA;IAAA,+BAAA;E3F+keZ;E2FzleM;IAUM,8BAAA;IAAA,6BAAA;E3FmleZ;E2F7leM;IAUM,gCAAA;IAAA,+BAAA;E3FuleZ;E2FjmeM;IAUM,8BAAA;IAAA,6BAAA;E3F2leZ;E2FrmeM;IAUM,yBAAA;IAAA,4BAAA;E3F+leZ;E2FzmeM;IAUM,+BAAA;IAAA,kCAAA;E3FmmeZ;E2F7meM;IAUM,8BAAA;IAAA,iCAAA;E3FumeZ;E2FjneM;IAUM,4BAAA;IAAA,+BAAA;E3F2meZ;E2FrneM;IAUM,8BAAA;IAAA,iCAAA;E3F+meZ;E2FzneM;IAUM,4BAAA;IAAA,+BAAA;E3FmneZ;E2F7neM;IAUM,yBAAA;E3FsneZ;E2FhoeM;IAUM,+BAAA;E3FyneZ;E2FnoeM;IAUM,8BAAA;E3F4neZ;E2FtoeM;IAUM,4BAAA;E3F+neZ;E2FzoeM;IAUM,8BAAA;E3FkoeZ;E2F5oeM;IAUM,4BAAA;E3FqoeZ;EMrteE;IAgCE,2BAAA;ENwreJ;EMhteE;IA+BI,0BAAA;ENoreN;EM3teE;IAgCE,iCAAA;EN8reJ;EMtteE;IA+BI,gCAAA;EN0reN;EMjueE;IAgCE,gCAAA;ENoseJ;EM5teE;IA+BI,+BAAA;ENgseN;EMvueE;IAgCE,8BAAA;EN0seJ;EMlueE;IA+BI,6BAAA;ENsseN;EM7ueE;IAgCE,gCAAA;ENgteJ;EMxueE;IA+BI,+BAAA;EN4seN;EMnveE;IAgCE,8BAAA;ENsteJ;EM9ueE;IA+BI,6BAAA;ENkteN;E2FnreM;IAUM,4BAAA;E3F4qeZ;E2FtreM;IAUM,kCAAA;E3F+qeZ;E2FzreM;IAUM,iCAAA;E3FkreZ;E2F5reM;IAUM,+BAAA;E3FqreZ;E2F/reM;IAUM,iCAAA;E3FwreZ;E2FlseM;IAUM,+BAAA;E3F2reZ;EM3weE;IAgCE,0BAAA;EN8ueJ;EMtweE;IA+BI,2BAAA;EN0ueN;EMjxeE;IAgCE,gCAAA;ENoveJ;EM5weE;IA+BI,iCAAA;ENgveN;EMvxeE;IAgCE,+BAAA;EN0veJ;EMlxeE;IA+BI,gCAAA;ENsveN;EM7xeE;IAgCE,6BAAA;ENgweJ;EMxxeE;IA+BI,8BAAA;EN4veN;EMnyeE;IAgCE,+BAAA;ENsweJ;EM9xeE;IA+BI,gCAAA;ENkweN;EMzyeE;IAgCE,6BAAA;EN4weJ;EMpyeE;IA+BI,8BAAA;ENwweN;E2FzueM;IAUM,iBAAA;E3FkueZ;E2F5ueM;IAUM,uBAAA;E3FqueZ;E2F/ueM;IAUM,sBAAA;E3FwueZ;E2FlveM;IAUM,oBAAA;E3F2ueZ;E2FrveM;IAUM,sBAAA;E3F8ueZ;E2FxveM;IAUM,oBAAA;E3FiveZ;E2F3veM;IAUM,qBAAA;E3FoveZ;E2F9veM;IAUM,2BAAA;E3FuveZ;E2FjweM;IAUM,0BAAA;E3F0veZ;E2FpweM;IAUM,wBAAA;E3F6veZ;E2FvweM;IAUM,0BAAA;E3FgweZ;E2F1weM;IAUM,wBAAA;E3FmweZ;E2F7weM;IAUM,wBAAA;E3FsweZ;E2FhxeM;IAUM,8BAAA;E3FyweZ;E2FnxeM;IAUM,6BAAA;E3F4weZ;E2FtxeM;IAUM,2BAAA;E3F+weZ;E2FzxeM;IAUM,6BAAA;E3FkxeZ;E2F5xeM;IAUM,2BAAA;E3FqxeZ;EMr2eE;IAgCE,2BAAA;ENw0eJ;EMh2eE;IA+BI,4BAAA;ENo0eN;EM32eE;IAgCE,4BAAA;EN80eJ;EMt2eE;IA+BI,2BAAA;EN00eN;EMj3eE;IAgCE,6BAAA;ENo1eJ;EM52eE;IA+BI,6BAAA;ENg1eN;AACF;Ac3zeI;ER7DA;IAgCE,sBAAA;EN41eJ;EMp3eE;IA+BI,uBAAA;ENw1eN;EM/3eE;IAgCE,uBAAA;ENk2eJ;EM13eE;IA+BI,sBAAA;EN81eN;EMr4eE;IAgCE,sBAAA;ENw2eJ;EMh4eE;IA+BI,sBAAA;ENo2eN;E2Fr0eM;IAUM,8BAAA;E3F8zeZ;E2Fx0eM;IAUM,4BAAA;E3Fi0eZ;E2F30eM;IAUM,2BAAA;E3Fo0eZ;E2F90eM;IAUM,iCAAA;E3Fu0eZ;E2Fj1eM;IAUM,2BAAA;E3F00eZ;E2Fp1eM;IAUM,0BAAA;E3F60eZ;E2Fv1eM;IAUM,gCAAA;E3Fg1eZ;E2F11eM;IAUM,yBAAA;E3Fm1eZ;E2F71eM;IAUM,wBAAA;E3Fs1eZ;E2Fh2eM;IAUM,+BAAA;E3Fy1eZ;E2Fn2eM;IAUM,yBAAA;E3F41eZ;E2Ft2eM;IAUM,6BAAA;E3F+1eZ;E2Fz2eM;IAUM,8BAAA;E3Fk2eZ;E2F52eM;IAUM,wBAAA;E3Fq2eZ;E2F/2eM;IAUM,+BAAA;E3Fw2eZ;E2Fl3eM;IAUM,wBAAA;E3F22eZ;E2Fr3eM;IAUM,yBAAA;E3F82eZ;E2Fx3eM;IAUM,8BAAA;E3Fi3eZ;E2F33eM;IAUM,iCAAA;E3Fo3eZ;E2F93eM;IAUM,sCAAA;E3Fu3eZ;E2Fj4eM;IAUM,yCAAA;E3F03eZ;E2Fp4eM;IAUM,uBAAA;E3F63eZ;E2Fv4eM;IAUM,uBAAA;E3Fg4eZ;E2F14eM;IAUM,yBAAA;E3Fm4eZ;E2F74eM;IAUM,yBAAA;E3Fs4eZ;E2Fh5eM;IAUM,0BAAA;E3Fy4eZ;E2Fn5eM;IAUM,4BAAA;E3F44eZ;E2Ft5eM;IAUM,kCAAA;E3F+4eZ;E2Fz5eM;IAUM,sCAAA;E3Fk5eZ;E2F55eM;IAUM,oCAAA;E3Fq5eZ;E2F/5eM;IAUM,kCAAA;E3Fw5eZ;E2Fl6eM;IAUM,yCAAA;E3F25eZ;E2Fr6eM;IAUM,wCAAA;E3F85eZ;E2Fx6eM;IAUM,wCAAA;E3Fi6eZ;E2F36eM;IAUM,kCAAA;E3Fo6eZ;E2F96eM;IAUM,gCAAA;E3Fu6eZ;E2Fj7eM;IAUM,8BAAA;E3F06eZ;E2Fp7eM;IAUM,gCAAA;E3F66eZ;E2Fv7eM;IAUM,+BAAA;E3Fg7eZ;E2F17eM;IAUM,oCAAA;E3Fm7eZ;E2F77eM;IAUM,kCAAA;E3Fs7eZ;E2Fh8eM;IAUM,gCAAA;E3Fy7eZ;E2Fn8eM;IAUM,uCAAA;E3F47eZ;E2Ft8eM;IAUM,sCAAA;E3F+7eZ;E2Fz8eM;IAUM,iCAAA;E3Fk8eZ;E2F58eM;IAUM,2BAAA;E3Fq8eZ;E2F/8eM;IAUM,iCAAA;E3Fw8eZ;E2Fl9eM;IAUM,+BAAA;E3F28eZ;E2Fr9eM;IAUM,6BAAA;E3F88eZ;E2Fx9eM;IAUM,+BAAA;E3Fi9eZ;E2F39eM;IAUM,8BAAA;E3Fo9eZ;E2F99eM;IAUM,oBAAA;E3Fu9eZ;E2Fj+eM;IAUM,mBAAA;E3F09eZ;E2Fp+eM;IAUM,mBAAA;E3F69eZ;E2Fv+eM;IAUM,mBAAA;E3Fg+eZ;E2F1+eM;IAUM,mBAAA;E3Fm+eZ;E2F7+eM;IAUM,mBAAA;E3Fs+eZ;E2Fh/eM;IAUM,mBAAA;E3Fy+eZ;E2Fn/eM;IAUM,mBAAA;E3F4+eZ;E2Ft/eM;IAUM,oBAAA;E3F++eZ;E2Fz/eM;IAUM,0BAAA;E3Fk/eZ;E2F5/eM;IAUM,yBAAA;E3Fq/eZ;E2F//eM;IAUM,uBAAA;E3Fw/eZ;E2FlgfM;IAUM,yBAAA;E3F2/eZ;E2FrgfM;IAUM,uBAAA;E3F8/eZ;E2FxgfM;IAUM,uBAAA;E3FigfZ;E2F3gfM;IAUM,0BAAA;IAAA,yBAAA;E3FqgfZ;E2F/gfM;IAUM,gCAAA;IAAA,+BAAA;E3FygfZ;E2FnhfM;IAUM,+BAAA;IAAA,8BAAA;E3F6gfZ;E2FvhfM;IAUM,6BAAA;IAAA,4BAAA;E3FihfZ;E2F3hfM;IAUM,+BAAA;IAAA,8BAAA;E3FqhfZ;E2F/hfM;IAUM,6BAAA;IAAA,4BAAA;E3FyhfZ;E2FnifM;IAUM,6BAAA;IAAA,4BAAA;E3F6hfZ;E2FvifM;IAUM,wBAAA;IAAA,2BAAA;E3FiifZ;E2F3ifM;IAUM,8BAAA;IAAA,iCAAA;E3FqifZ;E2F/ifM;IAUM,6BAAA;IAAA,gCAAA;E3FyifZ;E2FnjfM;IAUM,2BAAA;IAAA,8BAAA;E3F6ifZ;E2FvjfM;IAUM,6BAAA;IAAA,gCAAA;E3FijfZ;E2F3jfM;IAUM,2BAAA;IAAA,8BAAA;E3FqjfZ;E2F/jfM;IAUM,2BAAA;IAAA,8BAAA;E3FyjfZ;E2FnkfM;IAUM,wBAAA;E3F4jfZ;E2FtkfM;IAUM,8BAAA;E3F+jfZ;E2FzkfM;IAUM,6BAAA;E3FkkfZ;E2F5kfM;IAUM,2BAAA;E3FqkfZ;E2F/kfM;IAUM,6BAAA;E3FwkfZ;E2FllfM;IAUM,2BAAA;E3F2kfZ;E2FrlfM;IAUM,2BAAA;E3F8kfZ;EM9pfE;IAgCE,0BAAA;ENiofJ;EMzpfE;IA+BI,yBAAA;EN6nfN;EMpqfE;IAgCE,gCAAA;ENuofJ;EM/pfE;IA+BI,+BAAA;ENmofN;EM1qfE;IAgCE,+BAAA;EN6ofJ;EMrqfE;IA+BI,8BAAA;ENyofN;EMhrfE;IAgCE,6BAAA;ENmpfJ;EM3qfE;IA+BI,4BAAA;EN+ofN;EMtrfE;IAgCE,+BAAA;ENypfJ;EMjrfE;IA+BI,8BAAA;ENqpfN;EM5rfE;IAgCE,6BAAA;EN+pfJ;EMvrfE;IA+BI,4BAAA;EN2pfN;EMlsfE;IAgCE,6BAAA;ENqqfJ;EM7rfE;IA+BI,4BAAA;ENiqfN;E2FlofM;IAUM,2BAAA;E3F2nfZ;E2FrofM;IAUM,iCAAA;E3F8nfZ;E2FxofM;IAUM,gCAAA;E3FiofZ;E2F3ofM;IAUM,8BAAA;E3FoofZ;E2F9ofM;IAUM,gCAAA;E3FuofZ;E2FjpfM;IAUM,8BAAA;E3F0ofZ;E2FppfM;IAUM,8BAAA;E3F6ofZ;EM7tfE;IAgCE,yBAAA;ENgsfJ;EMxtfE;IA+BI,0BAAA;EN4rfN;EMnufE;IAgCE,+BAAA;ENssfJ;EM9tfE;IA+BI,gCAAA;ENksfN;EMzufE;IAgCE,8BAAA;EN4sfJ;EMpufE;IA+BI,+BAAA;ENwsfN;EM/ufE;IAgCE,4BAAA;ENktfJ;EM1ufE;IA+BI,6BAAA;EN8sfN;EMrvfE;IAgCE,8BAAA;ENwtfJ;EMhvfE;IA+BI,+BAAA;ENotfN;EM3vfE;IAgCE,4BAAA;EN8tfJ;EMtvfE;IA+BI,6BAAA;EN0tfN;EMjwfE;IAgCE,4BAAA;ENoufJ;EM5vfE;IA+BI,6BAAA;ENgufN;E2FjsfM;IAUM,qBAAA;E3F0rfZ;E2FpsfM;IAUM,2BAAA;E3F6rfZ;E2FvsfM;IAUM,0BAAA;E3FgsfZ;E2F1sfM;IAUM,wBAAA;E3FmsfZ;E2F7sfM;IAUM,0BAAA;E3FssfZ;E2FhtfM;IAUM,wBAAA;E3FysfZ;E2FntfM;IAUM,2BAAA;IAAA,0BAAA;E3F6sfZ;E2FvtfM;IAUM,iCAAA;IAAA,gCAAA;E3FitfZ;E2F3tfM;IAUM,gCAAA;IAAA,+BAAA;E3FqtfZ;E2F/tfM;IAUM,8BAAA;IAAA,6BAAA;E3FytfZ;E2FnufM;IAUM,gCAAA;IAAA,+BAAA;E3F6tfZ;E2FvufM;IAUM,8BAAA;IAAA,6BAAA;E3FiufZ;E2F3ufM;IAUM,yBAAA;IAAA,4BAAA;E3FqufZ;E2F/ufM;IAUM,+BAAA;IAAA,kCAAA;E3FyufZ;E2FnvfM;IAUM,8BAAA;IAAA,iCAAA;E3F6ufZ;E2FvvfM;IAUM,4BAAA;IAAA,+BAAA;E3FivfZ;E2F3vfM;IAUM,8BAAA;IAAA,iCAAA;E3FqvfZ;E2F/vfM;IAUM,4BAAA;IAAA,+BAAA;E3FyvfZ;E2FnwfM;IAUM,yBAAA;E3F4vfZ;E2FtwfM;IAUM,+BAAA;E3F+vfZ;E2FzwfM;IAUM,8BAAA;E3FkwfZ;E2F5wfM;IAUM,4BAAA;E3FqwfZ;E2F/wfM;IAUM,8BAAA;E3FwwfZ;E2FlxfM;IAUM,4BAAA;E3F2wfZ;EM31fE;IAgCE,2BAAA;EN8zfJ;EMt1fE;IA+BI,0BAAA;EN0zfN;EMj2fE;IAgCE,iCAAA;ENo0fJ;EM51fE;IA+BI,gCAAA;ENg0fN;EMv2fE;IAgCE,gCAAA;EN00fJ;EMl2fE;IA+BI,+BAAA;ENs0fN;EM72fE;IAgCE,8BAAA;ENg1fJ;EMx2fE;IA+BI,6BAAA;EN40fN;EMn3fE;IAgCE,gCAAA;ENs1fJ;EM92fE;IA+BI,+BAAA;ENk1fN;EMz3fE;IAgCE,8BAAA;EN41fJ;EMp3fE;IA+BI,6BAAA;ENw1fN;E2FzzfM;IAUM,4BAAA;E3FkzfZ;E2F5zfM;IAUM,kCAAA;E3FqzfZ;E2F/zfM;IAUM,iCAAA;E3FwzfZ;E2Fl0fM;IAUM,+BAAA;E3F2zfZ;E2Fr0fM;IAUM,iCAAA;E3F8zfZ;E2Fx0fM;IAUM,+BAAA;E3Fi0fZ;EMj5fE;IAgCE,0BAAA;ENo3fJ;EM54fE;IA+BI,2BAAA;ENg3fN;EMv5fE;IAgCE,gCAAA;EN03fJ;EMl5fE;IA+BI,iCAAA;ENs3fN;EM75fE;IAgCE,+BAAA;ENg4fJ;EMx5fE;IA+BI,gCAAA;EN43fN;EMn6fE;IAgCE,6BAAA;ENs4fJ;EM95fE;IA+BI,8BAAA;ENk4fN;EMz6fE;IAgCE,+BAAA;EN44fJ;EMp6fE;IA+BI,gCAAA;ENw4fN;EM/6fE;IAgCE,6BAAA;ENk5fJ;EM16fE;IA+BI,8BAAA;EN84fN;E2F/2fM;IAUM,iBAAA;E3Fw2fZ;E2Fl3fM;IAUM,uBAAA;E3F22fZ;E2Fr3fM;IAUM,sBAAA;E3F82fZ;E2Fx3fM;IAUM,oBAAA;E3Fi3fZ;E2F33fM;IAUM,sBAAA;E3Fo3fZ;E2F93fM;IAUM,oBAAA;E3Fu3fZ;E2Fj4fM;IAUM,qBAAA;E3F03fZ;E2Fp4fM;IAUM,2BAAA;E3F63fZ;E2Fv4fM;IAUM,0BAAA;E3Fg4fZ;E2F14fM;IAUM,wBAAA;E3Fm4fZ;E2F74fM;IAUM,0BAAA;E3Fs4fZ;E2Fh5fM;IAUM,wBAAA;E3Fy4fZ;E2Fn5fM;IAUM,wBAAA;E3F44fZ;E2Ft5fM;IAUM,8BAAA;E3F+4fZ;E2Fz5fM;IAUM,6BAAA;E3Fk5fZ;E2F55fM;IAUM,2BAAA;E3Fq5fZ;E2F/5fM;IAUM,6BAAA;E3Fw5fZ;E2Fl6fM;IAUM,2BAAA;E3F25fZ;EM3+fE;IAgCE,2BAAA;EN88fJ;EMt+fE;IA+BI,4BAAA;EN08fN;EMj/fE;IAgCE,4BAAA;ENo9fJ;EM5+fE;IA+BI,2BAAA;ENg9fN;EMv/fE;IAgCE,6BAAA;EN09fJ;EMl/fE;IA+BI,6BAAA;ENs9fN;AACF;A4F7+fA;EDqDQ;IAUM,4BAAA;E3Fk7fZ;E2F57fM;IAUM,0BAAA;E3Fq7fZ;E2F/7fM;IAUM,6BAAA;E3Fw7fZ;E2Fl8fM;IAUM,4BAAA;E3F27fZ;AACF;A4Fx+fA;EDkCQ;IAUM,0BAAA;E3Fg8fZ;E2F18fM;IAUM,gCAAA;E3Fm8fZ;E2F78fM;IAUM,yBAAA;E3Fs8fZ;E2Fh9fM;IAUM,wBAAA;E3Fy8fZ;E2Fn9fM;IAUM,+BAAA;E3F48fZ;E2Ft9fM;IAUM,yBAAA;E3F+8fZ;E2Fz9fM;IAUM,6BAAA;E3Fk9fZ;E2F59fM;IAUM,8BAAA;E3Fq9fZ;E2F/9fM;IAUM,wBAAA;E3Fw9fZ;E2Fl+fM;IAUM,+BAAA;E3F29fZ;E2Fr+fM;IAUM,wBAAA;E3F89fZ;AACF;A6FhjgBE;EtE+CA,6CAAA;EACA,qHAAA;AvBoggBF;;A6FpjgBE;EtE+CA,4CAAA;EACA,sHAAA;AvByggBF;;A6FzjgBE;EtE+CA,6CAAA;EACA,qHAAA;AvB8ggBF;;A6F9jgBE;EtE+CA,0CAAA;EACA,4GAAA;AvBmhgBF;;A6FnkgBE;EtE+CA,6CAAA;EACA,qHAAA;AvBwhgBF;;A6FxkgBE;EtE+CA,4CAAA;EACA,mHAAA;AvB6hgBF;;A6F7kgBE;EtE+CA,wCAAA;EACA,8GAAA;AvBkigBF;;A6FllgBE;EtE+CA,0CAAA;EACA,+GAAA;AvBuigBF;;A8F/kgBA;ECkBQ,sBAAA;EAAA,2CAAA;EAAA,mCAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,yCAAA;EAAA,8CAAA;EAAA,yBAAA;EAAA,+BAAA;EARJ,yBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,wCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,0CAAA;EAAA,oCAAA;A/FimgBJ;AgGnngBA;EAEI,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,qCAAA;EAAA,+BAAA;EAIA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,wBAAA;EAGF,mCAAA;EACA,6BAAA;EAEA,yBAAA;EACA,mCAAA;EAIE,4BAAA;EACA,2BAAA;EADA,8BAAA;EACA,2BAAA;EADA,4BAAA;EACA,2BAAA;EADA,yBAAA;EACA,wBAAA;EADA,4BAAA;EACA,2BAAA;EADA,2BAAA;EACA,0BAAA;EADA,0BAAA;EACA,uBAAA;EADA,yBAAA;EACA,wBAAA;AhGuogBJ;A+F5mgBM;EAnBE,uDAAA;EAAA,sCAAA;EAAA,+BAAA;EAAA,gDAAA;EAAA,wDAAA;EAAA,4DAAA;EAAA,4CAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,4EAAA;A/F2ogBR;A+FxngBM;EAnBE,yDAAA;EAAA,uDAAA;A/F+ogBR;A+F5ngBM;EAnBE,gDAAA;EAAA,4DAAA;A/FmpgBR;A+FhogBM;EAnBE,6BAAA;EAAA,mCAAA;EAAA,wDAAA;A/FwpgBR;A+FrogBM;EAnBE,+DAAA;EAAA,wDAAA;EAAA,4CAAA;EAAA,gEAAA;EAAA,kDAAA;EAAA,6DAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,2CAAA;EAAA,qDAAA;A/FoqgBR;A+FjpgBM;EAnBE,6EAAA;A/FuqgBR;A+FppgBM;EAnBE,sBAAA;EAAA,mDAAA;EAAA,0BAAA;A/F4qgBR;A+FzpgBM;EAnBE,+CAAA;EAAA,uDAAA;EAAA,0BAAA;EAAA,qDAAA;EAAA,oDAAA;EAAA,0DAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,4DAAA;EAAA,sDAAA;A/FyrgBR;A+FtqgBM;EAnBE,wBAAA;EAAA,6CAAA;EAAA,4BAAA;EAAA,sCAAA;A/F+rgBR;A+F5qgBM;EAnBE,4CAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,kDAAA;EAAA,+CAAA;EAAA,wDAAA;EAAA,4CAAA;EAAA,uDAAA;EAAA,sDAAA;EAAA,+CAAA;A/F2sgBR;A+FxrgBM;EAnBE,0CAAA;EAAA,gDAAA;EAAA,oDAAA;A/FgtgBR;A+F7rgBM;EAnBE,kDAAA;EAAA,+CAAA;EAAA,yDAAA;EAAA,8DAAA;EAAA,kDAAA;A/FutgBR;A+FpsgBM;EAnBE,wDAAA;EAAA,qDAAA;EAAA,+DAAA;EAAA,iEAAA;EAAA,wDAAA;EAAA,8DAAA;EAAA,2DAAA;EAAA,oEAAA;EAAA,wDAAA;EAAA,mEAAA;EAAA,+DAAA;EAAA,8CAAA;EAAA,sEAAA;EAAA,4EAAA;EAAA,kFAAA;EAAA,kFAAA;EAAA,uEAAA;EAAA,kEAAA;EAAA,kDAAA;EAAA,yEAAA;EAAA,wDAAA;EAAA,0EAAA;EAAA,gEAAA;EAAA,2CAAA;EAAA,uEAAA;EAAA,qEAAA;EAAA,iEAAA;EAAA,oEAAA;A/FqvgBR;A+FlugBM;EAnBE,wBAAA;EAAA,6CAAA;EAAA,kDAAA;EAAA,+BAAA;EAAA,sDAAA;EAAA,8BAAA;EAAA,oCAAA;EAAA,qDAAA;EAAA,sCAAA;EAAA,sEAAA;EAAA,4EAAA;EAAA,2DAAA;EAAA,2DAAA;A/FowgBR;A+F5xgBW;EAQH,sBAAA;A/FuxgBR;;A+FpvgBM;EAnBE,wDAAA;EAAA,qDAAA;EAAA,+DAAA;A/F6wgBR;A+F1vgBM;EAnBE,iDAAA;EAAA,gCAAA;EAAA,yDAAA;EAAA,mDAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,6CAAA;EAAA,yDAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA,8DAAA;EAAA,+DAAA;EAAA,0CAAA;A/F4xgBR;A+FzwgBM;EAnBE,uBAAA;EAAA,4CAAA;EAAA,mDAAA;EAAA,mDAAA;A/FkygBR;A+F/wgBM;EAnBE,wDAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,uDAAA;EAAA,yDAAA;EAAA,2DAAA;EAAA,oDAAA;EAAA,wHAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA,8CAAA;EAAA,qDAAA;A/FgzgBR;A+F7xgBM;EAnBE,iCAAA;EAAA,yCAAA;A/FozgBR;A+FjygBM;EAnBE,+BAAA;EAAA,gCAAA;EAAA,yDAAA;EAAA,qCAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,qDAAA;EAAA,+DAAA;EAAA,mCAAA;EAAA,sCAAA;EAAA,6CAAA;EAAA,0DAAA;EAAA,yCAAA;EAAA,kEAAA;A/Fo0gBR;A+FjzgBM;EAnBE,yCAAA;EAAA,iDAAA;EAAA,oEAAA;A/Fy0gBR;A+FtzgBM;EAnBE,yBAAA;EAAA,sDAAA;EAAA,gCAAA;EAAA,qDAAA;EAAA,mDAAA;EAAA,kCAAA;EAAA,2DAAA;A/Fk1gBR;A+F/zgBM;EAnBE,2CAAA;EAAA,8BAAA;EAAA,8BAAA;A/Fu1gBR;A+Fp0gBM;EAnBE,8CAAA;EAAA,yBAAA;EAAA,6BAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,mDAAA;EAAA,uDAAA;EAAA,sDAAA;EAAA,sCAAA;EAAA,2DAAA;EAAA,6DAAA;EAAA,0DAAA;EAAA,kEAAA;EAAA,8DAAA;EAAA,2DAAA;EAAA,mEAAA;EAAA,gEAAA;EAAA,oEAAA;EAAA,8CAAA;EAAA,mEAAA;EAAA,iEAAA;EAAA,gFAAA;EAAA,wEAAA;EAAA,sFAAA;A/Fq3gBR;A+Fl2gBM;EAnBE,4CAAA;EAAA,2BAAA;EAAA,oDAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,0CAAA;EAAA,kDAAA;EAAA,2CAAA;A/Fg4gBR;A+Fx5gBW;EAQH,uBAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/F25gBR;;A+Fn6gBW;EAQH,uBAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/Fu6gBR;;A+F/6gBW;EAQH,uBAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/Fm7gBR;;A+F37gBW;EAQH,uBAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/F+7gBR;;A+Fv8gBW;EAQH,uBAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/F28gBR;;A+Fn9gBW;EAQH,uBAAA;EAAA,yCAAA;EAAA,mDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/Fu9gBR;;A+F/9gBW;EAQH,wCAAA;EAAA,4CAAA;EAAA,oDAAA;EAAA,mDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,+CAAA;A/Fm+gBR;;A+F3+gBW;EAQH,mCAAA;EAAA,4CAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,oDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gDAAA;EAAA,kDAAA;A/F++gBR;;A+F58gBM;EAnBE,uEAAA;A/Fm+gBR;A+Fh9gBM;EAnBE,uBAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,mDAAA;EAAA,8BAAA;EAAA,oDAAA;A/F2+gBR;A8F7+gBI;EGrBF,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;AjGqghBF;AiG//gBE;EACE,kCAAA;AjGighBJ;A8Ft/gBI;EGrBF,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;AjG8ghBF;AiGxghBE;EACE,kCAAA;AjG0ghBJ;A8F//gBI;EGrBF,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;AjGuhhBF;AiGjhhBE;EACE,kCAAA;AjGmhhBJ;A8FxghBI;EGrBF,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;AjGgihBF;AiG1hhBE;EACE,kCAAA;AjG4hhBJ;A8FjhhBI;EGrBF,2CAAA;EACA,uBAAA;EACA,iCAAA;EACA,gDAAA;AjGyihBF;AiGnihBE;EACE,kCAAA;AjGqihBJ;A8F1hhBI;EGrBF,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,+BAAA;AjGkjhBF;AiG5ihBE;EACE,kCAAA;AjG8ihBJ;A8F5hhBI;E7DXF,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC0ihBF;A8F5ihBI;E7DXF,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;AjC0jhBF;A8F5jhBI;E7DXF,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC0khBF;A8F5khBI;E7DXF,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,uCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC0lhBF;A8F5lhBI;E7DXF,uCAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,gDAAA;EACA,8BAAA;EACA,wCAAA;AjC0mhBF;A8F5mhBI;E7DXF,wBAAA;EACA,qBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,8BAAA;EACA,wCAAA;AjC0nhBF;A8FtnhBI;E7DYF,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjC6mhBF;A8FrohBI;E7DYF,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjC4nhBF;A8FpphBI;E7DYF,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjC2ohBF;A8FnqhBI;E7DYF,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,yCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjC0phBF;A8FlrhBI;E7DYF,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCyqhBF;A8FjshBI;E7DYF,wBAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,wCAAA;EACA,+BAAA;EACA,4BAAA;EACA,sCAAA;EACA,8DAAA;EACA,iCAAA;EACA,kCAAA;EACA,oBAAA;AjCwrhBF;A8F1shBI;E7DkCF,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,0CAAA;AjC2qhBF;A8FrthBI;E7DkCF,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,0CAAA;AjCsrhBF;A8FhuhBI;E7DkCF,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AjCishBF;A8F3uhBI;E7DkCF,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,0CAAA;AjC4shBF;A8FtvhBI;E7DkCF,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AjCuthBF;A8FjwhBI;E7DkCF,wBAAA;EACA,2BAAA;EACA,qCAAA;EACA,8BAAA;EACA,4BAAA;EACA,sCAAA;EACA,+BAAA;EACA,iCAAA;EACA,yCAAA;AjCkuhBF;A8FrwhBI;E5C1CF,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlDkzhBF;A8F9whBI;E5C1CF,qFAAA;EACA,4BAAA;EACA,kCAAA;EACA,kGAAA;EACA,0CAAA;EACA,gGAAA;EACA,0GAAA;AlD2zhBF;A8FvxhBI;E5C1CF,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlDo0hBF;A8FhyhBI;E5C1CF,kFAAA;EACA,4BAAA;EACA,kCAAA;EACA,+FAAA;EACA,0CAAA;EACA,6FAAA;EACA,uGAAA;AlD60hBF;A8FzyhBI;E5C1CF,mFAAA;EACA,4BAAA;EACA,kCAAA;EACA,gGAAA;EACA,0CAAA;EACA,8FAAA;EACA,wGAAA;AlDs1hBF;A8FlzhBI;E5C1CF,gFAAA;EACA,4BAAA;EACA,kCAAA;EACA,6FAAA;EACA,0CAAA;EACA,2FAAA;EACA,qGAAA;AlD+1hBF;A8FrzhBE;EACE;;IAEE,cAAA;E9FuzhBJ;AACF;A8FnzhBI;EACE,8CAAA;A9FqzhBN;A8FlzhBI;EvEjEF,qC2EsT6B;AlGgkhB/B;A8FjzhBI;EACE,qCIiPyB;AlGkkhB/B;A8F/yhBE;EACE,8CAAA;A9FizhBJ;A2FxzhBQ;EAUM,uEAAA;A3FizhBd;A2F3zhBQ;EAUM,yEAAA;A3FozhBd;A2F9zhBQ;EAUM,uEAAA;A3FuzhBd;A2Fj0hBQ;EAUM,oEAAA;A3F0zhBd;A2Fp0hBQ;EAUM,uEAAA;A3F6zhBd;A2Fv0hBQ;EAUM,sEAAA;A3Fg0hBd;A2F10hBQ;EAUM,qEAAA;A3Fm0hBd;A2F70hBQ;EAUM,oEAAA;A3Fs0hBd;A2Fh1hBQ;EAUM,qEAAA;A3Fy0hBd;A2Fn1hBQ;EAUM,qEAAA;A3F40hBd;A2Ft1hBQ;EAUM,0EAAA;A3F+0hBd;A2Fz1hBQ;EAUM,6EAAA;A3Fk1hBd;A2F51hBQ;EAUM,+EAAA;A3Fq1hBd;A2F/1hBQ;EAUM,wEAAA;A3Fw1hBd;A2Fl2hBQ;EAUM,yBAAA;A3F21hBd;A2Fr2hBQ;EAIQ,mBAAA;EAMF,gFAAA;A3F+1hBd;A2Fz2hBQ;EAIQ,mBAAA;EAMF,kFAAA;A3Fm2hBd;A2F72hBQ;EAIQ,mBAAA;EAMF,gFAAA;A3Fu2hBd;A2Fj3hBQ;EAIQ,mBAAA;EAMF,6EAAA;A3F22hBd;A2Fr3hBQ;EAIQ,mBAAA;EAMF,gFAAA;A3F+2hBd;A2Fz3hBQ;EAIQ,mBAAA;EAMF,+EAAA;A3Fm3hBd;A2F73hBQ;EAIQ,mBAAA;EAMF,8EAAA;A3Fu3hBd;A2Fj4hBQ;EAIQ,mBAAA;EAMF,6EAAA;A3F23hBd;A2Fr4hBQ;EAIQ,mBAAA;EAMF,8EAAA;A3F+3hBd;A2Fz4hBQ;EAIQ,mBAAA;EAMF,8EAAA;A3Fm4hBd;A2F74hBQ;EAIQ,mBAAA;EAMF,gFAAA;A3Fu4hBd;A2Fj5hBQ;EAIQ,mBAAA;EAMF,wCAAA;A3F24hBd;A2F/5hBQ;EACE,qBAAA;A3Fi6hBV;A2Fl6hBQ;EACE,sBAAA;A3Fo6hBV;A2Fr6hBQ;EACE,qBAAA;A3Fu6hBV;A2Fx6hBQ;EACE,sBAAA;A3F06hBV;A2F36hBQ;EACE,mBAAA;A3F66hBV;AmG5+hBA;;;;;;EAAA;ACEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,UAAA;ECOI,0BDNJ;EACA,6BAAA;EEQE,uBAAA;AtG4+hBJ;AqG3+hBM;EDlBN;ICmBQ,gBAAA;ErG8+hBN;AACF;;AoGr/hBA;EACE,qBAAA;ApGw/hBF;;AoGr/hBA;EACE,mB/FgtB4B;E+F/sB5B,gB/FutB4B;ALiygB9B;;AoGr/hBA;EACE,mBAAA;EACA,mB/F0sB4B;E+FzsB5B,mBAAA;ApGw/hBF;;AuGnhiBA;EACE,WAAA;EAEA,iBAAA;EFaI,yBEZJ;AvGqhiBF;AwGvhiBI;EAgCE,gDAAA;AxG0/hBN;AwGlhiBI;EA+BI,iDAAA;AxGs/hBR;AqG3giBM;EEpBN;IFqBQ,gBAAA;ErG8giBN;AACF;;AyGpiiBA;EACE,2BAAA;EACA,wBAAA;EACA,8CAAA;EACA,gCAAA;EACA,mDAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EACA,mCAAA;EACA,uCAAA;EACA,oCAAA;EACA,wCAAA;EACA,4BAAA;EACA,gCAAA;EACA,2BAAA;EACA,qDAAA;EACA,iCAAA;EACA,uCAAA;EACA,wCAAA;EACA,gDAAA;EACA,uCAAA;EACA,yBAAA;EACA,6CAAA;EACA,4CAAA;EACA,2CAAA;AzGuiiBF;;A0G/jiBE;EACE,kBAAA;A1GkkiBJ;A0G/jiBE;EACE,oCAAA;A1GikiBJ;A0G/jiBa;EACP,qDAAA;A1GikiBN;;A0G7jiBE;;EAEE,8BAAA;A1GgkiBJ;A0G7jiBE;;EAEE,uBAAA;A1G+jiBJ;A0G5jiBE;EAME,kBAAA;A1GyjiBJ;A0GnjiBI;;EACE,gBAAA;A1GsjiBN;A0GljiBM;;EACE,kBAAA;A1GqjiBR;A0GjjiBI;;;;;;;;EAIE,gBAAA;A1GujiBN;A0GpjiBI;;EACE,gBAAA;EACA,cAAA;A1GujiBN;A0GpjiBI;;EACE,gBAAA;A1GujiBN;A0GnjiBI;;;;EAEE,mBAAA;A1GujiBN;A0GnjiBI;;;;EAEE,wBAAA;A1GujiBN;A0GrjiBI;;EACE,kBAAA;A1GwjiBN;A0GpjiBI;;EACE,gBAAA;A1GujiBN;A0GpjiBI;;EACE,eAAA;A1GujiBN;A0GnjiBI;;;;EAEE,gBAAA;EACA,wBAAA;A1GujiBN;A0GpjiBI;;EACE,gBAAA;EACA,wBAAA;A1GujiBN;A2GtliBI;EDmCE;;;;IAEE,4BAAA;E1GwjiBN;E0GtjiBI;;IACE,4BAAA;E1GyjiBN;AACF;A0GrjiBI;;EACE,kBAAA;EACA,qBAAA;A1GwjiBN;;A4GrqiBA;EACE,gBAAA;EACA,6BAAA;EACA,oCAAA;A5GwqiBF;;A4GrqiBA;EACE,YAAA;EAEA,aAAA;A5GuqiBF;;A4GpqiBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;A5GuqiBF;;A4GpqiBA;EACE,6BAAA;EACA,mBAAA;A5GuqiBF;;A4GpqiBA;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;A5GuqiBF;;A4GpqiBA;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;A5GuqiBF;;A4GpqiBA;EACE,iBAAA;EACA,YAAA;EACA,iBAAA;A5GuqiBF;;A4GpqiBA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;A5GuqiBF;;A4GpqiBA;EACE,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;A5GuqiBF;;A4GpqiBA;EACE,YAAA;EACA,4FAAA;EACA,QAAA;EACA,uBAAA;A5GuqiBF;;A4G5piBA;EACE,mCAAA;EACA,WAAA;EACA,mCAAA;EACA,oBAAA;A5G+piBF;;A4G5piBA;EACE,gBAAA;EACA,6DAAA;EACA,YAAA;EACA,kDAAA;A5G+piBF;;A4G5piBA;EACE,gBAAA;EACA,gCAAA;EACA,QAAA;EACA,yEAAA;A5G+piBF;;A4G5piBA;EACE,yBAAA;EACA,kDAAA;EACA,WAAA;EACA,oBAAA;A5G+piBF;;A4G5piBA;;EAEE,gBAAA;EACA,iCAAA;A5G+piBF;;A4G5piBA;EACE,cAAA;EACA,yBAAA;EACA,yBAAA;A5G+piBF;;A4G5piBA;EACE,WAAA;A5G+piBF;;A4G5piBA;;EAEE,yBAAA;EACA,gBAAA;A5G+piBF;;A4G5piBA;EACE,eAAA;A5G+piBF;;A4G5piBA;EACE,mBAAA;A5G+piBF;;A4G5piBA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;A5G+piBF;;A4G5piBA;;;EASE,WAAA;A5GypiBF;;A4GtpiBA;EACE,cAAA;A5GypiBF;;A4GtpiBA;EACE,WAAA;A5GypiBF;;A4GrpiBE;EACE,UAAA;EACA,WAAA;EACA,SAAA;EAEA,gBAAA;A5GupiBJ;A4GjpiBE;EACE,YAAA;EACA,eAAA;EAEA,gBAAA;A5GkpiBJ;;A4G9oiBA;EACE;IACE,aAAA;E5GipiBF;AACF;A4G9oiBA;EACE;;IAEE,0BAAA;IACA,4BAAA;IACA,iCAAA;E5GgpiBF;AACF;A4G7oiBA;EACE;IACE,gBAAA;IACA,cAAA;IACA,yBAAA;E5G+oiBF;AACF;A4G5oiBA;EACE,UAAA;EACA,YAAA;A5G8oiBF;A4G/niBA;EACE,aAAA;EACA,eAAA;A5GioiBF;;A4G9niBA;;EAEE,SAAA;A5GioiBF;;A4G9niBA;EACE,cAAA;EACA,uCAAA;EACA,wBAAA;A5GioiBF;;A4G9niBA;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;A5GioiBF;;A4G9niBA;EAEE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,0CAAA;EACA,iBAAA;A5GgoiBF;;A4G7niBA;EACE,aAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;A5GgoiBF;;A4G7niBA;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;A5GgoiBF;;A4G7niBA;EACE,eAAA;EACA,yBvGjLc;EuGkLd,YAAA;EACA,0BAAA;A5GgoiBF;;A4G7niBA;;;EAGE,gBAAA;EACA,uCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;A5GgoiBF;;A4G7niBA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;A5GgoiBF;;A4G7niBA;EACE,yBvGzMc;ALy0iBhB;;A4G7niBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;A5GgoiBF;A4G9niBE;EACE,yBvG1NY;EuG2NZ,cvG7NY;AL61iBhB;A4G7niBE;EACE,yBvGhNW;EuGiNX,cvGnNW;ALk1iBf;A4G5niBE;EACE,yBvG9OY;EuG+OZ,cvGjPY;AL+2iBhB;;A4G1niBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;A5G6niBF;A4G5niBE;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;A5G8niBJ;A4G3niBE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;A5G6niBJ;;A4GzniBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;A5G4niBF;A4G3niBE;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;A5G6niBJ;A4G1niBE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;A5G4niBJ;;A4GxniBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;A5G2niBF;A4G1niBE;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;A5G4niBJ;A4GzniBE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;A5G2niBJ;;A4GvniBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;A5G0niBF;A4GzniBE;EACE,6CAAA;EACA,0CAAA;EACA,kBAAA;A5G2niBJ;A4GxniBE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;A5G0niBJ;;A4GtniBA;EACE,gBAAA;A5GyniBF;;A4GtniBA;EACE,gBAAA;A5GyniBF;;A4GtniBA;EACE,4FACE;A5GwniBJ;;A4GnniBA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A5GsniBF;A4GpniBE;EACE,YAAA;EACA,yBvGvVY;AL68iBhB;A4GpniBE;EACE,YAAA;EACA,yBvG5UW;ALk8iBf;A4GpniBE;EACE,YAAA;EACA,yBvGzWY;AL+9iBhB;;A4GhniBA;EACE,wBAAA;EACA,iBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,aAAA;EACA,0DAAA;EAEA,sCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;A5GiniBF;;A4G9miBA;EACE,wBAAA;EACA,iBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,aAAA;EACA,0DAAA;EAEA,sCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;A5G+miBF;;A4G5miBA;EACE,gBAAA;EACA,aAAA;EACA,0DAAA;EAEA,sCAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;A5G8miBF;;A4G3miBA;EACE,8BAAA,EAAA,mBAAA;EACA,oCAAA,EAAA,gCAAA;EACA,YAAA;EACA,4DAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A5G8miBF;;A4G3miBA;EACE,8BAAA,EAAA,mBAAA;EACA,oCAAA,EAAA,gCAAA;EACA,YAAA;EACA,4DAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A5G8miBF","sourcesContent":["// If you want to override variables do it here\n@import \"variables\";\n\n$enable-ltr: true; /* stylelint-disable-line scss/dollar-variable-default */\n$enable-rtl: true; /* stylelint-disable-line scss/dollar-variable-default */\n\n// Import styles\n@import \"@coreui/coreui-pro/scss/coreui\";\n@import \"@coreui/coreui-pro/scss/themes/dark\";\n\n// Import Chart.js custom tooltips styles\n@import \"@coreui/chartjs/scss/coreui-chartjs\";\n\n@import \"layout\";\n\n// Plugins\n@import \"calendar\";\n\n// Prism.js\n@import \"examples\";\n\n// If you want to add custom CSS you can put it here.\n@import \"custom\";\n@import '~leaflet/dist/leaflet.css';\n\n","@mixin bsBanner($file) {\n  /*!\n   * CoreUI PRO #{$file} v4.6.4 (https://coreui.io)\n   * Copyright (c) 2023 creativeLabs Łukasz Holeczek\n   * License (https://coreui.io/pro/license/)\n   */\n}\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}high-emphasis: #{$text-high-emphasis};\n  --#{$prefix}medium-emphasis: #{$text-medium-emphasis};\n  --#{$prefix}disabled: #{$text-disabled};\n\n  --#{$prefix}high-emphasis-inverse: #{$text-high-emphasis-inverse};\n  --#{$prefix}medium-emphasis-inverse: #{$text-medium-emphasis-inverse};\n  --#{$prefix}disabled-inverse: #{$text-disabled-inverse};\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.0.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\n// ol,\n// ul {\n//   @include ltr-rtl(\"padding-left\", 2rem); // TODO: find solution\n// }\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  @include ltr-rtl(\"margin-left\", 0); // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}pre-color, $pre-color);\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: var(--#{$prefix}kbd-color, $kbd-color);\n  background-color: var(--#{$prefix}kbd-bg, $kbd-bg);\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: var(--#{$prefix}table-caption-color, $table-caption-color);\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  @include ltr-rtl(\"float\", left); // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n\n*[dir=\"rtl\"] {\n  [type=\"tel\"],\n  [type=\"url\"],\n  [type=\"email\"],\n  [type=\"number\"] {\n    direction: ltr;\n  }\n}\n\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:     #fff !default;\n$gray-base: #3c4b64 !default;\n$gray-100:  #ebedef !default;\n$gray-200:  #d8dbe0 !default;\n$gray-300:  #c4c9d0 !default;\n$gray-400:  #b1b7c1 !default;\n$gray-500:  #9da5b1 !default;\n$gray-600:  #8a93a2 !default;\n$gray-700:  #768192 !default;\n$gray-800:  #636f83 !default;\n$gray-900:  #4f5d73 !default;\n$black:     #000015 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n$high-emphasis:            rgba(shift-color($gray-base, +26%), .95) !default;\n$medium-emphasis:          rgba(shift-color($gray-base, +26%), .681) !default;\n$disabled:                 rgba(shift-color($gray-base, +26%), .38) !default;\n\n$high-emphasis-inverse:    rgba($white, .87) !default;\n$medium-emphasis-inverse:  rgba($white, .6) !default;\n$disabled-inverse:         rgba($white, .38) !default;\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// fusv-disable\n$primary-dark:  #1f1498 !default;\n$primary-base:  #321fdb !default;\n$primary-50:    #988fed !default;\n$primary-25:    #ccc7f6 !default;\n\n$secondary-dark:  #212233 !default;\n$secondary-base:  #9da5b1 !default;\n$secondary-50:    #9da5b1 !default;\n$secondary-25:    #ced2d8 !default;\n\n$success-dark:  #1b9e3e !default;\n$success-base:  #2eb85c !default;\n$success-50:    #96dbad !default;\n$success-25:    #cbedd6 !default;\n\n$info-dark:  #2982cc !default;\n$info-base:  #39f !default;\n$info-50:    #80c6ff !default;\n$info-25:    #c0e6ff !default;\n\n$warning-dark:  #f6960b !default;\n$warning-base:  #f9b115 !default;\n$warning-50:    #fcd88a !default;\n$warning-25:    #feecc5 !default;\n\n$danger-dark:  #d93737 !default;\n$danger-base:  #e55353 !default;\n$danger-50:    #f2a9a9 !default;\n$danger-25:    #f9d4d4 !default;\n\n$light-dark:     $gray-100 !default;\n$light-base:     $gray-100 !default;\n$light-50:       shift-color($light-base, -70%) !default;\n$light-25:       shift-color($light-base, -80%) !default;\n\n$dark-dark:      $gray-900 !default;\n$dark-base:      $gray-900 !default;\n$dark-50:        shift-color($dark-base, -70%) !default;\n$dark-25:        shift-color($dark-base, -80%) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $primary-base !default;\n$secondary:     $secondary-base !default;\n$success:       $success-base !default;\n$info:          $info-base !default;\n$warning:       $warning-base !default;\n$danger:        $danger-base !default;\n$light:         $light-base !default;\n$dark:          $dark-base !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Gradients\n\n// scss-docs-start theme-gradients\n$primary-gradient: (\n  \"start\":  #321fdb,\n  \"stop\":   #1f1498\n) !default;\n\n$secondary-gradient: (\n  \"start\":  #c8d2dc,\n  \"stop\":    $white\n) !default;\n\n$light-gradient: (\n  \"start\":  #e3e8ed,\n  \"stop\":    $white\n) !default;\n\n$dark-gradient: (\n  \"start\":  #3c4b64,\n  \"stop\":   #212333\n) !default;\n\n$danger-gradient: (\n  \"start\":  #e55353,\n  \"stop\":   #d93737\n) !default;\n\n$warning-gradient: (\n  \"start\":  #f9b115,\n  \"stop\":   #f6960b\n) !default;\n\n$success-gradient: (\n  \"start\":  #2eb85c,\n  \"stop\":   #1b9e3e\n) !default;\n\n$info-gradient: (\n  \"start\":  #39f,\n  \"stop\":   #2982cc\n) !default;\n\n$theme-gradients: (\n  \"primary\":    $primary-gradient,\n  \"secondary\":  $secondary-gradient,\n  \"success\":    $success-gradient,\n  \"info\":       $info-gradient,\n  \"warning\":    $warning-gradient,\n  \"danger\":     $danger-gradient,\n  \"light\":      $light-gradient,\n  \"dark\":       $dark-gradient\n) !default;\n// scss-docs-end theme-gradients\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $high-emphasis-inverse !default;\n$color-contrast-light:     $high-emphasis !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n$enable-elevations:           true !default;\n$enable-ltr:                  true !default;\n$enable-rtl:                  false !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             cui- !default; // Deprecated in v4.3.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Set mobile breakpoint\n\n$mobile-breakpoint:           md !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Elevation\n//\n// Define common box shadows\n$elevation-base-color: 60, 75, 100 !default; //#3c4b64\n\n$elevations: (\n  0: unquote(\"none\"),\n  1: unquote(\"0 1px 1px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 2px 1px -1px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 1px 3px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  2: unquote(\"0 2px 2px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 3px 1px -2px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 1px 5px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  3: unquote(\"0 3px 4px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 3px 3px -2px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 1px 8px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  4: unquote(\"0 4px 5px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 1px 10px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 2px 4px -1px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  6: unquote(\"0 6px 10px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 1px 18px 0 rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 3px 5px -1px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  8: unquote(\"0 8px 10px 1px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 3px 14px 2px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 5px 5px -3px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  9: unquote(\"0 9px 12px 1px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 3px 16px 2px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 5px 6px -3px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  12: unquote(\"0 12px 17px 2px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 5px 22px 4px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 7px 8px -4px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  16: unquote(\"0 16px 24px 2px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 6px 30px 5px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 8px 10px -5px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\"),\n  24: unquote(\"0 24px 38px 3px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .14), 0 9px 46px 8px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .12), 0 11px 15px -7px rgba(var(--#{$prefix}elevation-base-color, #{$elevation-base-color}), .20)\")\n) !default;\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $high-emphasis !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      $medium-emphasis !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       $disabled !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-200 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.0.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $high-emphasis-inverse !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:                $font-size-base * 1.25 !default;\n$lead-font-weight:              300 !default;\n\n$small-font-size:               .875em !default;\n\n$sub-sup-font-size:             .75em !default;\n\n$text-high-emphasis:            $high-emphasis !default;\n$text-medium-emphasis:          $medium-emphasis !default;\n$text-disabled:                 $disabled !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 4.3.0\n// fusv-enable\n\n$text-high-emphasis-inverse:    $high-emphasis-inverse !default;\n$text-medium-emphasis-inverse:  $medium-emphasis-inverse !default;\n$text-disabled-inverse:         $disabled-inverse !default;\n\n$initialism-font-size:          $small-font-size !default;\n\n$blockquote-margin-y:           $spacer !default;\n$blockquote-font-size:          $font-size-base * 1.25 !default;\n$blockquote-footer-color:       $gray-600 !default;\n$blockquote-footer-font-size:   $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v4.2.6\n$hr-height:                   null !default; // Deprecated in v4.2.6\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n// Icons\n$icon-size-base:  1rem !default;\n$icon-size-sm:    $icon-size-base * .875 !default;\n$icon-size-lg:    $icon-size-base * 1.25 !default;\n$icon-size-xl:    $icon-size-base * 1.5 !default;\n$icon-size-xxl:   $icon-size-base * 2 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n\n// scss-docs-start button-variants\n$button-variants: (\n  \"primary\": btn-color-map($primary, $primary),\n  \"secondary\": btn-color-map($secondary, $secondary),\n  \"success\": btn-color-map($success, $success),\n  \"danger\": btn-color-map($danger, $danger),\n  \"warning\": btn-color-map($warning, $warning),\n  \"info\": btn-color-map($info, $info),\n  \"light\": btn-color-map($light, $light),\n  \"dark\": btn-color-map($dark, $dark)\n) !default;\n\n$button-outline-ghost-variants: (\n  \"primary\": btn-outline-color-map($primary),\n  \"secondary\": btn-outline-color-map($secondary),\n  \"success\": btn-outline-color-map($success),\n  \"danger\": btn-outline-color-map($danger),\n  \"warning\": btn-outline-color-map($warning),\n  \"info\": btn-outline-color-map($info),\n  \"light\": btn-outline-color-map($light),\n  \"dark\": btn-outline-color-map($dark)\n) !default;\n// scss-docs-end button-variants\n// scss-docs-end btn-variables\n\n\n// Forms\n// scss-docs-start form-variables\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n\n$form-switch-widths: (\n  lg: (\n    width: 1.75em,\n    height: 1.25em\n  ),\n  xl: (\n    width: 2em,\n    height: 1.5em\n  )\n) !default;\n// scss-docs-end form-switch-variables\n\n$form-check-inline-margin-end:    1rem !default;\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-multi-select-variables\n$form-multi-select-padding-y:               $input-padding-y !default;\n$form-multi-select-padding-x:               $input-padding-x !default;\n$form-multi-select-font-family:             $input-font-family !default;\n$form-multi-select-font-size:               $input-font-size !default;\n$form-multi-select-font-weight:             $input-font-weight !default;\n$form-multi-select-line-height:             $input-line-height !default;\n$form-multi-select-color:                   $input-color !default;\n$form-multi-select-disabled-color:          $input-disabled-color !default;\n$form-multi-select-bg:                      $input-bg !default;\n\n$form-multi-select-bg-position:             right $form-multi-select-padding-x center !default;\n$form-multi-select-bg-size:                 16px 12px !default; // In pixels because image dimensions\n$form-multi-select-disabled-bg:             $input-disabled-bg !default;\n$form-multi-select-indicator-padding:       $form-multi-select-padding-x * 3 !default; // Extra padding to account for the presence of the background-image based indicator\n$form-multi-select-indicator-color:         $body-secondary-color !default;\n$form-multi-select-indicator:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-multi-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-multi-select-border-width:            $input-border-width !default;\n$form-multi-select-border-color:            $input-border-color !default;\n$form-multi-select-border-radius:           $input-border-radius !default;\n$form-multi-select-border-radius-sm:        $input-border-radius-sm !default;\n$form-multi-select-border-radius-lg:        $input-border-radius-lg !default;\n$form-multi-select-box-shadow:              inset 0 1px 2px rgba($black, .075) !default;\n\n$form-multi-select-focus-width:             $input-focus-width !default;\n$form-multi-select-focus-color:             $input-color !default;\n$form-multi-select-focus-bg:                $input-bg !default;\n$form-multi-select-focus-border-color:      shift-color($component-active-bg, -25%) !default;\n$form-multi-select-focus-box-shadow:        0 0 0 $form-multi-select-focus-width $input-btn-focus-color !default;\n\n$form-multi-select-selection-tags-padding-y:  .125rem !default;\n$form-multi-select-selection-tags-padding-x:  .125rem !default;\n\n$form-multi-select-tag-bg:                var(--#{$prefix}secondary-bg) !default;\n$form-multi-select-tag-border-width:      var(--#{$prefix}border-width) !default;\n$form-multi-select-tag-border-color:      var(--#{$prefix}border-color) !default;\n$form-multi-select-tag-border-radius:     .25rem !default;\n$form-multi-select-tag-border-radius-sm:  .125rem !default;\n$form-multi-select-tag-border-radius-lg:  .375rem !default;\n$form-multi-select-tag-margin-y:          .125rem !default;\n$form-multi-select-tag-margin-x:          .125rem !default;\n$form-multi-select-tag-padding-y:         calc(($form-multi-select-padding-y - $form-multi-select-selection-tags-padding-y - $form-multi-select-tag-margin-y) - $form-multi-select-tag-border-width) !default; // stylelint-disable-line function-disallowed-list\n$form-multi-select-tag-padding-x:         .5rem !default;\n\n$form-multi-select-search-color:          $input-color !default;\n$form-multi-select-search-bg:             $input-bg !default;\n$form-multi-select-search-border-radius:  $border-radius !default;\n\n$form-multi-select-cleaner-width:         .75rem !default;\n$form-multi-select-cleaner-height:        .75rem !default;\n$form-multi-select-cleaner-padding-x:     .75rem !default;\n$form-multi-select-cleaner-padding-y:     .5rem !default;\n$form-multi-select-cleaner-color:         $body-secondary-color !default;\n$form-multi-select-cleaner-bg:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$form-multi-select-cleaner-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$form-multi-select-cleaner-hover-color:   $body-color !default;\n$form-multi-select-cleaner-hover-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$form-multi-select-cleaner-hover-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$form-multi-select-cleaner-focus-color:   $body-color !default;\n$form-multi-select-cleaner-focus-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$form-multi-select-cleaner-focus-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$form-multi-select-cleaner-border-color:  $input-border-color !default;\n\n$form-multi-select-select-all-padding-y:     .5rem !default;\n$form-multi-select-select-all-padding-x:     .75rem !default;\n$form-multi-select-select-all-color:         var(--#{$prefix}body-secondary-color) !default;\n$form-multi-select-select-all-bg:            transparent !default;\n$form-multi-select-select-all-hover-color:   var(--#{$prefix}body-color) !default;\n$form-multi-select-select-all-hover-bg:      transparent !default;\n$form-multi-select-select-all-border-width:  $input-border-width !default;\n$form-multi-select-select-all-border-color:  $input-border-color !default;\n\n$form-multi-select-options-padding-y:      .5rem !default;\n$form-multi-select-options-padding-x:      .75rem !default;\n$form-multi-select-options-margin-top:     .625rem !default;\n$form-multi-select-options-font-size:      $font-size-base !default;\n$form-multi-select-options-color:          var(--#{$prefix}body-color) !default;\n$form-multi-select-options-bg:             $white !default;\n$form-multi-select-options-border-color:   $border-color !default;\n$form-multi-select-options-border-width:   $border-width !default;\n$form-multi-select-options-border-radius:  $border-radius !default;\n\n$form-multi-select-optgroup-label-font-weight:  $font-weight-bold !default;\n$form-multi-select-optgroup-label-color:        var(--#{$prefix}tertiary-color) !default;\n\n$form-multi-select-option-padding-y:        .5rem !default;\n$form-multi-select-option-padding-x:        1.25rem !default;\n$form-multi-select-option-border-radius:    $border-radius !default;\n\n$form-multi-select-option-hover-color:     shift-color($gray-900, +5%) !default;\n$form-multi-select-option-hover-bg:        rgba($gray-100, .5) !default;\n\n$form-multi-select-option-indicator-width:          1em !default;\n$form-multi-select-option-indicator-bg:             $form-check-input-bg !default;\n$form-multi-select-option-indicator-border:         $form-check-input-border !default;\n$form-multi-select-option-indicator-border-radius:  .25em !default;\n\n$form-multi-select-option-selected-bg:                      $light !default;\n$form-multi-select-option-selected-indicator-bg:            $form-check-input-checked-bg-color !default;\n$form-multi-select-option-selected-indicator-bg-image:      $form-check-input-checked-bg-image !default;\n$form-multi-select-option-selected-indicator-border-color:  $form-multi-select-option-selected-indicator-bg !default;\n\n$form-multi-select-option-disabled-color:  $gray-600 !default;\n\n$form-multi-select-padding-y-lg:                 $input-padding-y-lg !default;\n$form-multi-select-padding-x-lg:                 $input-padding-x-lg !default;\n$form-multi-select-font-size-lg:                 $input-font-size-lg !default;\n$form-multi-select-selection-tags-padding-y-lg:  .125rem !default;\n$form-multi-select-selection-tags-padding-x-lg:  .125rem !default;\n$form-multi-select-tag-margin-y-lg:              .125rem !default;\n$form-multi-select-tag-margin-x-lg:              .125rem !default;\n$form-multi-select-tag-padding-y-lg:             subtract(($form-multi-select-padding-y-lg - $form-multi-select-selection-tags-padding-y-lg - $form-multi-select-tag-margin-y-lg), $form-multi-select-tag-border-width) !default;\n$form-multi-select-tag-padding-x-lg:             .5rem !default;\n\n$form-multi-select-padding-y-sm:                 $input-padding-y-sm !default;\n$form-multi-select-padding-x-sm:                 $input-padding-x-sm !default;\n$form-multi-select-font-size-sm:                 $input-font-size-sm !default;\n$form-multi-select-selection-tags-padding-y-sm:  .0675rem !default;\n$form-multi-select-selection-tags-padding-x-sm:  .125rem !default;\n$form-multi-select-tag-margin-y-sm:              .0675rem !default;\n$form-multi-select-tag-margin-x-sm:              .0675rem !default;\n$form-multi-select-tag-padding-y-sm:             0 !default;\n$form-multi-select-tag-padding-x-sm:             .5rem !default;\n// scss-docs-end form-multi-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n// scss-docs-end form-variables\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-sidebar-backdrop:           1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-border-color:              $gray-300 !default;\n$nav-underline-border-width:              $border-width * 2 !default;\n$nav-underline-link-color:                $gray-700 !default;\n$nav-underline-link-active-color:         $primary !default;\n$nav-underline-link-active-border-color:  $primary !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v4.2.6\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $high-emphasis-inverse !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 4.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in 4.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $high-emphasis-inverse !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n$badge-font-size-sm:                .65em !default;\n$badge-padding-y-sm:                .3em !default;\n$badge-padding-x-sm:                .5em !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Avatars\n// scss-docs-start avatar-variables\n$avatar-width:  2rem !default;\n\n$avatar-widths: (\n  sm: 1.5rem,\n  md: 2.5rem,\n  lg: 3rem,\n  xl: 4rem\n) !default;\n\n$avatar-transition: margin .15s !default;\n// scss-docs-end avatar-variables\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// scss-docs-start alert-variants\n$alert-variants: () !default;\n@each $state, $value in $theme-colors {\n  $map: ();\n  $alert-variants: map-merge($alert-variants, map-merge($map, ($state: alert-color-map($value))));\n}\n\n// Callouts\n// scss-docs-start callout-variables\n$callout-padding-y:                 $spacer !default;\n$callout-padding-x:                 $spacer !default;\n$callout-margin-y:                  $spacer !default;\n$callout-margin-x:                  0 !default;\n$callout-border-radius:             var(--#{$prefix}border-radius) !default;\n$callout-border-width:              var(--#{$prefix}border-width) !default;\n$callout-border-color:              var(--#{$prefix}border-color) !default;\n$callout-border-left-width:         calc($callout-border-width * 4) !default; // stylelint-disable-line function-disallowed-list\n\n$callout-variants: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"danger\":     $danger,\n  \"warning\":    $warning,\n  \"info\":       $info,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end callout-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $high-emphasis-inverse !default;\n$progress-bar-bg:                   var(--#{$prefix}primary) !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n$progress-group-margin-bottom:         $spacer !default;\n$progress-group-header-margin-bottom:  $spacer * .25 !default;\n// scss-docs-end progress-variables\n\n// List group\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n$list-group-variants: (\n  \"primary\": list-group-color-map($primary),\n  \"secondary\": list-group-color-map($secondary),\n  \"success\": list-group-color-map($success),\n  \"danger\": list-group-color-map($danger),\n  \"warning\": list-group-color-map($warning),\n  \"info\": list-group-color-map($info),\n  \"light\": list-group-color-map($light),\n  \"dark\": list-group-color-map($dark)\n) !default;\n// scss-docs-end list-group-variables\n\n\n// Header\n// scss-docs-start header-variables\n$header-min-height:             4rem !default;\n$header-padding-y:              $spacer * .5 !default;\n$header-padding-x:              $spacer * .5 !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-color:                  rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-bg:                     var(--#{$prefix}body-bg) !default;\n$header-border-color:           var(--#{$prefix}border-color) !default;\n$header-border-width:           var(--#{$prefix}border-width) !default;\n$header-hover-color:            rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$header-active-color:           rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$header-disabled-color:         rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n\n// Compute the header-brand padding-y so the header-brand will have the same height as header-text and nav-link\n$nav-link-height:               $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$header-brand-height:           $header-brand-font-size * $line-height-base !default;\n$header-brand-padding-y:        ($nav-link-height - $header-brand-height) * .5 !default;\n$header-brand-margin-end:       1rem !default;\n$header-brand-font-size:        $font-size-lg !default;\n$header-brand-color:            $gray-900 !default;\n$header-brand-hover-color:      shade-color($gray-900, 10%) !default;\n\n$header-toggler-padding-y:      .25rem !default;\n$header-toggler-padding-x:      .75rem !default;\n$header-toggler-font-size:      $font-size-lg !default;\n$header-toggler-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$header-toggler-bg:             transparent !default;\n$header-toggler-border-radius:  $btn-border-radius !default;\n$header-toggler-hover-color:    rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n\n$header-toggler-icon-color:        currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-icon-bg:           url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n$header-toggler-hover-icon-color:  currentColor !default; // stylelint-disable-line value-keyword-case\n$header-toggler-hover-icon-bg:     url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-toggler-hover-icon-color}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\") !default;\n\n$header-nav-link-padding-x:     .5rem !default;\n$header-nav-link-padding-y:     .5rem !default;\n\n$header-divider-border-width:   var(--#{$prefix}border-width) !default;\n$header-divider-border-color:   var(--#{$prefix}border-color) !default;\n// scss-docs-end header-variables\n\n// Subheader\n// scss-docs-start subheader-variables\n$subheader-min-height:           3rem !default;\n$subheader-padding-y:            $spacer * .5 !default;\n$subheader-padding-x:            $spacer !default;\n$subheader-border-color:         var(--#{$prefix}border-color) !default;\n$subheader-border-width:         var(--#{$prefix}border-width) !default;\n\n$subheader-nav-link-padding-x:  .5rem !default;\n// scss-docs-end subheader-variables\n\n// Default theme\n// scss-docs-start subheader-default-themes\n$subheader-bg:                     $white !default;\n$subheader-color:                  var(--#{$prefix}secondary-color) !default;\n$subheader-hover-color:            var(--#{$prefix}body-color) !default;\n$subheader-active-color:           var(--#{$prefix}body-color) !default;\n$subheader-disabled-color:         $disabled !default;\n// scss-docs-end subheader-default-themes\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n// scss-docs-start carousel-variables\n$carousel-control-color:             $high-emphasis-inverse !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $high-emphasis-inverse !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $high-emphasis !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n// scss-docs-start sidebar-variables\n$sidebar-width:                            16rem !default;\n$sidebar-widths: (\n  sm: 12rem,\n  lg: 20rem,\n  xl: 24rem\n) !default;\n$sidebar-padding-y:                        0 !default;\n$sidebar-padding-x:                        0 !default;\n$sidebar-color:                            $high-emphasis-inverse !default;\n$sidebar-bg:                               $gray-base !default;\n$sidebar-border-width:                     0 !default;\n$sidebar-border-color:                     transparent !default;\n$sidebar-transition:                       margin-left .15s, margin-right .15s, box-shadow .075s, transform .15s, width .15s, z-index 0s ease .15s !default;\n\n$sidebar-close-button-width:               2rem !default;\n$sidebar-close-button-height:              4rem !default;\n\n$sidebar-brand-height:                     4rem !default;\n$sidebar-brand-color:                      $high-emphasis-inverse !default;\n$sidebar-brand-bg:                         rgba($black, .2) !default;\n\n$sidebar-header-height:                    4rem !default;\n$sidebar-header-padding-y:                 .75rem !default;\n$sidebar-header-padding-x:                 1rem !default;\n$sidebar-header-bg:                        rgba($black, .2) !default;\n$sidebar-header-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-narrow-width:                     4rem !default;\n\n$sidebar-backdrop-bg:                      $black !default;\n$sidebar-backdrop-opacity:                 .5 !default;\n\n$sidebar-nav-title-padding-y:              .75rem !default;\n$sidebar-nav-title-padding-x:              1rem !default;\n$sidebar-nav-title-margin-top:             1rem !default;\n$sidebar-nav-title-color:                  $medium-emphasis-inverse !default;\n$sidebar-nav-title-transition:             height .15s, margin .15s !default;\n\n$sidebar-nav-link-padding-y:               .8445rem !default;\n$sidebar-nav-link-padding-x:               1rem !default;\n$sidebar-nav-link-color:                   $medium-emphasis-inverse !default;\n$sidebar-nav-link-bg:                      transparent !default;\n$sidebar-nav-link-border-width:            0 !default;\n$sidebar-nav-link-border-color:            transparent !default;\n$sidebar-nav-link-border-radius:           0 !default;\n$sidebar-nav-link-transition:              background .15s ease, color .15s ease !default;\n$sidebar-nav-link-icon-color:              $medium-emphasis-inverse !default;\n\n$sidebar-nav-link-hover-color:             $high-emphasis-inverse !default;\n$sidebar-nav-link-hover-bg:                rgba($white, .05) !default;\n$sidebar-nav-link-hover-icon-color:        $high-emphasis-inverse !default;\n\n$sidebar-nav-link-active-color:            $high-emphasis-inverse !default;\n$sidebar-nav-link-active-bg:               rgba($white, .05) !default;\n$sidebar-nav-link-active-icon-color:       $high-emphasis-inverse !default;\n\n$sidebar-nav-link-disabled-color:          $disabled-inverse !default;\n$sidebar-nav-link-disabled-icon-color:     $sidebar-nav-link-icon-color !default;\n\n$sidebar-nav-icon-width:                   4rem !default;\n$sidebar-nav-icon-height:                  1.25rem !default;\n$sidebar-nav-icon-font-size:               $sidebar-nav-icon-height !default;\n\n$sidebar-nav-group-bg:                     rgba(0, 0, 0, .2) !default;\n$sidebar-nav-group-transition:             background .15s ease-in-out !default;\n$sidebar-nav-group-toggle-show-color:      $sidebar-nav-link-color !default;\n\n$sidebar-nav-group-items-padding-y:        0 !default;\n$sidebar-nav-group-items-padding-x:        0 !default;\n$sidebar-nav-group-items-transition:       height .15s ease !default;\n\n$sidebar-nav-group-indicator-color:        $medium-emphasis-inverse !default;\n$sidebar-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color:  $sidebar-nav-link-hover-color !default;\n$sidebar-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-transition:   transform .15s !default;\n\n$sidebar-footer-height:                    auto !default;\n$sidebar-footer-padding-y:                 .75rem !default;\n$sidebar-footer-padding-x:                 1rem !default;\n$sidebar-footer-bg:                        rgba($black, .2) !default;\n$sidebar-footer-height-transition:         height .15s, padding .15s !default;\n\n$sidebar-toggler-height:                   3rem !default;\n$sidebar-toggler-bg:                       rgba($black, .2) !default;\n$sidebar-toggler-transition:               transform .15s !default;\n\n$sidebar-toggler-indicator-width:          4rem !default;\n$sidebar-toggler-indicator-height:         3rem !default;\n$sidebar-toggler-indicator-color:          $disabled-inverse !default;\n$sidebar-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n$sidebar-toggler-hover-bg:                 rgba(0, 0, 0, .3) !default;\n\n$sidebar-toggler-indicator-hover-color:    $sidebar-nav-link-hover-color !default;\n$sidebar-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n\n$sidebar-light-color:    $body-color !default;\n$sidebar-light-bg:       $white !default;\n$sidebar-light-border-width:                     0 !default;\n$sidebar-light-border-color:                     transparent !default;\n\n$sidebar-light-brand-color:  $white !default;\n$sidebar-light-brand-bg:     $primary !default;\n\n$sidebar-light-header-bg: rgba($black, .2) !default;\n\n$sidebar-light-nav-title-color:                  $medium-emphasis !default;\n\n$sidebar-light-nav-link-color:                   $medium-emphasis !default;\n$sidebar-light-nav-link-bg:                      transparent !default;\n$sidebar-light-nav-link-icon-color:              $medium-emphasis !default;\n\n$sidebar-light-nav-link-hover-color:             $high-emphasis !default;\n$sidebar-light-nav-link-hover-bg:                theme-color(\"primary\") !default;\n$sidebar-light-nav-link-hover-icon-color:        $high-emphasis !default;\n\n$sidebar-light-nav-link-active-color:            $high-emphasis !default;\n$sidebar-light-nav-link-active-bg:               rgba($white, .05) !default;\n$sidebar-light-nav-link-active-icon-color:       $high-emphasis !default;\n\n$sidebar-light-nav-link-disabled-color:          $disabled !default;\n$sidebar-light-nav-link-disabled-icon-color:     $sidebar-light-nav-link-icon-color !default;\n\n$sidebar-light-nav-group-bg:                     rgba(0, 0, 0, .05) !default;\n$sidebar-light-nav-group-toggle-show-color:      $sidebar-light-nav-link-color !default;\n\n$sidebar-light-nav-group-indicator-color:        $medium-emphasis !default;\n$sidebar-light-nav-group-indicator-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-light-nav-group-indicator-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-light-nav-group-indicator-hover-color:  $sidebar-light-nav-link-hover-color !default;\n$sidebar-light-nav-group-indicator-hover-icon:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-light-nav-group-indicator-hover-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$sidebar-light-footer-bg:                        rgba($black, .1) !default;\n\n$sidebar-light-toggler-bg:                       rgba($black, .1) !default;\n$sidebar-light-toggler-hover-bg:                 rgba(0, 0, 0, .2) !default;\n$sidebar-light-toggler-indicator-color:          $medium-emphasis !default;\n$sidebar-light-toggler-indicator-icon:           url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-light-toggler-indicator-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n$sidebar-light-toggler-indicator-hover-color:    $sidebar-light-nav-link-hover-color !default;\n$sidebar-light-toggler-indicator-hover-icon:     url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='#{$sidebar-light-toggler-indicator-hover-color}' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E\") !default;\n// scss-docs-end sidebar-variables\n\n// Footer\n// scss-docs-start footer-variables\n$footer-min-height:    3rem !default;\n$footer-padding-y:     $spacer * .5 !default;\n$footer-padding-x:     $spacer !default;\n$footer-bg:            var(--#{$prefix}tertiary-bg) !default;\n$footer-color:         var(--#{$prefix}body-color) !default;\n$footer-border-width:  var(--#{$prefix}border-width) !default;\n$footer-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end footer-variables\n\n// Spinners\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $high-emphasis !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v4.2.6, removing in v6\n\n$pre-color:                         null !default;\n\n// Calendar & Date & Time Pickers\n\n// Calendar\n// scss-docs-start calendar-variables\n$calendar-table-margin:                     .5rem !default;\n$calendar-table-cell-size:                  2.75rem !default;\n\n$calendar-nav-padding:                      .5rem !default;\n$calendar-nav-border-width:                 1px !default;\n$calendar-nav-border-color:                 var(--#{$prefix}border-color) !default;\n$calendar-nav-date-color:                   var(--#{$prefix}body-color) !default;\n$calendar-nav-date-hover-color:             var(--#{$prefix}primary) !default;\n$calendar-nav-icon-width:                   1rem !default;\n$calendar-nav-icon-height:                  1rem !default;\n\n$calendar-nav-icon-double-next-color:       $body-tertiary-color !default;\n$calendar-nav-icon-double-next:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-double-next-color}' points='95.314 447.313 72.686 424.687 245.373 252 72.686 79.313 95.314 56.687 290.627 252 95.314 447.313'></polygon><polygon fill='#{$calendar-nav-icon-double-next-color}' points='255.314 447.313 232.686 424.687 405.373 252 232.686 79.313 255.314 56.687 450.627 252 255.314 447.313'></polygon></svg>\") !default;\n$calendar-nav-icon-double-next-hover-color: $body-color !default;\n$calendar-nav-icon-double-next-hover:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-double-next-hover-color}' points='95.314 447.313 72.686 424.687 245.373 252 72.686 79.313 95.314 56.687 290.627 252 95.314 447.313'></polygon><polygon fill='#{$calendar-nav-icon-double-next-hover-color}' points='255.314 447.313 232.686 424.687 405.373 252 232.686 79.313 255.314 56.687 450.627 252 255.314 447.313'></polygon></svg>\") !default;\n\n$calendar-nav-icon-double-prev-color:       $body-tertiary-color !default;\n$calendar-nav-icon-double-prev:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-double-prev-color}' points='416.686 447.313 221.373 252 416.686 56.687 439.314 79.313 266.627 252 439.314 424.687 416.686 447.313'></polygon><polygon fill='#{$calendar-nav-icon-double-prev-color}' points='256.686 447.313 61.373 252 256.686 56.687 279.314 79.313 106.627 252 279.314 424.687 256.686 447.313'></polygon></svg>\") !default;\n$calendar-nav-icon-double-prev-hover-color: $body-color !default;\n$calendar-nav-icon-double-prev-hover:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-double-prev-hover-color}' points='416.686 447.313 221.373 252 416.686 56.687 439.314 79.313 266.627 252 439.314 424.687 416.686 447.313'></polygon><polygon fill='#{$calendar-nav-icon-double-prev-hover-color}' points='256.686 447.313 61.373 252 256.686 56.687 279.314 79.313 106.627 252 279.314 424.687 256.686 447.313'></polygon></svg>\") !default;\n\n$calendar-nav-icon-next-color:              $body-tertiary-color !default;\n$calendar-nav-icon-next:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-next-color}' points='179.313 451.313 156.687 428.687 329.372 256 156.687 83.313 179.313 60.687 374.627 256 179.313 451.313'></polygon></svg>\") !default;\n$calendar-nav-icon-next-hover-color:        $body-color !default;\n$calendar-nav-icon-next-hover:              url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-next-hover-color}' points='179.313 451.313 156.687 428.687 329.372 256 156.687 83.313 179.313 60.687 374.627 256 179.313 451.313'></polygon></svg>\") !default;\n\n$calendar-nav-icon-prev-color:              $body-tertiary-color !default;\n$calendar-nav-icon-prev:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-prev-color}' points='324.687 451.313 129.373 256 324.687 60.687 347.313 83.313 174.628 256 347.313 428.687 324.687 451.313'></polygon></svg>\") !default;\n$calendar-nav-icon-prev-hover-color:        $body-color !default;\n$calendar-nav-icon-prev-hover:              url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$calendar-nav-icon-prev-hover-color}' points='324.687 451.313 129.373 256 324.687 60.687 347.313 83.313 174.628 256 347.313 428.687 324.687 451.313'></polygon></svg>\") !default;\n\n$calendar-cell-header-inner-color:          var(--#{$prefix}secondary-color) !default;\n\n$calendar-cell-hover-bg:                    var(--#{$prefix}tertiary-bg) !default;\n$calendar-cell-disabled-color:              var(--#{$prefix}tertiary-color) !default;\n\n$calendar-cell-selected-color:              $white !default;\n$calendar-cell-selected-bg:                 var(--#{$prefix}primary) !default;\n\n$calendar-cell-range-bg:                    rgba(var(--#{$prefix}primary-rgb), .125) !default;\n$calendar-cell-range-hover-bg:              rgba(var(--#{$prefix}primary-rgb), .25) !default;\n$calendar-cell-range-hover-border-color:    var(--#{$prefix}primary) !default;\n\n$calendar-cell-today-color:                 var(--#{$prefix}$danger) !default;\n// scss-docs-end calendar-variables\n\n// Picker\n$picker-footer-border-width:  1px !default;\n$picker-footer-border-color:  $border-color !default;\n$picker-footer-padding:       .5rem !default;\n\n// Date Picker\n// scss-docs-start date-picker-variables\n$date-picker-default-icon-color:       $gray-600 !default;\n$date-picker-default-icon:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><path fill='#{$date-picker-default-icon-color}' d='M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z'></path><rect width='32' height='32' x='112' y='224' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='200' y='224' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='280' y='224' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='368' y='224' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='112' y='296' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='200' y='296' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='280' y='296' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='368' y='296' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='112' y='368' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='200' y='368' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='280' y='368' fill='#{$date-picker-default-icon-color}'></rect><rect width='32' height='32' x='368' y='368' fill='#{$date-picker-default-icon-color}'></rect></svg>\") !default;\n$date-picker-invalid-icon:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><path fill='#{$form-feedback-invalid-color}' d='M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z'></path><rect width='32' height='32' x='112' y='224' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='200' y='224' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='280' y='224' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='368' y='224' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='112' y='296' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='200' y='296' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='280' y='296' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='368' y='296' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='112' y='368' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='200' y='368' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='280' y='368' fill='#{$form-feedback-invalid-color}'></rect><rect width='32' height='32' x='368' y='368' fill='#{$form-feedback-invalid-color}'></rect></svg>\") !default;\n$date-picker-valid-icon:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><path fill='#{$form-feedback-valid-color}' d='M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z'></path><rect width='32' height='32' x='112' y='224' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='200' y='224' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='280' y='224' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='368' y='224' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='112' y='296' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='200' y='296' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='280' y='296' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='368' y='296' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='112' y='368' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='200' y='368' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='280' y='368' fill='#{$form-feedback-valid-color}'></rect><rect width='32' height='32' x='368' y='368' fill='#{$form-feedback-valid-color}'></rect></svg>\") !default;\n\n$date-picker-cleaner-icon-color:       $gray-600 !default;\n$date-picker-cleaner-icon:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$date-picker-cleaner-icon-color}' points='306.912 214.461 256 265.373 205.088 214.461 182.461 237.088 233.373 288 182.461 338.912 205.088 361.539 256 310.627 306.912 361.539 329.539 338.912 278.627 288 329.539 237.088 306.912 214.461'></polygon><path fill='#{$date-picker-cleaner-icon-color}' d='M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z'></path></svg>\") !default;\n$date-picker-cleaner-icon-hover-color: $body-color !default;\n$date-picker-cleaner-icon-hover:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$date-picker-cleaner-icon-hover-color}' points='306.912 214.461 256 265.373 205.088 214.461 182.461 237.088 233.373 288 182.461 338.912 205.088 361.539 256 310.627 306.912 361.539 329.539 338.912 278.627 288 329.539 237.088 306.912 214.461'></polygon><path fill='#{$date-picker-cleaner-icon-hover-color})' d='M472,96H384V40H352V96H160V40H128V96H40a24.028,24.028,0,0,0-24,24V456a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V120A24.028,24.028,0,0,0,472,96Zm-8,352H48V128h80v40h32V128H352v40h32V128h80Z'></path></svg>\") !default;\n\n$date-picker-separator-icon-color:     $gray-600 !default;\n$date-picker-separator-icon:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$date-picker-separator-icon-color}' points='359.873 121.377 337.246 144.004 433.243 240.001 16 240.001 16 240.002 16 272.001 16 272.002 433.24 272.002 337.246 367.996 359.873 390.623 494.498 256 359.873 121.377'></polygon></svg>\") !default;\n$date-picker-separator-icon-rtl:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$date-picker-separator-icon-color}' points='497.333 239.999 80.092 239.999 176.087 144.004 153.46 121.377 18.837 256 153.46 390.623 176.087 367.996 80.09 271.999 497.333 271.999 497.333 239.999'></polygon></svg>\") !default;\n\n$date-picker-ranges-width:             10rem !default;\n$date-picker-ranges-padding:           $spacer * .5 !default;\n$date-picker-ranges-border-width:      1px !default;\n$date-picker-ranges-border-color:      var(--#{$prefix}border-color) !default;\n\n$date-picker-timepicker-width:         (7 * $calendar-table-cell-size) + (2 * $calendar-table-margin) !default;\n$date-picker-timepicker-border-width:  1px !default;\n$date-picker-timepicker-border-color:  var(--#{$prefix}border-color) !default;\n// scss-docs-end date-picker-variables\n\n// Time Picker\n// scss-docs-start time-picker-variables\n$time-picker-default-icon-color:       $gray-600 !default;\n$time-picker-default-icon:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$time-picker-default-icon-color}' points='271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5' class='ci-primary'></polygon><path fill='#{$time-picker-default-icon-color}' d='M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z' class='ci-primary'></path></svg>\") !default;\n$time-picker-invalid-icon:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$form-feedback-invalid-color}' points='271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5' class='ci-primary'></polygon><path fill='#{$form-feedback-invalid-color}' d='M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z' class='ci-primary'></path></svg>\") !default;\n$time-picker-valid-icon:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$form-feedback-valid-color}' points='271.514 95.5 239.514 95.5 239.514 273.611 355.127 328.559 368.864 299.657 271.514 253.389 271.514 95.5' class='ci-primary'></polygon><path fill='#{$form-feedback-valid-color}' d='M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16Zm0,448C141.125,464,48,370.875,48,256S141.125,48,256,48s208,93.125,208,208S370.875,464,256,464Z' class='ci-primary'></path></svg>\") !default;\n\n$time-picker-cleaner-icon-color:       $gray-600 !default;\n$time-picker-cleaner-icon:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$time-picker-cleaner-icon-color}' points='348.071 141.302 260.308 229.065 172.545 141.302 149.917 163.929 237.681 251.692 149.917 339.456 172.545 362.083 260.308 274.32 348.071 362.083 370.699 339.456 282.935 251.692 370.699 163.929 348.071 141.302' class='ci-primary'></polygon><path fill='#{$time-picker-cleaner-icon-color}' d='M425.706,86.294A240,240,0,0,0,86.294,425.706,240,240,0,0,0,425.706,86.294ZM256,464C141.309,464,48,370.691,48,256S141.309,48,256,48s208,93.309,208,208S370.691,464,256,464Z' class='ci-primary'></path></svg>\") !default;\n$time-picker-cleaner-icon-hover-color: $body-color !default;\n$time-picker-cleaner-icon-hover:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' role='img'><polygon fill='#{$time-picker-cleaner-icon-hover-color}' points='348.071 141.302 260.308 229.065 172.545 141.302 149.917 163.929 237.681 251.692 149.917 339.456 172.545 362.083 260.308 274.32 348.071 362.083 370.699 339.456 282.935 251.692 370.699 163.929 348.071 141.302' class='ci-primary'></polygon><path fill='#{$time-picker-cleaner-icon-hover-color}' d='M425.706,86.294A240,240,0,0,0,86.294,425.706,240,240,0,0,0,425.706,86.294ZM256,464C141.309,464,48,370.691,48,256S141.309,48,256,48s208,93.309,208,208S370.691,464,256,464Z' class='ci-primary'></path></svg>\") !default;\n\n$time-picker-body-padding:             $spacer * .5 !default;\n$time-picker-roll-col-border-width:    1px !default;\n$time-picker-roll-col-border-color:    var(--#{$prefix}border-color) !default;\n// scss-docs-end time-picker-variables\n","@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n@function reflect($element) {\n  $string: #{$element};\n  @if str-index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if str-index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return unquote($string);\n}\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: null) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n    @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: null) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    } @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-left-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    @include ltr-rtl(\"margin-right\", $list-inline-padding);\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  @include ltr-rtl(\"padding-left\", 0);\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: var(--#{$prefix}thumbnail-bg, $thumbnail-bg);\n  border: $thumbnail-border-width solid var(--#{$prefix}thumbnail-border-color, $thumbnail-border-color);\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: var(--#{$prefix}figure-caption-color, $figure-caption-color);\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n\n  --#{$prefix}mobile-breakpoint: #{$mobile-breakpoint};\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  @include ltr-rtl(\"margin-left\", if($num == 0, 0, percentage($num)));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}form-label-color, $form-label-color);\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: var(--#{$prefix}form-text-color, $form-text-color);\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-color, $input-color);\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: var(--#{$prefix}input-bg, $input-bg);\n  background-clip: padding-box;\n  border: $input-border-width solid var(--#{$prefix}input-border-color, $input-border-color);\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: var(--#{$prefix}input-focus-color, $input-focus-color);\n    background-color: var(--#{$prefix}input-focus-bg, $input-focus-bg);\n    border-color: var(--#{$prefix}input-focus-border-color, $input-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: var(--#{$prefix}input-placeholder-color, $input-placeholder-color);\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: var(--#{$prefix}form-file-button-color, $form-file-button-color);\n    @include gradient-bg(var(--#{$prefix}form-file-button-bg, $form-file-button-bg));\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: var(--#{$prefix}form-file-button-hover-bg, $form-file-button-hover-bg);\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-plaintext-color, $input-plaintext-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n\n@mixin gradient($color, $value) {\n  background-color: var(--#{$prefix}#{$color}, map-get($value, \"stop\"));\n  background-image: linear-gradient(45deg, var(--#{$prefix}#{$color}-start, map-get($value, \"start\")) 0%, var(--#{$prefix}#{$color}-stop, map-get($value, \"stop\") 100%));\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  @include ltr-rtl-value-only(\"padding\", $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x, $form-select-padding-y $form-select-padding-x $form-select-padding-y $form-select-indicator-padding);\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: var(--#{$prefix}form-select-color, $form-select-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-select-bg, $form-select-bg);\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", $form-select-bg-position);\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid var(--#{$prefix}form-select-border-color, $form-select-border-color);\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: var(--#{$prefix}form-select-focus-border-color, $form-select-focus-border-color);\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    @include ltr-rtl(\"padding-right\", $form-select-padding-x);\n    background-image: none;\n  }\n\n  &:disabled {\n    color: var(--#{$prefix}form-select-disabled-color, $form-select-disabled-color);\n    background-color: var(--#{$prefix}form-select-disabled-bg, $form-select-disabled-bg);\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 var(--#{$prefix}form-select-color, $form-select-color);\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-sm);\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  @include ltr-rtl(\"padding-left\", $form-select-padding-x-lg);\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n//temp fix for dark-theme select options\n.dark-theme .form-select > option {\n  background-color: #44454e;\n}\n",".form-multi-select {\n  // scss-docs-start form-multi-select-css-vars\n  --#{$prefix}form-multi-select-padding-y: #{$form-multi-select-padding-y};\n  --#{$prefix}form-multi-select-padding-x: #{$form-multi-select-padding-x};\n  --#{$prefix}form-multi-select-font-family: #{$form-multi-select-font-family};\n  --#{$prefix}form-multi-select-font-size: #{$form-multi-select-font-size};\n  --#{$prefix}form-multi-select-font-weight: #{$form-multi-select-font-weight};\n  --#{$prefix}form-multi-select-line-height: #{$form-multi-select-line-height};\n  --#{$prefix}form-multi-select-color: #{$form-multi-select-color};\n  --#{$prefix}form-multi-select-bg: #{$form-multi-select-bg};\n  --#{$prefix}form-multi-select-bg-position: #{$form-multi-select-bg-position};\n  --#{$prefix}form-multi-select-bg-size: #{$form-multi-select-bg-size};\n  --#{$prefix}form-multi-select-border-color: #{$form-multi-select-border-color};\n  --#{$prefix}form-multi-select-border: #{$form-multi-select-border-width} solid var(--#{$prefix}form-multi-select-border-color);\n  --#{$prefix}form-multi-select-border-radius: #{$form-multi-select-border-radius};\n  --#{$prefix}form-multi-select-disabled-color: #{$form-multi-select-disabled-color};\n  --#{$prefix}form-multi-select-disabled-bg: #{$form-multi-select-disabled-bg};\n  --#{$prefix}form-multi-select-focus-color: #{$form-multi-select-focus-color};\n  --#{$prefix}form-multi-select-focus-bg: #{$form-multi-select-focus-bg};\n  --#{$prefix}form-multi-select-focus-border-color: #{$form-multi-select-focus-border-color};\n  --#{$prefix}form-multi-select-selection-tags-padding-y: #{$form-multi-select-selection-tags-padding-y};\n  --#{$prefix}form-multi-select-selection-tags-padding-x: #{$form-multi-select-selection-tags-padding-x};\n\n  --#{$prefix}form-multi-select-indicator: #{escape-svg($form-multi-select-indicator)};\n  --#{$prefix}form-multi-select-indicator-padding: #{$form-multi-select-indicator-padding};\n\n  --#{$prefix}form-multi-select-cleaner-width: #{$form-multi-select-cleaner-width};\n  --#{$prefix}form-multi-select-cleaner-height: #{$form-multi-select-cleaner-height};\n  --#{$prefix}form-multi-select-cleaner-padding-y: #{$form-multi-select-cleaner-padding-y};\n  --#{$prefix}form-multi-select-cleaner-padding-x: #{$form-multi-select-cleaner-padding-x};\n  --#{$prefix}form-multi-select-cleaner-bg: #{escape-svg($form-multi-select-cleaner-bg)};\n  --#{$prefix}form-multi-select-cleaner-hover-bg: #{escape-svg($form-multi-select-cleaner-hover-bg)};\n  --#{$prefix}form-multi-select-cleaner-focus-bg: #{escape-svg($form-multi-select-cleaner-focus-bg)};\n\n  --#{$prefix}form-multi-select-search-color: #{$form-multi-select-search-color};\n  --#{$prefix}form-multi-select-search-bg: #{$form-multi-select-search-bg};\n  --#{$prefix}form-multi-select-search-border-radius: #{$form-multi-select-search-border-radius};\n\n  --#{$prefix}form-multi-select-select-all-padding-y: #{$form-multi-select-select-all-padding-y};\n  --#{$prefix}form-multi-select-select-all-padding-x: #{$form-multi-select-select-all-padding-x};\n  --#{$prefix}form-multi-select-select-all-color: #{$form-multi-select-select-all-color};\n  --#{$prefix}form-multi-select-select-all-bg: #{$form-multi-select-select-all-bg};\n  --#{$prefix}form-multi-select-select-all-border-color: #{$form-multi-select-select-all-border-color};\n  --#{$prefix}form-multi-select-select-all-border: #{$form-multi-select-select-all-border-width} solid var(--#{$prefix}form-multi-select-select-all-border-color);\n  --#{$prefix}form-multi-select-select-all-hover-color: #{$form-multi-select-select-all-hover-color};\n  --#{$prefix}form-multi-select-select-all-hover-bg: #{$form-multi-select-select-all-hover-bg};\n\n  --#{$prefix}form-multi-select-options-margin-top: #{$form-multi-select-options-margin-top};\n  --#{$prefix}form-multi-select-options-bg: #{$form-multi-select-options-bg};\n  --#{$prefix}form-multi-select-options-border-color: #{$form-multi-select-options-border-color};\n  --#{$prefix}form-multi-select-options-border: #{$form-multi-select-options-border-width} solid var(--#{$prefix}form-multi-select-options-border-color);\n  --#{$prefix}form-multi-select-options-border-radius: #{$form-multi-select-options-border-radius};\n\n  --#{$prefix}form-multi-select-options-padding-y: #{$form-multi-select-options-padding-y};\n  --#{$prefix}form-multi-select-options-padding-x: #{$form-multi-select-options-padding-x};\n  --#{$prefix}form-multi-select-options-color: #{$form-multi-select-options-color};\n\n  --#{$prefix}form-multi-select-option-padding-y: #{$form-multi-select-option-padding-y};\n  --#{$prefix}form-multi-select-option-padding-x: #{$form-multi-select-option-padding-x};\n  --#{$prefix}form-multi-select-option-border-radius: #{$form-multi-select-option-border-radius};\n  --#{$prefix}form-multi-select-option-hover-color: #{$form-multi-select-option-hover-color};\n  --#{$prefix}form-multi-select-option-hover-bg: #{$form-multi-select-option-hover-bg};\n  --#{$prefix}form-multi-select-option-disabled-color: #{$form-multi-select-option-disabled-color};\n  --#{$prefix}form-multi-select-option-indicator-width: #{$form-multi-select-option-indicator-width};\n  --#{$prefix}form-multi-select-option-indicator-bg: #{$form-multi-select-option-indicator-bg};\n  --#{$prefix}form-multi-select-option-indicator-border: #{$form-multi-select-option-indicator-border};\n  --#{$prefix}form-multi-select-option-indicator-border-radius: #{$form-multi-select-option-indicator-border-radius};\n  --#{$prefix}form-multi-select-option-selected-bg: #{$form-multi-select-option-selected-bg};\n  --#{$prefix}form-multi-select-option-selected-indicator-bg: #{$form-multi-select-option-selected-indicator-bg};\n  --#{$prefix}form-multi-select-option-selected-indicator-bg-image: #{escape-svg($form-multi-select-option-selected-indicator-bg-image)};\n  --#{$prefix}form-multi-select-option-selected-indicator-border-color: #{$form-multi-select-option-selected-indicator-border-color};\n\n  --#{$prefix}form-multi-select-tag-padding-y: #{$form-multi-select-tag-padding-y};\n  --#{$prefix}form-multi-select-tag-padding-x: #{$form-multi-select-tag-padding-x};\n  --#{$prefix}form-multi-select-tag-margin-y: #{$form-multi-select-tag-margin-y};\n  --#{$prefix}form-multi-select-tag-margin-x: #{$form-multi-select-tag-margin-x};\n  --#{$prefix}form-multi-select-tag-bg: #{$form-multi-select-tag-bg};\n  --#{$prefix}form-multi-select-tag-border-color: #{$form-multi-select-tag-border-color};\n  --#{$prefix}form-multi-select-tag-border: #{$form-multi-select-tag-border-width} solid var(--#{$prefix}form-multi-select-tag-border-color);\n  --#{$prefix}form-multi-select-tag-border-radius: #{$form-multi-select-tag-border-radius};\n  // scss-docs-end form-multi-select-css-vars\n\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: var(--#{$prefix}form-multi-select-padding-y) var(--#{$prefix}form-multi-select-padding-x);\n  @include ltr-rtl(\"padding-right\", (var(--#{$prefix}form-multi-select-indicator-padding)));\n  font-family: var(--#{$prefix}form-multi-select-font-family);\n  @include font-size(var(--#{$prefix}form-multi-select-font-size));\n  font-weight: var(--#{$prefix}form-multi-select-font-weight);\n  line-height: var(--#{$prefix}form-multi-select-line-height);\n  color: var(--#{$prefix}form-multi-select-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-multi-select-bg);\n  background-image: var(--#{$prefix}form-multi-select-indicator);\n  background-repeat: no-repeat;\n  @include ltr-rtl-value-only(\"background-position\", var(--#{$prefix}form-multi-select-bg-position));\n  background-size: var(--#{$prefix}form-multi-select-bg-size);\n  border: var(--#{$prefix}form-multi-select-border);\n  @include border-radius(var(--#{$prefix}form-multi-select-border-radius), 0);\n\n  &:disabled,\n  &.disabled {\n    color: var(--#{$prefix}form-multi-select-disabled-color);\n    background-color: var(--#{$prefix}form-multi-select-disabled-bg);\n\n    .form-multi-select-search {\n      background: transparent;\n    }\n  }\n\n  &.form-multi-select-with-cleaner {\n    @include ltr-rtl(\"padding-right\", ($form-multi-select-indicator-padding + $form-multi-select-cleaner-width + 2 * $form-multi-select-cleaner-padding-x));\n  }\n\n  .was-validated .form-multi-select:invalid + &,\n  &.is-invalid  {\n    --#{$prefix}form-multi-select-border-color: #{$form-feedback-invalid-color};\n  }\n\n  .was-validated .form-multi-select:valid + &,\n  &.is-valid  {\n    --#{$prefix}form-multi-select-border-color: #{$form-feedback-valid-color};\n  }\n\n  // temporary fix for React.js & Vue.js versions\n  > div:not([class]):first-of-type::before {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 40px;\n    height: 100%;\n    content: \"\";\n  }\n}\n\n.form-multi-select-selection-tags {\n  min-height: calc((2 * $form-multi-select-padding-y) + ($form-multi-select-font-size * $form-multi-select-line-height) + ($form-multi-select-border-width * 2));  // stylelint-disable-line function-disallowed-list\n  padding: var(--#{$prefix}form-multi-select-selection-tags-padding-y) var(--#{$prefix}form-multi-select-selection-tags-padding-x);\n  @include ltr-rtl(\"padding-right\", var(--#{$prefix}form-multi-select-indicator-padding));\n\n  .form-multi-select-search {\n    height: ($form-multi-select-padding-y - $form-multi-select-selection-tags-padding-y) * 2 + ($form-multi-select-font-size * $form-multi-select-line-height);\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}form-multi-select-padding-x));\n  }\n}\n\n.form-multi-select-selection {\n  display: inline;\n  padding: 0;\n}\n\n.form-multi-select-selection-cleaner {\n  position: absolute;\n  top: 50%;\n  @include ltr-rtl(\"right\", var(--#{$prefix}form-multi-select-indicator-padding));\n  box-sizing: content-box;\n  width: var(--#{$prefix}form-multi-select-cleaner-width);\n  height: var(--#{$prefix}form-multi-select-cleaner-height);\n  padding: var(--#{$prefix}form-multi-select-cleaner-padding-y) var(--#{$prefix}form-multi-select-cleaner-padding-x);\n  background-color: transparent;\n  background-image: var(--#{$prefix}form-multi-select-cleaner-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: var(--#{$prefix}form-multi-select-cleaner-width) auto;\n  border: 0; // for button elements\n  @include ltr-rtl(\"border-right\", 1px solid var(--#{$prefix}form-multi-select-cleaner-border-color, $form-multi-select-cleaner-border-color));\n  transform: translateY(-50%);\n\n  &:hover {\n    background-image: var(--#{$prefix}form-multi-select-cleaner-hover-bg);\n  }\n\n  &:focus {\n    background-image: var(--#{$prefix}form-multi-select-cleaner-focus-bg);\n    outline: 0;\n  }\n}\n\n.form-multi-select-search {\n  width: auto;\n  padding: 0;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  color: var(--#{$prefix}form-multi-select-search-color);\n  appearance: none;\n  background-color: var(--#{$prefix}form-multi-select-search-bg);\n  border: 0;\n  @include border-radius(var(--#{$prefix}form-multi-select-search-border-radius), 0);\n\n  &:focus {\n    outline: 0;\n  }\n\n  &[size] {\n    display: none;\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}form-multi-select-padding-x));\n  }\n\n  &:placeholder-shown {\n    width: 100%;\n  }\n}\n\n.form-multi-select-all {\n  display: block;\n  width: 100%;\n  padding: var(--#{$prefix}form-multi-select-select-all-padding-y) var(--#{$prefix}form-multi-select-select-all-padding-x);\n  color: var(--#{$prefix}form-multi-select-select-all-color);\n  text-align: start;\n  background-color: var(--#{$prefix}form-multi-select-select-all-bg);\n  border: 0;\n  border-bottom: var(--#{$prefix}form-multi-select-select-all-border);\n\n  &:hover {\n    color: var(--#{$prefix}form-multi-select-select-all-hover-color);\n    background-color: var(--#{$prefix}form-multi-select-select-all-hover-bg);\n  }\n}\n\n.form-multi-select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  display: none; // none by default, but block on \"open\" of the menu\n  width: 100%;\n  margin-top: var(--#{$prefix}form-multi-select-options-margin-top);\n  background-color: var(--#{$prefix}form-multi-select-options-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}form-multi-select-options-border);\n  @include border-radius(var(--#{$prefix}form-multi-select-options-border-radius));\n  @include elevation(4);\n}\n\n.form-multi-select-options {\n  padding: var(--#{$prefix}form-multi-select-options-padding-y) var(--#{$prefix}form-multi-select-options-padding-x);\n  font-size: $form-multi-select-options-font-size;\n  color: var(--#{$prefix}form-multi-select-options-color);\n}\n\n.form-multi-select-option {\n  position: relative;\n  padding: var(--#{$prefix}form-multi-select-option-padding-y) var(--#{$prefix}form-multi-select-option-padding-x);\n  margin-bottom: 2px;\n  vertical-align: top;\n  cursor: pointer;\n  @include border-radius(var(--#{$prefix}form-multi-select-option-border-radius), 0);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}form-multi-select-option-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}form-multi-select-option-hover-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}form-multi-select-option-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n  }\n\n  &.form-multi-select-option-with-checkbox {\n    padding: $form-multi-select-option-padding-y $form-multi-select-option-padding-x;\n    @include ltr-rtl(\"padding-left\", calc(var(--#{$prefix}form-multi-select-option-padding-x) + var(--#{$prefix}form-multi-select-option-indicator-width)));\n    &::before {\n      position: absolute;\n      top: .7rem;\n      @include ltr-rtl(\"left\",  calc(var(--#{$prefix}form-multi-select-option-padding-x) * .5));\n      display: block;\n      width: var(--#{$prefix}form-multi-select-option-indicator-width);\n      height: var(--#{$prefix}form-multi-select-option-indicator-width);\n      pointer-events: none;\n      content: \"\";\n      background-color: var(--#{$prefix}form-multi-select-option-indicator-bg);\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: contain;\n      border: var(--#{$prefix}form-multi-select-option-indicator-border);\n      @include border-radius(var(--#{$prefix}form-multi-select-option-indicator-border-radius));\n    }\n  }\n\n\n  &.form-multi-selected {\n    background-color: var(--#{$prefix}form-multi-select-option-selected-bg);\n\n    &::before {\n      background-color: var(--#{$prefix}form-multi-select-option-selected-indicator-bg);\n      background-image: var(--#{$prefix}form-multi-select-option-selected-indicator-bg-image);\n      border-color: var(--#{$prefix}form-multi-select-option-selected-indicator-border-color);\n    }\n  }\n}\n\n.form-multi-select-optgroup-label {\n  padding: ($form-multi-select-option-padding-y * 1.5) ($form-multi-select-option-padding-x * .5) $form-multi-select-option-padding-y ($form-multi-select-option-padding-x * .5);\n  font-size: 80%;\n  font-weight: $form-multi-select-optgroup-label-font-weight;\n  color: $form-multi-select-optgroup-label-color;\n  text-transform: uppercase;\n}\n\n.form-multi-select-options-empty {\n  padding: var(--#{$prefix}form-multi-select-option-padding-y) var(--#{$prefix}form-multi-select-option-padding-x);\n}\n\n\n.form-multi-select-tag {\n  display: inline-block;\n  padding: var(--#{$prefix}form-multi-select-tag-padding-y) var(--#{$prefix}form-multi-select-tag-padding-x);\n  margin: var(--#{$prefix}form-multi-select-tag-margin-y) var(--#{$prefix}form-multi-select-tag-margin-x);\n  background-color: var(--#{$prefix}form-multi-select-tag-bg);\n  border: var(--#{$prefix}form-multi-select-tag-border);\n  @include border-radius(var(--#{$prefix}form-multi-select-tag-border-radius));\n}\n\n.form-multi-select-tag-delete {\n  padding: 0;\n  @include ltr-rtl(\"margin-left\", $spacer * .5);\n  background-color: transparent;\n  border: 0;\n}\n\n.form-multi-select.show {\n  color: var(--#{$prefix}form-multi-select-focus-color);\n  background-color: var(--#{$prefix}form-multi-select-focus-bg);\n  border-color: var(--#{$prefix}form-multi-select-focus-border-color);\n\n  @if $enable-shadows {\n    @include box-shadow($form-multi-select-box-shadow, $form-multi-select-focus-box-shadow);\n  } @else {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    box-shadow: $form-multi-select-focus-box-shadow;\n  }\n\n  .form-multi-select-search[size] {\n    display: inline;\n  }\n\n  .form-multi-select-dropdown {\n    z-index: $zindex-dropdown;\n    display: initial;\n  }\n}\n\n.form-multi-select-sm {\n  --#{$prefix}form-multi-select-padding-y: #{$form-multi-select-padding-y-sm};\n  --#{$prefix}form-multi-select-padding-x: #{$form-multi-select-padding-x-sm};\n  --#{$prefix}form-multi-select-font-size: #{$form-multi-select-font-size-sm};\n  --#{$prefix}form-multi-select-border-radius: #{$form-multi-select-border-radius-sm};\n  --#{$prefix}form-multi-select-selection-tags-padding-x: #{$form-multi-select-selection-tags-padding-x-sm};\n  --#{$prefix}form-multi-select-tag-padding-y: #{$form-multi-select-tag-padding-y-sm};\n  --#{$prefix}form-multi-select-tag-padding-x: #{$form-multi-select-tag-padding-x-sm};\n  --#{$prefix}form-multi-select-tag-margin-y: #{$form-multi-select-tag-margin-y-sm};\n  --#{$prefix}form-multi-select-tag-margin-x: #{$form-multi-select-tag-margin-x-sm};\n  --#{$prefix}form-multi-select-tag-border-radius: #{$form-multi-select-tag-border-radius-sm};\n\n  &.form-multi-select-selection-tags {\n    min-height: calc((2 * $form-multi-select-padding-y-sm) + ($form-multi-select-font-size-sm * $form-multi-select-line-height) + ($form-multi-select-border-width * 2));  // stylelint-disable-line function-disallowed-list\n\n    .form-multi-select-search {\n      height: calc((($form-multi-select-padding-y-sm - $form-multi-select-selection-tags-padding-y-sm) * 2 + ($form-multi-select-font-size-sm * $form-multi-select-line-height)) - ($form-multi-select-border-width * 2)); // stylelint-disable-line function-disallowed-list\n    }\n  }\n}\n\n.form-multi-select-lg {\n  --#{$prefix}form-multi-select-padding-y: #{$form-multi-select-padding-y-lg};\n  --#{$prefix}form-multi-select-padding-x: #{$form-multi-select-padding-x-lg};\n  --#{$prefix}form-multi-select-font-size: #{$form-multi-select-font-size-lg};\n  --#{$prefix}form-multi-select-border-radius: #{$form-multi-select-border-radius-lg};\n  --#{$prefix}form-multi-select-selection-tags-padding-x: #{$form-multi-select-selection-tags-padding-x-lg};\n  --#{$prefix}form-multi-select-tag-padding-y: #{$form-multi-select-tag-padding-y-lg};\n  --#{$prefix}form-multi-select-tag-padding-x: #{$form-multi-select-tag-padding-x-lg};\n  --#{$prefix}form-multi-select-tag-margin-y: #{$form-multi-select-tag-margin-y-lg};\n  --#{$prefix}form-multi-select-tag-margin-x: #{$form-multi-select-tag-margin-x-lg};\n  --#{$prefix}form-multi-select-tag-border-radius: #{$form-multi-select-tag-border-radius-lg};\n\n  &.form-multi-select-selection-tags {\n    min-height: calc((2 * $form-multi-select-padding-y-lg) + ($form-multi-select-font-size-lg * $form-multi-select-line-height) + ($form-multi-select-border-width * 2));  // stylelint-disable-line function-disallowed-list\n\n    .form-multi-select-search {\n      height: ($form-multi-select-padding-y-lg - $form-multi-select-selection-tags-padding-y-lg) * 2 + ($form-multi-select-font-size-lg * $form-multi-select-line-height);\n    }\n  }\n}\n","@mixin elevation($value, $exclude: null) {\n  @if $enable-elevations {\n    @if $exclude == null {\n      &:not([class*=\"border\"]) {\n        border: 0;\n      }\n      box-shadow: map-get($elevations, $value);\n    }\n    @else {\n      $selector: \":not(.placeholder)\";\n      @each $element in $exclude {\n        $selector: selector-append($selector, \":not(#{$element})\");\n      }\n      @if ($selector != \":not(.aaa\") {\n        &#{$selector} {\n          border-color: transparent;\n          box-shadow: map-get($elevations, $value);\n        }\n      }\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  @include ltr-rtl(\"padding-left\", $form-check-padding-start);\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", left);\n    @include ltr-rtl(\"margin-left\", $form-check-padding-start * -1);\n  }\n}\n\n.form-check-reverse {\n  @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n  @include ltr-rtl(\"padding-left\", 0);\n  @include ltr-rtl(\"text-align\", right);\n\n  .form-check-input {\n    @include ltr-rtl(\"float\", right);\n    @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: var(--#{$prefix}form-check-input-checked-bg-color, $form-check-input-checked-bg-color);\n    border-color: var(--#{$prefix}form-check-input-checked-border-color, $form-check-input-checked-border-color);\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: var(--#{$prefix}form-check-label-color, $form-check-label-color);\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  @include ltr-rtl(\"padding-left\", $form-switch-padding-start);\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    @include ltr-rtl(\"margin-left\", $form-switch-padding-start * -1);\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    @include ltr-rtl(\"padding-right\", $form-check-padding-start);\n    @include ltr-rtl(\"padding-left\", 0);\n\n    .form-check-input {\n      @include ltr-rtl(\"margin-right\", $form-check-padding-start * -1);\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n\n@each $size, $map in $form-switch-widths {\n  $width: map-get($map, \"width\");\n  $height: map-get($map, \"height\");\n\n  .form-switch-#{$size} {\n    min-height: $height;\n    @include ltr-rtl(\"padding-left\", $width + .5em);\n\n    .form-check-input {\n      width: $width;\n      height: $height;\n      @include ltr-rtl(\"margin-left\", ($width + .5em) * -1);\n    }\n\n    .form-check-label {\n      // stylelint-disable-next-line function-disallowed-list\n      padding-top: calc((#{$height} - #{$font-size-base}) / 2);\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  @include ltr-rtl(\"margin-right\", $form-check-inline-margin-end);\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg(var(--#{$prefix}form-range-thumb-bg, $form-range-thumb-bg));\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg(var(--#{$prefix}form-range-thumb-active-bg, $form-range-thumb-active-bg));\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: var(--#{$prefix}form-range-track-bg, $form-range-track-bg);\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n\n    &::-moz-range-thumb {\n      background-color: var(--#{$prefix}form-range-thumb-disabled-bg, $form-range-thumb-disabled-bg);\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: var(--#{$prefix}input-group-addon-color, $input-group-addon-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}input-group-addon-bg, $input-group-addon-bg);\n  border: $input-border-width solid var(--#{$prefix}input-group-addon-border-color, $input-group-addon-border-color);\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  @include ltr-rtl(\"padding-right\", $form-select-padding-x + $form-select-indicator-padding);\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    @include ltr-rtl(\"margin-left\", calc(#{$input-border-width} * -1));\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        @include ltr-rtl-value-only(\"background-position\", right $input-height-inner-quarter center, left $input-height-inner-quarter center);\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        @include ltr-rtl(\"padding-right\", $input-height-inner);\n        @include ltr-rtl-value-only(\"background-position\", top $input-height-inner-quarter right $input-height-inner-quarter, top $input-height-inner-quarter left $input-height-inner-quarter);\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          @include ltr-rtl(\"padding-right\", $form-select-feedback-icon-padding-end);\n          @include ltr-rtl-value-only(\"background-position\", #{$form-select-bg-position, $form-select-feedback-icon-position});\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      @include ltr-rtl(\"margin-left\", .5em);\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n  @include elevation(1, (\"[class*='link']\", \"[class*='outline']\", \"[class*='ghost']\", \"[class*='transparent']\", \"[class*='close']\"));\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    @include elevation(2, (\"[class*='link']\", \"[class*='outline']\", \"[class*='ghost']\", \"[class*='transparent']\", \"[class*='close']\"));\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $state, $variant in $button-variants {\n  .btn-#{$state} {\n    @include button-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-outline-#{$state} {\n    @include button-outline-variant($variant);\n  }\n}\n\n@each $state, $variant in $button-outline-ghost-variants {\n  .btn-ghost-#{$state} {\n    @include button-ghost-variant($variant);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n.btn-transparent {\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  @if $enable-gradients {\n    background-image: none;\n  }\n}\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant($variant) {\n  $background: map-get($variant, \"bg\");\n  $border-color: map-get($variant, \"border-color\");\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-background: map-get($variant, \"disabled-bg\");\n  $disabled-border-color: map-get($variant, \"disabled-border-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border-color, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border-color};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border-color};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-ghost-variant-mixin\n@mixin button-ghost-variant($variant) {\n  $color: map-get($variant, \"color\");\n  $hover-background: map-get($variant, \"hover-bg\");\n  $hover-border-color: map-get($variant, \"hover-border-color\");\n  $hover-color: map-get($variant, \"hover-color\");\n  $active-background: map-get($variant, \"active-bg\");\n  $active-border-color: map-get($variant, \"active-border-color\");\n  $active-color: map-get($variant, \"active-color\");\n  $disabled-color: map-get($variant, \"disabled-color\");\n  $shadow: map-get($variant, \"shadow\");\n\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border-color};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border-color};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-shadow: #{$shadow};\n}\n// scss-docs-end btn-ghost-variant-mixin\n\n// Button sizes\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n","//\n// Loading button\n//\n\n.btn-loading {\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-loading-spinner {\n  @include ltr-rtl(\"margin-right\", $spacer);\n  @include ltr-rtl(\"margin-left\", ($spacer * -2));\n  opacity: 0;\n  @include transition(margin .15s, opacity .15s, border .15s);\n}\n\n.btn-loading.is-loading {\n  .btn-loading-spinner {\n    width: 1rem;\n    @include ltr-rtl(\"margin-left\", 0);\n    opacity: 1;\n  }\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n  @include elevation(4);\n\n  &[data-coreui-popper] {\n    top: 100%;\n    @include ltr-rtl(\"left\", 0);\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `cui-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --cui-position: start;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", auto);\n        @include ltr-rtl(\"left\", 0);\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --cui-position: end;\n\n      &[data-coreui-popper] {\n        @include ltr-rtl(\"right\", 0);\n        @include ltr-rtl(\"left\", auto);\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-coreui-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", auto);\n    @include ltr-rtl(\"left\", 100%);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-coreui-popper] {\n    top: 0;\n    @include ltr-rtl(\"right\", 100%);\n    @include ltr-rtl(\"left\", auto);\n    margin-top: 0;\n    @include ltr-rtl(\"margin-right\", var(--#{$prefix}dropdown-spacer));\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      @include ltr-rtl(\"margin-left\", $spacing);\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        @include ltr-rtl(\"margin-right\", $spacing);\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      @include ltr-rtl(\"margin-left\", 0);\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    @include ltr-rtl(\"margin-left\", calc(#{$btn-border-width} * -1));\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    @include ltr-rtl(\"margin-left\", 0);\n  }\n\n  .dropstart &::before {\n    @include ltr-rtl(\"margin-right\", 0);\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n//\n// Underline\n//\n\n.nav-underline {\n  border-bottom: $nav-underline-border-width solid var(--#{$prefix}nav-underline-border-color, $nav-underline-border-color);\n\n  .nav-item {\n    margin-bottom: $nav-underline-border-width * -1;\n  }\n\n  .nav-link {\n    color: var(--#{$prefix}nav-underline-link-color, $nav-underline-link-color);\n    border-bottom: $nav-underline-border-width solid transparent;\n\n    &:hover,\n    &:focus {\n      border-color: var(--#{$prefix}nav-underline-link-active-border-color, $nav-underline-link-active-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-underline-link-active-color, $nav-underline-link-active-color);\n    background: transparent;\n    border-color: var(--#{$prefix}nav-underline-link-active-border-color, $nav-underline-link-active-border-color);\n  }\n}\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", var(--#{$prefix}navbar-brand-margin-end));\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v4.3.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n  @include elevation(1);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}card-spacer-x));\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        @include ltr-rtl(\"margin-left\", 0);\n        @include ltr-rtl(\"border-left\", 0);\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    @include ltr-rtl(\"padding-left\",  var(--#{$prefix}breadcrumb-item-padding-x));\n\n    &::before {\n      @include ltr-rtl(\"float\", left); // Suppress inline spacings and underlining of the separator\n      @include ltr-rtl(\"padding-right\", var(--#{$prefix}breadcrumb-item-padding-x));\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      @include ltr-rtl(\n        \"content\",\n        var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)),\n        null,\n        var(--#{$prefix}breadcrumb-divider-flipped, escape-svg($breadcrumb-divider-flipped))\n      );\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    @include ltr-rtl(\"margin-left\", $pagination-margin-start);\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--#{$prefix}badge-border-radius, 0); // stylelint-disable-line property-disallowed-list\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n//\n// Badge Sizes\n//\n\n.badge-sm {\n  --#{$prefix}badge-padding-x: #{$badge-padding-x-sm};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y-sm};\n  @include font-size($badge-font-size-sm);\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  @include ltr-rtl(\"padding-right\", $alert-dismissible-padding-r);\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"right\", 0);\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n@each $state, $value in $alert-variants {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: #{map-get($value, \"alert-color\")};\n    --#{$prefix}alert-bg: #{map-get($value, \"alert-bg\")};\n    --#{$prefix}alert-border-color: #{map-get($value, \"alert-border\")};\n    --#{$prefix}alert-link-color: #{shade-color(map-get($value, \"alert-color\"), 20%)};\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n\n.progress-thin {\n  height: 4px;\n}\n\n// White progress bar\n.progress.progress-white {\n  background-color: rgba(255, 255, 255, .2);\n  .progress-bar {\n    background-color: $white;\n  }\n}\n\n.progress-group {\n  display: flex;\n  flex-flow: row wrap;\n  margin-bottom: $progress-group-margin-bottom;\n}\n\n.progress-group-prepend {\n  flex: 0 0 100px;\n  align-self: center;\n}\n\n.progress-group-header {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  margin-bottom: $progress-group-header-margin-bottom;\n}\n\n.progress-group-bars {\n  flex-grow: 1;\n  align-self: center;\n\n  .progress:not(:last-child) {\n    margin-bottom: 2px;\n  }\n}\n\n.progress-group-header + .progress-group-bars {\n  flex-basis: 100%;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  @include ltr-rtl(\"padding-left\", 0); // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          @include ltr-rtl(\"border-left-width\", 0);\n\n          &.active {\n            @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}list-group-border-width)));\n            @include ltr-rtl(\"border-left-width\", var(--#{$prefix}list-group-border-width));\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $variant in $list-group-variants {\n  .list-group-item-#{$state} {\n    @include list-group-item-variant($state, $variant);\n  }\n}\n// scss-docs-end list-group-modifiers\n","@include deprecate(\"`list-group-item-variant()`\", \"v4.3.0\", \"v6.0.0\");\n\n// List Groups\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $variant) {\n  $background: map-get($variant, \"bg\");\n  $background-hover: map-get($variant, \"bg-hover\");\n  $color: contrast-ratio-correction(map-get($variant, \"color\"), map-get($variant, \"bg\"), $alert-color-scale, $state);\n\n  --#{$prefix}list-group-color: #{$color};\n  --#{$prefix}list-group-bg: #{$background};\n  --#{$prefix}list-group-hover-bg: #{$background-hover};\n  --#{$prefix}list-group-action-hover-color: #{$color};\n  --#{$prefix}list-group-action-active-color: #{$white};\n  --#{$prefix}list-group-action-active-bg: #{$color};\n  --#{$prefix}list-group-action-active-border-color: #{$color};\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n.btn-close-white {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}toast-padding-x)));\n    @include ltr-rtl(\"margin-left\", var(--#{$prefix}toast-padding-x));\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  @include ltr-rtl(\"left\", 0);\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n  @include elevation(24);\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    @include ltr-rtl-value-only(\"margin\", calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto, calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)));\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v4\", \"v4.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}carousel-control-color, $carousel-control-color);\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-coreui-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-coreui-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg, $carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color, $carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-dark-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-dark-caption-color};\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-coreui-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        @include ltr-rtl(\"left\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-right\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        @include ltr-rtl-value-only(\"transform\", translateX(-100%), translateX(100%));\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        @include ltr-rtl(\"right\", 0);\n        width: var(--#{$prefix}offcanvas-width);\n        @include ltr-rtl(\"border-left\", var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color));\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none !important; // stylelint-disable-line declaration-no-important\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, var(--#{$prefix}offcanvas-backdrop-bg, $offcanvas-backdrop-bg), $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    @include ltr-rtl(\"margin-right\", calc(-.5 * var(--#{$prefix}offcanvas-padding-x)));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n",".avatar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  @include border-radius(50em);\n  @include transition($avatar-transition);\n  @include avatar($avatar-width);\n}\n\n.avatar-img {\n  width: 100%;\n  height: auto;\n  @include border-radius(50em);\n}\n\n.avatar-status {\n  position: absolute;\n  @include ltr-rtl(\"right\", 0);\n  bottom: 0;\n  display: block;\n  border: 1px solid $white;\n  @include border-radius(50em);\n}\n\n@each $width, $value in $avatar-widths {\n  .avatar-#{$width} {\n    @include avatar($value);\n  }\n}\n\n.avatars-stack {\n  display: flex;\n\n  .avatar {\n    @include ltr-rtl(\"margin-right\", - ($avatar-width * .4));\n\n    &:hover {\n      @include ltr-rtl(\"margin-right\", 0);\n    }\n  }\n\n  @each $width, $value in $avatar-widths {\n    .avatar-#{$width} {\n      @include ltr-rtl(\"margin-right\", - ($value * .4));\n    }\n  }\n}\n","@mixin avatar($width) {\n  width: $width;\n  height: $width;\n  font-size: $width * .4;\n\n  .avatar-status {\n    width: divide($width, 3.75);\n    height: divide($width, 3.75);\n  }\n}\n",".calendar {\n  // scss-docs-start calendar-css-vars\n  --#{$prefix}calendar-table-margin: #{$calendar-table-margin};\n  --#{$prefix}calendar-table-cell-size: #{$calendar-table-cell-size};\n  --#{$prefix}calendar-nav-padding: #{$calendar-nav-padding};\n  --#{$prefix}calendar-nav-border: #{$calendar-nav-border-width} solid #{$calendar-nav-border-color};\n  --#{$prefix}calendar-nav-date-color: #{$calendar-nav-date-color};\n  --#{$prefix}calendar-nav-date-hover-color: #{$calendar-nav-date-hover-color};\n  --#{$prefix}calendar-nav-icon-width: #{$calendar-nav-icon-width};\n  --#{$prefix}calendar-nav-icon-height: #{$calendar-nav-icon-height};\n  --#{$prefix}calendar-cell-header-inner-color: #{$calendar-cell-header-inner-color};\n  --#{$prefix}calendar-cell-hover-bg: #{$calendar-cell-hover-bg};\n  --#{$prefix}calendar-cell-disabled-color: #{$calendar-cell-disabled-color};\n  --#{$prefix}calendar-cell-selected-color: #{$calendar-cell-selected-color};\n  --#{$prefix}calendar-cell-selected-bg: #{$calendar-cell-selected-bg};\n  --#{$prefix}calendar-cell-range-bg: #{$calendar-cell-range-bg};\n  --#{$prefix}calendar-cell-range-hover-bg: #{$calendar-cell-range-hover-bg};\n  --#{$prefix}calendar-cell-range-hover-border-color: #{$calendar-cell-range-hover-border-color};\n  --#{$prefix}calendar-cell-today-color: #{$calendar-cell-today-color};\n  // scss-docs-end calendar-css-vars\n\n  font-weight: initial;\n\n  table {\n    width: calc(var(--#{$prefix}calendar-table-cell-size) * 7); // stylelint-disable-line function-disallowed-list\n    margin: var(--#{$prefix}calendar-table-margin);\n\n    th,\n    td {\n      width: var(--#{$prefix}calendar-table-cell-size);\n    }\n  }\n\n  &.months ~ .time-picker,\n  &.years ~ .time-picker {\n    display: none;\n  }\n}\n\n.calendars {\n  display: flex;\n}\n\n.calendar-nav {\n  display: flex;\n  align-items: baseline;\n  padding: var(--#{$prefix}calendar-nav-padding);\n  border-bottom: var(--#{$prefix}calendar-nav-border);\n}\n\n.calendar-nav-date {\n  flex: 1;\n  text-align: center;\n\n  .btn {\n    font-weight: 600;\n    color: var(--#{$prefix}calendar-nav-date-color);\n\n    &:hover {\n      color: var(--#{$prefix}calendar-nav-date-hover-color);\n    }\n  }\n}\n\n.calendar-nav-icon {\n  display: block;\n  width: var(--#{$prefix}calendar-nav-icon-width);\n  height: var(--#{$prefix}calendar-nav-icon-height);\n  @include transition(background-image .15s ease-in-out);\n}\n\n.calendar-nav-icon-double-next {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-double-next), escape-svg($calendar-nav-icon-double-prev));\n  &:hover {\n    @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-double-next-hover), escape-svg($calendar-nav-icon-double-prev-hover));\n  }\n}\n\n.calendar-nav-icon-double-prev {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-double-prev), escape-svg($calendar-nav-icon-double-next));\n  &:hover {\n    @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-double-prev-hover), escape-svg($calendar-nav-icon-double-next-hover));\n  }\n}\n\n.calendar-nav-icon-next {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-next), escape-svg($calendar-nav-icon-prev));\n  &:hover {\n    @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-next-hover), escape-svg($calendar-nav-icon-prev-hover));\n  }\n}\n\n.calendar-nav-icon-prev {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-prev), escape-svg($calendar-nav-icon-next));\n  &:hover {\n    @include ltr-rtl-value-only(\"background-image\", escape-svg($calendar-nav-icon-prev-hover), escape-svg($calendar-nav-icon-next-hover));\n  }\n}\n\n.calendar-header-cell-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: var(--#{$prefix}calendar-table-cell-size);\n  font-weight: 600;\n  color: var(--#{$prefix}calendar-cell-header-inner-color);\n}\n\n.calendar-cell {\n  padding: 1px 0;\n  text-align: center;\n\n  &:not(.disabled):not(.next):not(.previous):hover .calendar-cell-inner,\n  &.clickable:hover .calendar-cell-inner {\n    cursor: pointer;\n    background-color: var(--#{$prefix}calendar-cell-hover-bg);\n  }\n\n  &.today .calendar-cell-inner {\n    color: var(--#{$prefix}calendar-cell-today-color);\n  }\n\n  &.disabled,\n  &.next,\n  &.previous .calendar-cell-inner {\n    color: var(--#{$prefix}calendar-cell-disabled-color);\n  }\n\n  &.disabled .calendar-cell-inner {\n    cursor: not-allowed;\n  }\n\n  &.range:not(.selected) .calendar-cell-inner {\n    background: var(--#{$prefix}calendar-cell-range-bg);\n    @include border-radius(0);\n  }\n\n  &.range:not(.selected):hover .calendar-cell-inner {\n    position: relative;\n    &::after {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      content: \"\";\n      background: var(--#{$prefix}calendar-cell-range-hover-bg);\n      @include border-radius($border-radius);\n    }\n  }\n\n  &.range:not(.selected):first-child .calendar-cell-inner,\n  &:not(.range) + .range .calendar-cell-inner {\n    @include border-start-radius($border-radius);\n  }\n\n  &.range:not(.selected):last-child .calendar-cell-inner,\n  &.range:not(.selected).last .calendar-cell-inner {\n    @include border-end-radius($border-radius);\n  }\n\n  &.range-hover .calendar-cell-inner {\n    position: relative;\n    &::before {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      content: \"\";\n    }\n  }\n\n  &.range-hover .calendar-cell-inner,\n  &.range-hover.selected .calendar-cell-inner {\n    &::before {\n      border-top: 1px dashed var(--#{$prefix}calendar-cell-selected-bg);\n      border-bottom: 1px dashed var(--#{$prefix}calendar-cell-selected-bg);\n      @include border-radius(0);\n    }\n  }\n\n  &.range-hover:first-child .calendar-cell-inner,\n  &:not(.range-hover) + .range-hover .calendar-cell-inner {\n    &::before {\n      border-left: 1px dashed var(--#{$prefix}calendar-cell-selected-bg);\n      @include border-start-radius($border-radius);\n    }\n  }\n\n  &.range-hover:last-child .calendar-cell-inner,\n  &.range-hover.last .calendar-cell-inner,\n  &.range-hover + .range-hover:hover .calendar-cell-inner,\n  &.range-hover:first-child:hover .calendar-cell-inner {\n    &::before {\n      border-right: 1px dashed var(--#{$prefix}calendar-cell-selected-bg);\n      @include border-end-radius($border-radius);\n    }\n  }\n\n  &.range-hover.selected:hover .calendar-cell-inner {\n    &::before {\n      border: 0;\n    }\n  }\n\n  &.selected:not(.previous):not(.next) .calendar-cell-inner,\n  &.selected:not(.previous):not(.next).start .calendar-cell-inner,\n  &.selected:not(.previous):not(.next).end .calendar-cell-inner {\n    position: relative;\n    color: var(--#{$prefix}calendar-cell-selected-color);\n    background: var(--#{$prefix}calendar-cell-selected-bg);\n  }\n\n  &.selected:not(.previous):not(.next).start .calendar-cell-inner,\n  &.selected:not(.previous):not(.next).end .calendar-cell-inner {\n    &::before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      z-index: -1;\n      content: \"\";\n      background: var(--#{$prefix}calendar-cell-range-bg);\n    }\n  }\n\n  &.selected:not(.previous):not(.next).start .calendar-cell-inner::before {\n    @include border-start-radius($border-radius);\n    @include border-end-radius(0);\n  }\n  &.selected:not(.previous):not(.next).end .calendar-cell-inner::before {\n    @include border-start-radius(0);\n    @include border-end-radius($border-radius);\n  }\n}\n\n.calendar-cell-inner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: var(--#{$prefix}calendar-table-cell-size);\n  @include border-radius($border-radius);\n}\n",".callout {\n  // scss-docs-start callout-css-vars\n  --#{$prefix}callout-padding-x: #{$callout-padding-x};\n  --#{$prefix}callout-padding-y: #{$callout-padding-y};\n  --#{$prefix}callout-margin-x: #{$callout-margin-x};\n  --#{$prefix}callout-margin-y: #{$callout-margin-y};\n  --#{$prefix}callout-border-width: #{$callout-border-width};\n  --#{$prefix}callout-border-color: #{$callout-border-color};\n  --#{$prefix}callout-border-left-width: #{$callout-border-left-width};\n  --#{$prefix}callout-border-radius: #{$callout-border-radius};\n  // scss-docs-end callout-css-vars\n\n  padding: var(--#{$prefix}callout-padding-y) var(--#{$prefix}callout-padding-x);\n  margin: var(--#{$prefix}callout-margin-y) var(--#{$prefix}callout-margin-x);\n  border: var(--#{$prefix}callout-border-width) solid var(--#{$prefix}callout-border-color);\n  @include ltr-rtl(\"border-left-width\", var(--#{$prefix}callout-border-left-width));\n  @include ltr-rtl(\"border-left-color\", var(--#{$prefix}callout-border-left-color));\n  @include border-radius(var(--#{$prefix}callout-border-radius));\n}\n\n// scss-docs-start callout-modifiers\n// Generate contextual modifier classes for colorizing the collor.\n@each $state, $value in $callout-variants {\n  .callout-#{$state} {\n    --#{$prefix}callout-border-left-color: #{$value};\n  }\n}\n// scss-docs-end callout-modifiers\n",".picker {\n  // scss-docs-start picker-css-vars\n  --#{$prefix}picker-footer-border-top: #{$picker-footer-border-width} solid #{$picker-footer-border-color};\n  --#{$prefix}picker-footer-padding: #{$picker-footer-padding};\n  // scss-docs-end picker-css-vars\n\n  .dropdown-menu {\n    padding: 0;\n  }\n\n  &.show {\n    .input-group {\n      color: var(--#{$prefix}input-focus-color, $input-focus-color);\n      background-color: var(--#{$prefix}input-focus-bg, $input-focus-bg);\n      border-color: var(--#{$prefix}input-focus-border-color, $input-focus-border-color);\n      outline: 0;\n      @if $enable-shadows {\n        @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: $input-focus-box-shadow;\n      }\n    }\n  }\n}\n\n.picker-input-group {\n  &:hover {\n    .form-control:not(:placeholder-shown) ~ .input-group-text {\n      .picker-input-group-indicator:not(:last-child) {\n        display: none;\n      }\n      .picker-input-group-cleaner {\n        display: initial;\n      }\n    }\n  }\n\n  .form-control {\n    &.hover {\n      color: var(--cui-gray-500);\n    }\n\n    &:focus {\n      border-color: var(--#{$prefix}input-border-color, $input-border-color);\n      outline: 0;\n      box-shadow: none;\n    }\n\n    &:not(:first-child) {\n      @include ltr-rtl(\"border-left\", 0);\n    }\n\n    &:not(:last-child) {\n      @include ltr-rtl(\"border-right\", 0);\n    }\n\n    &[readonly] {\n      background-color: var(--#{$prefix}input-bg, $input-bg);\n    }\n\n    &.form-control:disabled + .input-group-text {\n      background-color: var(--#{$prefix}input-disabled-bg, $input-disabled-bg);\n    }\n  }\n\n  &.input-group {\n    @include border-radius($input-border-radius, 0);\n  }\n\n  &.input-group-lg {\n    @include border-radius($input-border-radius-lg, 0);\n\n    .picker-input-group-icon {\n      width: 1.25rem;\n      height: 1.25rem;\n      font-size: 1.25rem;\n    }\n  }\n\n  &.input-group-sm {\n    @include border-radius($input-border-radius-sm, 0);\n\n    .picker-input-group-icon {\n      width: .875rem;\n      height: .875rem;\n      font-size: .875rem;\n    }\n  }\n\n  .input-group-text {\n    color: var(--cui-gray-400);\n    background-color: var(--#{$prefix}input-bg, $input-bg);\n  }\n}\n\n.picker-input-group-cleaner {\n  display: none;\n}\n\n.picker-input-group-icon {\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  font-size: 1rem;\n  @include transition(background-image .15s ease-in-out);\n}\n\n.picker-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: var(--#{$prefix}picker-footer-padding);\n  border-top: var(--#{$prefix}picker-footer-border-top);\n\n  .btn + .btn {\n    @include ltr-rtl(\"margin-left\", .5rem);\n  }\n}\n",".date-picker {\n  // scss-docs-start date-picker-css-vars\n  --#{$prefix}date-picker-ranges-width: #{$date-picker-ranges-width};\n  --#{$prefix}date-picker-ranges-padding: #{$date-picker-ranges-padding};\n  --#{$prefix}date-picker-ranges-border: #{$date-picker-ranges-border-width} solid #{$date-picker-ranges-border-color};\n  --#{$prefix}date-picker-timepicker-width: #{$date-picker-timepicker-width};\n  --#{$prefix}date-picker-timepicker-border-top: #{$date-picker-timepicker-border-width} solid #{$date-picker-timepicker-border-color};\n  // scss-docs-end date-picker-css-vars\n\n  .dropdown-menu {\n    width: min-content;\n  }\n\n  &.is-invalid  {\n    .form-control {\n      --#{$prefix}input-border-color: #{$form-feedback-invalid-color};\n    }\n\n    .input-group-text {\n      --#{$prefix}input-group-addon-border-color: #{$form-feedback-invalid-color};\n    }\n\n    .picker-input-group-indicator {\n      --#{$prefix}input-group-addon-color: #{$form-feedback-invalid-color};\n    }\n\n    .date-picker-input-icon {\n      background-image: escape-svg($date-picker-invalid-icon);\n    }\n  }\n\n  &.is-valid  {\n    .form-control {\n      --#{$prefix}input-border-color: #{$form-feedback-valid-color};\n    }\n\n    .input-group-text {\n      --#{$prefix}input-group-addon-border-color: #{$form-feedback-valid-color};\n    }\n\n    .picker-input-group-indicator {\n      --#{$prefix}input-group-addon-color: #{$form-feedback-valid-color};\n    }\n\n    .date-picker-input-icon {\n      background-image: escape-svg($date-picker-valid-icon);\n    }\n  }\n}\n\n.date-picker-body {\n  display: grid;\n  grid-template-areas:\n    \"ranges calendars\"\n    \"ranges timepickers\";\n  grid-template-rows: auto;\n  grid-template-columns: auto auto;\n\n}\n\n.date-picker-ranges {\n  grid-area: ranges;\n  width: var(--#{$prefix}date-picker-ranges-width);\n  padding: var(--#{$prefix}date-picker-ranges-padding);\n  border-right: var(--#{$prefix}date-picker-ranges-border);\n}\n\n.date-picker-calendars {\n  display: flex;\n  grid-area: calendars;\n\n  .date-picker-calendar {\n    &:not(:last-child) {\n      .calendar-navigation-next {\n        visibility: hidden;\n      }\n    }\n    &:not(:first-child) {\n      .calendar-navigation-prev {\n        visibility: hidden;\n      }\n    }\n  }\n}\n\n.date-picker-arrow-icon {\n  @include ltr-rtl-value-only(\"background-image\", escape-svg($date-picker-separator-icon), escape-svg($date-picker-separator-icon-rtl));\n}\n\n.date-picker-cleaner-icon {\n  background-image: escape-svg($date-picker-cleaner-icon);\n\n  &:hover {\n    background-image: escape-svg($date-picker-cleaner-icon-hover);\n  }\n}\n\n.date-picker-input-icon {\n  background-image: escape-svg($date-picker-default-icon);\n}\n\n.date-picker-timepickers {\n  display: flex;\n  flex-wrap: wrap;\n  grid-area: timepickers;\n  justify-content: space-between;\n  border-top: var(--#{$prefix}date-picker-timepicker-border-top);\n\n  .time-picker {\n    width: var(--#{$prefix}date-picker-timepicker-width);\n\n    .form-select {\n      width: initial;\n      padding-right: .25rem !important; // stylelint-disable-line declaration-no-important\n      padding-left: .25rem !important; // stylelint-disable-line declaration-no-important\n      text-align: right;\n      background-image: none !important; // stylelint-disable-line declaration-no-important\n      border: 0;\n\n      &:disabled {\n        color: $text-disabled;\n        background-color: transparent;\n      }\n    }\n  }\n\n  @include media-breakpoint-down(md) {\n    display: block;\n\n    .time-picker {\n      width: 100%;\n\n      + .time-picker {\n        border-top: var(--#{$prefix}date-picker-timepicker-border-top);\n      }\n    }\n  }\n}\n",".time-picker {\n  // scss-docs-start time-picker-css-vars\n  --#{$prefix}time-picker-body-padding: #{$time-picker-body-padding};\n  --#{$prefix}time-picker-roll-col-border: #{$time-picker-roll-col-border-width} solid #{$time-picker-roll-col-border-color};\n  // scss-docs-end time-picker-css-vars\n\n  &.is-invalid  {\n    .form-control {\n      --#{$prefix}input-border-color: #{$form-feedback-invalid-color};\n    }\n\n    .input-group-text {\n      --#{$prefix}input-group-addon-border-color: #{$form-feedback-invalid-color};\n    }\n\n    .picker-input-group-indicator {\n      --#{$prefix}input-group-addon-color: #{$form-feedback-invalid-color};\n    }\n\n    .time-picker-input-icon {\n      background-image: escape-svg($time-picker-invalid-icon);\n    }\n  }\n\n  &.is-valid  {\n    .form-control {\n      --#{$prefix}input-border-color: #{$form-feedback-valid-color};\n    }\n\n    .input-group-text {\n      --#{$prefix}input-group-addon-border-color: #{$form-feedback-valid-color};\n    }\n\n    .picker-input-group-indicator {\n      --#{$prefix}input-group-addon-color: #{$form-feedback-valid-color};\n    }\n\n    .time-picker-input-icon {\n      background-image: escape-svg($time-picker-valid-icon);\n    }\n  }\n}\n\n.time-picker-body {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}time-picker-body-padding);\n\n  .form-select {\n    padding-right: 1.25rem;\n    background-position: right .5rem center;\n\n    + .form-select {\n      margin-left: $spacer * .5;\n    }\n\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n\n    &::-webkit-scrollbar {\n      width: 10px;\n    }\n  }\n\n  .time-picker-inline-icon {\n    display: block;\n    width: 40px;\n    height: 1.25rem;\n    background-image: escape-svg($time-picker-default-icon);\n    background-repeat: no-repeat;\n    background-position: center;\n  }\n}\n\n.time-picker-cleaner-icon {\n  background-image: escape-svg($time-picker-cleaner-icon);\n\n  &:hover {\n    background-image: escape-svg($time-picker-cleaner-icon-hover);\n  }\n}\n\n.time-picker-input-icon {\n  background-image: escape-svg($time-picker-default-icon);\n}\n\n.time-picker-roll {\n  padding: 0;\n  overflow: hidden;\n  border-radius: inherit; // stylelint-disable-line\n}\n\n.time-picker-roll-col {\n  height: calc(8 * 32px); // stylelint-disable-line\n  overflow: scroll;\n  border-right: var(--#{$prefix}time-picker-roll-col-border);\n\n  -ms-overflow-style: none;  /* Internet Explorer 10+ */\n  scrollbar-width: none;  /* Firefox */\n\n  &::-webkit-scrollbar {\n    display: none;  /* Safari and Chrome */\n  }\n}\n\n.time-picker-roll-cell {\n  width: 50px;\n  height: 32px;\n  padding: 0 $spacer 0 $spacer * .5;\n  line-height: 32px;\n\n  &.selected {\n    color: var(--cui-white);\n    background: var(--cui-primary);\n  }\n\n  &:last-child::after {\n    display: block;\n    height: calc(7 * 32px); // stylelint-disable-line\n    content: \"\";\n  }\n}\n",".footer {\n  // scss-docs-start footer-css-vars\n  --#{$prefix}footer-min-height: #{$footer-min-height};\n  --#{$prefix}footer-padding-x: #{$footer-padding-x};\n  --#{$prefix}footer-padding-y: #{$footer-padding-y};\n  --#{$prefix}footer-color: #{$footer-color};\n  --#{$prefix}footer-bg: #{$footer-bg};\n  --#{$prefix}footer-border-color: #{$footer-border-color};\n  --#{$prefix}footer-border: #{$footer-border-width} solid var(--#{$prefix}footer-border-color);\n  // scss-docs-end footer-css-vars\n\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between;\n  min-height: var(--#{$prefix}footer-min-height);\n  padding: var(--#{$prefix}footer-padding-y) var(--#{$prefix}footer-padding-x);\n  color: var(--#{$prefix}footer-color);\n  background: var(--#{$prefix}footer-bg);\n  border-top: var(--#{$prefix}footer-border);\n}\n\n.footer-sticky {\n  position: sticky;\n  bottom: 0;\n  z-index: $zindex-fixed;\n  @include elevation(2, \"top\");\n}\n",".header {\n  // scss-docs-start header-css-vars\n  --#{$prefix}header-min-height: #{$header-min-height};\n  --#{$prefix}header-padding-x: #{$header-padding-x};\n  --#{$prefix}header-padding-y: #{$header-padding-y};\n  --#{$prefix}header-bg: #{$header-bg};\n  --#{$prefix}header-color: #{$header-color};\n  --#{$prefix}header-border-color: #{$header-border-color};\n  --#{$prefix}header-border: #{$header-border-width} solid var(--#{$prefix}header-border-color);\n  --#{$prefix}header-hover-color: #{$header-hover-color};\n  --#{$prefix}header-disabled-color: #{$header-disabled-color};\n  --#{$prefix}header-active-color: #{$header-active-color};\n  --#{$prefix}header-brand-padding-y: #{$header-brand-padding-y};\n  --#{$prefix}header-brand-color: #{$header-brand-color};\n  --#{$prefix}header-brand-hover-color: #{$header-brand-hover-color};\n  --#{$prefix}header-toggler-padding-x: #{$header-toggler-padding-x};\n  --#{$prefix}header-toggler-padding-y: #{$header-toggler-padding-y};\n  --#{$prefix}header-toggler-bg: #{$header-toggler-bg};\n  --#{$prefix}header-toggler-color: #{$header-toggler-color};\n  --#{$prefix}header-toggler-border-radius: #{$header-toggler-border-radius};\n  --#{$prefix}header-toggler-hover-color: #{$header-toggler-hover-color};\n  --#{$prefix}header-toggler-icon-bg: #{escape-svg($header-toggler-icon-bg)};\n  --#{$prefix}header-toggler-hover-icon-bg: #{escape-svg($header-toggler-hover-icon-bg)};\n  --#{$prefix}header-nav-link-padding-x: #{$header-nav-link-padding-x};\n  --#{$prefix}header-nav-link-padding-y: #{$header-nav-link-padding-y};\n  --#{$prefix}header-divider-border-color: #{$header-divider-border-color};\n  --#{$prefix}header-divider-border: #{$header-divider-border-width} solid var(--#{$prefix}header-divider-border-color);\n  --#{$prefix}subheader-min-height: #{$subheader-min-height};\n  // scss-docs-end header-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: var(--#{$prefix}header-min-height);\n  padding: var(--#{$prefix}header-padding-y) var(--#{$prefix}header-padding-x);\n  background: var(--#{$prefix}header-bg);\n  border-bottom: var(--#{$prefix}header-border);\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n\n  .container:first-child,\n  .container-fluid:first-child {\n    min-height: calc(var(--#{$prefix}header-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  .container:nth-child(n+2),\n  .container-fluid:nth-child(n+2) {\n    min-height: calc(var(--#{$prefix}subheader-min-height) - (2 * var(--#{$prefix}header-padding-y))); // stylelint-disable-line function-disallowed-list\n  }\n\n  &.header-sticky {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-fixed - 1;\n    @include elevation(2);\n  }\n}\n\n.header-divider {\n  flex-basis: calc(100% + (2 * var(--#{$prefix}header-padding-x))); // stylelint-disable-line function-disallowed-list\n  height: 0;\n  margin: var(--#{$prefix}header-padding-y) calc(var(--#{$prefix}header-padding-x) * -1); // stylelint-disable-line function-disallowed-list\n  border-top: var(--#{$prefix}header-divider-border);\n}\n\n// Header brand\n//\n// Used for brand, project, or site names.\n\n.header-brand {\n  padding-top: var(--#{$prefix}header-brand-padding-y);\n  padding-bottom: var(--#{$prefix}header-brand-padding-y);\n  @include ltr-rtl(\"margin-right\", $header-brand-margin-end);\n  @include font-size($header-brand-font-size);\n  color: var(--#{$prefix}header-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}header-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n// Header nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.header-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding: var(--#{$prefix}header-nav-link-padding-y) var(--#{$prefix}header-nav-link-padding-x);\n    color: var(--#{$prefix}header-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}header-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}header-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n\n// Header text\n//\n//\n\n.header-text {\n  padding-top: var(--#{$prefix}header-nav-link-padding-y);\n  padding-bottom: var(--#{$prefix}header-nav-link-padding-y);\n  color: var(--#{$prefix}header-color);\n\n  a {\n    color: var(--#{$prefix}header-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}header-active-color);\n    }\n  }\n}\n\n.header-toggler {\n  padding: var(--#{$prefix}header-toggler-padding-y) var(--#{$prefix}header-toggler-padding-x);\n  @include font-size($header-toggler-font-size);\n  color: var(--#{$prefix}header-toggler-color);\n  background-color: var(--#{$prefix}header-toggler-bg);\n  border: 0; // remove default button style\n  @include border-radius(var(--#{$prefix}header-toggler-border-radius));\n\n  &:hover {\n    color: var(--#{$prefix}header-toggler-hover-color);\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  // Opinionated: add \"hand\" cursor to non-disabled .navbar-toggler elements\n  &:not(:disabled) {\n    cursor: pointer;\n  }\n\n  &.prevent-hide {\n    display: block !important; // stylelint-disable-line declaration-no-important\n  }\n}\n\n.header-toggler-icon {\n  display: block;\n  height: $header-toggler-font-size * 1.25;\n  background-image: var(--#{$prefix}header-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 100% 100%;\n\n  &:hover {\n    background-image: var(--#{$prefix}header-toggler-hover-icon-bg);\n  }\n}\n",".icon {\n  display: inline-block;\n  color: inherit;\n  text-align: center;\n  vertical-align: -.125rem; // Fix the position of icon\n  fill: currentcolor;\n  &:not(.icon-c-s):not(.icon-custom-size) {\n    @include icon-size($icon-size-base);\n\n    &.icon-xxl {\n      @include icon-size($icon-size-xxl);\n    }\n\n    &.icon-xl {\n      @include icon-size($icon-size-xl);\n    }\n\n    &.icon-lg {\n      @include icon-size($icon-size-lg);\n    }\n\n    &.icon-sm {\n      @include icon-size($icon-size-sm);\n    }\n\n    @for $i from 3 through 9 {\n      &.icon-#{$i}xl {\n        @include icon-size($i * $icon-size-base);\n      }\n    }\n  }\n}\n","// Icon sizes\n@mixin icon-size($icon-size) {\n  width: $icon-size;\n  height: $icon-size;\n  font-size: $icon-size;\n}\n",".sidebar {\n  // scss-docs-start sidebar-css-vars\n  --#{$prefix}sidebar-width: #{$sidebar-width};\n  --#{$prefix}sidebar-bg: #{$sidebar-bg};\n  --#{$prefix}sidebar-padding-x: #{$sidebar-padding-x};\n  --#{$prefix}sidebar-padding-y: #{$sidebar-padding-y};\n  --#{$prefix}sidebar-color: #{$sidebar-color};\n  --#{$prefix}sidebar-border-width: #{$sidebar-border-width};\n  --#{$prefix}sidebar-border-color: #{$sidebar-border-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-brand-color};\n  --#{$prefix}sidebar-brand-height: #{$sidebar-brand-height};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-brand-bg};\n  --#{$prefix}sidebar-close-button-width: #{$sidebar-close-button-width};\n  --#{$prefix}sidebar-close-button-height: #{$sidebar-close-button-height};\n  --#{$prefix}sidebar-header-height: #{$sidebar-header-height};\n  --#{$prefix}sidebar-header-bg: #{$sidebar-header-bg};\n  --#{$prefix}sidebar-header-padding-x: #{$sidebar-header-padding-x};\n  --#{$prefix}sidebar-header-padding-y: #{$sidebar-header-padding-y};\n  --#{$prefix}sidebar-footer-bg: #{$sidebar-footer-bg};\n  --#{$prefix}sidebar-footer-height: #{$sidebar-footer-height};\n  --#{$prefix}sidebar-footer-padding-x: #{$sidebar-footer-padding-x};\n  --#{$prefix}sidebar-footer-padding-y: #{$sidebar-footer-padding-y};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-toggler-bg};\n  --#{$prefix}sidebar-toggler-height: #{$sidebar-toggler-height};\n  --#{$prefix}sidebar-toggler-indicator: #{escape-svg($sidebar-toggler-indicator-icon)};\n  --#{$prefix}sidebar-toggler-indicator-width: #{$sidebar-toggler-indicator-width};\n  --#{$prefix}sidebar-toggler-indicator-height: #{$sidebar-toggler-indicator-height};\n  --#{$prefix}sidebar-toggler-hover-bg: #{$sidebar-toggler-hover-bg};\n  --#{$prefix}sidebar-toggler-indicator-hover: #{escape-svg($sidebar-toggler-indicator-hover-icon)};\n\n  --#{$prefix}sidebar-narrow-width: #{$sidebar-narrow-width};\n\n  --#{$prefix}sidebar-nav-title-padding-x: #{$sidebar-nav-title-padding-x};\n  --#{$prefix}sidebar-nav-title-padding-y: #{$sidebar-nav-title-padding-y};\n  --#{$prefix}sidebar-nav-title-margin-top: #{$sidebar-nav-title-margin-top};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-nav-title-color};\n  --#{$prefix}sidebar-nav-link-padding-x: #{$sidebar-nav-link-padding-x};\n  --#{$prefix}sidebar-nav-link-padding-y: #{$sidebar-nav-link-padding-y};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-border-color: #{$sidebar-nav-link-border-color};\n  --#{$prefix}sidebar-nav-link-border: #{$sidebar-nav-link-border-width} solid var(--#{$prefix}sidebar-nav-link-border-color);\n  --#{$prefix}sidebar-nav-link-border-radius: #{$sidebar-nav-link-border-radius};\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-nav-link-hover-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-nav-link-hover-icon-color};\n  --#{$prefix}sidebar-nav-icon-width: #{$sidebar-nav-icon-width};\n  --#{$prefix}sidebar-nav-icon-height: #{$sidebar-nav-icon-height};\n  --#{$prefix}sidebar-nav-icon-font-size: #{$sidebar-nav-icon-font-size};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-items-padding-y: #{$sidebar-nav-group-items-padding-y};\n  --#{$prefix}sidebar-nav-group-items-padding-x: #{$sidebar-nav-group-items-padding-x};\n  --#{$prefix}sidebar-nav-group-indicator: #{escape-svg($sidebar-nav-group-indicator-icon)};\n  --#{$prefix}sidebar-nav-group-indicator-hover: #{escape-svg($sidebar-nav-group-indicator-hover-icon)};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-nav-group-toggle-show-color};\n  // scss-docs-end sidebar-css-vars\n\n  position: relative;\n  display: flex;\n  // $sidebar-width is the width of the columns\n  flex: 0 0 var(--#{$prefix}sidebar-width);\n  flex-direction: column;\n  // put the nav on the left\n  order: -1;\n  width: var(--#{$prefix}sidebar-width);\n  padding: var(--#{$prefix}sidebar-padding-y) var(--#{$prefix}sidebar-padding-x);\n  color: var(--#{$prefix}sidebar-color);\n  background: var(--#{$prefix}sidebar-bg);\n  @include ltr-rtl(\"border-right\", var(--#{$prefix}sidebar-border-width) solid var(--#{$prefix}sidebar-border-color));\n  box-shadow: none;\n  @include transition($sidebar-transition);\n\n  &:not(.sidebar-end){\n    @include ltr-rtl(\"margin-left\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-start: #{$sidebar-width};\n    }\n  }\n\n  &.sidebar-end {\n    order: 99;\n    @include ltr-rtl(\"margin-right\", 0);\n    ~ * {\n      --#{$prefix}sidebar-occupy-end: #{$sidebar-width};\n    }\n  }\n\n  &[class*=\"bg-\"]  {\n    border-color: rgba($black, .1);\n  }\n\n  @each $width, $value in $sidebar-widths {\n    &.sidebar-#{$width} {\n      --#{$prefix}sidebar-width: #{$value};\n      @include media-breakpoint-up($mobile-breakpoint) {\n        &:not(.sidebar-end):not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-start: #{$value};\n          }\n        }\n        &.sidebar-end:not(.hide) {\n          ~ * {\n            --#{$prefix}sidebar-occupy-end: #{$value};\n          }\n        }\n      }\n    }\n  }\n\n  @include media-breakpoint-up($mobile-breakpoint) {\n    &.hide {\n      &:not(.sidebar-end){\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-start: 0;\n        }\n      }\n      &.sidebar-end {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n        ~ * {\n          --#{$prefix}sidebar-occupy-end: 0;\n        }\n      }\n    }\n  }\n\n  &.sidebar-fixed {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: fixed;\n      top: 0;\n      bottom: 0;\n      z-index: $zindex-fixed;\n      @include elevation(2);\n\n      &:not(.sidebar-end) {\n        @include ltr-rtl(\"left\", 0);\n      }\n\n      &.sidebar-end {\n        @include ltr-rtl(\"right\", 0);\n      }\n    }\n  }\n\n  &.sidebar-sticky {\n    @include media-breakpoint-up($mobile-breakpoint) {\n      position: sticky;\n      top: 0;\n      height: 100vh;\n    }\n  }\n\n  &.sidebar-overlaid {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 2;\n\n    &:not(.hide) {\n      @include elevation(3);\n    }\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0 !important;  // stylelint-disable-line\n      }\n    }\n\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0  !important; // stylelint-disable-line\n      }\n    }\n  }\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    // Some of our components use this property to detect if the sidebar has mobile behavior.\n    --#{$prefix}is-mobile: true;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    z-index: $zindex-fixed + 1;\n\n    &:not(.sidebar-end) {\n      @include ltr-rtl(\"left\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-start: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-left\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n    &.sidebar-end {\n      @include ltr-rtl(\"right\", 0);\n      ~ * {\n        --#{$prefix}sidebar-occupy-end: 0 !important; // stylelint-disable-line\n      }\n\n      &:not(.show) {\n        @include ltr-rtl(\"margin-right\", calc(-1 * var(--#{$prefix}sidebar-width)));\n      }\n    }\n  }\n}\n\n.sidebar-close {\n  position: absolute;\n  top: 0;\n  @include ltr-rtl(\"right\", 0);\n  width: var(--#{$prefix}sidebar-close-button-width);\n  height: var(--#{$prefix}sidebar-close-button-height);\n  color: var(--#{$prefix}sidebar-color);\n  background: transparent;\n  border: 0;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.sidebar-brand {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-brand-height);\n  align-items: center;\n  justify-content: center;\n  color: var(--#{$prefix}sidebar-brand-color);\n  background: var(--#{$prefix}sidebar-brand-bg);\n\n  .sidebar-brand-narrow {\n    display: none;\n  }\n}\n\n.sidebar-header {\n  flex: 0 0 var(--#{$prefix}sidebar-header-height);\n  padding: var(--#{$prefix}sidebar-header-padding-y) var(--#{$prefix}sidebar-header-padding-x);\n  text-align: center;\n  background: var(--#{$prefix}sidebar-header-bg);\n  @include transition($sidebar-header-height-transition);\n\n  .nav-link {\n    display: flex;\n    align-items: center;\n    min-height: var(--#{$prefix}sidebar-header-height);\n  }\n}\n\n.sidebar-footer {\n  flex: 0 0 var(--#{$prefix}sidebar-footer-height);\n  padding: var(--#{$prefix}sidebar-footer-padding-y) var(--#{$prefix}sidebar-footer-padding-x);\n  background: var(--#{$prefix}sidebar-footer-bg);\n  @include transition($sidebar-footer-height-transition);\n}\n\n.sidebar-toggler {\n  display: flex;\n  flex: 0 0 var(--#{$prefix}sidebar-toggler-height);\n  justify-content: flex-end;\n  width: inherit;\n  padding: 0;\n  cursor: pointer;\n  background-color: var(--#{$prefix}sidebar-toggler-bg);\n  border: 0;\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    display: none;\n  }\n\n  &::before {\n    display: block;\n    width: var(--#{$prefix}sidebar-toggler-indicator-width);\n    height: var(--#{$prefix}sidebar-toggler-indicator-height);\n    content: \"\";\n    background-image: var(--#{$prefix}sidebar-toggler-indicator);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: calc(var(--#{$prefix}sidebar-toggler-indicator-height) * .25); // stylelint-disable-line function-disallowed-list\n    @include transition($sidebar-toggler-transition);\n    @include rtl() {\n      transform: rotate(-180deg);\n    }\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:hover {\n    background-color: var(--#{$prefix}sidebar-toggler-hover-bg);\n    &::before {\n      background-image: var(--#{$prefix}sidebar-toggler-indicator-hover);\n    }\n  }\n\n  .sidebar-end & {\n    justify-content: flex-start;\n    &::before {\n      transform: rotate(-180deg);\n    }\n  }\n}\n\n// Backdrop background\n\n.sidebar-backdrop {\n  // scss-docs-start sidebar-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-sidebar-backdrop};\n  --#{$prefix}backdrop-bg: #{$sidebar-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$sidebar-backdrop-opacity};\n  // scss-docs-end sidebar-backdrop-css-vars\n\n  @include media-breakpoint-down($mobile-breakpoint) {\n    @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n  }\n}\n//\n// Sidebar themes\n//\n\n.sidebar-light {\n  --#{$prefix}sidebar-color: #{$sidebar-light-color};\n  --#{$prefix}sidebar-bg: #{$sidebar-light-bg};\n  --#{$prefix}sidebar-border-width: #{$sidebar-light-border-width};\n  --#{$prefix}sidebar-border-color: #{$sidebar-light-border-color};\n  --#{$prefix}sidebar-brand-color: #{$sidebar-light-brand-color};\n  --#{$prefix}sidebar-brand-bg: #{$sidebar-light-brand-bg};\n  --#{$prefix}sidebar-header-bg: #{$sidebar-light-header-bg};\n  --#{$prefix}sidebar-nav-title-color: #{$sidebar-light-nav-title-color};\n  --#{$prefix}sidebar-nav-link-color: #{$sidebar-light-nav-link-color};\n  --#{$prefix}sidebar-nav-link-bg: #{$sidebar-light-nav-link-bg};\n  --#{$prefix}sidebar-nav-link-icon-color: #{$sidebar-light-nav-link-icon-color};\n  --#{$prefix}sidebar-nav-link-hover-color: #{$sidebar-light-nav-link-hover-color};\n  --#{$prefix}sidebar-nav-link-hover-bg: #{$sidebar-light-nav-link-hover-bg};\n  --#{$prefix}sidebar-nav-link-hover-icon-color: #{$sidebar-light-nav-link-hover-icon-color};\n  --#{$prefix}sidebar-nav-link-active-color: #{$sidebar-light-nav-link-active-color};\n  --#{$prefix}sidebar-nav-link-active-bg: #{$sidebar-light-nav-link-active-bg};\n  --#{$prefix}sidebar-nav-link-active-icon-color: #{$sidebar-light-nav-link-active-icon-color};\n  --#{$prefix}sidebar-nav-link-disabled-color: #{$sidebar-light-nav-link-disabled-color};\n  --#{$prefix}sidebar-nav-link-disabled-icon-color: #{$sidebar-light-nav-link-disabled-icon-color};\n  --#{$prefix}sidebar-nav-group-bg: #{$sidebar-light-nav-group-bg};\n  --#{$prefix}sidebar-nav-group-toggle-show-color: #{$sidebar-light-nav-group-toggle-show-color};\n  --#{$prefix}sidebar-nav-group-indicator: #{$sidebar-light-nav-group-indicator-icon};\n  --#{$prefix}sidebar-nav-group-indicator-hover: #{$sidebar-light-nav-group-indicator-hover-icon};\n  --#{$prefix}sidebar-footer-bg: #{$sidebar-light-footer-bg};\n  --#{$prefix}sidebar-toggler-bg: #{$sidebar-light-toggler-bg};\n  --#{$prefix}sidebar-toggler-hover-bg: #{$sidebar-light-toggler-hover-bg};\n  --#{$prefix}sidebar-toggler-indicator: #{$sidebar-light-toggler-indicator-icon};\n  --#{$prefix}sidebar-toggler-indicator-hover: #{$sidebar-light-toggler-indicator-hover-icon};\n}\n","// Sidebar navigation\n\n.sidebar-nav {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  padding: 0;\n  margin-bottom: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  list-style: none;\n\n  .nav-title {\n    padding: var(--#{$prefix}sidebar-nav-title-padding-y) var(--#{$prefix}sidebar-nav-title-padding-x);\n    margin-top: var(--#{$prefix}sidebar-nav-title-margin-top);\n    font-size: 80%;\n    font-weight: 700;\n    color: var(--#{$prefix}sidebar-nav-title-color);\n    text-transform: uppercase;\n    @include transition($sidebar-nav-title-transition);\n  }\n\n  .nav-link {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    padding: var(--#{$prefix}sidebar-nav-link-padding-y) var(--#{$prefix}sidebar-nav-link-padding-x);\n    color: var(--#{$prefix}sidebar-nav-link-color);\n    text-decoration: none;\n    white-space: nowrap;\n    background: var(--#{$prefix}sidebar-nav-link-bg);\n    border: var(--#{$prefix}sidebar-nav-link-border);\n    @include border-radius(var(--#{$prefix}sidebar-nav-link-border-radius));\n    @include transition($sidebar-nav-link-transition);\n\n    &.active {\n      color: var(--#{$prefix}sidebar-nav-link-active-color);\n      background: var(--#{$prefix}sidebar-nav-link-active-bg);\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-active-icon-color);\n      }\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n      pointer-events: none;\n      cursor: not-allowed;\n      background: transparent;\n\n      .nav-icon {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n      }\n\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-disabled-color);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-disabled-icon-color);\n        }\n\n        &.nav-dropdown-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n\n    @media (hover: hover), (-ms-high-contrast: none) {\n      &:hover {\n        color: var(--#{$prefix}sidebar-nav-link-hover-color);\n        text-decoration: none;\n        background: var(--#{$prefix}sidebar-nav-link-hover-bg);\n\n        .nav-icon {\n          color: var(--#{$prefix}sidebar-nav-link-hover-icon-color);\n        }\n\n        &.nav-group-toggle::after {\n          background-image: var(--#{$prefix}sidebar-nav-group-indicator-hover);\n        }\n      }\n    }\n  }\n\n  .nav-icon {\n    flex: 0 0 var(--#{$prefix}sidebar-nav-icon-width);\n    height: var(--#{$prefix}sidebar-nav-icon-height);\n    font-size: var(--#{$prefix}sidebar-nav-icon-font-size);\n    color: var(--#{$prefix}sidebar-nav-link-icon-color);\n    text-align: center;\n    pointer-events: none;\n    fill: currentcolor;\n    @include transition(inherit);\n\n    &:first-child {\n      @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-link-padding-x) * -1));\n    }\n  }\n  // stylelint-disable-next-line selector-no-qualifying-type\n  svg.nav-icon {\n    overflow: hidden; // fix chrome 105+ width issue\n  }\n\n  .nav-group {\n    position: relative;\n    @include transition($sidebar-nav-group-transition);\n\n    .nav-group-items {\n      padding: var(--#{$prefix}sidebar-nav-group-items-padding-y) var(--#{$prefix}sidebar-nav-group-items-padding-x);\n      overflow: hidden;\n      @include transition($sidebar-nav-group-items-transition);\n    }\n\n    &:not(.show) .nav-group-items {\n      display: none;\n    }\n\n    &.show {\n      background: var(--#{$prefix}sidebar-nav-group-bg);\n\n      .nav-group-toggle {\n        color: var(--#{$prefix}sidebar-nav-group-toggle-show-color);\n      }\n\n      > .nav-group-toggle::after {\n        transform: rotate(180deg);\n      }\n\n      + .show {\n        margin-top: 1px;\n      }\n    }\n  }\n\n  .nav-group-toggle {\n    cursor: pointer;\n\n    &::after {\n      display: block;\n      flex: 0 12px;\n      height: 12px;\n      @include ltr-rtl(\"margin-left\", auto);\n      content: \"\";\n      background-image: var(--#{$prefix}sidebar-nav-group-indicator);\n      background-repeat: no-repeat;\n      background-position: center;\n      @include transition($sidebar-nav-group-indicator-transition);\n    }\n  }\n\n  .nav-group-items {\n    padding: 0;\n    list-style: none;\n\n    .nav-link {\n      @include ltr-rtl(\"padding-left\", var(--#{$prefix}sidebar-nav-icon-width));\n\n      .nav-icon {\n        @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-nav-icon-width) * -1));\n      }\n    }\n  }\n\n  &.compact,\n  .compact {\n    .nav-link {\n      padding-top: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n      padding-bottom: calc(var(--#{$prefix}sidebar-nav-link-padding-y) * .5); // stylelint-disable-line function-disallowed-list\n    }\n  }\n}\n","%sidebar-narrow {\n  @include media-breakpoint-up($mobile-breakpoint) {\n    z-index: $zindex-fixed + 1;\n    flex: 0 0 var(--#{$prefix}sidebar-narrow-width);\n    width: var(--#{$prefix}sidebar-narrow-width);\n    padding-bottom: var(--#{$prefix}sidebar-toggler-height);\n    overflow: visible;\n\n    &.sidebar-fixed {\n      z-index: $zindex-fixed + 1;\n      width: var(--#{$prefix}sidebar-narrow-width);\n    }\n\n    .sidebar-brand-full {\n      display: none;\n    }\n\n    .sidebar-brand-narrow {\n      display: block;\n    }\n\n    .d-narrow-none,\n    .nav-label,\n    .nav-title,\n    .nav-group-items,\n    .nav-group.show .nav-group-items,\n    .sidebar-footer,\n    .sidebar-form,\n    .sidebar-header {\n      height: 0 !important; // stylelint-disable-line declaration-no-important\n      padding: 0;\n      margin: 0;\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .sidebar-toggler {\n      position: fixed;\n      bottom: 0;\n\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n.sidebar-narrow {\n  @extend %sidebar-narrow;\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n}\n\n.sidebar-narrow-unfoldable {\n  position: fixed;\n  z-index: $zindex-fixed + 1;\n\n  &:not(.sidebar-end) ~ * {\n    --#{$prefix}sidebar-occupy-start: #{$sidebar-narrow-width};\n  }\n  &.sidebar-end ~ * {\n    --#{$prefix}sidebar-occupy-end: #{$sidebar-narrow-width};\n  }\n\n  &:not(:hover) {\n    @extend %sidebar-narrow;\n  }\n\n  &:hover {\n    .sidebar-toggler {\n      &::before {\n        @include ltr-rtl(\"transform\", rotate(-180deg), null, rotate(0deg));\n      }\n    }\n\n    &.sidebar-end .sidebar-toggler::before {\n      transform: rotate(0deg);\n    }\n  }\n}\n\n// Responsive behavior\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-down($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n    .sidebar:not(.show).sidebar-self-hiding#{$infix} {\n      &.sidebar-narrow,\n      &.sidebar-narrow-unfoldable {\n        &:not(.sidebar-end) {\n          @include ltr-rtl(\"margin-left\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n        &.sidebar-end {\n          @include ltr-rtl(\"margin-right\", calc(var(--#{$prefix}sidebar-narrow-width) * -1));\n        }\n      }\n    }\n  }\n}\n",".subheader {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  min-height: $subheader-min-height;\n  padding: $subheader-padding-y $subheader-padding-x;\n  background: var(--#{$prefix}subheader-bg, $subheader-bg);\n  border-bottom: var(--#{$prefix}subheader-border-width, $subheader-border-width) solid var(--#{$prefix}subheader-border-color, $subheader-border-color);\n}\n\n.subheader-sticky {\n  position: sticky;\n  top: 0;\n  z-index: $zindex-fixed - 1;\n  @include elevation(2);\n}\n\n// Subheader nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.subheader-nav {\n  display: flex;\n  flex-direction: row; // cannot use `inherit` to get the `.header`s value\n  @include ltr-rtl(\"padding-left\", 0);\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: $subheader-nav-link-padding-x;\n    padding-left: $subheader-nav-link-padding-x;\n    color: var(--#{$prefix}subheader-color, $subheader-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-hover-color, $subheader-hover-color);\n    }\n\n    &.disabled {\n      color: var(--#{$prefix}subheader-disabled-color, $subheader-disabled-color);\n    }\n  }\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n  }\n\n  .dropdown-menu {\n    position: absolute;\n  }\n}\n\n// Subheader text\n//\n//\n\n.subheader-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}subheader-color, $subheader-color);\n\n  a {\n    color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n\n    &:hover,\n    &:focus {\n      color: var(--#{$prefix}subheader-active-color, $subheader-active-color);\n    }\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--cui-focus-ring-x`, `--cui-focus-ring-y`, or `--cui-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    @include ltr-rtl(\"left\", 0);\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  padding: 0;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    // Add theme prefix\n    $theme-prefix: if(map-has-key($utility, theme-prefix), map-get($utility, theme-prefix), false);\n\n    // Generate RTL version\n    $generate-rtl: if(map-has-key($utility, rtl), map-get($utility, rtl), false);\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        #{if($theme-prefix, theme-prefix(\"#{$property-class + $infix + $property-class-modifier}\"), \".#{$property-class + $infix + $property-class-modifier}\")} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        #{if($theme-prefix, theme-prefix(\"#{$property-class + $infix + $property-class-modifier}\"), \".#{$property-class + $infix + $property-class-modifier}\")} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            @if $generate-rtl == true {\n              @include ltr-rtl($property, $value, null, null, if($enable-important-utilities, !important, null));\n            } @else {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","@each $color, $value in $theme-gradients {\n  .bg-#{$color}-gradient {\n    @include gradient($color, $value);\n  }\n}\n","@import \"./../functions\";\n@import \"./../variables\";\n@import \"./../maps\";\n@import \"./../mixins\";\n@import \"./../utilities\";\n\n$theme-name: \"dark-theme\" !default;\n$theme-prefix: \"dark\" !default;\n\n.#{$theme-name} {\n  @import \"dark/variables\";\n  @import \"dark/utilities\";\n  @import \"dark/root\";\n\n  @include theme($theme-map);\n\n  // Alert variants\n  @each $state, $value in $alert-variants-dt {\n    $alert-background: map-get($value, \"alert-bg\");\n    $alert-border: map-get($value, \"alert-border\");\n    $alert-color: map-get($value, \"alert-color\");\n\n    @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n      $alert-color: mix(map-get($value, \"base-color\"), color-contrast($alert-background), $alert-color-scale);\n    }\n    .alert-#{$state} {\n      @include alert-variant($alert-background, $alert-border, $alert-color);\n    }\n  }\n\n  // Button variants\n  @each $state, $variant in $button-variants-dt {\n    .btn-#{$state} {\n      @include button-variant($variant);\n    }\n  }\n\n  @each $state, $variant in $button-outline-ghost-variants-dt {\n    .btn-outline-#{$state} {\n      @include button-outline-variant($variant);\n    }\n  }\n\n  @each $state, $variant in $button-outline-ghost-variants-dt {\n    .btn-ghost-#{$state} {\n      @include button-ghost-variant($variant);\n    }\n  }\n\n  // List group variants\n  @each $state, $variant in $list-group-variants-dt {\n    .list-group-item-#{$state} {\n      @include list-group-item-variant($state, $variant);\n    }\n  }\n\n  // Fix Firefox option color\n  @-moz-document url-prefix(\"\") {\n    select:not([multiple]) option,\n    select optgroup {\n      color: initial;\n    }\n  }\n\n  .form-control {\n    &:disabled {\n      background-color: var(--cui-input-disabled-bg);\n    }\n\n    &::file-selector-button {\n      @include gradient-bg($form-file-button-bg-dt);\n    }\n\n    &:hover:not(:disabled):not([readonly])::file-selector-button {\n      background-color: $form-file-button-hove-bg-dt;\n    }\n  }\n\n  .picker-input-group .form-control:disabled + .input-group-text {\n    background-color: var(--cui-input-disabled-bg);\n  }\n\n  // Utilities\n  @import \"./../utilities/api\";\n}\n","@mixin theme-variants($map, $state, $component) {\n  $selector: &;\n  $selector-with-prefix: selector-replace($selector, \".#{$component}\", \".#{$theme-prefix}\\\\:#{$component}\");\n  @at-root #{$selector-with-prefix}-#{$state}, &-#{$state}:not([class*=\"#{$theme-prefix}:\"]) {\n    @each $name, $value in $map {\n      @if $value != null {\n        // TODO: find solution\n        @if $name == \"border\" {\n          $name: \"border-color\";\n        }\n\n        --#{$prefix}#{$component}-#{$name}: #{$value};\n      }\n    }\n  }\n}\n\n@mixin theme-colors($map, $class) {\n  @each $name, $value in $map {\n    --#{$prefix}#{$class}-#{$name}: #{$value};\n  }\n}\n\n@mixin theme-components($map, $component: null) {\n  @each $name, $value in $map {\n    @if $value != null {\n      @if type-of($value) != \"map\" {\n        --#{$prefix}#{$name}: #{$value};\n      }\n      @else {\n        @include theme-variants($value, $name, $component);\n      }\n    }\n  }\n}\n\n@mixin theme($map) {\n  @each $name, $value in $map {\n    @if $name == \"root\" {\n      @include theme-components($value, $name);\n    }\n    @else if $name == \"utilities\" {\n      @each $class, $variants in $value {\n        @include theme-colors($variants, $class);\n      }\n    } @else {\n      .#{$name} {\n        @include theme-components($value, $name);\n      }\n    }\n  }\n}\n","// stylelint-disable scss/selector-no-redundant-nesting-selector\n& {\n  @each $color, $value in $theme-colors-dt {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb-dt {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color-dt)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dt)};\n\n  --#{$prefix}link-color: #{$link-color-dt};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color-dt)};\n\n  // Gradients\n  @each $color, $map in $theme-gradients-dt {\n    --#{$prefix}#{$color}-start: #{map-get($map, \"start\")};\n    --#{$prefix}#{$color}-stop: #{map-get($map, \"stop\")};\n  }\n}\n","@include deprecate(\"`alert-variant()`\", \"v4.3.0\", \"v6.0.0\");\n\n// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n  --#{$prefix}alert-link-color: #{shade-color($color, 20%)};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: var(--#{$prefix}alert-link-color);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Color system\n\n// fusv-disable\n$bg-elevation-0: #181924 !default;\n$bg-elevation-1:   rgba(mix(rgba(255, 255, 255, .1), $bg-elevation-0), 1) !default;\n$bg-elevation-2:   rgba(mix(rgba(255, 255, 255, .14), $bg-elevation-0), 1) !default;\n$bg-elevation-3:   rgba(mix(rgba(255, 255, 255, .16), $bg-elevation-0), 1) !default;\n$bg-elevation-4:   rgba(mix(rgba(255, 255, 255, .18), $bg-elevation-0), 1) !default;\n$bg-elevation-6:   rgba(mix(rgba(255, 255, 255, .22), $bg-elevation-0), 1) !default;\n$bg-elevation-8:   rgba(mix(rgba(255, 255, 255, .24), $bg-elevation-0), 1) !default;\n$bg-elevation-12:  rgba(mix(rgba(255, 255, 255, .28), $bg-elevation-0), 1) !default;\n$bg-elevation-16:  rgba(mix(rgba(255, 255, 255, .3), $bg-elevation-0), 1) !default;\n$bg-elevation-24:  rgba(mix(rgba(255, 255, 255, .32), $bg-elevation-0), 1) !default;\n// fusv-enable\n\n$high-emphasis-dt:    rgba($white, .87) !default;\n$medium-emphasis-dt:  rgba($white, .6) !default;\n$disabled-dt:         rgba($white, .38) !default;\n\n$primary-dt:    tint-color(desaturate($primary, 30%), 30%) !default;\n$secondary-dt:  desaturate($secondary, 30%) !default;\n$success-dt:    desaturate($success, 30%) !default;\n$info-dt:       desaturate($info, 30%) !default;\n$warning-dt:    desaturate($warning, 30%) !default;\n$danger-dt:     desaturate($danger, 30%) !default;\n$light-dt:      rgba($white, .1) !default;\n$dark-dt:       rgba($black, .1) !default;\n\n\n// fusv-disable\n$theme-colors-dt: (\n  \"primary\":    $primary-dt,\n  \"secondary\":  $secondary-dt,\n  \"success\":    $success-dt,\n  \"info\":       $info-dt,\n  \"warning\":    $warning-dt,\n  \"danger\":     $danger-dt,\n  \"light\":      $light-dt,\n  \"dark\":       $dark-dt\n) !default;\n// fusv-enable\n\n$theme-colors-rgb-dt: map-loop($theme-colors-dt, to-rgb, \"$value\") !default;\n\n// Gradients\n\n// scss-docs-start theme-gradients\n$primary-gradient-dt: (\n  \"start\":  desaturate(#321fdb, 20%),\n  \"stop\":   desaturate(#1f1498, 20%)\n) !default;\n\n$secondary-gradient-dt: (\n  \"start\":  desaturate(#c8d2dc, 20%),\n  \"stop\":    desaturate($white, 20%)\n) !default;\n\n$light-gradient-dt: (\n  \"start\":  desaturate(#e3e8ed, 20%),\n  \"stop\":    desaturate($white, 20%)\n) !default;\n\n$dark-gradient-dt: (\n  \"start\":  desaturate(#3c4b64, 20%),\n  \"stop\":   desaturate(#212333, 20%)\n) !default;\n\n$danger-gradient-dt: (\n  \"start\":  desaturate(#e55353, 20%),\n  \"stop\":   desaturate(#d93737, 20%)\n) !default;\n\n$warning-gradient-dt: (\n  \"start\":  desaturate(#f9b115, 20%),\n  \"stop\":   desaturate(#f6960b, 20%)\n) !default;\n\n$success-gradient-dt: (\n  \"start\":  desaturate(#2eb85c, 20%),\n  \"stop\":   desaturate(#1b9e3e, 20%)\n) !default;\n\n$info-gradient-dt: (\n  \"start\":  desaturate(#39f, 20%),\n  \"stop\":   desaturate(#2982cc, 20%)\n) !default;\n\n$theme-gradients-dt: (\n  \"primary\":    $primary-gradient-dt,\n  \"secondary\":  $secondary-gradient-dt,\n  \"success\":    $success-gradient-dt,\n  \"info\":       $info-gradient-dt,\n  \"warning\":    $warning-gradient-dt,\n  \"danger\":     $danger-gradient-dt,\n  \"light\":      $light-gradient-dt,\n  \"dark\":       $dark-gradient-dt\n) !default;\n// scss-docs-end theme-gradients\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg-dt:                   $bg-elevation-0 !default;\n$body-color-dt:                $high-emphasis-dt !default;\n$elevation-base-color-dt:      0, 0, 0 !default;\n$link-color-dt:                $primary-dt !default;\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$border-color-dt:   rgba(255, 255, 255, .075) !default;\n\n$theme-root-dt: (\n  \"body-bg\":               $body-bg-dt,\n  \"body-color\":            $body-color-dt,\n  \"elevation-base-color\":  $elevation-base-color-dt,\n  \"high-emphasis\":         $high-emphasis-dt,\n  \"medium-emphasis\":       $medium-emphasis-dt,\n  \"disabled\":              $disabled-dt,\n  \"border-color\":          $border-color-dt\n) !default;\n\n// $component-color-dt:  $body-color-dt !default;\n// $component-bg-dt:     $gray-800-dt !default;\n\n$component-active-color-dt:  $white !default;\n$component-active-bg-dt:     $primary-dt !default;\n\n// Accordion\n\n$accordion-button-color-dt:               $body-color-dt !default;\n$accordion-button-bg-dt:                  transparent !default;\n$accordion-border-color-dt:               rgba($white, .125) !default;\n$accordion-color-dt:                      $high-emphasis-dt !default;\n$accordion-bg-dt:                         transparent !default;\n\n$accordion-button-color-dt:               $body-color-dt !default;\n$accordion-button-bg-dt:                  transparent !default;\n$accordion-border-color-dt:               rgba($white, .125) !default;\n\n$accordion-button-active-bg-dt:           tint-color(rgba($component-active-bg-dt, .5), 5%) !default;\n$accordion-button-active-color-dt:        shade-color($component-active-color-dt, 10%) !default;\n\n$accordion-button-focus-border-color-dt:  rgba($white, .2) !default;\n\n$accordion-icon-color-dt:                 $body-color-dt !default;\n$accordion-icon-active-color-dt:          $body-color-dt !default;\n\n$accordion-button-icon-dt:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color-dt}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon-dt:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color-dt}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n\n$accordion-theme-map: (\n  \"accordion-button-color\":               $accordion-button-color-dt,\n  \"accordion-button-bg\":                  $accordion-button-bg-dt,\n  \"accordion-bg\":                         $accordion-bg-dt,\n  \"accordion-color\":                      $accordion-color-dt,\n  \"accordion-border-color\":               $accordion-border-color-dt,\n  \"accordion-button-active-bg\":           $accordion-button-active-bg-dt,\n  \"accordion-button-active-color\":        $accordion-button-active-color-dt,\n  \"accordion-button-focus-border-color\":  $accordion-button-focus-border-color-dt,\n  \"accordion-button-icon\":                $accordion-button-icon-dt,\n  \"accordion-button-active-icon\":         $accordion-button-active-icon-dt\n) !default;\n\n// Alert\n\n$alert-variants-dt: (\n  \"primary\":    alert-color-map($primary),\n  \"secondary\":  alert-color-map($secondary),\n  \"success\":    alert-color-map($success),\n  \"danger\":     alert-color-map($danger),\n  \"warning\":    alert-color-map($warning),\n  \"info\":       alert-color-map($info)\n) !default;\n\n// Breadcrumb\n\n$breadcrumb-bg-dt:             null !default;\n$breadcrumb-divider-color-dt:  $body-color-dt !default;\n$breadcrumb-active-color-dt:   $medium-emphasis-dt !default;\n\n$breadcrumb-theme-map: (\n  \"breadcrumb-bg\":             $breadcrumb-bg-dt,\n  \"breadcrumb-divider-color\":  $breadcrumb-divider-color-dt,\n  \"breadcrumb-active-color\":   $breadcrumb-active-color-dt\n) !default;\n\n// Buttons\n\n$button-variants-dt: (\n  \"primary\":    btn-color-map($primary-dt, $primary-dt),\n  \"secondary\":  btn-color-map($secondary-dt, $secondary-dt),\n  \"success\":    btn-color-map($success-dt, $success-dt),\n  \"danger\":     btn-color-map($danger-dt, $danger-dt),\n  \"warning\":    btn-color-map($warning-dt, $warning-dt),\n  \"info\":       btn-color-map($info-dt, $info-dt)\n) !default;\n\n$button-outline-ghost-variants-dt: (\n  \"primary\":    btn-outline-color-map($primary-dt),\n  \"secondary\":  btn-outline-color-map($secondary-dt),\n  \"success\":    btn-outline-color-map($success-dt),\n  \"danger\":     btn-outline-color-map($danger-dt),\n  \"warning\":    btn-outline-color-map($warning-dt),\n  \"info\":       btn-outline-color-map($info-dt)\n) !default;\n\n// Cards\n\n// scss-docs-start card-variables\n$card-bg-dt:            $bg-elevation-1 !default;\n$card-color-dt:         null !default;\n$card-border-color-dt:  $border-color-dt !default;\n$card-cap-bg-dt:        $bg-elevation-2 !default;\n$card-cap-color-dt:     null !default;\n\n$card-theme-map: (\n  \"card-bg\":            $card-bg-dt,\n  \"card-color\":         $card-color-dt,\n  \"card-border-color\":  $card-border-color-dt,\n  \"card-cap-bg\":        $card-cap-bg-dt,\n  \"card-cap-color\":     $card-cap-color-dt\n) !default;\n// scss-docs-end card-variables\n\n// Close button\n\n$btn-close-color-dt:  $high-emphasis-dt !default;\n$btn-close-bg-dt:     url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color-dt}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n\n$close-theme-map: (\n  \"btn-close-color\":  $btn-close-color-dt,\n  \"btn-close-bg\":     $btn-close-bg-dt\n) !default;\n\n// Dropdown\n\n$dropdown-color-dt:                $body-color-dt !default;\n$dropdown-bg-dt:                   $bg-elevation-8 !default;\n$dropdown-border-color-dt:         $border-color-dt !default;\n$dropdown-divider-bg-dt:           $border-color-dt !default;\n$dropdown-link-color-dt:           $body-color-dt !default;\n$dropdown-link-hover-color-dt:     $body-color-dt !default;\n$dropdown-link-hover-bg-dt:        $bg-elevation-16 !default;\n$dropdown-link-active-color-dt:    $component-active-color-dt !default;\n$dropdown-link-active-bg-dt:       $component-active-bg-dt !default;\n$dropdown-link-disabled-color-dt:  rgba($body-color-dt, .6) !default;\n$dropdown-header-color-dt:         $body-color-dt !default;\n\n$dropdown-theme-map: (\n  \"dropdown-color\":                $dropdown-color-dt,\n  \"dropdown-border-color\":         $dropdown-border-color-dt,\n  \"dropdown-bg\":                   $dropdown-bg-dt,\n  \"dropdown-divider-bg\":           $dropdown-divider-bg-dt,\n  \"dropdown-link-color\":           $dropdown-link-color-dt,\n  \"dropdown-link-hover-color\":     $dropdown-link-hover-color-dt,\n  \"dropdown-link-hover-bg\":        $dropdown-link-hover-bg-dt,\n  \"dropdown-link-active-color\":    $dropdown-link-active-color-dt,\n  \"dropdown-link-active-bg\":       $dropdown-link-active-bg-dt,\n  \"dropdown-link-disabled-color\":  $dropdown-link-disabled-color-dt,\n  \"dropdown-header-color\":         $dropdown-header-color-dt\n) !default;\n\n// Footer\n\n$footer-dark-bg-dt:            $bg-elevation-3 !default;\n$footer-dark-color-dt:         $body-color-dt !default;\n$footer-dark-border-width-dt:  0 !default;\n$footer-dark-border-color-dt:  transparent !default;\n\n$footer-theme-map: (\n  \"footer-bg\":            $footer-dark-bg-dt,\n  \"footer-color\":         $footer-dark-color-dt,\n  \"footer-border-width\":  $footer-dark-border-width-dt,\n  \"footer-border-color\":  $footer-dark-border-color-dt\n) !default;\n\n// Forms\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-color-dt:                     $body-color-dt !default;\n$input-bg-dt:                        rgba($white, .05) !default;\n$input-border-color-dt:              rgba($white, .09) !default;\n$input-focus-color-dt:               $body-color-dt !default;\n$input-focus-bg-dt:                  rgba($white, .05) !default;\n$input-focus-border-color-dt:        rgba($white, .2) !default;\n$input-disabled-bg-dt:               rgba($black, .1) !default;\n$input-placeholder-color-dt:         $medium-emphasis-dt !default;\n$input-plaintext-color-dt:           $body-color-dt !default;\n\n$form-text-color-dt:                 $medium-emphasis-dt !default;\n\n$input-group-addon-color-dt:         $body-color-dt !default;\n$input-group-addon-bg-dt:            rgba($white, .09) !default;\n$input-group-addon-border-color-dt:  rgba($white, .09) !default;\n\n$form-select-color-dt:               $input-color-dt !default;\n$form-select-bg-dt:                  $input-bg-dt !default;\n$form-select-border-color-dt:        $input-border-color-dt !default;\n$form-select-focus-border-color-dt:  $input-focus-border-color-dt !default;\n// $form-select-disabled-color-dt:         $input-disabled-color-dt !default;\n$form-select-disabled-bg-dt:         $input-disabled-bg-dt !default;\n// $form-select-disabled-border-color-dt:  $input-disabled-border-color-dt !default;\n\n$form-check-input-checked-color-dt:          $component-active-color-dt !default;\n$form-check-input-checked-bg-color-dt:       $component-active-bg-dt !default;\n$form-check-input-checked-border-color-dt:   $form-check-input-checked-bg-color-dt !default;\n\n$form-file-button-bg-dt:       rgba($black, .1) !default;\n$form-file-button-hove-bg-dt:  rgba($black, .2) !default;\n\n$form-control-theme-map: (\n  \"input-color\":                            $input-color-dt,\n  \"input-bg\":                               $input-bg-dt,\n  \"input-border-color\":                     $input-border-color-dt,\n  \"input-focus-color\":                      $input-focus-color-dt,\n  \"input-focus-bg\":                         $input-focus-bg-dt,\n  \"input-focus-border-color\":               $input-focus-border-color-dt,\n  \"input-disabled-bg\":                      $input-disabled-bg-dt,\n  \"input-placeholder-color\":                $input-placeholder-color-dt,\n  \"input-plaintext-color\":                  $input-plaintext-color-dt,\n  \"form-text-color\":                        $form-text-color-dt,\n) !default;\n\n$input-group-theme-map: (\n  \"input-group-addon-color\":         $input-group-addon-color-dt,\n  \"input-group-addon-bg\":            $input-group-addon-bg-dt,\n  \"input-group-addon-border-color\":  $input-group-addon-border-color-dt\n) !default;\n\n$form-check-theme-map: (\n  \"form-check-input-checked-color\":         $form-check-input-checked-color-dt,\n  \"form-check-input-checked-bg-color\":      $form-check-input-checked-bg-color-dt,\n  \"form-check-input-checked-border-color\":  $form-check-input-checked-border-color-dt\n) !default;\n\n$form-select-theme-map: (\n  \"form-select-color\":                  $form-select-color-dt,\n  \"form-select-bg\":                     $form-select-bg-dt,\n  \"form-select-border-color\":           $form-select-border-color-dt,\n  \"form-select-focus-border-color\":     $form-select-focus-border-color-dt,\n  // \"form-select-disabled-color\":         $form-select-disabled-color-dt,\n  \"form-select-disabled-bg\":            $form-select-disabled-bg-dt,\n  // \"form-select-disabled-border-color\":  $form-select-disabled-border-color-dt,\n) !default;\n\n$form-multi-select-color-dt:               $input-color-dt !default;\n$form-multi-select-bg-dt:                  $input-bg-dt !default;\n$form-multi-select-border-color-dt:        $input-border-color-dt !default;\n\n$form-multi-select-focus-color-dt:         $input-focus-color-dt !default;\n$form-multi-select-focus-bg-dt:            $input-focus-bg-dt !default;\n$form-multi-select-focus-border-color-dt:  $input-focus-border-color-dt !default;\n\n$form-multi-select-disabled-color-dt:      $disabled-dt !default;\n$form-multi-select-disabled-bg-dt:         $input-disabled-bg-dt !default;\n\n$form-multi-select-tag-bg-dt:               $light-dt !default;\n$form-multi-select-tag-border-color-dt:     $input-border-color-dt !default;\n\n$form-multi-select-search-color-dt:         $input-color-dt !default;\n$form-multi-select-search-bg-dt:            transparent !default;\n$form-multi-select-search-border-color-dt:  $input-border-color-dt !default;\n\n$form-multi-select-cleaner-color-dt:         $medium-emphasis-dt !default;\n$form-multi-select-cleaner-bg-dt:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$form-multi-select-cleaner-color-dt}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$form-multi-select-cleaner-hover-color-dt:   $high-emphasis-dt !default;\n$form-multi-select-cleaner-hover-bg-dt:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$form-multi-select-cleaner-hover-color-dt}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$form-multi-select-cleaner-focus-color-dt:   $high-emphasis-dt !default;\n$form-multi-select-cleaner-focus-bg-dt:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$form-multi-select-cleaner-focus-color-dt}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$form-multi-select-cleaner-border-color-dt:  $input-border-color-dt !default;\n\n$form-multi-select-select-all-color-dt:         $medium-emphasis-dt !default;\n$form-multi-select-select-all-bg-dt:            transparent !default;\n$form-multi-select-select-all-hover-color-dt:   $high-emphasis-dt !default;\n$form-multi-select-select-all-hover-bg-dt:      transparent !default;\n$form-multi-select-select-all-border-color-dt:  $input-border-color-dt !default;\n\n$form-multi-select-options-color-dt:         $body-color-dt !default;\n$form-multi-select-options-bg-dt:            $bg-elevation-8 !default;\n$form-multi-select-options-border-color-dt:  $input-border-color-dt !default;\n\n$form-multi-select-option-hover-color-dt:    $body-color-dt !default;\n$form-multi-select-option-hover-bg-dt:       $light-dt !default;\n\n$form-multi-select-option-selected-bg-dt:    $light-dt !default;\n\n$form-multi-select-theme-map: (\n  \"form-multi-select-color\":                    $form-multi-select-color-dt,\n  \"form-multi-select-bg\":                       $form-multi-select-bg-dt,\n  \"form-multi-select-border-color\":             $form-multi-select-border-color-dt,\n  \"form-multi-select-disabled-color\":           $form-multi-select-disabled-color-dt,\n  \"form-multi-select-disabled-bg\":              $form-multi-select-disabled-bg-dt,\n  \"form-multi-select-focus-color\":              $form-multi-select-focus-color-dt,\n  \"form-multi-select-focus-bg\":                 $form-multi-select-focus-bg-dt,\n  \"form-multi-select-focus-border-color\":       $form-multi-select-focus-border-color-dt,\n  \"form-multi-select-tag-bg\":                   $form-multi-select-tag-bg-dt,\n  \"form-multi-select-tag-border-color\":         $form-multi-select-tag-border-color-dt,\n  \"form-multi-select-search-color\":             $form-multi-select-search-color-dt,\n  \"form-multi-select-search-bg\":                $form-multi-select-search-bg-dt,\n  \"form-multi-select-search-border-color\":      $form-multi-select-search-border-color-dt,\n  \"form-multi-select-cleaner-bg\":               $form-multi-select-cleaner-bg-dt,\n  \"form-multi-select-cleaner-hover-bg\":         $form-multi-select-cleaner-hover-bg-dt,\n  \"form-multi-select-cleaner-focus-bg\":         $form-multi-select-cleaner-focus-bg-dt,\n  \"form-multi-select-cleaner-border-color\":     $form-multi-select-cleaner-border-color-dt,\n  \"form-multi-select-select-all-color\":         $form-multi-select-select-all-color-dt,\n  \"form-multi-select-select-all-bg\":            $form-multi-select-select-all-bg-dt,\n  \"form-multi-select-select-all-hover-color\":   $form-multi-select-select-all-hover-color-dt,\n  \"form-multi-select-select-all-hover-bg\":      $form-multi-select-select-all-hover-bg-dt,\n  \"form-multi-select-select-all-border-color\":  $form-multi-select-select-all-border-color-dt,\n  \"form-multi-select-options-color\":            $form-multi-select-options-color-dt,\n  \"form-multi-select-options-bg\":               $form-multi-select-options-bg-dt,\n  \"form-multi-select-options-border-color\":     $form-multi-select-options-border-color-dt,\n  \"form-multi-select-option-hover-color\":       $form-multi-select-option-hover-color-dt,\n  \"form-multi-select-option-hover-bg\":          $form-multi-select-option-hover-bg-dt,\n  \"form-multi-select-option-selected-bg\":       $form-multi-select-option-selected-bg-dt,\n) !default;\n\n// Header\n\n$header-bg-dt:                     $bg-elevation-3 !default;\n$header-color-dt:                  rgba($white, .75) !default;\n$header-border-dt:                 ( bottom: 0 ) !default;\n$header-hover-color-dt:            rgba($white, .9) !default;\n$header-active-color-dt:           $white !default;\n$header-disabled-color-dt:         rgba($white, .25) !default;\n$header-brand-color-dt:            $header-active-color-dt !default;\n$header-brand-hover-color-dt:      $header-active-color-dt !default;\n$header-toggler-color-dt:          rgba($white, .75) !default;\n$header-toggler-hover-color-dt:    $white !default;\n$header-toggler-icon-bg-dt:        str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-color-dt}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$header-toggler-hover-icon-bg-dt:  str-replace(url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='#{$header-hover-color-dt}' stroke-width='2.25' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\"), \"#\", \"%23\") !default;\n$header-toggler-border-color-dt:   rgba($white, .1) !default;\n$header-divider-border-color-dt:   rgba($white, .1) !default;\n\n$header-theme-map: (\n  \"header-bg\":                     $header-bg-dt,\n  \"header-color\":                  $header-color-dt,\n  \"header-border\":                 $header-border-dt,\n  \"header-hover-color\":            $header-hover-color-dt,\n  \"header-active-color\":           $header-active-color-dt,\n  \"header-disabled-color\":         $header-disabled-color-dt,\n  \"header-brand-color\":            $header-brand-color-dt,\n  \"header-brand-hover-color\":      $header-brand-hover-color-dt,\n  \"header-toggler-color\":          $header-toggler-color-dt,\n  \"header-toggler-hover-color\":    $header-toggler-hover-color-dt,\n  \"header-toggler-icon-bg\":        $header-toggler-icon-bg-dt,\n  \"header-toggler-hover-icon-bg\":  $header-toggler-hover-icon-bg-dt,\n  \"header-toggler-border-color\":   $header-toggler-border-color-dt,\n  \"header-divider-border-color\":   $header-divider-border-color-dt\n) !default;\n\n// Links\n\n$link-color-dt:                    shift-color($primary-dt, -12%) !default;\n$link-hover-color-dt:              shift-color($link-color-dt, -20%) !default;\n\n$link-theme-map: (\n  \"link-color\":        $link-color-dt,\n  \"link-hover-color\":  $link-hover-color-dt\n) !default;\n\n// Btn link\n\n$btn-link-color-dt:           $link-color-dt !default;\n$btn-link-hover-color-dt:     $link-hover-color-dt !default;\n$btn-link-disabled-color-dt:  $disabled-dt !default;\n\n$btn-link-theme-map: (\n  \"btn-link-color\":           $btn-link-color-dt,\n  \"btn-link-hover-color\":     $btn-link-hover-color-dt,\n  \"btn-link-disabled-color\":  $btn-link-disabled-color-dt\n) !default;\n\n// List group\n\n// scss-docs-start list-group-dark-theme\n$list-group-color-dt:                $body-color-dt !default;\n$list-group-bg-dt:                   transparent !default;\n$list-group-border-color-dt:         $border-color-dt !default;\n$list-group-hover-bg-dt:             rgba($white, .1) !default;\n$list-group-active-color-dt:         $component-active-color-dt !default;\n$list-group-active-bg-dt:            $component-active-bg-dt !default;\n$list-group-active-border-color-dt:  $list-group-active-bg-dt !default;\n$list-group-disabled-color-dt:       rgba($body-color-dt, .5) !default;\n$list-group-disabled-bg-dt:          rgba($border-color-dt, .8) !default;\n$list-group-action-color-dt:         $body-color-dt !default;\n$list-group-action-hover-color-dt:   $body-color-dt !default;\n$list-group-action-active-color-dt:  $body-color-dt !default;\n$list-group-action-active-bg-dt:     $gray-900 !default;\n// scss-docs-end list-group-dark-theme\n\n$list-group-theme-map: (\n  \"list-group-color\":                $list-group-color-dt,\n  \"list-group-bg\":                   $list-group-bg-dt,\n  \"list-group-border-color\":         $list-group-border-color-dt,\n  \"list-group-hover-bg\":             $list-group-hover-bg-dt,\n  \"list-group-active-color\":         $list-group-active-color-dt,\n  \"list-group-active-bg\":            $list-group-active-bg-dt,\n  \"list-group-active-border-color\":  $list-group-active-border-color-dt,\n  \"list-group-disabled-color\":       $list-group-disabled-color-dt,\n  \"list-group-disabled-bg\":          $list-group-disabled-bg-dt,\n  \"list-group-action-color\":         $list-group-action-color-dt,\n  \"list-group-action-hover-color\":   $list-group-action-hover-color-dt,\n  \"list-group-action-active-color\":  $list-group-action-active-color-dt,\n  \"list-group-action-active-bg\":     $list-group-action-active-bg-dt\n) !default;\n\n$list-group-variants-dt: (\n  \"primary\":    list-group-color-map($primary-dt),\n  \"secondary\":  list-group-color-map($secondary-dt),\n  \"success\":    list-group-color-map($success-dt),\n  \"danger\":     list-group-color-map($danger-dt),\n  \"warning\":    list-group-color-map($warning-dt),\n  \"info\":       list-group-color-map($info-dt)\n) !default;\n\n// Modals\n\n// scss-docs-start modal-dark-theme\n$modal-color-dt:         null !default;\n$modal-bg-dt:            $bg-elevation-24 !default;\n$modal-border-color-dt:  rgba(0, 0, 0, .2) !default;\n$modal-header-border-color-dt:   rgba(0, 0, 0, .2) !default;\n$modal-footer-border-color-dt:   rgba(0, 0, 0, .2) !default;\n// scss-docs-end modal-dark-theme\n\n$modal-theme-map: (\n  \"modal-color\":                $modal-color-dt,\n  \"modal-bg\":                   $modal-bg-dt,\n  \"modal-border-color\":         $modal-border-color-dt,\n  \"modal-header-border-color\":  $modal-header-border-color-dt,\n  \"modal-footer-border-color\":  $modal-footer-border-color-dt\n) !default;\n\n\n// Navs\n\n$nav-link-color-dt:                          null !default;\n$nav-link-disabled-color-dt:                 $disabled-dt !default;\n$nav-link-hover-color-dt:                    null !default;\n$nav-pills-link-active-bg-dt:                $component-active-bg-dt !default;\n$nav-pills-link-active-color-dt:             $component-active-color-dt !default;\n$nav-tabs-border-color-dt:                   $border-color-dt !default;\n$nav-tabs-link-active-bg-dt:                 $border-color-dt !default;\n$nav-tabs-link-active-color-dt:              $body-color-dt !default;\n$nav-tabs-link-active-border-color-dt:       transparent !default;\n$nav-tabs-link-hover-border-color-dt:        $border-color-dt $border-color-dt $border-color-dt !default;\n\n$nav-underline-border-color-dt:              $border-color-dt !default;\n$nav-underline-link-color-dt:                $medium-emphasis-dt !default;\n$nav-underline-link-active-color-dt:         $component-active-bg-dt !default;\n$nav-underline-link-active-border-color-dt:  $component-active-bg-dt !default;\n\n\n$nav-theme-map: (\n  \"nav-link-color\":                          $nav-link-color-dt,\n  \"nav-link-disabled-color\":                 $nav-link-disabled-color-dt,\n  \"nav-link-hover-color\":                    $nav-link-hover-color-dt,\n  \"nav-pills-link-active-bg\":                $nav-pills-link-active-bg-dt,\n  \"nav-pills-link-active-color\":             $nav-pills-link-active-color-dt,\n  \"nav-tabs-border-color\":                   $nav-tabs-border-color-dt,\n  \"nav-tabs-link-active-bg\":                 $nav-tabs-link-active-bg-dt,\n  \"nav-tabs-link-active-color\":              $nav-tabs-link-active-color-dt,\n  \"nav-tabs-link-active-border-color\":       $nav-tabs-link-active-border-color-dt,\n  \"nav-tabs-link-hover-border-color\":        $nav-tabs-link-hover-border-color-dt,\n  \"nav-underline-border-color\":              $nav-underline-border-color-dt,\n  \"nav-underline-link-color\":                $nav-underline-link-color-dt,\n  \"nav-underline-link-active-color\":         $nav-underline-link-active-color-dt,\n  \"nav-underline-link-active-border-color\":  $nav-underline-link-active-border-color-dt\n) !default;\n\n// Offcanvas\n\n// scss-docs-start offcanvas-dark-theme\n$offcanvas-color-dt:         null !default;\n$offcanvas-bg-color-dt:      $bg-elevation-12 !default;\n$offcanvas-border-color-dt:  transparent !default;\n// scss-docs-end offcanvas-dark-theme\n\n$offcanvas-theme-map: (\n  \"offcanvas-color\":         $offcanvas-color-dt,\n  \"offcanvas-bg-color\":      $offcanvas-bg-color-dt,\n  \"offcanvas-border-color\":  $offcanvas-border-color-dt\n) !default;\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-color-dt:                  $link-color-dt !default;\n$pagination-bg-dt:                     transparent !default;\n$pagination-border-color-dt:           $border-color-dt !default;\n\n$pagination-focus-color-dt:            $link-hover-color-dt !default;\n$pagination-focus-bg-dt:               $border-color-dt !default;\n\n$pagination-hover-color-dt:            $link-hover-color-dt !default;\n$pagination-hover-bg-dt:               $border-color-dt !default;\n$pagination-hover-border-color-dt:     $border-color-dt !default;\n\n$pagination-active-color-dt:           $component-active-color-dt !default;\n$pagination-active-bg-dt:              $component-active-bg-dt !default;\n$pagination-active-border-color-dt:    $pagination-active-bg-dt !default;\n\n$pagination-disabled-color-dt:         $disabled-dt !default;\n$pagination-disabled-bg-dt:            transparent !default;\n$pagination-disabled-border-color-dt:  $border-color-dt !default;\n\n$pagination-theme-map: (\n  \"pagination-color\":                  $pagination-color-dt,\n  \"pagination-bg\":                     $pagination-bg-dt,\n  \"pagination-border-color\":           $pagination-border-color-dt,\n  \"pagination-focus-color\":            $pagination-focus-color-dt,\n  \"pagination-focus-bg\":               $pagination-focus-bg-dt,\n  \"pagination-hover-color\":            $pagination-hover-color-dt,\n  \"pagination-hover-bg\":               $pagination-hover-bg-dt,\n  \"pagination-hover-border-color\":     $pagination-hover-border-color-dt,\n  \"pagination-active-color\":           $pagination-active-color-dt,\n  \"pagination-active-bg-dt\":           $pagination-active-bg-dt,\n  \"pagination-active-border-color\":    $pagination-active-border-color-dt,\n  \"pagination-disabled-color\":         $pagination-disabled-color-dt,\n  \"pagination-disabled-bg\":            $pagination-disabled-bg-dt,\n  \"pagination-disabled-border-color\":  $pagination-disabled-border-color-dt\n) !default;\n\n\n// Popovers\n\n// scss-docs-start popover-dark-theme\n$popover-bg-dt:                 $bg-elevation-16 !default;\n$popover-border-color-dt:       $border-color-dt !default;\n$popover-header-bg-dt:          $bg-elevation-16 !default;\n$popover-header-color-dt:       $body-color-dt !default;\n$popover-body-color-dt:         $body-color-dt !default;\n$popover-arrow-color-dt:        $popover-bg-dt !default;\n$popover-arrow-outer-color-dt:  fade-in($popover-border-color-dt, .05) !default;\n// scss-docs-end popover-dark-theme\n\n$popover-theme-map: (\n  \"popover-bg\":                 $popover-bg-dt,\n  \"popover-border-color\":       $popover-border-color-dt,\n  \"popover-header-bg\":          $popover-header-bg-dt,\n  \"popover-header-color\":       $popover-header-color-dt,\n  \"popover-body-color\":         $popover-body-color-dt,\n  \"popover-arrow-color\":        $popover-arrow-color-dt,\n  \"popover-arrow-outer-color\":  $popover-arrow-outer-color-dt\n) !default;\n\n\n// Progress\n\n$progress-bg-dt:         rgba($white, .2) !default;\n$progress-bar-color-dt:  $white !default;\n$progress-bar-bg-dt:     $primary-dt !default;\n\n$progress-theme-map: (\n  \"progress-bg\":         $progress-bg-dt,\n  \"progress-bar-bg\":     $progress-bar-bg-dt,\n  \"progress-bar-color\":  $progress-bar-color-dt\n) !default;\n\n// Sidebar\n\n$sidebar-color-dt:                    $body-color-dt !default;\n$sidebar-bg-dt:                       $bg-elevation-3 !default;\n$sidebar-border-width-dt:             0 !default;\n$sidebar-border-color-dt:             transparent !default;\n$sidebar-brand-color-dt:              inherit !default;\n$sidebar-brand-bg-dt:                 rgba($black, .2) !default;\n$sidebar-footer-bg-dt:                rgba($black, .2) !default;\n$sidebar-header-bg-dt:                rgba($black, .2) !default;\n$sidebar-toggler-bg-dt:               rgba($black, .2) !default;\n$sidebar-toggler-hover-bg-dt:         rgba($black, .3) !default;\n$sidebar-nav-title-color-dt:                 $medium-emphasis-dt !default;\n$sidebar-nav-link-color-dt:                  $medium-emphasis-dt !default;\n$sidebar-nav-link-bg-dt:                     transparent !default;\n$sidebar-nav-link-icon-color-dt:             $medium-emphasis-dt !default;\n$sidebar-nav-link-hover-color-dt:            $high-emphasis-dt !default;\n$sidebar-nav-link-hover-bg-dt:               rgba($white, .05) !default;\n$sidebar-nav-link-hover-icon-color-dt:       $high-emphasis-dt !default;\n\n$sidebar-nav-link-active-color-dt:           $high-emphasis-dt !default;\n$sidebar-nav-link-active-bg-dt:              rgba($white, .05) !default;\n$sidebar-nav-link-active-icon-color-dt:      $high-emphasis-dt !default;\n\n$sidebar-nav-link-disabled-color-dt:         $disabled-dt !default;\n$sidebar-nav-link-disabled-icon-color-dt:    $sidebar-nav-link-icon-color-dt !default;\n\n$sidebar-nav-group-bg-dt:                    rgba(0, 0, 0, .2) !default;\n$sidebar-nav-group-toggle-show-color-dt:     $sidebar-nav-link-color-dt !default;\n\n$sidebar-nav-group-indicator-color-dt:        $medium-emphasis-dt !default;\n$sidebar-nav-group-indicator-icon-dt:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-color-dt}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$sidebar-nav-group-indicator-hover-color-dt:  $sidebar-nav-link-hover-color-dt !default;\n$sidebar-nav-group-indicator-hover-icon-dt:   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$sidebar-nav-group-indicator-hover-color-dt}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$sidebar-theme-map: (\n  \"sidebar-color\":                            $sidebar-color-dt,\n  \"sidebar-bg\":                               $sidebar-bg-dt,\n  \"sidebar-border-width\":                     $sidebar-border-width-dt,\n  \"sidebar-border-color\":                     $sidebar-border-color-dt,\n  \"sidebar-brand-color\":                      $sidebar-brand-color-dt,\n  \"sidebar-brand-bg\":                         $sidebar-brand-bg-dt,\n  \"sidebar-footer-bg\":                        $sidebar-footer-bg-dt,\n  \"sidebar-header-bg\":                        $sidebar-header-bg-dt,\n  \"sidebar-toggler-bg\":                       $sidebar-toggler-bg-dt,\n  \"sidebar-toggler-hover-bg\":                 $sidebar-toggler-hover-bg-dt,\n  \"sidebar-nav-title-color\":                  $sidebar-nav-title-color-dt,\n  \"sidebar-nav-link-color\":                   $sidebar-nav-link-color-dt,\n  \"sidebar-nav-link-bg\":                      $sidebar-nav-link-bg-dt,\n  \"sidebar-nav-link-icon-color\":              $sidebar-nav-link-icon-color-dt,\n  \"sidebar-nav-link-hover-color\":             $sidebar-nav-link-hover-color-dt,\n  \"sidebar-nav-link-hover-bg\":                $sidebar-nav-link-hover-bg-dt,\n  \"sidebar-nav-link-hover-icon-color\":        $sidebar-nav-link-hover-icon-color-dt,\n  \"sidebar-nav-link-active-color\":            $sidebar-nav-link-active-color-dt,\n  \"sidebar-nav-link-active-bg\":               $sidebar-nav-link-active-bg-dt,\n  \"sidebar-nav-link-active-icon-color\":       $sidebar-nav-link-active-icon-color-dt,\n  \"sidebar-nav-link-disabled-color\":          $sidebar-nav-link-disabled-color-dt,\n  \"sidebar-nav-link-disabled-icon-color\":     $sidebar-nav-link-disabled-icon-color-dt,\n  \"sidebar-nav-group-bg\":                     $sidebar-nav-group-bg-dt,\n  \"sidebar-nav-group-toggle-show-color\":      $sidebar-nav-group-toggle-show-color-dt,\n  \"sidebar-nav-group-indicator-color\":        $sidebar-nav-group-indicator-color-dt,\n  \"sidebar-nav-group-indicator-icon\":         $sidebar-nav-group-indicator-icon-dt,\n  \"sidebar-nav-group-indicator-hover-color\":  $sidebar-nav-group-indicator-hover-color-dt,\n  \"sidebar-nav-group-indicator-hover-icon\":   $sidebar-nav-group-indicator-hover-icon-dt,\n) !default;\n\n$table-color-dt:              $body-color-dt !default;\n$table-bg-dt:                 transparent !default;\n$table-border-color-dt:       $border-color-dt !default;\n\n$table-striped-color-dt:      $table-color-dt !default;\n$table-striped-bg-factor-dt:  .05 !default;\n$table-striped-bg-dt:         rgba($white, $table-striped-bg-factor-dt) !default;\n\n$table-active-color-dt:       $table-color-dt !default;\n$table-active-bg-factor-dt:   .1 !default;\n$table-active-bg-dt:          rgba($black, $table-active-bg-factor-dt) !default;\n\n$table-hover-color-dt:        $table-color-dt !default;\n$table-hover-bg-factor-dt:    .075 !default;\n$table-hover-bg-dt:           rgba($black, $table-hover-bg-factor-dt) !default;\n\n$table-theme-map: (\n  \"table-color\":          $table-color-dt,\n  \"table-bg\":             $table-bg-dt,\n  \"table-border-color\":   $table-border-color-dt,\n  \"table-striped-color\":  $table-striped-color-dt,\n  \"table-striped-bg\":     $table-striped-bg-dt,\n  \"table-active-color\":   $table-active-color-dt,\n  \"table-active-bg\":      $table-active-bg-dt,\n  \"table-hover-color\":    $table-hover-color-dt,\n  \"table-hover-bg\":       $table-hover-bg-dt\n) !default;\n\n$table-variants-dt: (\n  \"primary\":    table-color-map(shift-color($primary-dt, $table-bg-scale)),\n  \"secondary\":  table-color-map(shift-color($secondary-dt, $table-bg-scale)),\n  \"success\":    table-color-map(shift-color($success-dt, $table-bg-scale)),\n  \"info\":       table-color-map(shift-color($info-dt, $table-bg-scale)),\n  \"warning\":    table-color-map(shift-color($warning-dt, $table-bg-scale)),\n  \"danger\":     table-color-map(shift-color($danger-dt, $table-bg-scale)),\n  \"light\":      table-color-map($light-dt, $body-bg-dt),\n  \"dark\":       table-color-map($dark-dt, $body-bg-dt)\n) !default;\n\n// Toast\n\n$toast-bg-dt:                   $bg-elevation-16 !default;\n$toast-color-dt:                $body-color-dt !default;\n$toast-border-color-dt:         transparent !default;\n\n$toast-header-color-dt:         $body-color-dt !default;\n$toast-header-bg-dt:            $bg-elevation-24 !default;\n$toast-header-border-color-dt:  rgba($black, .2) !default;\n\n$toast-theme-map: (\n  \"toast-bg\":                   $toast-bg-dt,\n  \"toast-color\":                $toast-color-dt,\n  \"toast-border-color\":         $toast-border-color-dt,\n  \"toast-header-color\":         $toast-header-color-dt,\n  \"toast-header-bg\":            $toast-header-bg-dt,\n  \"toast-header-border-color\":  $toast-header-border-color-dt\n) !default;\n\n// Calendar & Date & Time Pickers\n\n$calendar-nav-border-color-dt:               $border-color-dt !default;\n$calendar-nav-date-color-dt:                 $body-color-dt !default;\n$calendar-nav-date-hover-color-dt:           $primary-dt !default;\n$calendar-cell-header-inner-color-dt:        $medium-emphasis-dt !default;\n$calendar-cell-hover-bg-dt:                  rgba($black, .25) !default;\n$calendar-cell-disabled-color-dt:            $disabled-dt !default;\n$calendar-cell-selected-bg-dt:               $primary-dt !default;\n$calendar-cell-range-bg-dt:                  tint-color($primary-dt, 25%) !default;\n$calendar-cell-range-hover-bg-dt:            tint-color($primary-dt, 12.5%) !default;\n$calendar-cell-range-hover-border-color-dt:  $primary-dt !default;\n\n$calendar-theme-map: (\n  \"calendar-nav-border\":                     $calendar-nav-border-width solid $calendar-nav-border-color-dt,\n  \"calendar-nav-date-color\":                 $calendar-nav-date-color-dt,\n  \"calendar-nav-date-hover-color\":           $calendar-nav-date-hover-color-dt,\n  \"calendar-cell-header-inner-color\":        $calendar-cell-header-inner-color-dt,\n  \"calendar-cell-hover-bg\":                  $calendar-cell-hover-bg-dt,\n  \"calendar-cell-disabled-color\":            $calendar-cell-disabled-color-dt,\n  \"calendar-cell-selected-bg\":               $calendar-cell-selected-bg-dt,\n  \"calendar-cell-range-bg\":                  $calendar-cell-range-bg-dt,\n  \"calendar-cell-range-hover-bg\":            $calendar-cell-range-hover-bg-dt,\n  \"calendar-cell-range-hover-border-color\":  $calendar-cell-range-hover-border-color-dt\n) !default;\n\n$date-picker-timepicker-border-color-dt:  $border-color-dt !default;\n\n$date-picker-theme-map: (\n  \"date-picker-timepicker-border-top\":  $date-picker-timepicker-border-width solid $date-picker-timepicker-border-color-dt\n) !default;\n\n$picker-footer-border-color-dt:  $border-color-dt !default;\n\n$picker-theme-map: (\n  \"input-bg\":                        $input-bg-dt,\n  \"input-group-addon-border-color\":  transparent,\n  \"picker-footer-border-top\":        $picker-footer-border-width solid $picker-footer-border-color-dt\n) !default;\n\n$time-picker-roll-col-color-dt:     $border-color-dt !default;\n\n$time-picker-theme-map: (\n  \"time-picker-roll-col-border\":  $time-picker-roll-col-border-width solid $time-picker-roll-col-color-dt\n) !default;\n\n$theme-map: (\n  \"root\":               map-merge($theme-root-dt, $link-theme-map),\n  \"utilities\": (\n    \"bg\":               $theme-colors-dt,\n    \"text\":             $theme-colors-dt\n  ),\n  \"accordion\":          $accordion-theme-map,\n  \"breadcrumb\":         $breadcrumb-theme-map,\n  \"btn-close\":          $close-theme-map,\n  \"btn-link\":           $btn-link-theme-map,\n  \"calendar\":           $calendar-theme-map,\n  \"date-picker\":        $date-picker-theme-map,\n  \"card\":               $card-theme-map,\n  \"dropdown-menu\":      $dropdown-theme-map,\n  \"footer\":             $footer-theme-map,\n  \"form-control\":       $form-control-theme-map,\n  \"form-check\":         $form-check-theme-map,\n  \"form-select\":        $form-select-theme-map,\n  \"form-multi-select\":  $form-multi-select-theme-map,\n  \"header\":             $header-theme-map,\n  \"input-group\":        $input-group-theme-map,\n  \"list-group\":         $list-group-theme-map,\n  \"modal\":              $modal-theme-map,\n  \"nav\":                $nav-theme-map,\n  \"offcanvas\":          $offcanvas-theme-map,\n  \"pagination\":         $pagination-theme-map,\n  \"picker\":             $picker-theme-map,\n  \"popover\":            $popover-theme-map,\n  \"progress\":           $progress-theme-map,\n  \"sidebar\":            $sidebar-theme-map,\n  \"table\":              map-merge($table-theme-map, $table-variants-dt),\n  \"time-picker\":        $time-picker-theme-map,\n  \"toast\":              $toast-theme-map\n) !default;\n","/*!\n * CoreUI Plugins - Chart.js for CoreUI 3\n * @version v3.1.2\n * @link https://coreui.io\n * Copyright (c) 2021 creativeLabs Łukasz Holeczek\n * Licensed under MIT (https://github.com/coreui/coreui-chartjs/blob/main/LICENSE)\n */\n\n\n@import \"@coreui/coreui/scss/functions\";\n@import \"@coreui/coreui/scss/variables\";\n@import \"@coreui/coreui/scss/mixins\";\n@import \"tooltips\";\n","// Custom tooltips\n\n.chartjs-tooltip {\n  position: absolute;\n  z-index: $zindex-sticky + 1;\n  padding: ($spacer * .25) ($spacer * .5);\n  color: #fff;\n  pointer-events: none;\n  background: rgba(0, 0, 0, .7);\n  opacity: 0;\n  @include transition(all .15s ease);\n  transform: translate(-50%, 0);\n  @include border-radius($border-radius);\n}\n\n.chartjs-tooltip-header {\n  margin-bottom: ($spacer * .5);\n}\n\n.chartjs-tooltip-header-item {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-bold;\n}\n\n.chartjs-tooltip-body-item {\n  align-items: center;\n  font-size: $font-size-sm;\n  white-space: nowrap;\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-left-radius\", valid-radius($radius));\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-top-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-right-radius\", valid-radius($radius));\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    @include ltr-rtl(\"border-bottom-left-radius\", valid-radius($radius));\n  }\n}\n// scss-docs-end border-radius-mixins\n",".wrapper {\n  width: 100%;\n  @include ltr-rtl(\"padding-left\", var(--cui-sidebar-occupy-start, 0));\n  will-change: auto;\n  @include transition(padding .15s);\n}\n\n\n\n","@mixin ltr {\n  @if $enable-ltr {\n    html:not([dir=\"rtl\"]) & {\n      @content;\n    }\n  }\n}\n\n@mixin rtl {\n  @if $enable-rtl {\n    *[dir=\"rtl\"] & {\n      @content;\n    }\n  }\n}\n\n@function reflect($element) {\n  $string: #{$element};\n  @if str-index($string, \"left\") {\n    @return str-replace($string, \"left\", \"right\");\n  }\n  @if str-index($string, \"right\") {\n    @return str-replace($string, \"right\", \"left\");\n  }\n\n  @return unquote($string);\n}\n\n@mixin ltr-rtl($property, $value, $property-rtl: null, $value-rtl: null, $important: null) {\n  $property-reflected: reflect($property);\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property-reflected}: $value-rtl $important;\n      }\n      @else {\n        #{$property-reflected}: $value-reflected $important;\n      }\n    }\n    @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n\n@mixin ltr-rtl-value-only($property, $value, $value-rtl: null, $important: null) {\n  $value-reflected: reflect($value);\n\n  @if $enable-ltr and $enable-rtl {\n    @include ltr() {\n      #{$property}: $value $important;\n    }\n    @include rtl() {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    }\n  }\n  @else {\n    @if $enable-rtl {\n      @if $value-rtl {\n        #{$property}: $value-rtl $important;\n      } @else {\n        #{$property}: $value-reflected $important;\n      }\n    } @else {\n      #{$property}: $value $important;\n    }\n  }\n}\n",".fc {\n  --fc-small-font-size: .85em;\n  --fc-page-bg-color: #fff;\n  --fc-neutral-bg-color: rgba(208, 208, 208, .3);\n  --fc-neutral-text-color: #808080;\n  --fc-border-color: var(--cui-border-color, #{$border-color});\n  --fc-button-text-color: #fff;\n  --fc-button-bg-color: #2c3e50;\n  --fc-button-border-color: #2c3e50;\n  --fc-button-hover-bg-color: #1e2b37;\n  --fc-button-hover-border-color: #1a252f;\n  --fc-button-active-bg-color: #1a252f;\n  --fc-button-active-border-color: #151e27;\n  --fc-event-bg-color: #3788d8;\n  --fc-event-border-color: #3788d8;\n  --fc-event-text-color: #fff;\n  --fc-event-selected-overlay-color: rgba(0, 0, 0, .25);\n  --fc-event-resizer-thickness: 8px;\n  --fc-event-resizer-dot-total-width: 8px;\n  --fc-event-resizer-dot-border-width: 1px;\n  --fc-non-business-color: rgba(215, 215, 215, .3);\n  --fc-bg-event-color: rgb(143, 223, 130);\n  --fc-bg-event-opacity: .3;\n  --fc-highlight-color: rgba(188, 232, 241, .3);\n  --fc-today-bg-color: rgba(255, 220, 40, .15);\n  --fc-now-indicator-color: var(--cui-danger);\n}\n",".example {\n  &:not(:first-child) {\n    margin-top: 1.5rem;\n  }\n\n  .tab-content {\n    background-color: $light-50 !important;\n\n    @at-root .dark-theme & {\n      background-color: rgba(255, 255, 255, .1) !important;\n    }\n  }\n\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    font-size: .875rem !important;\n  }\n\n  :not(pre) > code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    background: transparent;\n  }\n\n  & + p,\n  & + h2,\n  & + h3,\n  & + h4,\n  & + h5,\n  & + h6 {\n    margin-top: 1.5rem;\n  }\n\n  // Components examples\n  .preview,\n  .preview .col {\n    + p {\n      margin-top: 2rem;\n    }\n\n    > .form-control {\n      + .form-control {\n        margin-top: .5rem;\n      }\n    }\n\n    > .nav + .nav,\n    > .alert + .alert,\n    > .navbar + .navbar,\n    > .progress + .progress {\n      margin-top: 1rem;\n    }\n\n    > .dropdown-menu {\n      position: static;\n      display: block;\n    }\n\n    > :last-child {\n      margin-bottom: 0;\n    }\n\n    // Images\n    > svg + svg,\n    > img + img {\n      margin-left: .5rem;\n    }\n\n    // Buttons\n    > .btn,\n    > .btn-group {\n      margin: .25rem .125rem;\n    }\n    > .btn-toolbar + .btn-toolbar {\n      margin-top: .5rem;\n    }\n\n    // List groups\n    > .list-group {\n      max-width: 400px;\n    }\n\n    > [class*=\"list-group-horizontal\"] {\n      max-width: 100%;\n    }\n\n    // Navbars\n    .fixed-top,\n    .sticky-top {\n      position: static;\n      margin: -1rem -1rem 1rem;\n    }\n\n    .fixed-bottom {\n      position: static;\n      margin: 1rem -1rem -1rem;\n    }\n\n    @include media-breakpoint-up(sm) {\n      .fixed-top,\n      .sticky-top {\n        margin: -1.5rem -1.5rem 1rem;\n      }\n      .fixed-bottom {\n        margin: 1rem -1.5rem -1.5rem;\n      }\n    }\n\n    // Pagination\n    .pagination {\n      margin-top: .5rem;\n      margin-bottom: .5rem;\n    }\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Here you can add other styles\n.contentSize {\n  min-height: 85vh;\n  scroll-snap-type: y mandatory;\n  min-height: '-webkit-fill-available';\n}\n\n.centerContent {\n  margin: auto;\n  // border: 3px solid green;\n  padding: 10px;\n}\n\n#map {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n}\n\n.active-scroll-spy {\n  background-color: yellowgreen;\n  border-radius: 15px;\n}\n\n.chartMinHeight {\n  min-height: 250px;\n  height: 100%;\n  max-height: 350px;\n}\n\n.chartMinHeightPie {\n  min-height: 130px;\n  height: 100%;\n  max-height: 350px;\n}\n\n.chartGauge {\n  min-height: 300px;\n  height: 100%;\n  max-height: 600px;\n}\n\n.mycluster {\n  width: 40px;\n  height: 40px;\n  background-color: greenyellow;\n  text-align: center;\n  font-size: 24px;\n}\n\n.custom-marker-cluster {\n  background: #ffffff;\n  border: 15px solid #f00800;\n  border-radius: 50%;\n  color: #000000;\n  height: 33px;\n  line-height: 37px;\n  text-align: center;\n  width: 33px;\n}\n\nhr.vertical {\n  height: 100%;\n  /* you might need some positioning for this to work, see other questions about 100% height */\n  width: 0;\n  border: 2px solid black;\n}\n\n// .btn {\n//   &:hover {\n//     background-color: var(--bs-btn-bg);\n//     color: var(--bs-btn-color);\n//   }\n\n// }\n\n--btn.disabled {\n  /* Make the disabled links grayish*/\n  color: gray;\n  /* And disable the pointer events */\n  pointer-events: none;\n}\n\n.tableFixHead {\n  overflow-y: auto;\n  /* make the table scrollable if height is more than 200 px  */\n  height: 70vh;\n  /* gives an initial height of 200px to the table */\n}\n\n.tableFixHead thead th {\n  position: sticky;\n  /* make the table heads sticky */\n  top: 0px;\n  /* table head will be placed from the top of the table and sticks to it */\n}\n\ntable {\n  border-collapse: collapse;\n  /* make the table borders collapse to each other */\n  width: 100%;\n  border-spacing: 10px;\n}\n\nth,\ntd {\n  padding: 1px 1px;\n  border-bottom: 2px dotted #2596be;\n}\n\nth {\n  color: #4dd7fb;\n  background-color: #012233;\n  text-transform: uppercase;\n}\n\ntable.summaryTable {\n  width: 100%;\n}\n\ntable.summaryTable td,\ntable.summaryTable th {\n  border: 1px solid #aaaaaa;\n  padding: 3px 2px;\n}\n\ntable.summaryTable tbody td {\n  font-size: 13px;\n}\n\ntable.summaryTable thead {\n  background: #321fdb;\n}\n\ntable.summaryTable thead th {\n  font-weight: bold;\n  color: #ffffff;\n  text-align: center;\n}\n\n.customDatePickerWidth,\n.customDatePickerWidth > div.react-datepicker-wrapper,\n.customDatePickerWidth\n  > div\n  > div.react-datepicker__input-container\n  .customDatePickerWidth\n  > div\n  > div.react-datepicker__input-container\n  input {\n  width: 100%;\n}\n\n.react-datepicker__input-container {\n  width: inherit;\n}\n\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.custom-map-modal {\n  .modal-dialog {\n    width: 90%;\n    height: 95%;\n    margin: 0;\n    // padding-top: 2em;\n    padding-top: 2em;\n    // padding-left: 2em;\n    // padding-right: -10em;\n    //  padding: 0 2em 0 2em;\n  }\n\n  .modal-content {\n    height: auto;\n    min-height: 95%;\n    // min-width: 100%;\n    border-radius: 0;\n  }\n}\n\n@media all {\n  .pagebreak {\n    display: none;\n  }\n}\n\n@media print {\n  html,\n  body {\n    height: initial !important;\n    overflow: initial !important;\n    -webkit-print-color-adjust: exact;\n  }\n}\n\n@media print {\n  .pagebreak {\n    margin-top: 1rem;\n    display: block;\n    page-break-before: always;\n  }\n}\n\n@page {\n  size: auto;\n  margin: 10mm;\n}\n\n// .previewA4 {\n//     color: 'red';\n//     font-family: \"Cambria\";\n//     font-weight: normal;\n//     font-size: '2px';\n// }\n\n// .previewA4 > * {\n//   color:red;\n//   margin: 0 20px;\n// }\n\n.parent {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n#range,\n#text {\n  flex: 1;\n}\n\n.error {\n  flex: 0 0 100%;\n  /* flex-grow, flex-shrink, flex-basis */\n  border: 1px dashed black;\n}\n\n.kioskcard {\n  height: 250px;\n  font-size: 18px;\n  display: flex;\n  flex-direction: column;\n}\n\n.kioskEnergyOptions {\n  // background-color: #E8EEF1;\n  box-shadow: 0px 0px;\n  height: 400px;\n  width: 400px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  column-gap: 10px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 2%;\n}\n\n.kioskChoice {\n  height: 350px;\n  width: 60%;\n  padding: 10px;\n  display: grid;\n  grid-template-columns: 1fr, 1fr;\n  row-gap: 10px;\n}\n\ntable.kioskTable {\n  width: 100%;\n  border-width: 0.5px;\n  border-color: #aaaaaa;\n}\n\ntable.kioskTable th {\n  font-size: 18px;\n  background-color: $warning;\n  color: white;\n  text-transform: capitalize;\n}\n\ntable.kioskTable th,\ntr,\ntd {\n  border-top: none;\n  border-bottom: solid rgba(0, 0, 0, 0.2);\n  border-left: none;\n  border-right: none;\n  font-size: 16px;\n  border-width: 0.5px;\n  padding: 0.2em;\n}\n\n.kioskUsageWidget {\n  width: 100%;\n  box-shadow: 0px 0px;\n  border-radius: 0%;\n}\n\n.kioskUsageCards {\n  background-color: $warning;\n}\n\n.kioskBadge {\n  border-radius: 2em;\n  padding: 5px;\n  font-size: 0.5em;\n\n  &.positive {\n    background-color: $success-25;\n    color: $success;\n  }\n\n  &.negative {\n    background-color: $danger-25;\n    color: $danger;\n  }\n\n  &.neutral {\n    background-color: $primary-25;\n    color: $primary;\n  }\n}\n\n.usageReductionCard {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  object-fit: cover;\n  min-height: 120px;\n  &.mainValue {\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-top: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0px;\n  }\n\n  &.subCard {\n    border-radius: 10px;\n    color: white;\n    background-color: #2eb85c;\n  }\n}\n\n.usageReductionCardBefore {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  object-fit: cover;\n  min-height: 120px;\n  &.mainValue {\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-top: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0px;\n  }\n\n  &.subCard {\n    border-radius: 10px;\n    color: white;\n    background-color: #b82e2e;\n  }\n}\n\n.usageReductionCard2 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  object-fit: cover;\n  min-height: 120px;\n  margin-right: 2px;\n  margin-left: 2px;\n  &.mainValue {\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-top: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0px;\n  }\n\n  &.subCard {\n    border-radius: 10px;\n    color: white;\n    background-color: #2eb85c;\n  }\n}\n\n.usageReductionCard2Before {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  object-fit: cover;\n  min-height: 120px;\n  margin-right: 2px;\n  margin-left: 2px;\n  &.mainValue {\n    border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-top: 0.5px solid rgba(0, 0, 0, 0.2);\n    border-radius: 0px;\n  }\n\n  &.subCard {\n    border-radius: 10px;\n    color: white;\n    background-color: #b82e2e;\n  }\n}\n\n#item1 {\n  grid-area: item1;\n}\n\n#item2 {\n  grid-area: item2;\n}\n\n.grid {\n  grid-template-areas:\n    '. . . .'\n    '. . . item1'\n    'item2 item2 item2 item1'\n    'item2 item2 item2 .';\n}\n.roundIconContainer {\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0;\n\n  &.arrowSuccess {\n    color: white;\n    background-color: $success;\n  }\n  &.arrowDanger {\n    color: white;\n    background-color: $danger;\n  }\n  &.arrowNeutral {\n    color: white;\n    background-color: $primary;\n  }\n}\n\n$text-medium-emphasis: #ffffff;\n\n.kioskBgImage {\n  /* Add the blur effect */\n  filter: blur(3px);\n  -webkit-filter: blur(3px);\n\n  /* Full height */\n  height: 100vh;\n  background-image: url('../assets/residential2.png');\n\n  /* Center and scale the image nicely */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.loginBgImage {\n  /* Add the blur effect */\n  filter: blur(3px);\n  -webkit-filter: blur(3px);\n\n  /* Full height */\n  height: 100vh;\n  background-image: url('../assets/loginpic.png');\n\n  /* Center and scale the image nicely */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.kioskBgImage2 {\n  /* Full height */\n  height: 100vh;\n  background-image: url('../assets/residential2.png');\n\n  /* Center and scale the image nicely */\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.kioskText {\n  background-color: rgb(0, 0, 0); /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.5); /* Black w/opacity/see-through */\n  color: white;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  border: 3px solid #f1f1f1;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  width: 80%;\n  padding: 20px;\n  text-align: center;\n  font-size: 40px;\n  justify-content: center;\n  align-items: center;\n  flex: content;\n  border-radius: 25px;\n}\n\n.loginText {\n  background-color: rgb(0, 0, 0); /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.5); /* Black w/opacity/see-through */\n  color: white;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  border: 3px solid #f1f1f1;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  padding: 20px;\n  text-align: center;\n  font-size: 40px;\n  justify-content: center;\n  align-items: center;\n  flex: content;\n  border-radius: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
